import { defineComponent as ue, openBlock as m, createElementBlock as x, normalizeClass as b, createElementVNode as C, useSlots as tt, computed as G, useCssModule as be, createBlock as H, resolveDynamicComponent as He, unref as p, withCtx as J, Fragment as pe, renderSlot as K, createCommentVNode as R, h as Ze, ref as Q, onMounted as wu, watch as qe, nextTick as Pe, onBeforeUnmount as Yt, createVNode as j, normalizeStyle as ht, resolveComponent as Va, withModifiers as ot, toDisplayString as ne, renderList as ge, createTextVNode as ce, createSlots as mt, normalizeProps as Le, guardReactiveProps as Ne, mergeProps as Te, withDirectives as Xe, mergeDefaults as lt, vModelDynamic as g0, useTemplateRef as Cs, withKeys as b0, vModelText as y0, createStaticVNode as sr, resolveDirective as Ds, toHandlers as As, vShow as iu, Transition as _0, markRaw as xs, getCurrentScope as w0, onScopeDispose as C0, toRef as D0, readonly as A0, customRef as x0, useCssVars as ja, shallowRef as E0, onBeforeUpdate as k0, useAttrs as S0, mergeModels as T0, useModel as B0 } from "vue";
import { useDebounceFn as Es, useResizeObserver as Ha, onClickOutside as Zt, useIntersectionObserver as $0, objectOmit as ks } from "@vueuse/core";
import { VueFinalModal as Ss } from "vue-final-modal";
import Ts from "vuedraggable";
import { useVuelidate as Bs } from "@vuelidate/core";
import { helpers as sa, required as la } from "@vuelidate/validators";
import { Chrome as M0 } from "@lk77/vue3-color";
import { useEditor as O0, EditorContent as L0 } from "@tiptap/vue-3";
import F0 from "turndown";
import * as Oi from "marked";
import I0 from "@tiptap/starter-kit";
import N0 from "@tiptap/extension-highlight";
import q0 from "vue3-emoji-picker";
var sn = /* @__PURE__ */ ((r) => (r.BUTTON = "button", r.LINK = "a", r))(sn || {}), qt = /* @__PURE__ */ ((r) => (r.PRIMARY = "primary", r.PRIMARY_OUTLINE = "primary-outline", r.SECONDARY_OUTLINE = "secondary-outline", r.ACTION = "action", r.BASIC = "basic", r.ICON = "icon", r.BRAND = "brand", r.GHOST = "ghost", r))(qt || {}), P0 = /* @__PURE__ */ ((r) => (r.SUBMIT = "submit", r.RESET = "reset", r.CANCEL = "cancel", r.SUCCESS = "success", r))(P0 || {}), Pt = /* @__PURE__ */ ((r) => (r.EXTRA_EXTRA_SMALL = "xxs", r.EXTRA_SMALL = "xs", r.X_SMALL = "xsm", r.SMALL = "sm", r.MEDIUM = "md", r.X_MEDIUM = "xmd", r.AUTO = "auto", r.MOBILE_ACTION = "mobile-action", r))(Pt || {}), Rt = /* @__PURE__ */ ((r) => (r.SMALL = "small", r.MEDIUM = "medium", r.LARGE = "large", r))(Rt || {}), ln = /* @__PURE__ */ ((r) => (r.PRIMARY = "primary", r.SECONDARY = "secondary", r))(ln || {});
const R0 = /* @__PURE__ */ ue({
  __name: "VSpinner",
  props: {
    size: { default: Rt.MEDIUM },
    variant: { default: ln.PRIMARY }
  },
  setup(r) {
    return (t, e) => (m(), x("div", {
      class: b([
        t.$style["v-spinner"],
        t.$style[`v-spinner--${t.variant}`],
        t.$style[`v-spinner--${t.size}`]
      ])
    }, e[0] || (e[0] = [
      C("div", null, null, -1),
      C("div", null, null, -1),
      C("div", null, null, -1),
      C("div", null, null, -1)
    ]), 2));
  }
}), V0 = {
  "v-spinner": "_v-spinner_4ds4o_1",
  "v-spinner-animation": "_v-spinner-animation_4ds4o_1",
  "v-spinner--large": "_v-spinner--large_4ds4o_23",
  "v-spinner--medium": "_v-spinner--medium_4ds4o_33",
  "v-spinner--small": "_v-spinner--small_4ds4o_43",
  "v-spinner--primary": "_v-spinner--primary_4ds4o_53",
  "v-spinner--secondary": "_v-spinner--secondary_4ds4o_57"
}, U = (r, t) => {
  const e = r.__vccOpts || r;
  for (const [u, n] of t)
    e[u] = n;
  return e;
}, j0 = {
  $style: V0
}, Cu = /* @__PURE__ */ U(R0, [["__cssModules", j0]]), H0 = /* @__PURE__ */ ue({
  __name: "VButton",
  props: {
    variant: { default: qt.PRIMARY },
    size: { default: Pt.MEDIUM },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    tag: { default: sn.BUTTON },
    rel: { default: null },
    active: { type: Boolean, default: !1 },
    fixedWidth: { type: Boolean, default: !0 },
    href: { default: null },
    target: { default: null },
    type: { default: null },
    fill: { type: Boolean, default: !1 },
    iconRight: { type: Boolean, default: !1 },
    iconOnly: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = tt(), a = G(() => Pt.EXTRA_SMALL === e.size || Pt.SMALL === e.size ? Rt.SMALL : Rt.MEDIUM), o = G(() => [qt.ACTION, qt.ICON].includes(e.variant) ? ln.PRIMARY : ln.SECONDARY), s = G(() => !!n.icon), i = G(() => e.loading || e.disabled), l = be();
    return (d, h) => (m(), H(He(d.tag), {
      class: b([
        p(l)["v-button"],
        p(l)[`v-button--${d.variant}`],
        p(l)[`v-button--${d.size}`],
        p(l)[`v-button--${d.type}`],
        {
          [p(l)["v-button--has-icon"]]: !d.loading && s.value,
          [p(l)["v-button--icon-only"]]: d.iconOnly,
          [p(l)["v-button--fill"]]: d.fill,
          [p(l)["v-button--active"]]: d.active,
          [p(l)["v-button--not-fixed-width"]]: !d.fixedWidth
        }
      ]),
      rel: d.rel,
      href: d.href,
      type: d.type || "button",
      target: d.target,
      disabled: i.value || null,
      "aria-label": "Button",
      onClick: h[0] || (h[0] = (c) => u("click"))
    }, {
      default: J(() => [
        d.loading ? (m(), H(p(Cu), {
          key: 0,
          size: a.value,
          variant: o.value
        }, null, 8, ["size", "variant"])) : (m(), x(pe, { key: 1 }, [
          d.iconRight ? R("", !0) : K(d.$slots, "icon", { key: 0 }),
          K(d.$slots, "default"),
          d.iconRight ? K(d.$slots, "icon", { key: 1 }) : R("", !0)
        ], 64))
      ]),
      _: 3
    }, 8, ["class", "rel", "href", "type", "target", "disabled"]));
  }
}), U0 = {
  "v-button": "_v-button_zhk7c_1",
  "v-button--fill": "_v-button--fill_zhk7c_23",
  "v-button--xxs": "_v-button--xxs_zhk7c_29",
  "v-button--xs": "_v-button--xs_zhk7c_29",
  "v-button--xmd": "_v-button--xmd_zhk7c_29",
  "v-button--mobile-action": "_v-button--mobile-action_zhk7c_29",
  "v-button--not-fixed-width": "_v-button--not-fixed-width_zhk7c_36",
  "v-button--md": "_v-button--md_zhk7c_39",
  "v-button--has-icon": "_v-button--has-icon_zhk7c_43",
  "v-button--icon-only": "_v-button--icon-only_zhk7c_49",
  "v-button--primary": "_v-button--primary_zhk7c_53",
  "v-button--ghost": "_v-button--ghost_zhk7c_69",
  "v-button--brand": "_v-button--brand_zhk7c_84",
  "v-button--primary-outline": "_v-button--primary-outline_zhk7c_100",
  "v-button--secondary-outline": "_v-button--secondary-outline_zhk7c_118",
  "v-button--basic": "_v-button--basic_zhk7c_136",
  "v-button--icon": "_v-button--icon_zhk7c_49",
  "v-button--action": "_v-button--action_zhk7c_167",
  "v-button--active": "_v-button--active_zhk7c_178",
  "v-button--cancel": "_v-button--cancel_zhk7c_186",
  "v-button--success": "_v-button--success_zhk7c_190",
  "v-button--xsm": "_v-button--xsm_zhk7c_227",
  "v-button--sm": "_v-button--sm_zhk7c_242"
}, z0 = {
  $style: U0
}, vt = /* @__PURE__ */ U(H0, [["__cssModules", z0]]), G0 = {}, W0 = {
  width: "6",
  height: "10",
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Y0(r, t) {
  return m(), x("svg", W0, t[0] || (t[0] = [
    C("path", {
      d: "M1 9L5 5L1 1",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const kt = /* @__PURE__ */ U(G0, [["render", Y0]]);
var Je = "top", gt = "bottom", bt = "right", Qe = "left", Ua = "auto", Du = [Je, gt, bt, Qe], Ar = "start", ou = "end", Z0 = "clippingParents", $s = "viewport", Gr = "popper", K0 = "reference", Li = /* @__PURE__ */ Du.reduce(function(r, t) {
  return r.concat([t + "-" + Ar, t + "-" + ou]);
}, []), Ms = /* @__PURE__ */ [].concat(Du, [Ua]).reduce(function(r, t) {
  return r.concat([t, t + "-" + Ar, t + "-" + ou]);
}, []), X0 = "beforeRead", J0 = "read", Q0 = "afterRead", e1 = "beforeMain", t1 = "main", r1 = "afterMain", u1 = "beforeWrite", n1 = "write", a1 = "afterWrite", i1 = [X0, J0, Q0, e1, t1, r1, u1, n1, a1];
function Et(r) {
  return r ? (r.nodeName || "").toLowerCase() : null;
}
function st(r) {
  if (r == null)
    return window;
  if (r.toString() !== "[object Window]") {
    var t = r.ownerDocument;
    return t && t.defaultView || window;
  }
  return r;
}
function ar(r) {
  var t = st(r).Element;
  return r instanceof t || r instanceof Element;
}
function pt(r) {
  var t = st(r).HTMLElement;
  return r instanceof t || r instanceof HTMLElement;
}
function za(r) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = st(r).ShadowRoot;
  return r instanceof t || r instanceof ShadowRoot;
}
function o1(r) {
  var t = r.state;
  Object.keys(t.elements).forEach(function(e) {
    var u = t.styles[e] || {}, n = t.attributes[e] || {}, a = t.elements[e];
    !pt(a) || !Et(a) || (Object.assign(a.style, u), Object.keys(n).forEach(function(o) {
      var s = n[o];
      s === !1 ? a.removeAttribute(o) : a.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function s1(r) {
  var t = r.state, e = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, e.popper), t.styles = e, t.elements.arrow && Object.assign(t.elements.arrow.style, e.arrow), function() {
    Object.keys(t.elements).forEach(function(u) {
      var n = t.elements[u], a = t.attributes[u] || {}, o = Object.keys(t.styles.hasOwnProperty(u) ? t.styles[u] : e[u]), s = o.reduce(function(i, l) {
        return i[l] = "", i;
      }, {});
      !pt(n) || !Et(n) || (Object.assign(n.style, s), Object.keys(a).forEach(function(i) {
        n.removeAttribute(i);
      }));
    });
  };
}
const l1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: o1,
  effect: s1,
  requires: ["computeStyles"]
};
function At(r) {
  return r.split("-")[0];
}
var rr = Math.max, cn = Math.min, xr = Math.round;
function ca() {
  var r = navigator.userAgentData;
  return r != null && r.brands && Array.isArray(r.brands) ? r.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Os() {
  return !/^((?!chrome|android).)*safari/i.test(ca());
}
function Er(r, t, e) {
  t === void 0 && (t = !1), e === void 0 && (e = !1);
  var u = r.getBoundingClientRect(), n = 1, a = 1;
  t && pt(r) && (n = r.offsetWidth > 0 && xr(u.width) / r.offsetWidth || 1, a = r.offsetHeight > 0 && xr(u.height) / r.offsetHeight || 1);
  var o = ar(r) ? st(r) : window, s = o.visualViewport, i = !Os() && e, l = (u.left + (i && s ? s.offsetLeft : 0)) / n, d = (u.top + (i && s ? s.offsetTop : 0)) / a, h = u.width / n, c = u.height / a;
  return {
    width: h,
    height: c,
    top: d,
    right: l + h,
    bottom: d + c,
    left: l,
    x: l,
    y: d
  };
}
function Ga(r) {
  var t = Er(r), e = r.offsetWidth, u = r.offsetHeight;
  return Math.abs(t.width - e) <= 1 && (e = t.width), Math.abs(t.height - u) <= 1 && (u = t.height), {
    x: r.offsetLeft,
    y: r.offsetTop,
    width: e,
    height: u
  };
}
function Ls(r, t) {
  var e = t.getRootNode && t.getRootNode();
  if (r.contains(t))
    return !0;
  if (e && za(e)) {
    var u = t;
    do {
      if (u && r.isSameNode(u))
        return !0;
      u = u.parentNode || u.host;
    } while (u);
  }
  return !1;
}
function Vt(r) {
  return st(r).getComputedStyle(r);
}
function c1(r) {
  return ["table", "td", "th"].indexOf(Et(r)) >= 0;
}
function Kt(r) {
  return ((ar(r) ? r.ownerDocument : (
    // $FlowFixMe[prop-missing]
    r.document
  )) || window.document).documentElement;
}
function An(r) {
  return Et(r) === "html" ? r : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    r.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    r.parentNode || // DOM Element detected
    (za(r) ? r.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Kt(r)
  );
}
function Fi(r) {
  return !pt(r) || // https://github.com/popperjs/popper-core/issues/837
  Vt(r).position === "fixed" ? null : r.offsetParent;
}
function d1(r) {
  var t = /firefox/i.test(ca()), e = /Trident/i.test(ca());
  if (e && pt(r)) {
    var u = Vt(r);
    if (u.position === "fixed")
      return null;
  }
  var n = An(r);
  for (za(n) && (n = n.host); pt(n) && ["html", "body"].indexOf(Et(n)) < 0; ) {
    var a = Vt(n);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function Au(r) {
  for (var t = st(r), e = Fi(r); e && c1(e) && Vt(e).position === "static"; )
    e = Fi(e);
  return e && (Et(e) === "html" || Et(e) === "body" && Vt(e).position === "static") ? t : e || d1(r) || t;
}
function Wa(r) {
  return ["top", "bottom"].indexOf(r) >= 0 ? "x" : "y";
}
function Qr(r, t, e) {
  return rr(r, cn(t, e));
}
function f1(r, t, e) {
  var u = Qr(r, t, e);
  return u > e ? e : u;
}
function Fs() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Is(r) {
  return Object.assign({}, Fs(), r);
}
function Ns(r, t) {
  return t.reduce(function(e, u) {
    return e[u] = r, e;
  }, {});
}
var p1 = function(t, e) {
  return t = typeof t == "function" ? t(Object.assign({}, e.rects, {
    placement: e.placement
  })) : t, Is(typeof t != "number" ? t : Ns(t, Du));
};
function h1(r) {
  var t, e = r.state, u = r.name, n = r.options, a = e.elements.arrow, o = e.modifiersData.popperOffsets, s = At(e.placement), i = Wa(s), l = [Qe, bt].indexOf(s) >= 0, d = l ? "height" : "width";
  if (!(!a || !o)) {
    var h = p1(n.padding, e), c = Ga(a), f = i === "y" ? Je : Qe, g = i === "y" ? gt : bt, D = e.rects.reference[d] + e.rects.reference[i] - o[i] - e.rects.popper[d], _ = o[i] - e.rects.reference[i], O = Au(a), M = O ? i === "y" ? O.clientHeight || 0 : O.clientWidth || 0 : 0, L = D / 2 - _ / 2, q = h[f], z = M - c[d] - h[g], X = M / 2 - c[d] / 2 + L, ee = Qr(q, X, z), V = i;
    e.modifiersData[u] = (t = {}, t[V] = ee, t.centerOffset = ee - X, t);
  }
}
function m1(r) {
  var t = r.state, e = r.options, u = e.element, n = u === void 0 ? "[data-popper-arrow]" : u;
  n != null && (typeof n == "string" && (n = t.elements.popper.querySelector(n), !n) || Ls(t.elements.popper, n) && (t.elements.arrow = n));
}
const v1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: h1,
  effect: m1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function kr(r) {
  return r.split("-")[1];
}
var g1 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function b1(r, t) {
  var e = r.x, u = r.y, n = t.devicePixelRatio || 1;
  return {
    x: xr(e * n) / n || 0,
    y: xr(u * n) / n || 0
  };
}
function Ii(r) {
  var t, e = r.popper, u = r.popperRect, n = r.placement, a = r.variation, o = r.offsets, s = r.position, i = r.gpuAcceleration, l = r.adaptive, d = r.roundOffsets, h = r.isFixed, c = o.x, f = c === void 0 ? 0 : c, g = o.y, D = g === void 0 ? 0 : g, _ = typeof d == "function" ? d({
    x: f,
    y: D
  }) : {
    x: f,
    y: D
  };
  f = _.x, D = _.y;
  var O = o.hasOwnProperty("x"), M = o.hasOwnProperty("y"), L = Qe, q = Je, z = window;
  if (l) {
    var X = Au(e), ee = "clientHeight", V = "clientWidth";
    if (X === st(e) && (X = Kt(e), Vt(X).position !== "static" && s === "absolute" && (ee = "scrollHeight", V = "scrollWidth")), X = X, n === Je || (n === Qe || n === bt) && a === ou) {
      q = gt;
      var oe = h && X === z && z.visualViewport ? z.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        X[ee]
      );
      D -= oe - u.height, D *= i ? 1 : -1;
    }
    if (n === Qe || (n === Je || n === gt) && a === ou) {
      L = bt;
      var W = h && X === z && z.visualViewport ? z.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        X[V]
      );
      f -= W - u.width, f *= i ? 1 : -1;
    }
  }
  var A = Object.assign({
    position: s
  }, l && g1), E = d === !0 ? b1({
    x: f,
    y: D
  }, st(e)) : {
    x: f,
    y: D
  };
  if (f = E.x, D = E.y, i) {
    var S;
    return Object.assign({}, A, (S = {}, S[q] = M ? "0" : "", S[L] = O ? "0" : "", S.transform = (z.devicePixelRatio || 1) <= 1 ? "translate(" + f + "px, " + D + "px)" : "translate3d(" + f + "px, " + D + "px, 0)", S));
  }
  return Object.assign({}, A, (t = {}, t[q] = M ? D + "px" : "", t[L] = O ? f + "px" : "", t.transform = "", t));
}
function y1(r) {
  var t = r.state, e = r.options, u = e.gpuAcceleration, n = u === void 0 ? !0 : u, a = e.adaptive, o = a === void 0 ? !0 : a, s = e.roundOffsets, i = s === void 0 ? !0 : s, l = {
    placement: At(t.placement),
    variation: kr(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: n,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Ii(Object.assign({}, l, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: i
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Ii(Object.assign({}, l, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: i
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const _1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: y1,
  data: {}
};
var Pu = {
  passive: !0
};
function w1(r) {
  var t = r.state, e = r.instance, u = r.options, n = u.scroll, a = n === void 0 ? !0 : n, o = u.resize, s = o === void 0 ? !0 : o, i = st(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && l.forEach(function(d) {
    d.addEventListener("scroll", e.update, Pu);
  }), s && i.addEventListener("resize", e.update, Pu), function() {
    a && l.forEach(function(d) {
      d.removeEventListener("scroll", e.update, Pu);
    }), s && i.removeEventListener("resize", e.update, Pu);
  };
}
const C1 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: w1,
  data: {}
};
var D1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function en(r) {
  return r.replace(/left|right|bottom|top/g, function(t) {
    return D1[t];
  });
}
var A1 = {
  start: "end",
  end: "start"
};
function Ni(r) {
  return r.replace(/start|end/g, function(t) {
    return A1[t];
  });
}
function Ya(r) {
  var t = st(r), e = t.pageXOffset, u = t.pageYOffset;
  return {
    scrollLeft: e,
    scrollTop: u
  };
}
function Za(r) {
  return Er(Kt(r)).left + Ya(r).scrollLeft;
}
function x1(r, t) {
  var e = st(r), u = Kt(r), n = e.visualViewport, a = u.clientWidth, o = u.clientHeight, s = 0, i = 0;
  if (n) {
    a = n.width, o = n.height;
    var l = Os();
    (l || !l && t === "fixed") && (s = n.offsetLeft, i = n.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s + Za(r),
    y: i
  };
}
function E1(r) {
  var t, e = Kt(r), u = Ya(r), n = (t = r.ownerDocument) == null ? void 0 : t.body, a = rr(e.scrollWidth, e.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), o = rr(e.scrollHeight, e.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), s = -u.scrollLeft + Za(r), i = -u.scrollTop;
  return Vt(n || e).direction === "rtl" && (s += rr(e.clientWidth, n ? n.clientWidth : 0) - a), {
    width: a,
    height: o,
    x: s,
    y: i
  };
}
function Ka(r) {
  var t = Vt(r), e = t.overflow, u = t.overflowX, n = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(e + n + u);
}
function qs(r) {
  return ["html", "body", "#document"].indexOf(Et(r)) >= 0 ? r.ownerDocument.body : pt(r) && Ka(r) ? r : qs(An(r));
}
function eu(r, t) {
  var e;
  t === void 0 && (t = []);
  var u = qs(r), n = u === ((e = r.ownerDocument) == null ? void 0 : e.body), a = st(u), o = n ? [a].concat(a.visualViewport || [], Ka(u) ? u : []) : u, s = t.concat(o);
  return n ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(eu(An(o)))
  );
}
function da(r) {
  return Object.assign({}, r, {
    left: r.x,
    top: r.y,
    right: r.x + r.width,
    bottom: r.y + r.height
  });
}
function k1(r, t) {
  var e = Er(r, !1, t === "fixed");
  return e.top = e.top + r.clientTop, e.left = e.left + r.clientLeft, e.bottom = e.top + r.clientHeight, e.right = e.left + r.clientWidth, e.width = r.clientWidth, e.height = r.clientHeight, e.x = e.left, e.y = e.top, e;
}
function qi(r, t, e) {
  return t === $s ? da(x1(r, e)) : ar(t) ? k1(t, e) : da(E1(Kt(r)));
}
function S1(r) {
  var t = eu(An(r)), e = ["absolute", "fixed"].indexOf(Vt(r).position) >= 0, u = e && pt(r) ? Au(r) : r;
  return ar(u) ? t.filter(function(n) {
    return ar(n) && Ls(n, u) && Et(n) !== "body";
  }) : [];
}
function T1(r, t, e, u) {
  var n = t === "clippingParents" ? S1(r) : [].concat(t), a = [].concat(n, [e]), o = a[0], s = a.reduce(function(i, l) {
    var d = qi(r, l, u);
    return i.top = rr(d.top, i.top), i.right = cn(d.right, i.right), i.bottom = cn(d.bottom, i.bottom), i.left = rr(d.left, i.left), i;
  }, qi(r, o, u));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Ps(r) {
  var t = r.reference, e = r.element, u = r.placement, n = u ? At(u) : null, a = u ? kr(u) : null, o = t.x + t.width / 2 - e.width / 2, s = t.y + t.height / 2 - e.height / 2, i;
  switch (n) {
    case Je:
      i = {
        x: o,
        y: t.y - e.height
      };
      break;
    case gt:
      i = {
        x: o,
        y: t.y + t.height
      };
      break;
    case bt:
      i = {
        x: t.x + t.width,
        y: s
      };
      break;
    case Qe:
      i = {
        x: t.x - e.width,
        y: s
      };
      break;
    default:
      i = {
        x: t.x,
        y: t.y
      };
  }
  var l = n ? Wa(n) : null;
  if (l != null) {
    var d = l === "y" ? "height" : "width";
    switch (a) {
      case Ar:
        i[l] = i[l] - (t[d] / 2 - e[d] / 2);
        break;
      case ou:
        i[l] = i[l] + (t[d] / 2 - e[d] / 2);
        break;
    }
  }
  return i;
}
function su(r, t) {
  t === void 0 && (t = {});
  var e = t, u = e.placement, n = u === void 0 ? r.placement : u, a = e.strategy, o = a === void 0 ? r.strategy : a, s = e.boundary, i = s === void 0 ? Z0 : s, l = e.rootBoundary, d = l === void 0 ? $s : l, h = e.elementContext, c = h === void 0 ? Gr : h, f = e.altBoundary, g = f === void 0 ? !1 : f, D = e.padding, _ = D === void 0 ? 0 : D, O = Is(typeof _ != "number" ? _ : Ns(_, Du)), M = c === Gr ? K0 : Gr, L = r.rects.popper, q = r.elements[g ? M : c], z = T1(ar(q) ? q : q.contextElement || Kt(r.elements.popper), i, d, o), X = Er(r.elements.reference), ee = Ps({
    reference: X,
    element: L,
    strategy: "absolute",
    placement: n
  }), V = da(Object.assign({}, L, ee)), oe = c === Gr ? V : X, W = {
    top: z.top - oe.top + O.top,
    bottom: oe.bottom - z.bottom + O.bottom,
    left: z.left - oe.left + O.left,
    right: oe.right - z.right + O.right
  }, A = r.modifiersData.offset;
  if (c === Gr && A) {
    var E = A[n];
    Object.keys(W).forEach(function(S) {
      var $ = [bt, gt].indexOf(S) >= 0 ? 1 : -1, w = [Je, gt].indexOf(S) >= 0 ? "y" : "x";
      W[S] += E[w] * $;
    });
  }
  return W;
}
function B1(r, t) {
  t === void 0 && (t = {});
  var e = t, u = e.placement, n = e.boundary, a = e.rootBoundary, o = e.padding, s = e.flipVariations, i = e.allowedAutoPlacements, l = i === void 0 ? Ms : i, d = kr(u), h = d ? s ? Li : Li.filter(function(g) {
    return kr(g) === d;
  }) : Du, c = h.filter(function(g) {
    return l.indexOf(g) >= 0;
  });
  c.length === 0 && (c = h);
  var f = c.reduce(function(g, D) {
    return g[D] = su(r, {
      placement: D,
      boundary: n,
      rootBoundary: a,
      padding: o
    })[At(D)], g;
  }, {});
  return Object.keys(f).sort(function(g, D) {
    return f[g] - f[D];
  });
}
function $1(r) {
  if (At(r) === Ua)
    return [];
  var t = en(r);
  return [Ni(r), t, Ni(t)];
}
function M1(r) {
  var t = r.state, e = r.options, u = r.name;
  if (!t.modifiersData[u]._skip) {
    for (var n = e.mainAxis, a = n === void 0 ? !0 : n, o = e.altAxis, s = o === void 0 ? !0 : o, i = e.fallbackPlacements, l = e.padding, d = e.boundary, h = e.rootBoundary, c = e.altBoundary, f = e.flipVariations, g = f === void 0 ? !0 : f, D = e.allowedAutoPlacements, _ = t.options.placement, O = At(_), M = O === _, L = i || (M || !g ? [en(_)] : $1(_)), q = [_].concat(L).reduce(function(se, ae) {
      return se.concat(At(ae) === Ua ? B1(t, {
        placement: ae,
        boundary: d,
        rootBoundary: h,
        padding: l,
        flipVariations: g,
        allowedAutoPlacements: D
      }) : ae);
    }, []), z = t.rects.reference, X = t.rects.popper, ee = /* @__PURE__ */ new Map(), V = !0, oe = q[0], W = 0; W < q.length; W++) {
      var A = q[W], E = At(A), S = kr(A) === Ar, $ = [Je, gt].indexOf(E) >= 0, w = $ ? "width" : "height", k = su(t, {
        placement: A,
        boundary: d,
        rootBoundary: h,
        altBoundary: c,
        padding: l
      }), T = $ ? S ? bt : Qe : S ? gt : Je;
      z[w] > X[w] && (T = en(T));
      var F = en(T), I = [];
      if (a && I.push(k[E] <= 0), s && I.push(k[T] <= 0, k[F] <= 0), I.every(function(se) {
        return se;
      })) {
        oe = A, V = !1;
        break;
      }
      ee.set(A, I);
    }
    if (V)
      for (var P = g ? 3 : 1, Y = function(ae) {
        var De = q.find(function(he) {
          var ye = ee.get(he);
          if (ye)
            return ye.slice(0, ae).every(function($e) {
              return $e;
            });
        });
        if (De)
          return oe = De, "break";
      }, te = P; te > 0; te--) {
        var we = Y(te);
        if (we === "break")
          break;
      }
    t.placement !== oe && (t.modifiersData[u]._skip = !0, t.placement = oe, t.reset = !0);
  }
}
const O1 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: M1,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Pi(r, t, e) {
  return e === void 0 && (e = {
    x: 0,
    y: 0
  }), {
    top: r.top - t.height - e.y,
    right: r.right - t.width + e.x,
    bottom: r.bottom - t.height + e.y,
    left: r.left - t.width - e.x
  };
}
function Ri(r) {
  return [Je, bt, gt, Qe].some(function(t) {
    return r[t] >= 0;
  });
}
function L1(r) {
  var t = r.state, e = r.name, u = t.rects.reference, n = t.rects.popper, a = t.modifiersData.preventOverflow, o = su(t, {
    elementContext: "reference"
  }), s = su(t, {
    altBoundary: !0
  }), i = Pi(o, u), l = Pi(s, n, a), d = Ri(i), h = Ri(l);
  t.modifiersData[e] = {
    referenceClippingOffsets: i,
    popperEscapeOffsets: l,
    isReferenceHidden: d,
    hasPopperEscaped: h
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": h
  });
}
const F1 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: L1
};
function I1(r, t, e) {
  var u = At(r), n = [Qe, Je].indexOf(u) >= 0 ? -1 : 1, a = typeof e == "function" ? e(Object.assign({}, t, {
    placement: r
  })) : e, o = a[0], s = a[1];
  return o = o || 0, s = (s || 0) * n, [Qe, bt].indexOf(u) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function N1(r) {
  var t = r.state, e = r.options, u = r.name, n = e.offset, a = n === void 0 ? [0, 0] : n, o = Ms.reduce(function(d, h) {
    return d[h] = I1(h, t.rects, a), d;
  }, {}), s = o[t.placement], i = s.x, l = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += i, t.modifiersData.popperOffsets.y += l), t.modifiersData[u] = o;
}
const q1 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: N1
};
function P1(r) {
  var t = r.state, e = r.name;
  t.modifiersData[e] = Ps({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const R1 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: P1,
  data: {}
};
function V1(r) {
  return r === "x" ? "y" : "x";
}
function j1(r) {
  var t = r.state, e = r.options, u = r.name, n = e.mainAxis, a = n === void 0 ? !0 : n, o = e.altAxis, s = o === void 0 ? !1 : o, i = e.boundary, l = e.rootBoundary, d = e.altBoundary, h = e.padding, c = e.tether, f = c === void 0 ? !0 : c, g = e.tetherOffset, D = g === void 0 ? 0 : g, _ = su(t, {
    boundary: i,
    rootBoundary: l,
    padding: h,
    altBoundary: d
  }), O = At(t.placement), M = kr(t.placement), L = !M, q = Wa(O), z = V1(q), X = t.modifiersData.popperOffsets, ee = t.rects.reference, V = t.rects.popper, oe = typeof D == "function" ? D(Object.assign({}, t.rects, {
    placement: t.placement
  })) : D, W = typeof oe == "number" ? {
    mainAxis: oe,
    altAxis: oe
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, oe), A = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, E = {
    x: 0,
    y: 0
  };
  if (X) {
    if (a) {
      var S, $ = q === "y" ? Je : Qe, w = q === "y" ? gt : bt, k = q === "y" ? "height" : "width", T = X[q], F = T + _[$], I = T - _[w], P = f ? -V[k] / 2 : 0, Y = M === Ar ? ee[k] : V[k], te = M === Ar ? -V[k] : -ee[k], we = t.elements.arrow, se = f && we ? Ga(we) : {
        width: 0,
        height: 0
      }, ae = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Fs(), De = ae[$], he = ae[w], ye = Qr(0, ee[k], se[k]), $e = L ? ee[k] / 2 - P - ye - De - W.mainAxis : Y - ye - De - W.mainAxis, Me = L ? -ee[k] / 2 + P + ye + he + W.mainAxis : te + ye + he + W.mainAxis, Ie = t.elements.arrow && Au(t.elements.arrow), je = Ie ? q === "y" ? Ie.clientTop || 0 : Ie.clientLeft || 0 : 0, dt = (S = A == null ? void 0 : A[q]) != null ? S : 0, pr = T + $e - dt - je, $t = T + Me - dt, Mt = Qr(f ? cn(F, pr) : F, T, f ? rr(I, $t) : I);
      X[q] = Mt, E[q] = Mt - T;
    }
    if (s) {
      var jr, Fu = q === "x" ? Je : Qe, hr = q === "x" ? gt : bt, Ot = X[z], mr = z === "y" ? "height" : "width", Hr = Ot + _[Fu], vr = Ot - _[hr], gr = [Je, Qe].indexOf(O) !== -1, Jt = (jr = A == null ? void 0 : A[z]) != null ? jr : 0, Iu = gr ? Hr : Ot - ee[mr] - V[mr] - Jt + W.altAxis, Ur = gr ? Ot + ee[mr] + V[mr] - Jt - W.altAxis : vr, Nu = f && gr ? f1(Iu, Ot, Ur) : Qr(f ? Iu : Hr, Ot, f ? Ur : vr);
      X[z] = Nu, E[z] = Nu - Ot;
    }
    t.modifiersData[u] = E;
  }
}
const St = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: j1,
  requiresIfExists: ["offset"]
};
function H1(r) {
  return {
    scrollLeft: r.scrollLeft,
    scrollTop: r.scrollTop
  };
}
function U1(r) {
  return r === st(r) || !pt(r) ? Ya(r) : H1(r);
}
function z1(r) {
  var t = r.getBoundingClientRect(), e = xr(t.width) / r.offsetWidth || 1, u = xr(t.height) / r.offsetHeight || 1;
  return e !== 1 || u !== 1;
}
function G1(r, t, e) {
  e === void 0 && (e = !1);
  var u = pt(t), n = pt(t) && z1(t), a = Kt(t), o = Er(r, n, e), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, i = {
    x: 0,
    y: 0
  };
  return (u || !u && !e) && ((Et(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Ka(a)) && (s = U1(t)), pt(t) ? (i = Er(t, !0), i.x += t.clientLeft, i.y += t.clientTop) : a && (i.x = Za(a))), {
    x: o.left + s.scrollLeft - i.x,
    y: o.top + s.scrollTop - i.y,
    width: o.width,
    height: o.height
  };
}
function W1(r) {
  var t = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Set(), u = [];
  r.forEach(function(a) {
    t.set(a.name, a);
  });
  function n(a) {
    e.add(a.name);
    var o = [].concat(a.requires || [], a.requiresIfExists || []);
    o.forEach(function(s) {
      if (!e.has(s)) {
        var i = t.get(s);
        i && n(i);
      }
    }), u.push(a);
  }
  return r.forEach(function(a) {
    e.has(a.name) || n(a);
  }), u;
}
function Y1(r) {
  var t = W1(r);
  return i1.reduce(function(e, u) {
    return e.concat(t.filter(function(n) {
      return n.phase === u;
    }));
  }, []);
}
function Z1(r) {
  var t;
  return function() {
    return t || (t = new Promise(function(e) {
      Promise.resolve().then(function() {
        t = void 0, e(r());
      });
    })), t;
  };
}
function K1(r) {
  var t = r.reduce(function(e, u) {
    var n = e[u.name];
    return e[u.name] = n ? Object.assign({}, n, u, {
      options: Object.assign({}, n.options, u.options),
      data: Object.assign({}, n.data, u.data)
    }) : u, e;
  }, {});
  return Object.keys(t).map(function(e) {
    return t[e];
  });
}
var Vi = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function ji() {
  for (var r = arguments.length, t = new Array(r), e = 0; e < r; e++)
    t[e] = arguments[e];
  return !t.some(function(u) {
    return !(u && typeof u.getBoundingClientRect == "function");
  });
}
function X1(r) {
  r === void 0 && (r = {});
  var t = r, e = t.defaultModifiers, u = e === void 0 ? [] : e, n = t.defaultOptions, a = n === void 0 ? Vi : n;
  return function(s, i, l) {
    l === void 0 && (l = a);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Vi, a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: i
      },
      attributes: {},
      styles: {}
    }, h = [], c = !1, f = {
      state: d,
      setOptions: function(O) {
        var M = typeof O == "function" ? O(d.options) : O;
        D(), d.options = Object.assign({}, a, d.options, M), d.scrollParents = {
          reference: ar(s) ? eu(s) : s.contextElement ? eu(s.contextElement) : [],
          popper: eu(i)
        };
        var L = Y1(K1([].concat(u, d.options.modifiers)));
        return d.orderedModifiers = L.filter(function(q) {
          return q.enabled;
        }), g(), f.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!c) {
          var O = d.elements, M = O.reference, L = O.popper;
          if (ji(M, L)) {
            d.rects = {
              reference: G1(M, Au(L), d.options.strategy === "fixed"),
              popper: Ga(L)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(W) {
              return d.modifiersData[W.name] = Object.assign({}, W.data);
            });
            for (var q = 0; q < d.orderedModifiers.length; q++) {
              if (d.reset === !0) {
                d.reset = !1, q = -1;
                continue;
              }
              var z = d.orderedModifiers[q], X = z.fn, ee = z.options, V = ee === void 0 ? {} : ee, oe = z.name;
              typeof X == "function" && (d = X({
                state: d,
                options: V,
                name: oe,
                instance: f
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Z1(function() {
        return new Promise(function(_) {
          f.forceUpdate(), _(d);
        });
      }),
      destroy: function() {
        D(), c = !0;
      }
    };
    if (!ji(s, i))
      return f;
    f.setOptions(l).then(function(_) {
      !c && l.onFirstUpdate && l.onFirstUpdate(_);
    });
    function g() {
      d.orderedModifiers.forEach(function(_) {
        var O = _.name, M = _.options, L = M === void 0 ? {} : M, q = _.effect;
        if (typeof q == "function") {
          var z = q({
            state: d,
            name: O,
            instance: f,
            options: L
          }), X = function() {
          };
          h.push(z || X);
        }
      });
    }
    function D() {
      h.forEach(function(_) {
        return _();
      }), h = [];
    }
    return f;
  };
}
var J1 = [C1, R1, _1, l1, q1, O1, St, v1, F1], Tt = /* @__PURE__ */ X1({
  defaultModifiers: J1
});
const Q1 = /^(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"[^\\"\r\n]+")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}|\[(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}\])$/i, ed = /* @__PURE__ */ ue({
  __name: "VShrinkText",
  props: {
    maxLength: { default: 50 },
    content: { default: "" },
    placement: { default: "auto" },
    autoShrink: { type: Boolean, default: !1 },
    hoverContent: { default: "" },
    tooltipClass: { default: null },
    tooltipMaxWidth: { default: "200px" },
    showEmailsAsLinks: { type: Boolean, default: !0 }
  },
  setup(r) {
    const t = r, e = tt(), u = be(), n = G(() => [
      u["v-shrink-text__tooltip"],
      ...t.autoShrink ? u["v-shrink-text__tooltip--auto-shrink"] : [],
      t.tooltipClass
    ].filter(Boolean)), a = new RegExp(/(https?:\/\/[^\s]+)/g), o = G(() => _.value ? {
      onmouseenter: q,
      onmouseleave: z
    } : {}), s = G(() => {
      var V;
      if (!t.autoShrink)
        return Ze("div", {
          class: [
            u["v-shrink-text__trigger"],
            {
              [u["v-shrink-text__trigger--auto-shrink"]]: t.autoShrink
            }
          ],
          ...o.value
        }, [O.value]);
      const ee = (V = String(O.value || "")) == null ? void 0 : V.split(a).map((oe) => a.test(String(oe)) ? Ze("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: oe
      }, [
        oe
      ]) : Q1.test(String(oe)) && t.showEmailsAsLinks ? Ze("a", {
        href: `mailto:${oe}`
      }, [
        oe
      ]) : oe);
      return Ze("div", {
        class: [
          u["v-shrink-text__trigger"],
          {
            [u["v-shrink-text__trigger--auto-shrink"]]: t.autoShrink
          }
        ],
        ...o.value
      }, [ee]);
    }), i = G(() => {
      const ee = String(t.hoverContent || t.content).split(a);
      return () => Ze("div", {
        class: n.value,
        ...o.value
      }, ee.map((V) => a.test(V) ? Ze("a", {
        href: V,
        target: "_blank",
        rel: "noopener noreferrer"
      }, [V]) : V));
    }), l = Q(null), d = Q(), h = Q();
    let c = () => {
    };
    const f = Q(!1), g = () => {
      window.requestAnimationFrame(() => {
        var ee, V;
        f.value = (((ee = d.value) == null ? void 0 : ee.offsetWidth) || 0) < (((V = d.value) == null ? void 0 : V.scrollWidth) || 0);
      });
    }, D = Es(g, 200);
    wu(() => {
      t.autoShrink && (g(), c = Ha(document.body, D).stop);
    });
    const _ = G(() => t.hoverContent && t.hoverContent !== t.content ? !0 : t.autoShrink ? f.value : String(t.content || "").length > t.maxLength), O = G(() => t.autoShrink || !_.value || t.hoverContent ? t.content : String(t.content || "").slice(0, t.maxLength).trim() + "..."), M = Q(!1);
    let L = null;
    const q = () => {
      L && clearTimeout(L), M.value = !0;
    }, z = () => {
      L && clearTimeout(L), L = window.setTimeout(() => {
        M.value = !1;
      }, 200);
    }, X = () => {
      var ee;
      l.value && ((ee = l.value) == null || ee.destroy(), l.value = null), h.value && document.body.removeChild(h.value);
    };
    return qe(() => M.value, async (ee) => {
      await Pe(), ee && d.value && h.value ? (l.value = Tt(d.value, h.value, {
        placement: t.placement,
        modifiers: [
          St,
          {
            name: "offset",
            options: {
              offset: [0, 4]
            }
          }
        ]
      }), document.body.appendChild(h.value)) : !ee && l.value && X();
    }), Yt(() => {
      c == null || c(), X();
    }), (ee, V) => (m(), x("div", {
      class: b([
        p(u)["v-shrink-text"],
        {
          [p(u)["v-shrink-text--with-icon"]]: p(e).icon
        }
      ])
    }, [
      j(p(s), {
        ref_key: "trigger",
        ref: d
      }, null, 512),
      M.value ? (m(), H(He(i.value), {
        key: 0,
        ref_key: "tooltip",
        ref: h,
        class: b(n.value),
        style: ht({
          maxWidth: t.tooltipMaxWidth
        })
      }, null, 8, ["class", "style"])) : R("", !0),
      K(ee.$slots, "icon")
    ], 2));
  }
}), td = {
  "v-shrink-text": "_v-shrink-text_1i4rh_1",
  "v-shrink-text--with-icon": "_v-shrink-text--with-icon_1i4rh_5",
  "v-shrink-text__tooltip": "_v-shrink-text__tooltip_1i4rh_11",
  "v-shrink-text__trigger": "_v-shrink-text__trigger_1i4rh_35",
  "v-shrink-text__trigger--auto-shrink": "_v-shrink-text__trigger--auto-shrink_1i4rh_40",
  "v-shrink-text__tooltip--auto-shrink": "_v-shrink-text__tooltip--auto-shrink_1i4rh_52"
}, rd = {
  $style: td
}, yt = /* @__PURE__ */ U(ed, [["__cssModules", rd]]), ud = /* @__PURE__ */ ue({
  __name: "VNavItem",
  props: {
    collapsed: { type: Boolean },
    icon: { default: null },
    title: { default: "" },
    to: { default: "" },
    action: {},
    active: { type: Boolean },
    subRoutes: { default: () => [] },
    openOnClick: { type: Boolean, default: !1 },
    type: { default: "" }
  },
  setup(r) {
    const t = r, e = Q(!1), u = G(() => {
      var s;
      return !!((s = t.subRoutes) != null && s.length);
    }), n = G(() => t.to ? "RouterLink" : "div"), a = () => {
      t.action && t.action();
    }, o = be();
    return (s, i) => {
      var d;
      const l = Va("RouterLink");
      return m(), H(He(n.value), {
        class: b([
          p(o)["v-nav-item"],
          {
            [p(o)["v-nav-item--active"]]: s.active,
            [p(o)["v-nav-item--collapsed"]]: s.collapsed,
            [p(o)["v-nav-item--open-on-click"]]: s.openOnClick && ((d = s.subRoutes) == null ? void 0 : d.length)
          }
        ]),
        to: s.to,
        onClick: i[4] || (i[4] = ot((h) => a(), ["self"]))
      }, {
        default: J(() => {
          var h;
          return [
            (m(), H(He(s.icon || "div"), {
              class: b([
                p(o)["v-nav-item__icon"],
                {
                  [p(o)["v-nav-item--danger"]]: s.type === "danger"
                }
              ]),
              onClick: i[0] || (i[0] = ot((c) => a(), ["self"]))
            }, null, 8, ["class"])),
            s.collapsed ? R("", !0) : (m(), H(p(yt), {
              key: 0,
              "max-length": 20,
              content: s.title,
              class: b(s.type === "danger" ? p(o)["v-nav-item--danger"] : ""),
              onClick: i[1] || (i[1] = (c) => a())
            }, null, 8, ["content", "class"])),
            s.openOnClick && ((h = s.subRoutes) != null && h.length) ? (m(), x("div", {
              key: 1,
              class: b([
                p(o)["v-nav-item__toggle"],
                {
                  [p(o)["v-nav-item__toggle--open"]]: e.value
                }
              ]),
              onClick: i[2] || (i[2] = ot((c) => e.value = !e.value, ["prevent"]))
            }, [
              j(kt)
            ], 2)) : R("", !0),
            s.collapsed ? (m(), x("div", {
              key: 2,
              class: b([
                p(o)["v-nav-item__collapsed-tooltip"],
                {
                  [p(o)["v-nav-item__collapsed-tooltip--active"]]: s.active,
                  [p(o)["v-nav-item__collapsed-tooltip--with-sub-routes"]]: u.value
                }
              ]),
              onClick: i[3] || (i[3] = ot((c) => a(), ["self"]))
            }, ne(s.title), 3)) : R("", !0),
            u.value ? (m(), x("div", {
              key: 3,
              class: b([
                p(o)["v-nav-item__sub-routes"],
                {
                  [p(o)["v-nav-item__sub-routes--append-left"]]: s.openOnClick,
                  [p(o)["v-nav-item__sub-routes--visible"]]: e.value
                }
              ])
            }, [
              C("div", {
                class: b([
                  p(o)["v-nav-item__sub-routes-wrapper"],
                  {
                    [p(o)["v-nav-item__sub-routes-wrapper--collapsed"]]: s.collapsed
                  }
                ])
              }, [
                (m(!0), x(pe, null, ge(s.subRoutes, (c, f) => (m(), H(l, {
                  key: f,
                  to: c.to || "",
                  class: b([
                    p(o)["v-nav-item__sub-route"],
                    {
                      [p(o)["v-nav-item__sub-route--active"]]: c.active
                    }
                  ])
                }, {
                  default: J(() => [
                    ce(ne(c.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "class"]))), 128))
              ], 2)
            ], 2)) : R("", !0)
          ];
        }),
        _: 1
      }, 8, ["class", "to"]);
    };
  }
}), nd = {
  "v-nav-item": "_v-nav-item_grvbj_1",
  "v-nav-item--active": "_v-nav-item--active_grvbj_18",
  "v-nav-item__sub-routes--append-left": "_v-nav-item__sub-routes--append-left_grvbj_25",
  "v-nav-item__sub-routes": "_v-nav-item__sub-routes_grvbj_25",
  "v-nav-item--danger": "_v-nav-item--danger_grvbj_28",
  "v-nav-item--collapsed": "_v-nav-item--collapsed_grvbj_35",
  "v-nav-item__collapsed-tooltip": "_v-nav-item__collapsed-tooltip_grvbj_38",
  "v-nav-item__collapsed-tooltip--active": "_v-nav-item__collapsed-tooltip--active_grvbj_38",
  "v-nav-item__toggle": "_v-nav-item__toggle_grvbj_65",
  "v-nav-item__toggle--open": "_v-nav-item__toggle--open_grvbj_81",
  "v-nav-item__icon": "_v-nav-item__icon_grvbj_85",
  "v-nav-item__sub-routes-wrapper": "_v-nav-item__sub-routes-wrapper_grvbj_110",
  "v-nav-item__sub-route": "_v-nav-item__sub-route_grvbj_25",
  "v-nav-item__sub-routes--visible": "_v-nav-item__sub-routes--visible_grvbj_117",
  "v-nav-item__collapsed-tooltip--with-sub-routes": "_v-nav-item__collapsed-tooltip--with-sub-routes_grvbj_147",
  "v-nav-item__sub-route--active": "_v-nav-item__sub-route--active_grvbj_177",
  "v-nav-item__sub-routes-wrapper--collapsed": "_v-nav-item__sub-routes-wrapper--collapsed_grvbj_218"
}, ad = {
  $style: nd
}, Rs = /* @__PURE__ */ U(ud, [["__cssModules", ad]]), id = ["src"], od = /* @__PURE__ */ ue({
  __name: "VSidebar",
  props: {
    collapsed: { type: Boolean, default: !1 },
    logoImage: { default: "" },
    routesGroups: { default: () => [] }
  },
  emits: ["update:collapsed", "click:logo"],
  setup(r, { emit: t }) {
    const e = t;
    return (u, n) => (m(), x("aside", {
      class: b([
        u.$style["v-sidebar"],
        {
          [u.$style["v-sidebar--collapsed"]]: u.collapsed
        }
      ])
    }, [
      C("div", {
        class: b([
          u.$style["v-sidebar__toggle"],
          { [u.$style["v-sidebar__toggle--collapsed"]]: u.collapsed }
        ]),
        onClick: n[0] || (n[0] = (a) => e("update:collapsed", !u.collapsed))
      }, [
        j(kt)
      ], 2),
      C("div", {
        class: b(u.$style["v-sidebar__logo-wrapper"]),
        onClick: n[1] || (n[1] = (a) => e("click:logo"))
      }, [
        C("img", {
          src: u.logoImage,
          alt: "Logo"
        }, null, 8, id)
      ], 2),
      C("div", {
        class: b(u.$style["v-sidebar__routes-wrapper"])
      }, [
        (m(!0), x(pe, null, ge(u.routesGroups, (a, o) => (m(), x("div", {
          key: o,
          class: b(u.$style["v-sidebar__routes-groups"])
        }, [
          C("nav", {
            class: b(u.$style["v-sidebar__routes-group"])
          }, [
            C("div", {
              class: b(u.$style["v-sidebar__routes-group-wrapper"])
            }, [
              (m(!0), x(pe, null, ge(a, (s, i) => (m(), H(p(Rs), {
                key: i,
                collapsed: u.collapsed,
                to: s.to,
                title: s.title,
                icon: s.icon,
                active: s.active,
                action: s.action,
                "sub-routes": s.subRoutes,
                type: s.type
              }, null, 8, ["collapsed", "to", "title", "icon", "active", "action", "sub-routes", "type"]))), 128))
            ], 2)
          ], 2)
        ], 2))), 128))
      ], 2)
    ], 2));
  }
}), sd = {
  "v-sidebar": "_v-sidebar_18ja0_1",
  "v-sidebar__toggle": "_v-sidebar__toggle_18ja0_16",
  "v-sidebar--collapsed": "_v-sidebar--collapsed_18ja0_20",
  "v-sidebar__logo-wrapper": "_v-sidebar__logo-wrapper_18ja0_23",
  "v-sidebar__routes-wrapper": "_v-sidebar__routes-wrapper_18ja0_42",
  "v-sidebar__routes-groups": "_v-sidebar__routes-groups_18ja0_48",
  "v-sidebar__routes-group": "_v-sidebar__routes-group_18ja0_48",
  "v-sidebar__toggle--collapsed": "_v-sidebar__toggle--collapsed_18ja0_90"
}, ld = {
  $style: sd
}, bx = /* @__PURE__ */ U(od, [["__cssModules", ld]]), cd = {}, dd = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function fd(r, t) {
  return m(), x("svg", dd, t[0] || (t[0] = [
    C("rect", {
      width: "24",
      height: "24",
      rx: "12",
      fill: "#FEF0C7"
    }, null, -1),
    C("path", {
      d: "M12.0059 8.66536V10.9987M12.0059 13.332H12",
      stroke: "#DC6803",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      d: "M11.567 5.75C11.7594 5.41667 12.2406 5.41667 12.433 5.75L17.6292 14.75C17.8216 15.0833 17.5811 15.5 17.1962 15.5H6.80385C6.41895 15.5 6.17838 15.0833 6.37084 14.75L11.567 5.75Z",
      stroke: "#DC6803"
    }, null, -1)
  ]));
}
const pd = /* @__PURE__ */ U(cd, [["render", fd]]), hd = {}, md = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function vd(r, t) {
  return m(), x("svg", md, t[0] || (t[0] = [
    C("path", {
      d: "M8.53553 1.53553L1.46447 8.6066M1.46447 1.53553L8.53553 8.6066",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Wt = /* @__PURE__ */ U(hd, [["render", vd]]);
var xu = /* @__PURE__ */ ((r) => (r.SMALL = "small", r.X_SMALL = "x-small", r.MEDIUM = "medium", r.LARGE = "large", r))(xu || {}), Gt = /* @__PURE__ */ ((r) => (r.EXTRA_SMALL = "extra-small", r.SMALL = "small", r.MEDIUM = "medium", r.MEDIUM_SMALL = "medium-small", r.LARGE = "large", r))(Gt || {}), Vs = /* @__PURE__ */ ((r) => (r.LEFT = "left", r.RIGHT = "right", r))(Vs || {}), js = /* @__PURE__ */ ((r) => (r.MEDIUM = "medium", r.LARGE = "large", r))(js || {}), lu = /* @__PURE__ */ ((r) => (r.PRIMARY = "primary", r.SECONDARY = "secondary", r.STATUS = "status", r))(lu || {}), gd = /* @__PURE__ */ ((r) => (r.LARGE = "large", r.MEDIUM = "medium", r))(gd || {});
const bd = /* @__PURE__ */ ue({
  __name: "VToast",
  props: {
    type: {},
    text: {},
    actionText: {},
    actionIcon: {}
  },
  emits: ["action:click", "close-toast"],
  setup(r, { emit: t }) {
    const e = t, u = be();
    return (n, a) => (m(), x("div", {
      class: b(p(u)["v-toast"])
    }, [
      j(pd),
      ce(" " + ne(n.text) + " ", 1),
      n.actionIcon || n.actionText ? (m(), H(p(vt), {
        key: 0,
        size: p(Pt).EXTRA_SMALL,
        onClick: a[0] || (a[0] = (o) => e("action:click"))
      }, mt({
        default: J(() => [
          ce(" " + ne(n.actionText), 1)
        ]),
        _: 2
      }, [
        n.actionIcon ? {
          name: "icon",
          fn: J(() => [
            (m(), H(He(n.actionIcon)))
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["size"])) : R("", !0),
      C("div", {
        class: b(p(u)["v-base-modal__close-icon"]),
        onClick: a[1] || (a[1] = (o) => e("close-toast"))
      }, [
        j(Wt)
      ], 2)
    ], 2));
  }
}), yd = {
  "v-toast": "_v-toast_9h80t_1",
  "v-base-modal__close-icon": "_v-base-modal__close-icon_9h80t_13"
}, _d = {
  $style: yd
}, yx = /* @__PURE__ */ U(bd, [["__cssModules", _d]]), wd = {}, Cd = {
  width: "14",
  height: "10",
  viewBox: "0 0 14 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Dd(r, t) {
  return m(), x("svg", Cd, t[0] || (t[0] = [
    C("path", {
      d: "M13 1L4.75 9L1 5.36364",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Eu = /* @__PURE__ */ U(wd, [["render", Dd]]), Ad = /* @__PURE__ */ ue({
  __name: "CheckboxComponent",
  props: {
    modelValue: { type: Boolean },
    label: { default: null },
    size: { default: xu.SMALL },
    disabled: { type: Boolean, default: !0 },
    rounded: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G({
      get() {
        return e.modelValue;
      },
      set(i) {
        e.disabled || u("update:modelValue", i);
      }
    }), a = () => {
      e.disabled || (n.value = !n.value);
    }, o = tt(), s = be();
    return (i, l) => (m(), x("div", {
      class: b([
        p(s)["v-checkbox"],
        {
          [p(s)["v-checkbox--with-label"]]: i.label || p(o).label
        }
      ])
    }, [
      C("div", {
        class: b([
          p(s)["v-checkbox--button"],
          p(s)[`v-checkbox--button-${i.size}`],
          {
            [p(s)["v-checkbox--button-checked"]]: n.value,
            [p(s)["v-checkbox--button--rounded"]]: i.rounded,
            [p(s)["v-checkbox--button--disabled"]]: i.disabled
          }
        ]),
        onClick: l[0] || (l[0] = (d) => a())
      }, [
        n.value ? (m(), H(Eu, {
          key: 0,
          class: b(p(s)["v-checkbox--button-checked-icon"])
        }, null, 8, ["class"])) : R("", !0)
      ], 2),
      i.label || p(o).label ? (m(), x("label", {
        key: 0,
        class: b([
          p(s)["v-checkbox--label"],
          {
            [p(s)["v-checkbox--label--disabled"]]: i.disabled
          }
        ]),
        onClick: l[1] || (l[1] = (d) => a())
      }, [
        K(i.$slots, "label", {}, () => [
          ce(ne(i.label), 1)
        ])
      ], 2)) : R("", !0)
    ], 2));
  }
}), xd = {
  "v-checkbox": "_v-checkbox_19u30_1",
  "v-checkbox--with-label": "_v-checkbox--with-label_19u30_14",
  "v-checkbox--button": "_v-checkbox--button_19u30_18",
  "v-checkbox--button--rounded": "_v-checkbox--button--rounded_19u30_36",
  "v-checkbox--label": "_v-checkbox--label_19u30_40",
  "v-checkbox--button--disabled": "_v-checkbox--button--disabled_19u30_44",
  "v-checkbox--label--disabled": "_v-checkbox--label--disabled_19u30_44",
  "v-checkbox--button-checked": "_v-checkbox--button-checked_19u30_52",
  "v-checkbox--button-checked-icon": "_v-checkbox--button-checked-icon_19u30_58",
  "v-checkbox--button-large": "_v-checkbox--button-large_19u30_62",
  "v-checkbox--button-medium": "_v-checkbox--button-medium_19u30_71",
  "v-checkbox--button-small": "_v-checkbox--button-small_19u30_80",
  "v-checkbox--button-x-small": "_v-checkbox--button-x-small_19u30_89"
}, Ed = {
  $style: xd
}, kd = /* @__PURE__ */ U(Ad, [["__cssModules", Ed]]), Sd = /* @__PURE__ */ ue({
  __name: "SwitchComponent",
  props: {
    modelValue: { type: Boolean },
    label: { default: null },
    size: { default: xu.SMALL },
    disabled: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G({
      get() {
        return e.modelValue;
      },
      set(i) {
        u("update:modelValue", i);
      }
    }), a = () => {
      e.disabled || (n.value = !n.value);
    }, o = tt(), s = be();
    return (i, l) => (m(), x("div", {
      class: b([
        p(s)["v-switch"],
        {
          [p(s)["v-switch--without-label"]]: !(i.label || p(o).label)
        }
      ])
    }, [
      C("div", {
        class: b([
          p(s)["v-switch__switch"],
          p(s)[`v-switch__switch--${i.size}`],
          {
            [p(s)["v-switch__switch--checked"]]: n.value,
            [p(s)["v-switch__switch--disabled"]]: i.disabled
          }
        ]),
        onClick: l[0] || (l[0] = (d) => a())
      }, [
        C("div", {
          class: b(p(s)["v-switch__switch-point"])
        }, null, 2)
      ], 2),
      i.label || p(o).label ? (m(), x("label", {
        key: 0,
        class: b([
          p(s)["v-switch__label"],
          {
            [p(s)["v-switch__label--disabled"]]: i.disabled
          }
        ]),
        onClick: l[1] || (l[1] = (d) => a())
      }, [
        K(i.$slots, "label", {}, () => [
          ce(ne(i.label), 1)
        ])
      ], 2)) : R("", !0)
    ], 2));
  }
}), Td = {
  "v-switch": "_v-switch_1ide0_1",
  "v-switch--without-label": "_v-switch--without-label_1ide0_14",
  "v-switch__switch": "_v-switch__switch_1ide0_18",
  "v-switch__switch--checked": "_v-switch__switch--checked_1ide0_26",
  "v-switch__switch-point": "_v-switch__switch-point_1ide0_26",
  "v-switch__switch--small": "_v-switch__switch--small_1ide0_37",
  "v-switch__switch--medium": "_v-switch__switch--medium_1ide0_59",
  "v-switch__switch--large": "_v-switch__switch--large_1ide0_75",
  "v-switch__label": "_v-switch__label_1ide0_91",
  "v-switch__switch--disabled": "_v-switch__switch--disabled_1ide0_95",
  "v-switch__label--disabled": "_v-switch__label--disabled_1ide0_95"
}, Bd = {
  $style: Td
}, $d = /* @__PURE__ */ U(Sd, [["__cssModules", Bd]]), Hs = /* @__PURE__ */ ue({
  __name: "VCheckbox",
  props: {
    value: { type: Boolean },
    label: { default: null },
    size: { default: xu.SMALL },
    disabled: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 },
    switch: { type: Boolean, default: !1 }
  },
  emits: ["update:value"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G({
      get() {
        return e.value;
      },
      set(o) {
        u("update:value", o);
      }
    }), a = tt();
    return (o, s) => e.switch ? (m(), H($d, {
      key: 0,
      modelValue: n.value,
      "onUpdate:modelValue": s[0] || (s[0] = (i) => n.value = i),
      label: o.label,
      disabled: o.disabled,
      size: o.size
    }, mt({ _: 2 }, [
      ge(p(a), (i, l) => ({
        name: l,
        fn: J((d) => [
          K(o.$slots, l, Le(Ne(d)))
        ])
      }))
    ]), 1032, ["modelValue", "label", "disabled", "size"])) : (m(), H(kd, {
      key: 1,
      modelValue: n.value,
      "onUpdate:modelValue": s[1] || (s[1] = (i) => n.value = i),
      label: o.label,
      disabled: o.disabled,
      rounded: o.rounded,
      size: o.size
    }, mt({ _: 2 }, [
      ge(p(a), (i, l) => ({
        name: l,
        fn: J((d) => [
          K(o.$slots, l, Le(Ne(d)))
        ])
      }))
    ]), 1032, ["modelValue", "label", "disabled", "rounded", "size"]));
  }
}), Md = {}, Od = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 17",
  fill: "none"
};
function Ld(r, t) {
  return m(), x("svg", Od, t[0] || (t[0] = [
    C("path", {
      d: "M8 11.3V8.5M8 5.7H8.007M15 8.5C15 4.63401 11.866 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5C11.866 15.5 15 12.366 15 8.5Z",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Fd = /* @__PURE__ */ U(Md, [["render", Ld]]);
var de = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function xn(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function Id(r) {
  if (r.__esModule)
    return r;
  var t = r.default;
  if (typeof t == "function") {
    var e = function u() {
      return this instanceof u ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    e.prototype = t.prototype;
  } else
    e = {};
  return Object.defineProperty(e, "__esModule", { value: !0 }), Object.keys(r).forEach(function(u) {
    var n = Object.getOwnPropertyDescriptor(r, u);
    Object.defineProperty(e, u, n.get ? n : {
      enumerable: !0,
      get: function() {
        return r[u];
      }
    });
  }), e;
}
var dn = { exports: {} };
/*! https://mths.be/he v1.2.0 by @mathias | MIT license */
dn.exports;
(function(r, t) {
  (function(e) {
    var u = t, n = r && r.exports == u && r, a = typeof de == "object" && de;
    (a.global === a || a.window === a) && (e = a);
    var o = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, s = /[\x01-\x7F]/g, i = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g, l = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g, d = { "­": "shy", "‌": "zwnj", "‍": "zwj", "‎": "lrm", "⁣": "ic", "⁢": "it", "⁡": "af", "‏": "rlm", "​": "ZeroWidthSpace", "⁠": "NoBreak", "̑": "DownBreve", "⃛": "tdot", "⃜": "DotDot", "	": "Tab", "\n": "NewLine", " ": "puncsp", " ": "MediumSpace", " ": "thinsp", " ": "hairsp", " ": "emsp13", " ": "ensp", " ": "emsp14", " ": "emsp", " ": "numsp", " ": "nbsp", "  ": "ThickSpace", "‾": "oline", _: "lowbar", "‐": "dash", "–": "ndash", "—": "mdash", "―": "horbar", ",": "comma", ";": "semi", "⁏": "bsemi", ":": "colon", "⩴": "Colone", "!": "excl", "¡": "iexcl", "?": "quest", "¿": "iquest", ".": "period", "‥": "nldr", "…": "mldr", "·": "middot", "'": "apos", "‘": "lsquo", "’": "rsquo", "‚": "sbquo", "‹": "lsaquo", "›": "rsaquo", '"': "quot", "“": "ldquo", "”": "rdquo", "„": "bdquo", "«": "laquo", "»": "raquo", "(": "lpar", ")": "rpar", "[": "lsqb", "]": "rsqb", "{": "lcub", "}": "rcub", "⌈": "lceil", "⌉": "rceil", "⌊": "lfloor", "⌋": "rfloor", "⦅": "lopar", "⦆": "ropar", "⦋": "lbrke", "⦌": "rbrke", "⦍": "lbrkslu", "⦎": "rbrksld", "⦏": "lbrksld", "⦐": "rbrkslu", "⦑": "langd", "⦒": "rangd", "⦓": "lparlt", "⦔": "rpargt", "⦕": "gtlPar", "⦖": "ltrPar", "⟦": "lobrk", "⟧": "robrk", "⟨": "lang", "⟩": "rang", "⟪": "Lang", "⟫": "Rang", "⟬": "loang", "⟭": "roang", "❲": "lbbrk", "❳": "rbbrk", "‖": "Vert", "§": "sect", "¶": "para", "@": "commat", "*": "ast", "/": "sol", undefined: null, "&": "amp", "#": "num", "%": "percnt", "‰": "permil", "‱": "pertenk", "†": "dagger", "‡": "Dagger", "•": "bull", "⁃": "hybull", "′": "prime", "″": "Prime", "‴": "tprime", "⁗": "qprime", "‵": "bprime", "⁁": "caret", "`": "grave", "´": "acute", "˜": "tilde", "^": "Hat", "¯": "macr", "˘": "breve", "˙": "dot", "¨": "die", "˚": "ring", "˝": "dblac", "¸": "cedil", "˛": "ogon", "ˆ": "circ", "ˇ": "caron", "°": "deg", "©": "copy", "®": "reg", "℗": "copysr", "℘": "wp", "℞": "rx", "℧": "mho", "℩": "iiota", "←": "larr", "↚": "nlarr", "→": "rarr", "↛": "nrarr", "↑": "uarr", "↓": "darr", "↔": "harr", "↮": "nharr", "↕": "varr", "↖": "nwarr", "↗": "nearr", "↘": "searr", "↙": "swarr", "↝": "rarrw", "↝̸": "nrarrw", "↞": "Larr", "↟": "Uarr", "↠": "Rarr", "↡": "Darr", "↢": "larrtl", "↣": "rarrtl", "↤": "mapstoleft", "↥": "mapstoup", "↦": "map", "↧": "mapstodown", "↩": "larrhk", "↪": "rarrhk", "↫": "larrlp", "↬": "rarrlp", "↭": "harrw", "↰": "lsh", "↱": "rsh", "↲": "ldsh", "↳": "rdsh", "↵": "crarr", "↶": "cularr", "↷": "curarr", "↺": "olarr", "↻": "orarr", "↼": "lharu", "↽": "lhard", "↾": "uharr", "↿": "uharl", "⇀": "rharu", "⇁": "rhard", "⇂": "dharr", "⇃": "dharl", "⇄": "rlarr", "⇅": "udarr", "⇆": "lrarr", "⇇": "llarr", "⇈": "uuarr", "⇉": "rrarr", "⇊": "ddarr", "⇋": "lrhar", "⇌": "rlhar", "⇐": "lArr", "⇍": "nlArr", "⇑": "uArr", "⇒": "rArr", "⇏": "nrArr", "⇓": "dArr", "⇔": "iff", "⇎": "nhArr", "⇕": "vArr", "⇖": "nwArr", "⇗": "neArr", "⇘": "seArr", "⇙": "swArr", "⇚": "lAarr", "⇛": "rAarr", "⇝": "zigrarr", "⇤": "larrb", "⇥": "rarrb", "⇵": "duarr", "⇽": "loarr", "⇾": "roarr", "⇿": "hoarr", "∀": "forall", "∁": "comp", "∂": "part", "∂̸": "npart", "∃": "exist", "∄": "nexist", "∅": "empty", "∇": "Del", "∈": "in", "∉": "notin", "∋": "ni", "∌": "notni", "϶": "bepsi", "∏": "prod", "∐": "coprod", "∑": "sum", "+": "plus", "±": "pm", "÷": "div", "×": "times", "<": "lt", "≮": "nlt", "<⃒": "nvlt", "=": "equals", "≠": "ne", "=⃥": "bne", "⩵": "Equal", ">": "gt", "≯": "ngt", ">⃒": "nvgt", "¬": "not", "|": "vert", "¦": "brvbar", "−": "minus", "∓": "mp", "∔": "plusdo", "⁄": "frasl", "∖": "setmn", "∗": "lowast", "∘": "compfn", "√": "Sqrt", "∝": "prop", "∞": "infin", "∟": "angrt", "∠": "ang", "∠⃒": "nang", "∡": "angmsd", "∢": "angsph", "∣": "mid", "∤": "nmid", "∥": "par", "∦": "npar", "∧": "and", "∨": "or", "∩": "cap", "∩︀": "caps", "∪": "cup", "∪︀": "cups", "∫": "int", "∬": "Int", "∭": "tint", "⨌": "qint", "∮": "oint", "∯": "Conint", "∰": "Cconint", "∱": "cwint", "∲": "cwconint", "∳": "awconint", "∴": "there4", "∵": "becaus", "∶": "ratio", "∷": "Colon", "∸": "minusd", "∺": "mDDot", "∻": "homtht", "∼": "sim", "≁": "nsim", "∼⃒": "nvsim", "∽": "bsim", "∽̱": "race", "∾": "ac", "∾̳": "acE", "∿": "acd", "≀": "wr", "≂": "esim", "≂̸": "nesim", "≃": "sime", "≄": "nsime", "≅": "cong", "≇": "ncong", "≆": "simne", "≈": "ap", "≉": "nap", "≊": "ape", "≋": "apid", "≋̸": "napid", "≌": "bcong", "≍": "CupCap", "≭": "NotCupCap", "≍⃒": "nvap", "≎": "bump", "≎̸": "nbump", "≏": "bumpe", "≏̸": "nbumpe", "≐": "doteq", "≐̸": "nedot", "≑": "eDot", "≒": "efDot", "≓": "erDot", "≔": "colone", "≕": "ecolon", "≖": "ecir", "≗": "cire", "≙": "wedgeq", "≚": "veeeq", "≜": "trie", "≟": "equest", "≡": "equiv", "≢": "nequiv", "≡⃥": "bnequiv", "≤": "le", "≰": "nle", "≤⃒": "nvle", "≥": "ge", "≱": "nge", "≥⃒": "nvge", "≦": "lE", "≦̸": "nlE", "≧": "gE", "≧̸": "ngE", "≨︀": "lvnE", "≨": "lnE", "≩": "gnE", "≩︀": "gvnE", "≪": "ll", "≪̸": "nLtv", "≪⃒": "nLt", "≫": "gg", "≫̸": "nGtv", "≫⃒": "nGt", "≬": "twixt", "≲": "lsim", "≴": "nlsim", "≳": "gsim", "≵": "ngsim", "≶": "lg", "≸": "ntlg", "≷": "gl", "≹": "ntgl", "≺": "pr", "⊀": "npr", "≻": "sc", "⊁": "nsc", "≼": "prcue", "⋠": "nprcue", "≽": "sccue", "⋡": "nsccue", "≾": "prsim", "≿": "scsim", "≿̸": "NotSucceedsTilde", "⊂": "sub", "⊄": "nsub", "⊂⃒": "vnsub", "⊃": "sup", "⊅": "nsup", "⊃⃒": "vnsup", "⊆": "sube", "⊈": "nsube", "⊇": "supe", "⊉": "nsupe", "⊊︀": "vsubne", "⊊": "subne", "⊋︀": "vsupne", "⊋": "supne", "⊍": "cupdot", "⊎": "uplus", "⊏": "sqsub", "⊏̸": "NotSquareSubset", "⊐": "sqsup", "⊐̸": "NotSquareSuperset", "⊑": "sqsube", "⋢": "nsqsube", "⊒": "sqsupe", "⋣": "nsqsupe", "⊓": "sqcap", "⊓︀": "sqcaps", "⊔": "sqcup", "⊔︀": "sqcups", "⊕": "oplus", "⊖": "ominus", "⊗": "otimes", "⊘": "osol", "⊙": "odot", "⊚": "ocir", "⊛": "oast", "⊝": "odash", "⊞": "plusb", "⊟": "minusb", "⊠": "timesb", "⊡": "sdotb", "⊢": "vdash", "⊬": "nvdash", "⊣": "dashv", "⊤": "top", "⊥": "bot", "⊧": "models", "⊨": "vDash", "⊭": "nvDash", "⊩": "Vdash", "⊮": "nVdash", "⊪": "Vvdash", "⊫": "VDash", "⊯": "nVDash", "⊰": "prurel", "⊲": "vltri", "⋪": "nltri", "⊳": "vrtri", "⋫": "nrtri", "⊴": "ltrie", "⋬": "nltrie", "⊴⃒": "nvltrie", "⊵": "rtrie", "⋭": "nrtrie", "⊵⃒": "nvrtrie", "⊶": "origof", "⊷": "imof", "⊸": "mumap", "⊹": "hercon", "⊺": "intcal", "⊻": "veebar", "⊽": "barvee", "⊾": "angrtvb", "⊿": "lrtri", "⋀": "Wedge", "⋁": "Vee", "⋂": "xcap", "⋃": "xcup", "⋄": "diam", "⋅": "sdot", "⋆": "Star", "⋇": "divonx", "⋈": "bowtie", "⋉": "ltimes", "⋊": "rtimes", "⋋": "lthree", "⋌": "rthree", "⋍": "bsime", "⋎": "cuvee", "⋏": "cuwed", "⋐": "Sub", "⋑": "Sup", "⋒": "Cap", "⋓": "Cup", "⋔": "fork", "⋕": "epar", "⋖": "ltdot", "⋗": "gtdot", "⋘": "Ll", "⋘̸": "nLl", "⋙": "Gg", "⋙̸": "nGg", "⋚︀": "lesg", "⋚": "leg", "⋛": "gel", "⋛︀": "gesl", "⋞": "cuepr", "⋟": "cuesc", "⋦": "lnsim", "⋧": "gnsim", "⋨": "prnsim", "⋩": "scnsim", "⋮": "vellip", "⋯": "ctdot", "⋰": "utdot", "⋱": "dtdot", "⋲": "disin", "⋳": "isinsv", "⋴": "isins", "⋵": "isindot", "⋵̸": "notindot", "⋶": "notinvc", "⋷": "notinvb", "⋹": "isinE", "⋹̸": "notinE", "⋺": "nisd", "⋻": "xnis", "⋼": "nis", "⋽": "notnivc", "⋾": "notnivb", "⌅": "barwed", "⌆": "Barwed", "⌌": "drcrop", "⌍": "dlcrop", "⌎": "urcrop", "⌏": "ulcrop", "⌐": "bnot", "⌒": "profline", "⌓": "profsurf", "⌕": "telrec", "⌖": "target", "⌜": "ulcorn", "⌝": "urcorn", "⌞": "dlcorn", "⌟": "drcorn", "⌢": "frown", "⌣": "smile", "⌭": "cylcty", "⌮": "profalar", "⌶": "topbot", "⌽": "ovbar", "⌿": "solbar", "⍼": "angzarr", "⎰": "lmoust", "⎱": "rmoust", "⎴": "tbrk", "⎵": "bbrk", "⎶": "bbrktbrk", "⏜": "OverParenthesis", "⏝": "UnderParenthesis", "⏞": "OverBrace", "⏟": "UnderBrace", "⏢": "trpezium", "⏧": "elinters", "␣": "blank", "─": "boxh", "│": "boxv", "┌": "boxdr", "┐": "boxdl", "└": "boxur", "┘": "boxul", "├": "boxvr", "┤": "boxvl", "┬": "boxhd", "┴": "boxhu", "┼": "boxvh", "═": "boxH", "║": "boxV", "╒": "boxdR", "╓": "boxDr", "╔": "boxDR", "╕": "boxdL", "╖": "boxDl", "╗": "boxDL", "╘": "boxuR", "╙": "boxUr", "╚": "boxUR", "╛": "boxuL", "╜": "boxUl", "╝": "boxUL", "╞": "boxvR", "╟": "boxVr", "╠": "boxVR", "╡": "boxvL", "╢": "boxVl", "╣": "boxVL", "╤": "boxHd", "╥": "boxhD", "╦": "boxHD", "╧": "boxHu", "╨": "boxhU", "╩": "boxHU", "╪": "boxvH", "╫": "boxVh", "╬": "boxVH", "▀": "uhblk", "▄": "lhblk", "█": "block", "░": "blk14", "▒": "blk12", "▓": "blk34", "□": "squ", "▪": "squf", "▫": "EmptyVerySmallSquare", "▭": "rect", "▮": "marker", "▱": "fltns", "△": "xutri", "▴": "utrif", "▵": "utri", "▸": "rtrif", "▹": "rtri", "▽": "xdtri", "▾": "dtrif", "▿": "dtri", "◂": "ltrif", "◃": "ltri", "◊": "loz", "○": "cir", "◬": "tridot", "◯": "xcirc", "◸": "ultri", "◹": "urtri", "◺": "lltri", "◻": "EmptySmallSquare", "◼": "FilledSmallSquare", "★": "starf", "☆": "star", "☎": "phone", "♀": "female", "♂": "male", "♠": "spades", "♣": "clubs", "♥": "hearts", "♦": "diams", "♪": "sung", "✓": "check", "✗": "cross", "✠": "malt", "✶": "sext", "❘": "VerticalSeparator", "⟈": "bsolhsub", "⟉": "suphsol", "⟵": "xlarr", "⟶": "xrarr", "⟷": "xharr", "⟸": "xlArr", "⟹": "xrArr", "⟺": "xhArr", "⟼": "xmap", "⟿": "dzigrarr", "⤂": "nvlArr", "⤃": "nvrArr", "⤄": "nvHarr", "⤅": "Map", "⤌": "lbarr", "⤍": "rbarr", "⤎": "lBarr", "⤏": "rBarr", "⤐": "RBarr", "⤑": "DDotrahd", "⤒": "UpArrowBar", "⤓": "DownArrowBar", "⤖": "Rarrtl", "⤙": "latail", "⤚": "ratail", "⤛": "lAtail", "⤜": "rAtail", "⤝": "larrfs", "⤞": "rarrfs", "⤟": "larrbfs", "⤠": "rarrbfs", "⤣": "nwarhk", "⤤": "nearhk", "⤥": "searhk", "⤦": "swarhk", "⤧": "nwnear", "⤨": "toea", "⤩": "tosa", "⤪": "swnwar", "⤳": "rarrc", "⤳̸": "nrarrc", "⤵": "cudarrr", "⤶": "ldca", "⤷": "rdca", "⤸": "cudarrl", "⤹": "larrpl", "⤼": "curarrm", "⤽": "cularrp", "⥅": "rarrpl", "⥈": "harrcir", "⥉": "Uarrocir", "⥊": "lurdshar", "⥋": "ldrushar", "⥎": "LeftRightVector", "⥏": "RightUpDownVector", "⥐": "DownLeftRightVector", "⥑": "LeftUpDownVector", "⥒": "LeftVectorBar", "⥓": "RightVectorBar", "⥔": "RightUpVectorBar", "⥕": "RightDownVectorBar", "⥖": "DownLeftVectorBar", "⥗": "DownRightVectorBar", "⥘": "LeftUpVectorBar", "⥙": "LeftDownVectorBar", "⥚": "LeftTeeVector", "⥛": "RightTeeVector", "⥜": "RightUpTeeVector", "⥝": "RightDownTeeVector", "⥞": "DownLeftTeeVector", "⥟": "DownRightTeeVector", "⥠": "LeftUpTeeVector", "⥡": "LeftDownTeeVector", "⥢": "lHar", "⥣": "uHar", "⥤": "rHar", "⥥": "dHar", "⥦": "luruhar", "⥧": "ldrdhar", "⥨": "ruluhar", "⥩": "rdldhar", "⥪": "lharul", "⥫": "llhard", "⥬": "rharul", "⥭": "lrhard", "⥮": "udhar", "⥯": "duhar", "⥰": "RoundImplies", "⥱": "erarr", "⥲": "simrarr", "⥳": "larrsim", "⥴": "rarrsim", "⥵": "rarrap", "⥶": "ltlarr", "⥸": "gtrarr", "⥹": "subrarr", "⥻": "suplarr", "⥼": "lfisht", "⥽": "rfisht", "⥾": "ufisht", "⥿": "dfisht", "⦚": "vzigzag", "⦜": "vangrt", "⦝": "angrtvbd", "⦤": "ange", "⦥": "range", "⦦": "dwangle", "⦧": "uwangle", "⦨": "angmsdaa", "⦩": "angmsdab", "⦪": "angmsdac", "⦫": "angmsdad", "⦬": "angmsdae", "⦭": "angmsdaf", "⦮": "angmsdag", "⦯": "angmsdah", "⦰": "bemptyv", "⦱": "demptyv", "⦲": "cemptyv", "⦳": "raemptyv", "⦴": "laemptyv", "⦵": "ohbar", "⦶": "omid", "⦷": "opar", "⦹": "operp", "⦻": "olcross", "⦼": "odsold", "⦾": "olcir", "⦿": "ofcir", "⧀": "olt", "⧁": "ogt", "⧂": "cirscir", "⧃": "cirE", "⧄": "solb", "⧅": "bsolb", "⧉": "boxbox", "⧍": "trisb", "⧎": "rtriltri", "⧏": "LeftTriangleBar", "⧏̸": "NotLeftTriangleBar", "⧐": "RightTriangleBar", "⧐̸": "NotRightTriangleBar", "⧜": "iinfin", "⧝": "infintie", "⧞": "nvinfin", "⧣": "eparsl", "⧤": "smeparsl", "⧥": "eqvparsl", "⧫": "lozf", "⧴": "RuleDelayed", "⧶": "dsol", "⨀": "xodot", "⨁": "xoplus", "⨂": "xotime", "⨄": "xuplus", "⨆": "xsqcup", "⨍": "fpartint", "⨐": "cirfnint", "⨑": "awint", "⨒": "rppolint", "⨓": "scpolint", "⨔": "npolint", "⨕": "pointint", "⨖": "quatint", "⨗": "intlarhk", "⨢": "pluscir", "⨣": "plusacir", "⨤": "simplus", "⨥": "plusdu", "⨦": "plussim", "⨧": "plustwo", "⨩": "mcomma", "⨪": "minusdu", "⨭": "loplus", "⨮": "roplus", "⨯": "Cross", "⨰": "timesd", "⨱": "timesbar", "⨳": "smashp", "⨴": "lotimes", "⨵": "rotimes", "⨶": "otimesas", "⨷": "Otimes", "⨸": "odiv", "⨹": "triplus", "⨺": "triminus", "⨻": "tritime", "⨼": "iprod", "⨿": "amalg", "⩀": "capdot", "⩂": "ncup", "⩃": "ncap", "⩄": "capand", "⩅": "cupor", "⩆": "cupcap", "⩇": "capcup", "⩈": "cupbrcap", "⩉": "capbrcup", "⩊": "cupcup", "⩋": "capcap", "⩌": "ccups", "⩍": "ccaps", "⩐": "ccupssm", "⩓": "And", "⩔": "Or", "⩕": "andand", "⩖": "oror", "⩗": "orslope", "⩘": "andslope", "⩚": "andv", "⩛": "orv", "⩜": "andd", "⩝": "ord", "⩟": "wedbar", "⩦": "sdote", "⩪": "simdot", "⩭": "congdot", "⩭̸": "ncongdot", "⩮": "easter", "⩯": "apacir", "⩰": "apE", "⩰̸": "napE", "⩱": "eplus", "⩲": "pluse", "⩳": "Esim", "⩷": "eDDot", "⩸": "equivDD", "⩹": "ltcir", "⩺": "gtcir", "⩻": "ltquest", "⩼": "gtquest", "⩽": "les", "⩽̸": "nles", "⩾": "ges", "⩾̸": "nges", "⩿": "lesdot", "⪀": "gesdot", "⪁": "lesdoto", "⪂": "gesdoto", "⪃": "lesdotor", "⪄": "gesdotol", "⪅": "lap", "⪆": "gap", "⪇": "lne", "⪈": "gne", "⪉": "lnap", "⪊": "gnap", "⪋": "lEg", "⪌": "gEl", "⪍": "lsime", "⪎": "gsime", "⪏": "lsimg", "⪐": "gsiml", "⪑": "lgE", "⪒": "glE", "⪓": "lesges", "⪔": "gesles", "⪕": "els", "⪖": "egs", "⪗": "elsdot", "⪘": "egsdot", "⪙": "el", "⪚": "eg", "⪝": "siml", "⪞": "simg", "⪟": "simlE", "⪠": "simgE", "⪡": "LessLess", "⪡̸": "NotNestedLessLess", "⪢": "GreaterGreater", "⪢̸": "NotNestedGreaterGreater", "⪤": "glj", "⪥": "gla", "⪦": "ltcc", "⪧": "gtcc", "⪨": "lescc", "⪩": "gescc", "⪪": "smt", "⪫": "lat", "⪬": "smte", "⪬︀": "smtes", "⪭": "late", "⪭︀": "lates", "⪮": "bumpE", "⪯": "pre", "⪯̸": "npre", "⪰": "sce", "⪰̸": "nsce", "⪳": "prE", "⪴": "scE", "⪵": "prnE", "⪶": "scnE", "⪷": "prap", "⪸": "scap", "⪹": "prnap", "⪺": "scnap", "⪻": "Pr", "⪼": "Sc", "⪽": "subdot", "⪾": "supdot", "⪿": "subplus", "⫀": "supplus", "⫁": "submult", "⫂": "supmult", "⫃": "subedot", "⫄": "supedot", "⫅": "subE", "⫅̸": "nsubE", "⫆": "supE", "⫆̸": "nsupE", "⫇": "subsim", "⫈": "supsim", "⫋︀": "vsubnE", "⫋": "subnE", "⫌︀": "vsupnE", "⫌": "supnE", "⫏": "csub", "⫐": "csup", "⫑": "csube", "⫒": "csupe", "⫓": "subsup", "⫔": "supsub", "⫕": "subsub", "⫖": "supsup", "⫗": "suphsub", "⫘": "supdsub", "⫙": "forkv", "⫚": "topfork", "⫛": "mlcp", "⫤": "Dashv", "⫦": "Vdashl", "⫧": "Barv", "⫨": "vBar", "⫩": "vBarv", "⫫": "Vbar", "⫬": "Not", "⫭": "bNot", "⫮": "rnmid", "⫯": "cirmid", "⫰": "midcir", "⫱": "topcir", "⫲": "nhpar", "⫳": "parsim", "⫽": "parsl", "⫽⃥": "nparsl", "♭": "flat", "♮": "natur", "♯": "sharp", "¤": "curren", "¢": "cent", $: "dollar", "£": "pound", "¥": "yen", "€": "euro", "¹": "sup1", "½": "half", "⅓": "frac13", "¼": "frac14", "⅕": "frac15", "⅙": "frac16", "⅛": "frac18", "²": "sup2", "⅔": "frac23", "⅖": "frac25", "³": "sup3", "¾": "frac34", "⅗": "frac35", "⅜": "frac38", "⅘": "frac45", "⅚": "frac56", "⅝": "frac58", "⅞": "frac78", "𝒶": "ascr", "𝕒": "aopf", "𝔞": "afr", "𝔸": "Aopf", "𝔄": "Afr", "𝒜": "Ascr", ª: "ordf", á: "aacute", Á: "Aacute", à: "agrave", À: "Agrave", ă: "abreve", Ă: "Abreve", â: "acirc", Â: "Acirc", å: "aring", Å: "angst", ä: "auml", Ä: "Auml", ã: "atilde", Ã: "Atilde", ą: "aogon", Ą: "Aogon", ā: "amacr", Ā: "Amacr", æ: "aelig", Æ: "AElig", "𝒷": "bscr", "𝕓": "bopf", "𝔟": "bfr", "𝔹": "Bopf", ℬ: "Bscr", "𝔅": "Bfr", "𝔠": "cfr", "𝒸": "cscr", "𝕔": "copf", ℭ: "Cfr", "𝒞": "Cscr", ℂ: "Copf", ć: "cacute", Ć: "Cacute", ĉ: "ccirc", Ĉ: "Ccirc", č: "ccaron", Č: "Ccaron", ċ: "cdot", Ċ: "Cdot", ç: "ccedil", Ç: "Ccedil", "℅": "incare", "𝔡": "dfr", "ⅆ": "dd", "𝕕": "dopf", "𝒹": "dscr", "𝒟": "Dscr", "𝔇": "Dfr", "ⅅ": "DD", "𝔻": "Dopf", ď: "dcaron", Ď: "Dcaron", đ: "dstrok", Đ: "Dstrok", ð: "eth", Ð: "ETH", "ⅇ": "ee", ℯ: "escr", "𝔢": "efr", "𝕖": "eopf", ℰ: "Escr", "𝔈": "Efr", "𝔼": "Eopf", é: "eacute", É: "Eacute", è: "egrave", È: "Egrave", ê: "ecirc", Ê: "Ecirc", ě: "ecaron", Ě: "Ecaron", ë: "euml", Ë: "Euml", ė: "edot", Ė: "Edot", ę: "eogon", Ę: "Eogon", ē: "emacr", Ē: "Emacr", "𝔣": "ffr", "𝕗": "fopf", "𝒻": "fscr", "𝔉": "Ffr", "𝔽": "Fopf", ℱ: "Fscr", ﬀ: "fflig", ﬃ: "ffilig", ﬄ: "ffllig", ﬁ: "filig", fj: "fjlig", ﬂ: "fllig", ƒ: "fnof", ℊ: "gscr", "𝕘": "gopf", "𝔤": "gfr", "𝒢": "Gscr", "𝔾": "Gopf", "𝔊": "Gfr", ǵ: "gacute", ğ: "gbreve", Ğ: "Gbreve", ĝ: "gcirc", Ĝ: "Gcirc", ġ: "gdot", Ġ: "Gdot", Ģ: "Gcedil", "𝔥": "hfr", ℎ: "planckh", "𝒽": "hscr", "𝕙": "hopf", ℋ: "Hscr", ℌ: "Hfr", ℍ: "Hopf", ĥ: "hcirc", Ĥ: "Hcirc", ℏ: "hbar", ħ: "hstrok", Ħ: "Hstrok", "𝕚": "iopf", "𝔦": "ifr", "𝒾": "iscr", "ⅈ": "ii", "𝕀": "Iopf", ℐ: "Iscr", ℑ: "Im", í: "iacute", Í: "Iacute", ì: "igrave", Ì: "Igrave", î: "icirc", Î: "Icirc", ï: "iuml", Ï: "Iuml", ĩ: "itilde", Ĩ: "Itilde", İ: "Idot", į: "iogon", Į: "Iogon", ī: "imacr", Ī: "Imacr", ĳ: "ijlig", Ĳ: "IJlig", ı: "imath", "𝒿": "jscr", "𝕛": "jopf", "𝔧": "jfr", "𝒥": "Jscr", "𝔍": "Jfr", "𝕁": "Jopf", ĵ: "jcirc", Ĵ: "Jcirc", "ȷ": "jmath", "𝕜": "kopf", "𝓀": "kscr", "𝔨": "kfr", "𝒦": "Kscr", "𝕂": "Kopf", "𝔎": "Kfr", ķ: "kcedil", Ķ: "Kcedil", "𝔩": "lfr", "𝓁": "lscr", ℓ: "ell", "𝕝": "lopf", ℒ: "Lscr", "𝔏": "Lfr", "𝕃": "Lopf", ĺ: "lacute", Ĺ: "Lacute", ľ: "lcaron", Ľ: "Lcaron", ļ: "lcedil", Ļ: "Lcedil", ł: "lstrok", Ł: "Lstrok", ŀ: "lmidot", Ŀ: "Lmidot", "𝔪": "mfr", "𝕞": "mopf", "𝓂": "mscr", "𝔐": "Mfr", "𝕄": "Mopf", ℳ: "Mscr", "𝔫": "nfr", "𝕟": "nopf", "𝓃": "nscr", ℕ: "Nopf", "𝒩": "Nscr", "𝔑": "Nfr", ń: "nacute", Ń: "Nacute", ň: "ncaron", Ň: "Ncaron", ñ: "ntilde", Ñ: "Ntilde", ņ: "ncedil", Ņ: "Ncedil", "№": "numero", ŋ: "eng", Ŋ: "ENG", "𝕠": "oopf", "𝔬": "ofr", ℴ: "oscr", "𝒪": "Oscr", "𝔒": "Ofr", "𝕆": "Oopf", º: "ordm", ó: "oacute", Ó: "Oacute", ò: "ograve", Ò: "Ograve", ô: "ocirc", Ô: "Ocirc", ö: "ouml", Ö: "Ouml", ő: "odblac", Ő: "Odblac", õ: "otilde", Õ: "Otilde", ø: "oslash", Ø: "Oslash", ō: "omacr", Ō: "Omacr", œ: "oelig", Œ: "OElig", "𝔭": "pfr", "𝓅": "pscr", "𝕡": "popf", ℙ: "Popf", "𝔓": "Pfr", "𝒫": "Pscr", "𝕢": "qopf", "𝔮": "qfr", "𝓆": "qscr", "𝒬": "Qscr", "𝔔": "Qfr", ℚ: "Qopf", ĸ: "kgreen", "𝔯": "rfr", "𝕣": "ropf", "𝓇": "rscr", ℛ: "Rscr", ℜ: "Re", ℝ: "Ropf", ŕ: "racute", Ŕ: "Racute", ř: "rcaron", Ř: "Rcaron", ŗ: "rcedil", Ŗ: "Rcedil", "𝕤": "sopf", "𝓈": "sscr", "𝔰": "sfr", "𝕊": "Sopf", "𝔖": "Sfr", "𝒮": "Sscr", "Ⓢ": "oS", ś: "sacute", Ś: "Sacute", ŝ: "scirc", Ŝ: "Scirc", š: "scaron", Š: "Scaron", ş: "scedil", Ş: "Scedil", ß: "szlig", "𝔱": "tfr", "𝓉": "tscr", "𝕥": "topf", "𝒯": "Tscr", "𝔗": "Tfr", "𝕋": "Topf", ť: "tcaron", Ť: "Tcaron", ţ: "tcedil", Ţ: "Tcedil", "™": "trade", ŧ: "tstrok", Ŧ: "Tstrok", "𝓊": "uscr", "𝕦": "uopf", "𝔲": "ufr", "𝕌": "Uopf", "𝔘": "Ufr", "𝒰": "Uscr", ú: "uacute", Ú: "Uacute", ù: "ugrave", Ù: "Ugrave", ŭ: "ubreve", Ŭ: "Ubreve", û: "ucirc", Û: "Ucirc", ů: "uring", Ů: "Uring", ü: "uuml", Ü: "Uuml", ű: "udblac", Ű: "Udblac", ũ: "utilde", Ũ: "Utilde", ų: "uogon", Ų: "Uogon", ū: "umacr", Ū: "Umacr", "𝔳": "vfr", "𝕧": "vopf", "𝓋": "vscr", "𝔙": "Vfr", "𝕍": "Vopf", "𝒱": "Vscr", "𝕨": "wopf", "𝓌": "wscr", "𝔴": "wfr", "𝒲": "Wscr", "𝕎": "Wopf", "𝔚": "Wfr", ŵ: "wcirc", Ŵ: "Wcirc", "𝔵": "xfr", "𝓍": "xscr", "𝕩": "xopf", "𝕏": "Xopf", "𝔛": "Xfr", "𝒳": "Xscr", "𝔶": "yfr", "𝓎": "yscr", "𝕪": "yopf", "𝒴": "Yscr", "𝔜": "Yfr", "𝕐": "Yopf", ý: "yacute", Ý: "Yacute", ŷ: "ycirc", Ŷ: "Ycirc", ÿ: "yuml", Ÿ: "Yuml", "𝓏": "zscr", "𝔷": "zfr", "𝕫": "zopf", ℨ: "Zfr", ℤ: "Zopf", "𝒵": "Zscr", ź: "zacute", Ź: "Zacute", ž: "zcaron", Ž: "Zcaron", ż: "zdot", Ż: "Zdot", Ƶ: "imped", þ: "thorn", Þ: "THORN", ŉ: "napos", α: "alpha", Α: "Alpha", β: "beta", Β: "Beta", γ: "gamma", Γ: "Gamma", δ: "delta", Δ: "Delta", ε: "epsi", "ϵ": "epsiv", Ε: "Epsilon", ϝ: "gammad", Ϝ: "Gammad", ζ: "zeta", Ζ: "Zeta", η: "eta", Η: "Eta", θ: "theta", ϑ: "thetav", Θ: "Theta", ι: "iota", Ι: "Iota", κ: "kappa", ϰ: "kappav", Κ: "Kappa", λ: "lambda", Λ: "Lambda", μ: "mu", µ: "micro", Μ: "Mu", ν: "nu", Ν: "Nu", ξ: "xi", Ξ: "Xi", ο: "omicron", Ο: "Omicron", π: "pi", ϖ: "piv", Π: "Pi", ρ: "rho", ϱ: "rhov", Ρ: "Rho", σ: "sigma", Σ: "Sigma", ς: "sigmaf", τ: "tau", Τ: "Tau", υ: "upsi", Υ: "Upsilon", ϒ: "Upsi", φ: "phi", ϕ: "phiv", Φ: "Phi", χ: "chi", Χ: "Chi", ψ: "psi", Ψ: "Psi", ω: "omega", Ω: "ohm", а: "acy", А: "Acy", б: "bcy", Б: "Bcy", в: "vcy", В: "Vcy", г: "gcy", Г: "Gcy", ѓ: "gjcy", Ѓ: "GJcy", д: "dcy", Д: "Dcy", ђ: "djcy", Ђ: "DJcy", е: "iecy", Е: "IEcy", ё: "iocy", Ё: "IOcy", є: "jukcy", Є: "Jukcy", ж: "zhcy", Ж: "ZHcy", з: "zcy", З: "Zcy", ѕ: "dscy", Ѕ: "DScy", и: "icy", И: "Icy", і: "iukcy", І: "Iukcy", ї: "yicy", Ї: "YIcy", й: "jcy", Й: "Jcy", ј: "jsercy", Ј: "Jsercy", к: "kcy", К: "Kcy", ќ: "kjcy", Ќ: "KJcy", л: "lcy", Л: "Lcy", љ: "ljcy", Љ: "LJcy", м: "mcy", М: "Mcy", н: "ncy", Н: "Ncy", њ: "njcy", Њ: "NJcy", о: "ocy", О: "Ocy", п: "pcy", П: "Pcy", р: "rcy", Р: "Rcy", с: "scy", С: "Scy", т: "tcy", Т: "Tcy", ћ: "tshcy", Ћ: "TSHcy", у: "ucy", У: "Ucy", ў: "ubrcy", Ў: "Ubrcy", ф: "fcy", Ф: "Fcy", х: "khcy", Х: "KHcy", ц: "tscy", Ц: "TScy", ч: "chcy", Ч: "CHcy", џ: "dzcy", Џ: "DZcy", ш: "shcy", Ш: "SHcy", щ: "shchcy", Щ: "SHCHcy", ъ: "hardcy", Ъ: "HARDcy", ы: "ycy", Ы: "Ycy", ь: "softcy", Ь: "SOFTcy", э: "ecy", Э: "Ecy", ю: "yucy", Ю: "YUcy", я: "yacy", Я: "YAcy", ℵ: "aleph", ℶ: "beth", ℷ: "gimel", ℸ: "daleth" }, h = /["&'<>`]/g, c = {
      '"': "&quot;",
      "&": "&amp;",
      "'": "&#x27;",
      "<": "&lt;",
      // See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
      // following is not strictly necessary unless it’s part of a tag or an
      // unquoted attribute value. We’re only escaping it to support those
      // situations, and for XML support.
      ">": "&gt;",
      // In Internet Explorer ≤ 8, the backtick character can be used
      // to break out of (un)quoted attribute values or HTML comments.
      // See http://html5sec.org/#102, http://html5sec.org/#108, and
      // http://html5sec.org/#133.
      "`": "&#x60;"
    }, f = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/, g = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, D = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g, _ = { aacute: "á", Aacute: "Á", abreve: "ă", Abreve: "Ă", ac: "∾", acd: "∿", acE: "∾̳", acirc: "â", Acirc: "Â", acute: "´", acy: "а", Acy: "А", aelig: "æ", AElig: "Æ", af: "⁡", afr: "𝔞", Afr: "𝔄", agrave: "à", Agrave: "À", alefsym: "ℵ", aleph: "ℵ", alpha: "α", Alpha: "Α", amacr: "ā", Amacr: "Ā", amalg: "⨿", amp: "&", AMP: "&", and: "∧", And: "⩓", andand: "⩕", andd: "⩜", andslope: "⩘", andv: "⩚", ang: "∠", ange: "⦤", angle: "∠", angmsd: "∡", angmsdaa: "⦨", angmsdab: "⦩", angmsdac: "⦪", angmsdad: "⦫", angmsdae: "⦬", angmsdaf: "⦭", angmsdag: "⦮", angmsdah: "⦯", angrt: "∟", angrtvb: "⊾", angrtvbd: "⦝", angsph: "∢", angst: "Å", angzarr: "⍼", aogon: "ą", Aogon: "Ą", aopf: "𝕒", Aopf: "𝔸", ap: "≈", apacir: "⩯", ape: "≊", apE: "⩰", apid: "≋", apos: "'", ApplyFunction: "⁡", approx: "≈", approxeq: "≊", aring: "å", Aring: "Å", ascr: "𝒶", Ascr: "𝒜", Assign: "≔", ast: "*", asymp: "≈", asympeq: "≍", atilde: "ã", Atilde: "Ã", auml: "ä", Auml: "Ä", awconint: "∳", awint: "⨑", backcong: "≌", backepsilon: "϶", backprime: "‵", backsim: "∽", backsimeq: "⋍", Backslash: "∖", Barv: "⫧", barvee: "⊽", barwed: "⌅", Barwed: "⌆", barwedge: "⌅", bbrk: "⎵", bbrktbrk: "⎶", bcong: "≌", bcy: "б", Bcy: "Б", bdquo: "„", becaus: "∵", because: "∵", Because: "∵", bemptyv: "⦰", bepsi: "϶", bernou: "ℬ", Bernoullis: "ℬ", beta: "β", Beta: "Β", beth: "ℶ", between: "≬", bfr: "𝔟", Bfr: "𝔅", bigcap: "⋂", bigcirc: "◯", bigcup: "⋃", bigodot: "⨀", bigoplus: "⨁", bigotimes: "⨂", bigsqcup: "⨆", bigstar: "★", bigtriangledown: "▽", bigtriangleup: "△", biguplus: "⨄", bigvee: "⋁", bigwedge: "⋀", bkarow: "⤍", blacklozenge: "⧫", blacksquare: "▪", blacktriangle: "▴", blacktriangledown: "▾", blacktriangleleft: "◂", blacktriangleright: "▸", blank: "␣", blk12: "▒", blk14: "░", blk34: "▓", block: "█", bne: "=⃥", bnequiv: "≡⃥", bnot: "⌐", bNot: "⫭", bopf: "𝕓", Bopf: "𝔹", bot: "⊥", bottom: "⊥", bowtie: "⋈", boxbox: "⧉", boxdl: "┐", boxdL: "╕", boxDl: "╖", boxDL: "╗", boxdr: "┌", boxdR: "╒", boxDr: "╓", boxDR: "╔", boxh: "─", boxH: "═", boxhd: "┬", boxhD: "╥", boxHd: "╤", boxHD: "╦", boxhu: "┴", boxhU: "╨", boxHu: "╧", boxHU: "╩", boxminus: "⊟", boxplus: "⊞", boxtimes: "⊠", boxul: "┘", boxuL: "╛", boxUl: "╜", boxUL: "╝", boxur: "└", boxuR: "╘", boxUr: "╙", boxUR: "╚", boxv: "│", boxV: "║", boxvh: "┼", boxvH: "╪", boxVh: "╫", boxVH: "╬", boxvl: "┤", boxvL: "╡", boxVl: "╢", boxVL: "╣", boxvr: "├", boxvR: "╞", boxVr: "╟", boxVR: "╠", bprime: "‵", breve: "˘", Breve: "˘", brvbar: "¦", bscr: "𝒷", Bscr: "ℬ", bsemi: "⁏", bsim: "∽", bsime: "⋍", bsol: "\\", bsolb: "⧅", bsolhsub: "⟈", bull: "•", bullet: "•", bump: "≎", bumpe: "≏", bumpE: "⪮", bumpeq: "≏", Bumpeq: "≎", cacute: "ć", Cacute: "Ć", cap: "∩", Cap: "⋒", capand: "⩄", capbrcup: "⩉", capcap: "⩋", capcup: "⩇", capdot: "⩀", CapitalDifferentialD: "ⅅ", caps: "∩︀", caret: "⁁", caron: "ˇ", Cayleys: "ℭ", ccaps: "⩍", ccaron: "č", Ccaron: "Č", ccedil: "ç", Ccedil: "Ç", ccirc: "ĉ", Ccirc: "Ĉ", Cconint: "∰", ccups: "⩌", ccupssm: "⩐", cdot: "ċ", Cdot: "Ċ", cedil: "¸", Cedilla: "¸", cemptyv: "⦲", cent: "¢", centerdot: "·", CenterDot: "·", cfr: "𝔠", Cfr: "ℭ", chcy: "ч", CHcy: "Ч", check: "✓", checkmark: "✓", chi: "χ", Chi: "Χ", cir: "○", circ: "ˆ", circeq: "≗", circlearrowleft: "↺", circlearrowright: "↻", circledast: "⊛", circledcirc: "⊚", circleddash: "⊝", CircleDot: "⊙", circledR: "®", circledS: "Ⓢ", CircleMinus: "⊖", CirclePlus: "⊕", CircleTimes: "⊗", cire: "≗", cirE: "⧃", cirfnint: "⨐", cirmid: "⫯", cirscir: "⧂", ClockwiseContourIntegral: "∲", CloseCurlyDoubleQuote: "”", CloseCurlyQuote: "’", clubs: "♣", clubsuit: "♣", colon: ":", Colon: "∷", colone: "≔", Colone: "⩴", coloneq: "≔", comma: ",", commat: "@", comp: "∁", compfn: "∘", complement: "∁", complexes: "ℂ", cong: "≅", congdot: "⩭", Congruent: "≡", conint: "∮", Conint: "∯", ContourIntegral: "∮", copf: "𝕔", Copf: "ℂ", coprod: "∐", Coproduct: "∐", copy: "©", COPY: "©", copysr: "℗", CounterClockwiseContourIntegral: "∳", crarr: "↵", cross: "✗", Cross: "⨯", cscr: "𝒸", Cscr: "𝒞", csub: "⫏", csube: "⫑", csup: "⫐", csupe: "⫒", ctdot: "⋯", cudarrl: "⤸", cudarrr: "⤵", cuepr: "⋞", cuesc: "⋟", cularr: "↶", cularrp: "⤽", cup: "∪", Cup: "⋓", cupbrcap: "⩈", cupcap: "⩆", CupCap: "≍", cupcup: "⩊", cupdot: "⊍", cupor: "⩅", cups: "∪︀", curarr: "↷", curarrm: "⤼", curlyeqprec: "⋞", curlyeqsucc: "⋟", curlyvee: "⋎", curlywedge: "⋏", curren: "¤", curvearrowleft: "↶", curvearrowright: "↷", cuvee: "⋎", cuwed: "⋏", cwconint: "∲", cwint: "∱", cylcty: "⌭", dagger: "†", Dagger: "‡", daleth: "ℸ", darr: "↓", dArr: "⇓", Darr: "↡", dash: "‐", dashv: "⊣", Dashv: "⫤", dbkarow: "⤏", dblac: "˝", dcaron: "ď", Dcaron: "Ď", dcy: "д", Dcy: "Д", dd: "ⅆ", DD: "ⅅ", ddagger: "‡", ddarr: "⇊", DDotrahd: "⤑", ddotseq: "⩷", deg: "°", Del: "∇", delta: "δ", Delta: "Δ", demptyv: "⦱", dfisht: "⥿", dfr: "𝔡", Dfr: "𝔇", dHar: "⥥", dharl: "⇃", dharr: "⇂", DiacriticalAcute: "´", DiacriticalDot: "˙", DiacriticalDoubleAcute: "˝", DiacriticalGrave: "`", DiacriticalTilde: "˜", diam: "⋄", diamond: "⋄", Diamond: "⋄", diamondsuit: "♦", diams: "♦", die: "¨", DifferentialD: "ⅆ", digamma: "ϝ", disin: "⋲", div: "÷", divide: "÷", divideontimes: "⋇", divonx: "⋇", djcy: "ђ", DJcy: "Ђ", dlcorn: "⌞", dlcrop: "⌍", dollar: "$", dopf: "𝕕", Dopf: "𝔻", dot: "˙", Dot: "¨", DotDot: "⃜", doteq: "≐", doteqdot: "≑", DotEqual: "≐", dotminus: "∸", dotplus: "∔", dotsquare: "⊡", doublebarwedge: "⌆", DoubleContourIntegral: "∯", DoubleDot: "¨", DoubleDownArrow: "⇓", DoubleLeftArrow: "⇐", DoubleLeftRightArrow: "⇔", DoubleLeftTee: "⫤", DoubleLongLeftArrow: "⟸", DoubleLongLeftRightArrow: "⟺", DoubleLongRightArrow: "⟹", DoubleRightArrow: "⇒", DoubleRightTee: "⊨", DoubleUpArrow: "⇑", DoubleUpDownArrow: "⇕", DoubleVerticalBar: "∥", downarrow: "↓", Downarrow: "⇓", DownArrow: "↓", DownArrowBar: "⤓", DownArrowUpArrow: "⇵", DownBreve: "̑", downdownarrows: "⇊", downharpoonleft: "⇃", downharpoonright: "⇂", DownLeftRightVector: "⥐", DownLeftTeeVector: "⥞", DownLeftVector: "↽", DownLeftVectorBar: "⥖", DownRightTeeVector: "⥟", DownRightVector: "⇁", DownRightVectorBar: "⥗", DownTee: "⊤", DownTeeArrow: "↧", drbkarow: "⤐", drcorn: "⌟", drcrop: "⌌", dscr: "𝒹", Dscr: "𝒟", dscy: "ѕ", DScy: "Ѕ", dsol: "⧶", dstrok: "đ", Dstrok: "Đ", dtdot: "⋱", dtri: "▿", dtrif: "▾", duarr: "⇵", duhar: "⥯", dwangle: "⦦", dzcy: "џ", DZcy: "Џ", dzigrarr: "⟿", eacute: "é", Eacute: "É", easter: "⩮", ecaron: "ě", Ecaron: "Ě", ecir: "≖", ecirc: "ê", Ecirc: "Ê", ecolon: "≕", ecy: "э", Ecy: "Э", eDDot: "⩷", edot: "ė", eDot: "≑", Edot: "Ė", ee: "ⅇ", efDot: "≒", efr: "𝔢", Efr: "𝔈", eg: "⪚", egrave: "è", Egrave: "È", egs: "⪖", egsdot: "⪘", el: "⪙", Element: "∈", elinters: "⏧", ell: "ℓ", els: "⪕", elsdot: "⪗", emacr: "ē", Emacr: "Ē", empty: "∅", emptyset: "∅", EmptySmallSquare: "◻", emptyv: "∅", EmptyVerySmallSquare: "▫", emsp: " ", emsp13: " ", emsp14: " ", eng: "ŋ", ENG: "Ŋ", ensp: " ", eogon: "ę", Eogon: "Ę", eopf: "𝕖", Eopf: "𝔼", epar: "⋕", eparsl: "⧣", eplus: "⩱", epsi: "ε", epsilon: "ε", Epsilon: "Ε", epsiv: "ϵ", eqcirc: "≖", eqcolon: "≕", eqsim: "≂", eqslantgtr: "⪖", eqslantless: "⪕", Equal: "⩵", equals: "=", EqualTilde: "≂", equest: "≟", Equilibrium: "⇌", equiv: "≡", equivDD: "⩸", eqvparsl: "⧥", erarr: "⥱", erDot: "≓", escr: "ℯ", Escr: "ℰ", esdot: "≐", esim: "≂", Esim: "⩳", eta: "η", Eta: "Η", eth: "ð", ETH: "Ð", euml: "ë", Euml: "Ë", euro: "€", excl: "!", exist: "∃", Exists: "∃", expectation: "ℰ", exponentiale: "ⅇ", ExponentialE: "ⅇ", fallingdotseq: "≒", fcy: "ф", Fcy: "Ф", female: "♀", ffilig: "ﬃ", fflig: "ﬀ", ffllig: "ﬄ", ffr: "𝔣", Ffr: "𝔉", filig: "ﬁ", FilledSmallSquare: "◼", FilledVerySmallSquare: "▪", fjlig: "fj", flat: "♭", fllig: "ﬂ", fltns: "▱", fnof: "ƒ", fopf: "𝕗", Fopf: "𝔽", forall: "∀", ForAll: "∀", fork: "⋔", forkv: "⫙", Fouriertrf: "ℱ", fpartint: "⨍", frac12: "½", frac13: "⅓", frac14: "¼", frac15: "⅕", frac16: "⅙", frac18: "⅛", frac23: "⅔", frac25: "⅖", frac34: "¾", frac35: "⅗", frac38: "⅜", frac45: "⅘", frac56: "⅚", frac58: "⅝", frac78: "⅞", frasl: "⁄", frown: "⌢", fscr: "𝒻", Fscr: "ℱ", gacute: "ǵ", gamma: "γ", Gamma: "Γ", gammad: "ϝ", Gammad: "Ϝ", gap: "⪆", gbreve: "ğ", Gbreve: "Ğ", Gcedil: "Ģ", gcirc: "ĝ", Gcirc: "Ĝ", gcy: "г", Gcy: "Г", gdot: "ġ", Gdot: "Ġ", ge: "≥", gE: "≧", gel: "⋛", gEl: "⪌", geq: "≥", geqq: "≧", geqslant: "⩾", ges: "⩾", gescc: "⪩", gesdot: "⪀", gesdoto: "⪂", gesdotol: "⪄", gesl: "⋛︀", gesles: "⪔", gfr: "𝔤", Gfr: "𝔊", gg: "≫", Gg: "⋙", ggg: "⋙", gimel: "ℷ", gjcy: "ѓ", GJcy: "Ѓ", gl: "≷", gla: "⪥", glE: "⪒", glj: "⪤", gnap: "⪊", gnapprox: "⪊", gne: "⪈", gnE: "≩", gneq: "⪈", gneqq: "≩", gnsim: "⋧", gopf: "𝕘", Gopf: "𝔾", grave: "`", GreaterEqual: "≥", GreaterEqualLess: "⋛", GreaterFullEqual: "≧", GreaterGreater: "⪢", GreaterLess: "≷", GreaterSlantEqual: "⩾", GreaterTilde: "≳", gscr: "ℊ", Gscr: "𝒢", gsim: "≳", gsime: "⪎", gsiml: "⪐", gt: ">", Gt: "≫", GT: ">", gtcc: "⪧", gtcir: "⩺", gtdot: "⋗", gtlPar: "⦕", gtquest: "⩼", gtrapprox: "⪆", gtrarr: "⥸", gtrdot: "⋗", gtreqless: "⋛", gtreqqless: "⪌", gtrless: "≷", gtrsim: "≳", gvertneqq: "≩︀", gvnE: "≩︀", Hacek: "ˇ", hairsp: " ", half: "½", hamilt: "ℋ", hardcy: "ъ", HARDcy: "Ъ", harr: "↔", hArr: "⇔", harrcir: "⥈", harrw: "↭", Hat: "^", hbar: "ℏ", hcirc: "ĥ", Hcirc: "Ĥ", hearts: "♥", heartsuit: "♥", hellip: "…", hercon: "⊹", hfr: "𝔥", Hfr: "ℌ", HilbertSpace: "ℋ", hksearow: "⤥", hkswarow: "⤦", hoarr: "⇿", homtht: "∻", hookleftarrow: "↩", hookrightarrow: "↪", hopf: "𝕙", Hopf: "ℍ", horbar: "―", HorizontalLine: "─", hscr: "𝒽", Hscr: "ℋ", hslash: "ℏ", hstrok: "ħ", Hstrok: "Ħ", HumpDownHump: "≎", HumpEqual: "≏", hybull: "⁃", hyphen: "‐", iacute: "í", Iacute: "Í", ic: "⁣", icirc: "î", Icirc: "Î", icy: "и", Icy: "И", Idot: "İ", iecy: "е", IEcy: "Е", iexcl: "¡", iff: "⇔", ifr: "𝔦", Ifr: "ℑ", igrave: "ì", Igrave: "Ì", ii: "ⅈ", iiiint: "⨌", iiint: "∭", iinfin: "⧜", iiota: "℩", ijlig: "ĳ", IJlig: "Ĳ", Im: "ℑ", imacr: "ī", Imacr: "Ī", image: "ℑ", ImaginaryI: "ⅈ", imagline: "ℐ", imagpart: "ℑ", imath: "ı", imof: "⊷", imped: "Ƶ", Implies: "⇒", in: "∈", incare: "℅", infin: "∞", infintie: "⧝", inodot: "ı", int: "∫", Int: "∬", intcal: "⊺", integers: "ℤ", Integral: "∫", intercal: "⊺", Intersection: "⋂", intlarhk: "⨗", intprod: "⨼", InvisibleComma: "⁣", InvisibleTimes: "⁢", iocy: "ё", IOcy: "Ё", iogon: "į", Iogon: "Į", iopf: "𝕚", Iopf: "𝕀", iota: "ι", Iota: "Ι", iprod: "⨼", iquest: "¿", iscr: "𝒾", Iscr: "ℐ", isin: "∈", isindot: "⋵", isinE: "⋹", isins: "⋴", isinsv: "⋳", isinv: "∈", it: "⁢", itilde: "ĩ", Itilde: "Ĩ", iukcy: "і", Iukcy: "І", iuml: "ï", Iuml: "Ï", jcirc: "ĵ", Jcirc: "Ĵ", jcy: "й", Jcy: "Й", jfr: "𝔧", Jfr: "𝔍", jmath: "ȷ", jopf: "𝕛", Jopf: "𝕁", jscr: "𝒿", Jscr: "𝒥", jsercy: "ј", Jsercy: "Ј", jukcy: "є", Jukcy: "Є", kappa: "κ", Kappa: "Κ", kappav: "ϰ", kcedil: "ķ", Kcedil: "Ķ", kcy: "к", Kcy: "К", kfr: "𝔨", Kfr: "𝔎", kgreen: "ĸ", khcy: "х", KHcy: "Х", kjcy: "ќ", KJcy: "Ќ", kopf: "𝕜", Kopf: "𝕂", kscr: "𝓀", Kscr: "𝒦", lAarr: "⇚", lacute: "ĺ", Lacute: "Ĺ", laemptyv: "⦴", lagran: "ℒ", lambda: "λ", Lambda: "Λ", lang: "⟨", Lang: "⟪", langd: "⦑", langle: "⟨", lap: "⪅", Laplacetrf: "ℒ", laquo: "«", larr: "←", lArr: "⇐", Larr: "↞", larrb: "⇤", larrbfs: "⤟", larrfs: "⤝", larrhk: "↩", larrlp: "↫", larrpl: "⤹", larrsim: "⥳", larrtl: "↢", lat: "⪫", latail: "⤙", lAtail: "⤛", late: "⪭", lates: "⪭︀", lbarr: "⤌", lBarr: "⤎", lbbrk: "❲", lbrace: "{", lbrack: "[", lbrke: "⦋", lbrksld: "⦏", lbrkslu: "⦍", lcaron: "ľ", Lcaron: "Ľ", lcedil: "ļ", Lcedil: "Ļ", lceil: "⌈", lcub: "{", lcy: "л", Lcy: "Л", ldca: "⤶", ldquo: "“", ldquor: "„", ldrdhar: "⥧", ldrushar: "⥋", ldsh: "↲", le: "≤", lE: "≦", LeftAngleBracket: "⟨", leftarrow: "←", Leftarrow: "⇐", LeftArrow: "←", LeftArrowBar: "⇤", LeftArrowRightArrow: "⇆", leftarrowtail: "↢", LeftCeiling: "⌈", LeftDoubleBracket: "⟦", LeftDownTeeVector: "⥡", LeftDownVector: "⇃", LeftDownVectorBar: "⥙", LeftFloor: "⌊", leftharpoondown: "↽", leftharpoonup: "↼", leftleftarrows: "⇇", leftrightarrow: "↔", Leftrightarrow: "⇔", LeftRightArrow: "↔", leftrightarrows: "⇆", leftrightharpoons: "⇋", leftrightsquigarrow: "↭", LeftRightVector: "⥎", LeftTee: "⊣", LeftTeeArrow: "↤", LeftTeeVector: "⥚", leftthreetimes: "⋋", LeftTriangle: "⊲", LeftTriangleBar: "⧏", LeftTriangleEqual: "⊴", LeftUpDownVector: "⥑", LeftUpTeeVector: "⥠", LeftUpVector: "↿", LeftUpVectorBar: "⥘", LeftVector: "↼", LeftVectorBar: "⥒", leg: "⋚", lEg: "⪋", leq: "≤", leqq: "≦", leqslant: "⩽", les: "⩽", lescc: "⪨", lesdot: "⩿", lesdoto: "⪁", lesdotor: "⪃", lesg: "⋚︀", lesges: "⪓", lessapprox: "⪅", lessdot: "⋖", lesseqgtr: "⋚", lesseqqgtr: "⪋", LessEqualGreater: "⋚", LessFullEqual: "≦", LessGreater: "≶", lessgtr: "≶", LessLess: "⪡", lesssim: "≲", LessSlantEqual: "⩽", LessTilde: "≲", lfisht: "⥼", lfloor: "⌊", lfr: "𝔩", Lfr: "𝔏", lg: "≶", lgE: "⪑", lHar: "⥢", lhard: "↽", lharu: "↼", lharul: "⥪", lhblk: "▄", ljcy: "љ", LJcy: "Љ", ll: "≪", Ll: "⋘", llarr: "⇇", llcorner: "⌞", Lleftarrow: "⇚", llhard: "⥫", lltri: "◺", lmidot: "ŀ", Lmidot: "Ŀ", lmoust: "⎰", lmoustache: "⎰", lnap: "⪉", lnapprox: "⪉", lne: "⪇", lnE: "≨", lneq: "⪇", lneqq: "≨", lnsim: "⋦", loang: "⟬", loarr: "⇽", lobrk: "⟦", longleftarrow: "⟵", Longleftarrow: "⟸", LongLeftArrow: "⟵", longleftrightarrow: "⟷", Longleftrightarrow: "⟺", LongLeftRightArrow: "⟷", longmapsto: "⟼", longrightarrow: "⟶", Longrightarrow: "⟹", LongRightArrow: "⟶", looparrowleft: "↫", looparrowright: "↬", lopar: "⦅", lopf: "𝕝", Lopf: "𝕃", loplus: "⨭", lotimes: "⨴", lowast: "∗", lowbar: "_", LowerLeftArrow: "↙", LowerRightArrow: "↘", loz: "◊", lozenge: "◊", lozf: "⧫", lpar: "(", lparlt: "⦓", lrarr: "⇆", lrcorner: "⌟", lrhar: "⇋", lrhard: "⥭", lrm: "‎", lrtri: "⊿", lsaquo: "‹", lscr: "𝓁", Lscr: "ℒ", lsh: "↰", Lsh: "↰", lsim: "≲", lsime: "⪍", lsimg: "⪏", lsqb: "[", lsquo: "‘", lsquor: "‚", lstrok: "ł", Lstrok: "Ł", lt: "<", Lt: "≪", LT: "<", ltcc: "⪦", ltcir: "⩹", ltdot: "⋖", lthree: "⋋", ltimes: "⋉", ltlarr: "⥶", ltquest: "⩻", ltri: "◃", ltrie: "⊴", ltrif: "◂", ltrPar: "⦖", lurdshar: "⥊", luruhar: "⥦", lvertneqq: "≨︀", lvnE: "≨︀", macr: "¯", male: "♂", malt: "✠", maltese: "✠", map: "↦", Map: "⤅", mapsto: "↦", mapstodown: "↧", mapstoleft: "↤", mapstoup: "↥", marker: "▮", mcomma: "⨩", mcy: "м", Mcy: "М", mdash: "—", mDDot: "∺", measuredangle: "∡", MediumSpace: " ", Mellintrf: "ℳ", mfr: "𝔪", Mfr: "𝔐", mho: "℧", micro: "µ", mid: "∣", midast: "*", midcir: "⫰", middot: "·", minus: "−", minusb: "⊟", minusd: "∸", minusdu: "⨪", MinusPlus: "∓", mlcp: "⫛", mldr: "…", mnplus: "∓", models: "⊧", mopf: "𝕞", Mopf: "𝕄", mp: "∓", mscr: "𝓂", Mscr: "ℳ", mstpos: "∾", mu: "μ", Mu: "Μ", multimap: "⊸", mumap: "⊸", nabla: "∇", nacute: "ń", Nacute: "Ń", nang: "∠⃒", nap: "≉", napE: "⩰̸", napid: "≋̸", napos: "ŉ", napprox: "≉", natur: "♮", natural: "♮", naturals: "ℕ", nbsp: " ", nbump: "≎̸", nbumpe: "≏̸", ncap: "⩃", ncaron: "ň", Ncaron: "Ň", ncedil: "ņ", Ncedil: "Ņ", ncong: "≇", ncongdot: "⩭̸", ncup: "⩂", ncy: "н", Ncy: "Н", ndash: "–", ne: "≠", nearhk: "⤤", nearr: "↗", neArr: "⇗", nearrow: "↗", nedot: "≐̸", NegativeMediumSpace: "​", NegativeThickSpace: "​", NegativeThinSpace: "​", NegativeVeryThinSpace: "​", nequiv: "≢", nesear: "⤨", nesim: "≂̸", NestedGreaterGreater: "≫", NestedLessLess: "≪", NewLine: `
`, nexist: "∄", nexists: "∄", nfr: "𝔫", Nfr: "𝔑", nge: "≱", ngE: "≧̸", ngeq: "≱", ngeqq: "≧̸", ngeqslant: "⩾̸", nges: "⩾̸", nGg: "⋙̸", ngsim: "≵", ngt: "≯", nGt: "≫⃒", ngtr: "≯", nGtv: "≫̸", nharr: "↮", nhArr: "⇎", nhpar: "⫲", ni: "∋", nis: "⋼", nisd: "⋺", niv: "∋", njcy: "њ", NJcy: "Њ", nlarr: "↚", nlArr: "⇍", nldr: "‥", nle: "≰", nlE: "≦̸", nleftarrow: "↚", nLeftarrow: "⇍", nleftrightarrow: "↮", nLeftrightarrow: "⇎", nleq: "≰", nleqq: "≦̸", nleqslant: "⩽̸", nles: "⩽̸", nless: "≮", nLl: "⋘̸", nlsim: "≴", nlt: "≮", nLt: "≪⃒", nltri: "⋪", nltrie: "⋬", nLtv: "≪̸", nmid: "∤", NoBreak: "⁠", NonBreakingSpace: " ", nopf: "𝕟", Nopf: "ℕ", not: "¬", Not: "⫬", NotCongruent: "≢", NotCupCap: "≭", NotDoubleVerticalBar: "∦", NotElement: "∉", NotEqual: "≠", NotEqualTilde: "≂̸", NotExists: "∄", NotGreater: "≯", NotGreaterEqual: "≱", NotGreaterFullEqual: "≧̸", NotGreaterGreater: "≫̸", NotGreaterLess: "≹", NotGreaterSlantEqual: "⩾̸", NotGreaterTilde: "≵", NotHumpDownHump: "≎̸", NotHumpEqual: "≏̸", notin: "∉", notindot: "⋵̸", notinE: "⋹̸", notinva: "∉", notinvb: "⋷", notinvc: "⋶", NotLeftTriangle: "⋪", NotLeftTriangleBar: "⧏̸", NotLeftTriangleEqual: "⋬", NotLess: "≮", NotLessEqual: "≰", NotLessGreater: "≸", NotLessLess: "≪̸", NotLessSlantEqual: "⩽̸", NotLessTilde: "≴", NotNestedGreaterGreater: "⪢̸", NotNestedLessLess: "⪡̸", notni: "∌", notniva: "∌", notnivb: "⋾", notnivc: "⋽", NotPrecedes: "⊀", NotPrecedesEqual: "⪯̸", NotPrecedesSlantEqual: "⋠", NotReverseElement: "∌", NotRightTriangle: "⋫", NotRightTriangleBar: "⧐̸", NotRightTriangleEqual: "⋭", NotSquareSubset: "⊏̸", NotSquareSubsetEqual: "⋢", NotSquareSuperset: "⊐̸", NotSquareSupersetEqual: "⋣", NotSubset: "⊂⃒", NotSubsetEqual: "⊈", NotSucceeds: "⊁", NotSucceedsEqual: "⪰̸", NotSucceedsSlantEqual: "⋡", NotSucceedsTilde: "≿̸", NotSuperset: "⊃⃒", NotSupersetEqual: "⊉", NotTilde: "≁", NotTildeEqual: "≄", NotTildeFullEqual: "≇", NotTildeTilde: "≉", NotVerticalBar: "∤", npar: "∦", nparallel: "∦", nparsl: "⫽⃥", npart: "∂̸", npolint: "⨔", npr: "⊀", nprcue: "⋠", npre: "⪯̸", nprec: "⊀", npreceq: "⪯̸", nrarr: "↛", nrArr: "⇏", nrarrc: "⤳̸", nrarrw: "↝̸", nrightarrow: "↛", nRightarrow: "⇏", nrtri: "⋫", nrtrie: "⋭", nsc: "⊁", nsccue: "⋡", nsce: "⪰̸", nscr: "𝓃", Nscr: "𝒩", nshortmid: "∤", nshortparallel: "∦", nsim: "≁", nsime: "≄", nsimeq: "≄", nsmid: "∤", nspar: "∦", nsqsube: "⋢", nsqsupe: "⋣", nsub: "⊄", nsube: "⊈", nsubE: "⫅̸", nsubset: "⊂⃒", nsubseteq: "⊈", nsubseteqq: "⫅̸", nsucc: "⊁", nsucceq: "⪰̸", nsup: "⊅", nsupe: "⊉", nsupE: "⫆̸", nsupset: "⊃⃒", nsupseteq: "⊉", nsupseteqq: "⫆̸", ntgl: "≹", ntilde: "ñ", Ntilde: "Ñ", ntlg: "≸", ntriangleleft: "⋪", ntrianglelefteq: "⋬", ntriangleright: "⋫", ntrianglerighteq: "⋭", nu: "ν", Nu: "Ν", num: "#", numero: "№", numsp: " ", nvap: "≍⃒", nvdash: "⊬", nvDash: "⊭", nVdash: "⊮", nVDash: "⊯", nvge: "≥⃒", nvgt: ">⃒", nvHarr: "⤄", nvinfin: "⧞", nvlArr: "⤂", nvle: "≤⃒", nvlt: "<⃒", nvltrie: "⊴⃒", nvrArr: "⤃", nvrtrie: "⊵⃒", nvsim: "∼⃒", nwarhk: "⤣", nwarr: "↖", nwArr: "⇖", nwarrow: "↖", nwnear: "⤧", oacute: "ó", Oacute: "Ó", oast: "⊛", ocir: "⊚", ocirc: "ô", Ocirc: "Ô", ocy: "о", Ocy: "О", odash: "⊝", odblac: "ő", Odblac: "Ő", odiv: "⨸", odot: "⊙", odsold: "⦼", oelig: "œ", OElig: "Œ", ofcir: "⦿", ofr: "𝔬", Ofr: "𝔒", ogon: "˛", ograve: "ò", Ograve: "Ò", ogt: "⧁", ohbar: "⦵", ohm: "Ω", oint: "∮", olarr: "↺", olcir: "⦾", olcross: "⦻", oline: "‾", olt: "⧀", omacr: "ō", Omacr: "Ō", omega: "ω", Omega: "Ω", omicron: "ο", Omicron: "Ο", omid: "⦶", ominus: "⊖", oopf: "𝕠", Oopf: "𝕆", opar: "⦷", OpenCurlyDoubleQuote: "“", OpenCurlyQuote: "‘", operp: "⦹", oplus: "⊕", or: "∨", Or: "⩔", orarr: "↻", ord: "⩝", order: "ℴ", orderof: "ℴ", ordf: "ª", ordm: "º", origof: "⊶", oror: "⩖", orslope: "⩗", orv: "⩛", oS: "Ⓢ", oscr: "ℴ", Oscr: "𝒪", oslash: "ø", Oslash: "Ø", osol: "⊘", otilde: "õ", Otilde: "Õ", otimes: "⊗", Otimes: "⨷", otimesas: "⨶", ouml: "ö", Ouml: "Ö", ovbar: "⌽", OverBar: "‾", OverBrace: "⏞", OverBracket: "⎴", OverParenthesis: "⏜", par: "∥", para: "¶", parallel: "∥", parsim: "⫳", parsl: "⫽", part: "∂", PartialD: "∂", pcy: "п", Pcy: "П", percnt: "%", period: ".", permil: "‰", perp: "⊥", pertenk: "‱", pfr: "𝔭", Pfr: "𝔓", phi: "φ", Phi: "Φ", phiv: "ϕ", phmmat: "ℳ", phone: "☎", pi: "π", Pi: "Π", pitchfork: "⋔", piv: "ϖ", planck: "ℏ", planckh: "ℎ", plankv: "ℏ", plus: "+", plusacir: "⨣", plusb: "⊞", pluscir: "⨢", plusdo: "∔", plusdu: "⨥", pluse: "⩲", PlusMinus: "±", plusmn: "±", plussim: "⨦", plustwo: "⨧", pm: "±", Poincareplane: "ℌ", pointint: "⨕", popf: "𝕡", Popf: "ℙ", pound: "£", pr: "≺", Pr: "⪻", prap: "⪷", prcue: "≼", pre: "⪯", prE: "⪳", prec: "≺", precapprox: "⪷", preccurlyeq: "≼", Precedes: "≺", PrecedesEqual: "⪯", PrecedesSlantEqual: "≼", PrecedesTilde: "≾", preceq: "⪯", precnapprox: "⪹", precneqq: "⪵", precnsim: "⋨", precsim: "≾", prime: "′", Prime: "″", primes: "ℙ", prnap: "⪹", prnE: "⪵", prnsim: "⋨", prod: "∏", Product: "∏", profalar: "⌮", profline: "⌒", profsurf: "⌓", prop: "∝", Proportion: "∷", Proportional: "∝", propto: "∝", prsim: "≾", prurel: "⊰", pscr: "𝓅", Pscr: "𝒫", psi: "ψ", Psi: "Ψ", puncsp: " ", qfr: "𝔮", Qfr: "𝔔", qint: "⨌", qopf: "𝕢", Qopf: "ℚ", qprime: "⁗", qscr: "𝓆", Qscr: "𝒬", quaternions: "ℍ", quatint: "⨖", quest: "?", questeq: "≟", quot: '"', QUOT: '"', rAarr: "⇛", race: "∽̱", racute: "ŕ", Racute: "Ŕ", radic: "√", raemptyv: "⦳", rang: "⟩", Rang: "⟫", rangd: "⦒", range: "⦥", rangle: "⟩", raquo: "»", rarr: "→", rArr: "⇒", Rarr: "↠", rarrap: "⥵", rarrb: "⇥", rarrbfs: "⤠", rarrc: "⤳", rarrfs: "⤞", rarrhk: "↪", rarrlp: "↬", rarrpl: "⥅", rarrsim: "⥴", rarrtl: "↣", Rarrtl: "⤖", rarrw: "↝", ratail: "⤚", rAtail: "⤜", ratio: "∶", rationals: "ℚ", rbarr: "⤍", rBarr: "⤏", RBarr: "⤐", rbbrk: "❳", rbrace: "}", rbrack: "]", rbrke: "⦌", rbrksld: "⦎", rbrkslu: "⦐", rcaron: "ř", Rcaron: "Ř", rcedil: "ŗ", Rcedil: "Ŗ", rceil: "⌉", rcub: "}", rcy: "р", Rcy: "Р", rdca: "⤷", rdldhar: "⥩", rdquo: "”", rdquor: "”", rdsh: "↳", Re: "ℜ", real: "ℜ", realine: "ℛ", realpart: "ℜ", reals: "ℝ", rect: "▭", reg: "®", REG: "®", ReverseElement: "∋", ReverseEquilibrium: "⇋", ReverseUpEquilibrium: "⥯", rfisht: "⥽", rfloor: "⌋", rfr: "𝔯", Rfr: "ℜ", rHar: "⥤", rhard: "⇁", rharu: "⇀", rharul: "⥬", rho: "ρ", Rho: "Ρ", rhov: "ϱ", RightAngleBracket: "⟩", rightarrow: "→", Rightarrow: "⇒", RightArrow: "→", RightArrowBar: "⇥", RightArrowLeftArrow: "⇄", rightarrowtail: "↣", RightCeiling: "⌉", RightDoubleBracket: "⟧", RightDownTeeVector: "⥝", RightDownVector: "⇂", RightDownVectorBar: "⥕", RightFloor: "⌋", rightharpoondown: "⇁", rightharpoonup: "⇀", rightleftarrows: "⇄", rightleftharpoons: "⇌", rightrightarrows: "⇉", rightsquigarrow: "↝", RightTee: "⊢", RightTeeArrow: "↦", RightTeeVector: "⥛", rightthreetimes: "⋌", RightTriangle: "⊳", RightTriangleBar: "⧐", RightTriangleEqual: "⊵", RightUpDownVector: "⥏", RightUpTeeVector: "⥜", RightUpVector: "↾", RightUpVectorBar: "⥔", RightVector: "⇀", RightVectorBar: "⥓", ring: "˚", risingdotseq: "≓", rlarr: "⇄", rlhar: "⇌", rlm: "‏", rmoust: "⎱", rmoustache: "⎱", rnmid: "⫮", roang: "⟭", roarr: "⇾", robrk: "⟧", ropar: "⦆", ropf: "𝕣", Ropf: "ℝ", roplus: "⨮", rotimes: "⨵", RoundImplies: "⥰", rpar: ")", rpargt: "⦔", rppolint: "⨒", rrarr: "⇉", Rrightarrow: "⇛", rsaquo: "›", rscr: "𝓇", Rscr: "ℛ", rsh: "↱", Rsh: "↱", rsqb: "]", rsquo: "’", rsquor: "’", rthree: "⋌", rtimes: "⋊", rtri: "▹", rtrie: "⊵", rtrif: "▸", rtriltri: "⧎", RuleDelayed: "⧴", ruluhar: "⥨", rx: "℞", sacute: "ś", Sacute: "Ś", sbquo: "‚", sc: "≻", Sc: "⪼", scap: "⪸", scaron: "š", Scaron: "Š", sccue: "≽", sce: "⪰", scE: "⪴", scedil: "ş", Scedil: "Ş", scirc: "ŝ", Scirc: "Ŝ", scnap: "⪺", scnE: "⪶", scnsim: "⋩", scpolint: "⨓", scsim: "≿", scy: "с", Scy: "С", sdot: "⋅", sdotb: "⊡", sdote: "⩦", searhk: "⤥", searr: "↘", seArr: "⇘", searrow: "↘", sect: "§", semi: ";", seswar: "⤩", setminus: "∖", setmn: "∖", sext: "✶", sfr: "𝔰", Sfr: "𝔖", sfrown: "⌢", sharp: "♯", shchcy: "щ", SHCHcy: "Щ", shcy: "ш", SHcy: "Ш", ShortDownArrow: "↓", ShortLeftArrow: "←", shortmid: "∣", shortparallel: "∥", ShortRightArrow: "→", ShortUpArrow: "↑", shy: "­", sigma: "σ", Sigma: "Σ", sigmaf: "ς", sigmav: "ς", sim: "∼", simdot: "⩪", sime: "≃", simeq: "≃", simg: "⪞", simgE: "⪠", siml: "⪝", simlE: "⪟", simne: "≆", simplus: "⨤", simrarr: "⥲", slarr: "←", SmallCircle: "∘", smallsetminus: "∖", smashp: "⨳", smeparsl: "⧤", smid: "∣", smile: "⌣", smt: "⪪", smte: "⪬", smtes: "⪬︀", softcy: "ь", SOFTcy: "Ь", sol: "/", solb: "⧄", solbar: "⌿", sopf: "𝕤", Sopf: "𝕊", spades: "♠", spadesuit: "♠", spar: "∥", sqcap: "⊓", sqcaps: "⊓︀", sqcup: "⊔", sqcups: "⊔︀", Sqrt: "√", sqsub: "⊏", sqsube: "⊑", sqsubset: "⊏", sqsubseteq: "⊑", sqsup: "⊐", sqsupe: "⊒", sqsupset: "⊐", sqsupseteq: "⊒", squ: "□", square: "□", Square: "□", SquareIntersection: "⊓", SquareSubset: "⊏", SquareSubsetEqual: "⊑", SquareSuperset: "⊐", SquareSupersetEqual: "⊒", SquareUnion: "⊔", squarf: "▪", squf: "▪", srarr: "→", sscr: "𝓈", Sscr: "𝒮", ssetmn: "∖", ssmile: "⌣", sstarf: "⋆", star: "☆", Star: "⋆", starf: "★", straightepsilon: "ϵ", straightphi: "ϕ", strns: "¯", sub: "⊂", Sub: "⋐", subdot: "⪽", sube: "⊆", subE: "⫅", subedot: "⫃", submult: "⫁", subne: "⊊", subnE: "⫋", subplus: "⪿", subrarr: "⥹", subset: "⊂", Subset: "⋐", subseteq: "⊆", subseteqq: "⫅", SubsetEqual: "⊆", subsetneq: "⊊", subsetneqq: "⫋", subsim: "⫇", subsub: "⫕", subsup: "⫓", succ: "≻", succapprox: "⪸", succcurlyeq: "≽", Succeeds: "≻", SucceedsEqual: "⪰", SucceedsSlantEqual: "≽", SucceedsTilde: "≿", succeq: "⪰", succnapprox: "⪺", succneqq: "⪶", succnsim: "⋩", succsim: "≿", SuchThat: "∋", sum: "∑", Sum: "∑", sung: "♪", sup: "⊃", Sup: "⋑", sup1: "¹", sup2: "²", sup3: "³", supdot: "⪾", supdsub: "⫘", supe: "⊇", supE: "⫆", supedot: "⫄", Superset: "⊃", SupersetEqual: "⊇", suphsol: "⟉", suphsub: "⫗", suplarr: "⥻", supmult: "⫂", supne: "⊋", supnE: "⫌", supplus: "⫀", supset: "⊃", Supset: "⋑", supseteq: "⊇", supseteqq: "⫆", supsetneq: "⊋", supsetneqq: "⫌", supsim: "⫈", supsub: "⫔", supsup: "⫖", swarhk: "⤦", swarr: "↙", swArr: "⇙", swarrow: "↙", swnwar: "⤪", szlig: "ß", Tab: "	", target: "⌖", tau: "τ", Tau: "Τ", tbrk: "⎴", tcaron: "ť", Tcaron: "Ť", tcedil: "ţ", Tcedil: "Ţ", tcy: "т", Tcy: "Т", tdot: "⃛", telrec: "⌕", tfr: "𝔱", Tfr: "𝔗", there4: "∴", therefore: "∴", Therefore: "∴", theta: "θ", Theta: "Θ", thetasym: "ϑ", thetav: "ϑ", thickapprox: "≈", thicksim: "∼", ThickSpace: "  ", thinsp: " ", ThinSpace: " ", thkap: "≈", thksim: "∼", thorn: "þ", THORN: "Þ", tilde: "˜", Tilde: "∼", TildeEqual: "≃", TildeFullEqual: "≅", TildeTilde: "≈", times: "×", timesb: "⊠", timesbar: "⨱", timesd: "⨰", tint: "∭", toea: "⤨", top: "⊤", topbot: "⌶", topcir: "⫱", topf: "𝕥", Topf: "𝕋", topfork: "⫚", tosa: "⤩", tprime: "‴", trade: "™", TRADE: "™", triangle: "▵", triangledown: "▿", triangleleft: "◃", trianglelefteq: "⊴", triangleq: "≜", triangleright: "▹", trianglerighteq: "⊵", tridot: "◬", trie: "≜", triminus: "⨺", TripleDot: "⃛", triplus: "⨹", trisb: "⧍", tritime: "⨻", trpezium: "⏢", tscr: "𝓉", Tscr: "𝒯", tscy: "ц", TScy: "Ц", tshcy: "ћ", TSHcy: "Ћ", tstrok: "ŧ", Tstrok: "Ŧ", twixt: "≬", twoheadleftarrow: "↞", twoheadrightarrow: "↠", uacute: "ú", Uacute: "Ú", uarr: "↑", uArr: "⇑", Uarr: "↟", Uarrocir: "⥉", ubrcy: "ў", Ubrcy: "Ў", ubreve: "ŭ", Ubreve: "Ŭ", ucirc: "û", Ucirc: "Û", ucy: "у", Ucy: "У", udarr: "⇅", udblac: "ű", Udblac: "Ű", udhar: "⥮", ufisht: "⥾", ufr: "𝔲", Ufr: "𝔘", ugrave: "ù", Ugrave: "Ù", uHar: "⥣", uharl: "↿", uharr: "↾", uhblk: "▀", ulcorn: "⌜", ulcorner: "⌜", ulcrop: "⌏", ultri: "◸", umacr: "ū", Umacr: "Ū", uml: "¨", UnderBar: "_", UnderBrace: "⏟", UnderBracket: "⎵", UnderParenthesis: "⏝", Union: "⋃", UnionPlus: "⊎", uogon: "ų", Uogon: "Ų", uopf: "𝕦", Uopf: "𝕌", uparrow: "↑", Uparrow: "⇑", UpArrow: "↑", UpArrowBar: "⤒", UpArrowDownArrow: "⇅", updownarrow: "↕", Updownarrow: "⇕", UpDownArrow: "↕", UpEquilibrium: "⥮", upharpoonleft: "↿", upharpoonright: "↾", uplus: "⊎", UpperLeftArrow: "↖", UpperRightArrow: "↗", upsi: "υ", Upsi: "ϒ", upsih: "ϒ", upsilon: "υ", Upsilon: "Υ", UpTee: "⊥", UpTeeArrow: "↥", upuparrows: "⇈", urcorn: "⌝", urcorner: "⌝", urcrop: "⌎", uring: "ů", Uring: "Ů", urtri: "◹", uscr: "𝓊", Uscr: "𝒰", utdot: "⋰", utilde: "ũ", Utilde: "Ũ", utri: "▵", utrif: "▴", uuarr: "⇈", uuml: "ü", Uuml: "Ü", uwangle: "⦧", vangrt: "⦜", varepsilon: "ϵ", varkappa: "ϰ", varnothing: "∅", varphi: "ϕ", varpi: "ϖ", varpropto: "∝", varr: "↕", vArr: "⇕", varrho: "ϱ", varsigma: "ς", varsubsetneq: "⊊︀", varsubsetneqq: "⫋︀", varsupsetneq: "⊋︀", varsupsetneqq: "⫌︀", vartheta: "ϑ", vartriangleleft: "⊲", vartriangleright: "⊳", vBar: "⫨", Vbar: "⫫", vBarv: "⫩", vcy: "в", Vcy: "В", vdash: "⊢", vDash: "⊨", Vdash: "⊩", VDash: "⊫", Vdashl: "⫦", vee: "∨", Vee: "⋁", veebar: "⊻", veeeq: "≚", vellip: "⋮", verbar: "|", Verbar: "‖", vert: "|", Vert: "‖", VerticalBar: "∣", VerticalLine: "|", VerticalSeparator: "❘", VerticalTilde: "≀", VeryThinSpace: " ", vfr: "𝔳", Vfr: "𝔙", vltri: "⊲", vnsub: "⊂⃒", vnsup: "⊃⃒", vopf: "𝕧", Vopf: "𝕍", vprop: "∝", vrtri: "⊳", vscr: "𝓋", Vscr: "𝒱", vsubne: "⊊︀", vsubnE: "⫋︀", vsupne: "⊋︀", vsupnE: "⫌︀", Vvdash: "⊪", vzigzag: "⦚", wcirc: "ŵ", Wcirc: "Ŵ", wedbar: "⩟", wedge: "∧", Wedge: "⋀", wedgeq: "≙", weierp: "℘", wfr: "𝔴", Wfr: "𝔚", wopf: "𝕨", Wopf: "𝕎", wp: "℘", wr: "≀", wreath: "≀", wscr: "𝓌", Wscr: "𝒲", xcap: "⋂", xcirc: "◯", xcup: "⋃", xdtri: "▽", xfr: "𝔵", Xfr: "𝔛", xharr: "⟷", xhArr: "⟺", xi: "ξ", Xi: "Ξ", xlarr: "⟵", xlArr: "⟸", xmap: "⟼", xnis: "⋻", xodot: "⨀", xopf: "𝕩", Xopf: "𝕏", xoplus: "⨁", xotime: "⨂", xrarr: "⟶", xrArr: "⟹", xscr: "𝓍", Xscr: "𝒳", xsqcup: "⨆", xuplus: "⨄", xutri: "△", xvee: "⋁", xwedge: "⋀", yacute: "ý", Yacute: "Ý", yacy: "я", YAcy: "Я", ycirc: "ŷ", Ycirc: "Ŷ", ycy: "ы", Ycy: "Ы", yen: "¥", yfr: "𝔶", Yfr: "𝔜", yicy: "ї", YIcy: "Ї", yopf: "𝕪", Yopf: "𝕐", yscr: "𝓎", Yscr: "𝒴", yucy: "ю", YUcy: "Ю", yuml: "ÿ", Yuml: "Ÿ", zacute: "ź", Zacute: "Ź", zcaron: "ž", Zcaron: "Ž", zcy: "з", Zcy: "З", zdot: "ż", Zdot: "Ż", zeetrf: "ℨ", ZeroWidthSpace: "​", zeta: "ζ", Zeta: "Ζ", zfr: "𝔷", Zfr: "ℨ", zhcy: "ж", ZHcy: "Ж", zigrarr: "⇝", zopf: "𝕫", Zopf: "ℤ", zscr: "𝓏", Zscr: "𝒵", zwj: "‍", zwnj: "‌" }, O = { aacute: "á", Aacute: "Á", acirc: "â", Acirc: "Â", acute: "´", aelig: "æ", AElig: "Æ", agrave: "à", Agrave: "À", amp: "&", AMP: "&", aring: "å", Aring: "Å", atilde: "ã", Atilde: "Ã", auml: "ä", Auml: "Ä", brvbar: "¦", ccedil: "ç", Ccedil: "Ç", cedil: "¸", cent: "¢", copy: "©", COPY: "©", curren: "¤", deg: "°", divide: "÷", eacute: "é", Eacute: "É", ecirc: "ê", Ecirc: "Ê", egrave: "è", Egrave: "È", eth: "ð", ETH: "Ð", euml: "ë", Euml: "Ë", frac12: "½", frac14: "¼", frac34: "¾", gt: ">", GT: ">", iacute: "í", Iacute: "Í", icirc: "î", Icirc: "Î", iexcl: "¡", igrave: "ì", Igrave: "Ì", iquest: "¿", iuml: "ï", Iuml: "Ï", laquo: "«", lt: "<", LT: "<", macr: "¯", micro: "µ", middot: "·", nbsp: " ", not: "¬", ntilde: "ñ", Ntilde: "Ñ", oacute: "ó", Oacute: "Ó", ocirc: "ô", Ocirc: "Ô", ograve: "ò", Ograve: "Ò", ordf: "ª", ordm: "º", oslash: "ø", Oslash: "Ø", otilde: "õ", Otilde: "Õ", ouml: "ö", Ouml: "Ö", para: "¶", plusmn: "±", pound: "£", quot: '"', QUOT: '"', raquo: "»", reg: "®", REG: "®", sect: "§", shy: "­", sup1: "¹", sup2: "²", sup3: "³", szlig: "ß", thorn: "þ", THORN: "Þ", times: "×", uacute: "ú", Uacute: "Ú", ucirc: "û", Ucirc: "Û", ugrave: "ù", Ugrave: "Ù", uml: "¨", uuml: "ü", Uuml: "Ü", yacute: "ý", Yacute: "Ý", yen: "¥", yuml: "ÿ" }, M = { 0: "�", 128: "€", 130: "‚", 131: "ƒ", 132: "„", 133: "…", 134: "†", 135: "‡", 136: "ˆ", 137: "‰", 138: "Š", 139: "‹", 140: "Œ", 142: "Ž", 145: "‘", 146: "’", 147: "“", 148: "”", 149: "•", 150: "–", 151: "—", 152: "˜", 153: "™", 154: "š", 155: "›", 156: "œ", 158: "ž", 159: "Ÿ" }, L = [1, 2, 3, 4, 5, 6, 7, 8, 11, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 64976, 64977, 64978, 64979, 64980, 64981, 64982, 64983, 64984, 64985, 64986, 64987, 64988, 64989, 64990, 64991, 64992, 64993, 64994, 64995, 64996, 64997, 64998, 64999, 65e3, 65001, 65002, 65003, 65004, 65005, 65006, 65007, 65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111], q = String.fromCharCode, z = {}, X = z.hasOwnProperty, ee = function(I, P) {
      return X.call(I, P);
    }, V = function(I, P) {
      for (var Y = -1, te = I.length; ++Y < te; )
        if (I[Y] == P)
          return !0;
      return !1;
    }, oe = function(I, P) {
      if (!I)
        return P;
      var Y = {}, te;
      for (te in P)
        Y[te] = ee(I, te) ? I[te] : P[te];
      return Y;
    }, W = function(I, P) {
      var Y = "";
      return I >= 55296 && I <= 57343 || I > 1114111 ? (P && S("character reference outside the permissible Unicode range"), "�") : ee(M, I) ? (P && S("disallowed character reference"), M[I]) : (P && V(L, I) && S("disallowed character reference"), I > 65535 && (I -= 65536, Y += q(I >>> 10 & 1023 | 55296), I = 56320 | I & 1023), Y += q(I), Y);
    }, A = function(I) {
      return "&#x" + I.toString(16).toUpperCase() + ";";
    }, E = function(I) {
      return "&#" + I + ";";
    }, S = function(I) {
      throw Error("Parse error: " + I);
    }, $ = function(I, P) {
      P = oe(P, $.options);
      var Y = P.strict;
      Y && g.test(I) && S("forbidden code point");
      var te = P.encodeEverything, we = P.useNamedReferences, se = P.allowUnsafeSymbols, ae = P.decimal ? E : A, De = function(he) {
        return ae(he.charCodeAt(0));
      };
      return te ? (I = I.replace(s, function(he) {
        return we && ee(d, he) ? "&" + d[he] + ";" : De(he);
      }), we && (I = I.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;").replace(/&#x66;&#x6A;/g, "&fjlig;")), we && (I = I.replace(l, function(he) {
        return "&" + d[he] + ";";
      }))) : we ? (se || (I = I.replace(h, function(he) {
        return "&" + d[he] + ";";
      })), I = I.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;"), I = I.replace(l, function(he) {
        return "&" + d[he] + ";";
      })) : se || (I = I.replace(h, De)), I.replace(o, function(he) {
        var ye = he.charCodeAt(0), $e = he.charCodeAt(1), Me = (ye - 55296) * 1024 + $e - 56320 + 65536;
        return ae(Me);
      }).replace(i, De);
    };
    $.options = {
      allowUnsafeSymbols: !1,
      encodeEverything: !1,
      strict: !1,
      useNamedReferences: !1,
      decimal: !1
    };
    var w = function(I, P) {
      P = oe(P, w.options);
      var Y = P.strict;
      return Y && f.test(I) && S("malformed character reference"), I.replace(D, function(te, we, se, ae, De, he, ye, $e, Me) {
        var Ie, je, dt, pr, $t, Mt;
        return we ? ($t = we, _[$t]) : se ? ($t = se, Mt = ae, Mt && P.isAttributeValue ? (Y && Mt == "=" && S("`&` did not start a character reference"), te) : (Y && S(
          "named character reference was not terminated by a semicolon"
        ), O[$t] + (Mt || ""))) : De ? (dt = De, je = he, Y && !je && S("character reference was not terminated by a semicolon"), Ie = parseInt(dt, 10), W(Ie, Y)) : ye ? (pr = ye, je = $e, Y && !je && S("character reference was not terminated by a semicolon"), Ie = parseInt(pr, 16), W(Ie, Y)) : (Y && S(
          "named character reference was not terminated by a semicolon"
        ), te);
      });
    };
    w.options = {
      isAttributeValue: !1,
      strict: !1
    };
    var k = function(I) {
      return I.replace(h, function(P) {
        return c[P];
      });
    }, T = {
      version: "1.2.0",
      encode: $,
      decode: w,
      escape: k,
      unescape: w
    };
    if (u && !u.nodeType)
      if (n)
        n.exports = T;
      else
        for (var F in T)
          ee(T, F) && (u[F] = T[F]);
    else
      e.he = T;
  })(de);
})(dn, dn.exports);
var Nd = dn.exports;
const Us = /* @__PURE__ */ xn(Nd), qd = /* @__PURE__ */ ue({
  __name: "VTooltip",
  props: {
    content: { default: "" },
    componentProps: { default: () => ({}) },
    placement: { default: "bottom" },
    tooltipClass: { default: "" },
    size: { default: "md" },
    maxWidth: { default: "300px" },
    disabled: { type: Boolean, default: !1 },
    type: { default: "default" }
  },
  setup(r, { expose: t }) {
    const e = r, u = Q(null), n = Q(), a = Q(), o = G(() => [
      _["v-tooltip__tooltip"],
      _[`v-tooltip__tooltip--${e.size}`],
      _[`v-tooltip__tooltip--${e.type}`],
      e.tooltipClass
    ].filter(Boolean)), s = Q(!1), i = G(() => ({
      ontouchstart: c,
      ontouchend: f,
      onmouseenter: c,
      onmouseleave: f,
      onclick: c
    })), l = /(https?:\/\/[^\s]+)/g, d = G(() => {
      if (typeof e.content != "string")
        return () => Ze("div", {
          class: o.value,
          ...i.value
        }, [
          Ze(e.content, {
            ...e.componentProps
          })
        ]);
      const O = Us.decode(e.content || "").split(l);
      return () => Ze("div", {
        class: o.value,
        ...i.value
      }, O.map((M) => l.test(M) ? Ze("a", {
        href: M,
        target: "_blank",
        rel: "noopener noreferrer"
      }, [M]) : M));
    });
    let h = null;
    const c = () => {
      h && clearTimeout(h), !e.disabled && (s.value = !0);
    }, f = () => {
      h && clearTimeout(h), h = window.setTimeout(() => {
        s.value = !1;
      }, 200);
    }, g = () => {
      u.value && (u.value.destroy(), u.value = null);
      const O = a.value;
      Pe(() => {
        O && document.body.removeChild(O);
      });
    };
    qe(() => s.value, async (O) => {
      await Pe(), O && n.value && a.value ? (u.value = Tt(n.value, a.value, {
        placement: e.placement,
        modifiers: [
          St,
          {
            name: "offset",
            options: {
              offset: [0, 4]
            }
          }
        ]
      }), a.value.style.maxWidth = D.value, document.body.appendChild(a.value)) : !O && u.value && a.value && g();
    });
    const D = G(() => e.maxWidth);
    Yt(() => {
      g();
    }), t({
      trigger: n
    });
    const _ = be();
    return (O, M) => (m(), x("div", Te({
      ref_key: "trigger",
      ref: n,
      class: p(_)["v-tooltip"]
    }, i.value), [
      K(O.$slots, "default", {}, () => [
        j(Fd)
      ]),
      s.value ? (m(), H(He(d.value), {
        key: 0,
        ref_key: "tooltip",
        ref: a
      }, null, 512)) : R("", !0)
    ], 16));
  }
}), Pd = {
  "v-tooltip": "_v-tooltip_1b2i1_1",
  "v-tooltip__tooltip": "_v-tooltip__tooltip_1b2i1_6",
  "v-tooltip__tooltip--danger": "_v-tooltip__tooltip--danger_1b2i1_31",
  "v-tooltip__tooltip--md": "_v-tooltip__tooltip--md_1b2i1_35",
  "v-tooltip__tooltip--sm": "_v-tooltip__tooltip--sm_1b2i1_39"
}, Rd = {
  $style: Pd
}, Ve = /* @__PURE__ */ U(qd, [["__cssModules", Rd]]), Vd = /* @__PURE__ */ ue({
  __name: "VLabel",
  props: {
    withSpaceBottom: { type: Boolean, default: !0 },
    showRequiredStar: { type: Boolean, default: !1 },
    size: { default: "medium" },
    color: { default: "gray" },
    uppercase: { type: Boolean, default: !1 },
    helpText: { default: "" }
  },
  setup(r) {
    const t = tt(), e = G(() => !!t["label-right"]);
    return (u, n) => (m(), x("div", {
      class: b([
        u.$style["v-label"],
        u.$style[`v-label--${u.size}`],
        u.$style[`v-label--${u.color}`],
        {
          [u.$style["v-label--space-bottom"]]: u.withSpaceBottom,
          [u.$style["v-label--with-left"]]: e.value,
          [u.$style["v-label--uppercase"]]: u.uppercase
        }
      ])
    }, [
      C("div", {
        class: b(u.$style["v-label-wrapper"])
      }, [
        u.showRequiredStar ? (m(), x("span", {
          key: 0,
          class: b(u.$style["v-label__required-star"])
        }, " * ", 2)) : R("", !0),
        K(u.$slots, "default"),
        u.helpText ? (m(), H(Ve, {
          key: 1,
          placement: "top",
          content: u.helpText
        }, null, 8, ["content"])) : R("", !0)
      ], 2),
      K(u.$slots, "label-right")
    ], 2));
  }
}), jd = {
  "v-label": "_v-label_1suhg_1",
  "v-label--gray": "_v-label--gray_1suhg_8",
  "v-label--black": "_v-label--black_1suhg_12",
  "v-label--small": "_v-label--small_1suhg_16",
  "v-label--medium": "_v-label--medium_1suhg_20",
  "v-label--large": "_v-label--large_1suhg_24",
  "v-label--with-left": "_v-label--with-left_1suhg_28",
  "v-label--space-bottom": "_v-label--space-bottom_1suhg_33",
  "v-label--uppercase": "_v-label--uppercase_1suhg_37",
  "v-label-wrapper": "_v-label-wrapper_1suhg_41",
  "v-label__required-star": "_v-label__required-star_1suhg_47"
}, Hd = {
  $style: jd
}, zs = /* @__PURE__ */ U(Vd, [["__cssModules", Hd]]), Hi = (r, t) => {
  t.value ? r.style.opacity = "0" : r.style.opacity = "1";
}, En = {
  beforeMount: (r, t, e, u) => Hi(r, t),
  updated: (r, t, e) => Hi(r, t)
};
var Gs = {}, cu = {}, Xa = {}, du = {}, Ja = {};
Object.defineProperty(Ja, "__esModule", { value: !0 });
Ja.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(r) {
    return r.charCodeAt(0);
  })
);
var Qa = {};
Object.defineProperty(Qa, "__esModule", { value: !0 });
Qa.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(r) {
    return r.charCodeAt(0);
  })
);
var fa = {};
(function(r) {
  var t;
  Object.defineProperty(r, "__esModule", { value: !0 }), r.replaceCodePoint = r.fromCodePoint = void 0;
  var e = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  r.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (t = String.fromCodePoint) !== null && t !== void 0 ? t : function(a) {
    var o = "";
    return a > 65535 && (a -= 65536, o += String.fromCharCode(a >>> 10 & 1023 | 55296), a = 56320 | a & 1023), o += String.fromCharCode(a), o;
  };
  function u(a) {
    var o;
    return a >= 55296 && a <= 57343 || a > 1114111 ? 65533 : (o = e.get(a)) !== null && o !== void 0 ? o : a;
  }
  r.replaceCodePoint = u;
  function n(a) {
    return (0, r.fromCodePoint)(u(a));
  }
  r.default = n;
})(fa);
(function(r) {
  var t = de && de.__createBinding || (Object.create ? function(A, E, S, $) {
    $ === void 0 && ($ = S);
    var w = Object.getOwnPropertyDescriptor(E, S);
    (!w || ("get" in w ? !E.__esModule : w.writable || w.configurable)) && (w = { enumerable: !0, get: function() {
      return E[S];
    } }), Object.defineProperty(A, $, w);
  } : function(A, E, S, $) {
    $ === void 0 && ($ = S), A[$] = E[S];
  }), e = de && de.__setModuleDefault || (Object.create ? function(A, E) {
    Object.defineProperty(A, "default", { enumerable: !0, value: E });
  } : function(A, E) {
    A.default = E;
  }), u = de && de.__importStar || function(A) {
    if (A && A.__esModule)
      return A;
    var E = {};
    if (A != null)
      for (var S in A)
        S !== "default" && Object.prototype.hasOwnProperty.call(A, S) && t(E, A, S);
    return e(E, A), E;
  }, n = de && de.__importDefault || function(A) {
    return A && A.__esModule ? A : { default: A };
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.decodeXML = r.decodeHTMLStrict = r.decodeHTMLAttribute = r.decodeHTML = r.determineBranch = r.EntityDecoder = r.DecodingMode = r.BinTrieFlags = r.fromCodePoint = r.replaceCodePoint = r.decodeCodePoint = r.xmlDecodeTree = r.htmlDecodeTree = void 0;
  var a = n(Ja);
  r.htmlDecodeTree = a.default;
  var o = n(Qa);
  r.xmlDecodeTree = o.default;
  var s = u(fa);
  r.decodeCodePoint = s.default;
  var i = fa;
  Object.defineProperty(r, "replaceCodePoint", { enumerable: !0, get: function() {
    return i.replaceCodePoint;
  } }), Object.defineProperty(r, "fromCodePoint", { enumerable: !0, get: function() {
    return i.fromCodePoint;
  } });
  var l;
  (function(A) {
    A[A.NUM = 35] = "NUM", A[A.SEMI = 59] = "SEMI", A[A.EQUALS = 61] = "EQUALS", A[A.ZERO = 48] = "ZERO", A[A.NINE = 57] = "NINE", A[A.LOWER_A = 97] = "LOWER_A", A[A.LOWER_F = 102] = "LOWER_F", A[A.LOWER_X = 120] = "LOWER_X", A[A.LOWER_Z = 122] = "LOWER_Z", A[A.UPPER_A = 65] = "UPPER_A", A[A.UPPER_F = 70] = "UPPER_F", A[A.UPPER_Z = 90] = "UPPER_Z";
  })(l || (l = {}));
  var d = 32, h;
  (function(A) {
    A[A.VALUE_LENGTH = 49152] = "VALUE_LENGTH", A[A.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", A[A.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(h = r.BinTrieFlags || (r.BinTrieFlags = {}));
  function c(A) {
    return A >= l.ZERO && A <= l.NINE;
  }
  function f(A) {
    return A >= l.UPPER_A && A <= l.UPPER_F || A >= l.LOWER_A && A <= l.LOWER_F;
  }
  function g(A) {
    return A >= l.UPPER_A && A <= l.UPPER_Z || A >= l.LOWER_A && A <= l.LOWER_Z || c(A);
  }
  function D(A) {
    return A === l.EQUALS || g(A);
  }
  var _;
  (function(A) {
    A[A.EntityStart = 0] = "EntityStart", A[A.NumericStart = 1] = "NumericStart", A[A.NumericDecimal = 2] = "NumericDecimal", A[A.NumericHex = 3] = "NumericHex", A[A.NamedEntity = 4] = "NamedEntity";
  })(_ || (_ = {}));
  var O;
  (function(A) {
    A[A.Legacy = 0] = "Legacy", A[A.Strict = 1] = "Strict", A[A.Attribute = 2] = "Attribute";
  })(O = r.DecodingMode || (r.DecodingMode = {}));
  var M = (
    /** @class */
    function() {
      function A(E, S, $) {
        this.decodeTree = E, this.emitCodePoint = S, this.errors = $, this.state = _.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = O.Strict;
      }
      return A.prototype.startEntity = function(E) {
        this.decodeMode = E, this.state = _.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
      }, A.prototype.write = function(E, S) {
        switch (this.state) {
          case _.EntityStart:
            return E.charCodeAt(S) === l.NUM ? (this.state = _.NumericStart, this.consumed += 1, this.stateNumericStart(E, S + 1)) : (this.state = _.NamedEntity, this.stateNamedEntity(E, S));
          case _.NumericStart:
            return this.stateNumericStart(E, S);
          case _.NumericDecimal:
            return this.stateNumericDecimal(E, S);
          case _.NumericHex:
            return this.stateNumericHex(E, S);
          case _.NamedEntity:
            return this.stateNamedEntity(E, S);
        }
      }, A.prototype.stateNumericStart = function(E, S) {
        return S >= E.length ? -1 : (E.charCodeAt(S) | d) === l.LOWER_X ? (this.state = _.NumericHex, this.consumed += 1, this.stateNumericHex(E, S + 1)) : (this.state = _.NumericDecimal, this.stateNumericDecimal(E, S));
      }, A.prototype.addToNumericResult = function(E, S, $, w) {
        if (S !== $) {
          var k = $ - S;
          this.result = this.result * Math.pow(w, k) + parseInt(E.substr(S, k), w), this.consumed += k;
        }
      }, A.prototype.stateNumericHex = function(E, S) {
        for (var $ = S; S < E.length; ) {
          var w = E.charCodeAt(S);
          if (c(w) || f(w))
            S += 1;
          else
            return this.addToNumericResult(E, $, S, 16), this.emitNumericEntity(w, 3);
        }
        return this.addToNumericResult(E, $, S, 16), -1;
      }, A.prototype.stateNumericDecimal = function(E, S) {
        for (var $ = S; S < E.length; ) {
          var w = E.charCodeAt(S);
          if (c(w))
            S += 1;
          else
            return this.addToNumericResult(E, $, S, 10), this.emitNumericEntity(w, 2);
        }
        return this.addToNumericResult(E, $, S, 10), -1;
      }, A.prototype.emitNumericEntity = function(E, S) {
        var $;
        if (this.consumed <= S)
          return ($ = this.errors) === null || $ === void 0 || $.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (E === l.SEMI)
          this.consumed += 1;
        else if (this.decodeMode === O.Strict)
          return 0;
        return this.emitCodePoint((0, s.replaceCodePoint)(this.result), this.consumed), this.errors && (E !== l.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }, A.prototype.stateNamedEntity = function(E, S) {
        for (var $ = this.decodeTree, w = $[this.treeIndex], k = (w & h.VALUE_LENGTH) >> 14; S < E.length; S++, this.excess++) {
          var T = E.charCodeAt(S);
          if (this.treeIndex = q($, w, this.treeIndex + Math.max(1, k), T), this.treeIndex < 0)
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === O.Attribute && // We shouldn't have consumed any characters after the entity,
            (k === 0 || // And there should be no invalid characters.
            D(T)) ? 0 : this.emitNotTerminatedNamedEntity();
          if (w = $[this.treeIndex], k = (w & h.VALUE_LENGTH) >> 14, k !== 0) {
            if (T === l.SEMI)
              return this.emitNamedEntityData(this.treeIndex, k, this.consumed + this.excess);
            this.decodeMode !== O.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
        }
        return -1;
      }, A.prototype.emitNotTerminatedNamedEntity = function() {
        var E, S = this, $ = S.result, w = S.decodeTree, k = (w[$] & h.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData($, k, this.consumed), (E = this.errors) === null || E === void 0 || E.missingSemicolonAfterCharacterReference(), this.consumed;
      }, A.prototype.emitNamedEntityData = function(E, S, $) {
        var w = this.decodeTree;
        return this.emitCodePoint(S === 1 ? w[E] & ~h.VALUE_LENGTH : w[E + 1], $), S === 3 && this.emitCodePoint(w[E + 2], $), $;
      }, A.prototype.end = function() {
        var E;
        switch (this.state) {
          case _.NamedEntity:
            return this.result !== 0 && (this.decodeMode !== O.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          case _.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case _.NumericHex:
            return this.emitNumericEntity(0, 3);
          case _.NumericStart:
            return (E = this.errors) === null || E === void 0 || E.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case _.EntityStart:
            return 0;
        }
      }, A;
    }()
  );
  r.EntityDecoder = M;
  function L(A) {
    var E = "", S = new M(A, function($) {
      return E += (0, s.fromCodePoint)($);
    });
    return function(w, k) {
      for (var T = 0, F = 0; (F = w.indexOf("&", F)) >= 0; ) {
        E += w.slice(T, F), S.startEntity(k);
        var I = S.write(
          w,
          // Skip the "&"
          F + 1
        );
        if (I < 0) {
          T = F + S.end();
          break;
        }
        T = F + I, F = I === 0 ? T + 1 : T;
      }
      var P = E + w.slice(T);
      return E = "", P;
    };
  }
  function q(A, E, S, $) {
    var w = (E & h.BRANCH_LENGTH) >> 7, k = E & h.JUMP_TABLE;
    if (w === 0)
      return k !== 0 && $ === k ? S : -1;
    if (k) {
      var T = $ - k;
      return T < 0 || T >= w ? -1 : A[S + T] - 1;
    }
    for (var F = S, I = F + w - 1; F <= I; ) {
      var P = F + I >>> 1, Y = A[P];
      if (Y < $)
        F = P + 1;
      else if (Y > $)
        I = P - 1;
      else
        return A[P + w];
    }
    return -1;
  }
  r.determineBranch = q;
  var z = L(a.default), X = L(o.default);
  function ee(A, E) {
    return E === void 0 && (E = O.Legacy), z(A, E);
  }
  r.decodeHTML = ee;
  function V(A) {
    return z(A, O.Attribute);
  }
  r.decodeHTMLAttribute = V;
  function oe(A) {
    return z(A, O.Strict);
  }
  r.decodeHTMLStrict = oe;
  function W(A) {
    return X(A, O.Strict);
  }
  r.decodeXML = W;
})(du);
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.QuoteType = void 0;
  var t = du, e;
  (function(c) {
    c[c.Tab = 9] = "Tab", c[c.NewLine = 10] = "NewLine", c[c.FormFeed = 12] = "FormFeed", c[c.CarriageReturn = 13] = "CarriageReturn", c[c.Space = 32] = "Space", c[c.ExclamationMark = 33] = "ExclamationMark", c[c.Number = 35] = "Number", c[c.Amp = 38] = "Amp", c[c.SingleQuote = 39] = "SingleQuote", c[c.DoubleQuote = 34] = "DoubleQuote", c[c.Dash = 45] = "Dash", c[c.Slash = 47] = "Slash", c[c.Zero = 48] = "Zero", c[c.Nine = 57] = "Nine", c[c.Semi = 59] = "Semi", c[c.Lt = 60] = "Lt", c[c.Eq = 61] = "Eq", c[c.Gt = 62] = "Gt", c[c.Questionmark = 63] = "Questionmark", c[c.UpperA = 65] = "UpperA", c[c.LowerA = 97] = "LowerA", c[c.UpperF = 70] = "UpperF", c[c.LowerF = 102] = "LowerF", c[c.UpperZ = 90] = "UpperZ", c[c.LowerZ = 122] = "LowerZ", c[c.LowerX = 120] = "LowerX", c[c.OpeningSquareBracket = 91] = "OpeningSquareBracket";
  })(e || (e = {}));
  var u;
  (function(c) {
    c[c.Text = 1] = "Text", c[c.BeforeTagName = 2] = "BeforeTagName", c[c.InTagName = 3] = "InTagName", c[c.InSelfClosingTag = 4] = "InSelfClosingTag", c[c.BeforeClosingTagName = 5] = "BeforeClosingTagName", c[c.InClosingTagName = 6] = "InClosingTagName", c[c.AfterClosingTagName = 7] = "AfterClosingTagName", c[c.BeforeAttributeName = 8] = "BeforeAttributeName", c[c.InAttributeName = 9] = "InAttributeName", c[c.AfterAttributeName = 10] = "AfterAttributeName", c[c.BeforeAttributeValue = 11] = "BeforeAttributeValue", c[c.InAttributeValueDq = 12] = "InAttributeValueDq", c[c.InAttributeValueSq = 13] = "InAttributeValueSq", c[c.InAttributeValueNq = 14] = "InAttributeValueNq", c[c.BeforeDeclaration = 15] = "BeforeDeclaration", c[c.InDeclaration = 16] = "InDeclaration", c[c.InProcessingInstruction = 17] = "InProcessingInstruction", c[c.BeforeComment = 18] = "BeforeComment", c[c.CDATASequence = 19] = "CDATASequence", c[c.InSpecialComment = 20] = "InSpecialComment", c[c.InCommentLike = 21] = "InCommentLike", c[c.BeforeSpecialS = 22] = "BeforeSpecialS", c[c.SpecialStartSequence = 23] = "SpecialStartSequence", c[c.InSpecialTag = 24] = "InSpecialTag", c[c.BeforeEntity = 25] = "BeforeEntity", c[c.BeforeNumericEntity = 26] = "BeforeNumericEntity", c[c.InNamedEntity = 27] = "InNamedEntity", c[c.InNumericEntity = 28] = "InNumericEntity", c[c.InHexEntity = 29] = "InHexEntity";
  })(u || (u = {}));
  function n(c) {
    return c === e.Space || c === e.NewLine || c === e.Tab || c === e.FormFeed || c === e.CarriageReturn;
  }
  function a(c) {
    return c === e.Slash || c === e.Gt || n(c);
  }
  function o(c) {
    return c >= e.Zero && c <= e.Nine;
  }
  function s(c) {
    return c >= e.LowerA && c <= e.LowerZ || c >= e.UpperA && c <= e.UpperZ;
  }
  function i(c) {
    return c >= e.UpperA && c <= e.UpperF || c >= e.LowerA && c <= e.LowerF;
  }
  var l;
  (function(c) {
    c[c.NoValue = 0] = "NoValue", c[c.Unquoted = 1] = "Unquoted", c[c.Single = 2] = "Single", c[c.Double = 3] = "Double";
  })(l = r.QuoteType || (r.QuoteType = {}));
  var d = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    CdataEnd: new Uint8Array([93, 93, 62]),
    CommentEnd: new Uint8Array([45, 45, 62]),
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
    // `</title`
  }, h = (
    /** @class */
    function() {
      function c(f, g) {
        var D = f.xmlMode, _ = D === void 0 ? !1 : D, O = f.decodeEntities, M = O === void 0 ? !0 : O;
        this.cbs = g, this.state = u.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = u.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = _, this.decodeEntities = M, this.entityTrie = _ ? t.xmlDecodeTree : t.htmlDecodeTree;
      }
      return c.prototype.reset = function() {
        this.state = u.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = u.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
      }, c.prototype.write = function(f) {
        this.offset += this.buffer.length, this.buffer = f, this.parse();
      }, c.prototype.end = function() {
        this.running && this.finish();
      }, c.prototype.pause = function() {
        this.running = !1;
      }, c.prototype.resume = function() {
        this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
      }, c.prototype.getIndex = function() {
        return this.index;
      }, c.prototype.getSectionStart = function() {
        return this.sectionStart;
      }, c.prototype.stateText = function(f) {
        f === e.Lt || !this.decodeEntities && this.fastForwardTo(e.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = u.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && f === e.Amp && (this.state = u.BeforeEntity);
      }, c.prototype.stateSpecialStartSequence = function(f) {
        var g = this.sequenceIndex === this.currentSequence.length, D = g ? (
          // If we are at the end of the sequence, make sure the tag name has ended
          a(f)
        ) : (
          // Otherwise, do a case-insensitive comparison
          (f | 32) === this.currentSequence[this.sequenceIndex]
        );
        if (!D)
          this.isSpecial = !1;
        else if (!g) {
          this.sequenceIndex++;
          return;
        }
        this.sequenceIndex = 0, this.state = u.InTagName, this.stateInTagName(f);
      }, c.prototype.stateInSpecialTag = function(f) {
        if (this.sequenceIndex === this.currentSequence.length) {
          if (f === e.Gt || n(f)) {
            var g = this.index - this.currentSequence.length;
            if (this.sectionStart < g) {
              var D = this.index;
              this.index = g, this.cbs.ontext(this.sectionStart, g), this.index = D;
            }
            this.isSpecial = !1, this.sectionStart = g + 2, this.stateInClosingTagName(f);
            return;
          }
          this.sequenceIndex = 0;
        }
        (f | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === d.TitleEnd ? this.decodeEntities && f === e.Amp && (this.state = u.BeforeEntity) : this.fastForwardTo(e.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(f === e.Lt);
      }, c.prototype.stateCDATASequence = function(f) {
        f === d.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === d.Cdata.length && (this.state = u.InCommentLike, this.currentSequence = d.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = u.InDeclaration, this.stateInDeclaration(f));
      }, c.prototype.fastForwardTo = function(f) {
        for (; ++this.index < this.buffer.length + this.offset; )
          if (this.buffer.charCodeAt(this.index - this.offset) === f)
            return !0;
        return this.index = this.buffer.length + this.offset - 1, !1;
      }, c.prototype.stateInCommentLike = function(f) {
        f === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === d.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = u.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : f !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
      }, c.prototype.isTagStartChar = function(f) {
        return this.xmlMode ? !a(f) : s(f);
      }, c.prototype.startSpecial = function(f, g) {
        this.isSpecial = !0, this.currentSequence = f, this.sequenceIndex = g, this.state = u.SpecialStartSequence;
      }, c.prototype.stateBeforeTagName = function(f) {
        if (f === e.ExclamationMark)
          this.state = u.BeforeDeclaration, this.sectionStart = this.index + 1;
        else if (f === e.Questionmark)
          this.state = u.InProcessingInstruction, this.sectionStart = this.index + 1;
        else if (this.isTagStartChar(f)) {
          var g = f | 32;
          this.sectionStart = this.index, !this.xmlMode && g === d.TitleEnd[2] ? this.startSpecial(d.TitleEnd, 3) : this.state = !this.xmlMode && g === d.ScriptEnd[2] ? u.BeforeSpecialS : u.InTagName;
        } else
          f === e.Slash ? this.state = u.BeforeClosingTagName : (this.state = u.Text, this.stateText(f));
      }, c.prototype.stateInTagName = function(f) {
        a(f) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(f));
      }, c.prototype.stateBeforeClosingTagName = function(f) {
        n(f) || (f === e.Gt ? this.state = u.Text : (this.state = this.isTagStartChar(f) ? u.InClosingTagName : u.InSpecialComment, this.sectionStart = this.index));
      }, c.prototype.stateInClosingTagName = function(f) {
        (f === e.Gt || n(f)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.AfterClosingTagName, this.stateAfterClosingTagName(f));
      }, c.prototype.stateAfterClosingTagName = function(f) {
        (f === e.Gt || this.fastForwardTo(e.Gt)) && (this.state = u.Text, this.baseState = u.Text, this.sectionStart = this.index + 1);
      }, c.prototype.stateBeforeAttributeName = function(f) {
        f === e.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = u.InSpecialTag, this.sequenceIndex = 0) : this.state = u.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : f === e.Slash ? this.state = u.InSelfClosingTag : n(f) || (this.state = u.InAttributeName, this.sectionStart = this.index);
      }, c.prototype.stateInSelfClosingTag = function(f) {
        f === e.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = u.Text, this.baseState = u.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : n(f) || (this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(f));
      }, c.prototype.stateInAttributeName = function(f) {
        (f === e.Eq || a(f)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.AfterAttributeName, this.stateAfterAttributeName(f));
      }, c.prototype.stateAfterAttributeName = function(f) {
        f === e.Eq ? this.state = u.BeforeAttributeValue : f === e.Slash || f === e.Gt ? (this.cbs.onattribend(l.NoValue, this.index), this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(f)) : n(f) || (this.cbs.onattribend(l.NoValue, this.index), this.state = u.InAttributeName, this.sectionStart = this.index);
      }, c.prototype.stateBeforeAttributeValue = function(f) {
        f === e.DoubleQuote ? (this.state = u.InAttributeValueDq, this.sectionStart = this.index + 1) : f === e.SingleQuote ? (this.state = u.InAttributeValueSq, this.sectionStart = this.index + 1) : n(f) || (this.sectionStart = this.index, this.state = u.InAttributeValueNq, this.stateInAttributeValueNoQuotes(f));
      }, c.prototype.handleInAttributeValue = function(f, g) {
        f === g || !this.decodeEntities && this.fastForwardTo(g) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(g === e.DoubleQuote ? l.Double : l.Single, this.index), this.state = u.BeforeAttributeName) : this.decodeEntities && f === e.Amp && (this.baseState = this.state, this.state = u.BeforeEntity);
      }, c.prototype.stateInAttributeValueDoubleQuotes = function(f) {
        this.handleInAttributeValue(f, e.DoubleQuote);
      }, c.prototype.stateInAttributeValueSingleQuotes = function(f) {
        this.handleInAttributeValue(f, e.SingleQuote);
      }, c.prototype.stateInAttributeValueNoQuotes = function(f) {
        n(f) || f === e.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(l.Unquoted, this.index), this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(f)) : this.decodeEntities && f === e.Amp && (this.baseState = this.state, this.state = u.BeforeEntity);
      }, c.prototype.stateBeforeDeclaration = function(f) {
        f === e.OpeningSquareBracket ? (this.state = u.CDATASequence, this.sequenceIndex = 0) : this.state = f === e.Dash ? u.BeforeComment : u.InDeclaration;
      }, c.prototype.stateInDeclaration = function(f) {
        (f === e.Gt || this.fastForwardTo(e.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = u.Text, this.sectionStart = this.index + 1);
      }, c.prototype.stateInProcessingInstruction = function(f) {
        (f === e.Gt || this.fastForwardTo(e.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = u.Text, this.sectionStart = this.index + 1);
      }, c.prototype.stateBeforeComment = function(f) {
        f === e.Dash ? (this.state = u.InCommentLike, this.currentSequence = d.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = u.InDeclaration;
      }, c.prototype.stateInSpecialComment = function(f) {
        (f === e.Gt || this.fastForwardTo(e.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = u.Text, this.sectionStart = this.index + 1);
      }, c.prototype.stateBeforeSpecialS = function(f) {
        var g = f | 32;
        g === d.ScriptEnd[3] ? this.startSpecial(d.ScriptEnd, 4) : g === d.StyleEnd[3] ? this.startSpecial(d.StyleEnd, 4) : (this.state = u.InTagName, this.stateInTagName(f));
      }, c.prototype.stateBeforeEntity = function(f) {
        this.entityExcess = 1, this.entityResult = 0, f === e.Number ? this.state = u.BeforeNumericEntity : f === e.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = u.InNamedEntity, this.stateInNamedEntity(f));
      }, c.prototype.stateInNamedEntity = function(f) {
        if (this.entityExcess += 1, this.trieIndex = (0, t.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, f), this.trieIndex < 0) {
          this.emitNamedEntity(), this.index--;
          return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var g = this.trieCurrent & t.BinTrieFlags.VALUE_LENGTH;
        if (g) {
          var D = (g >> 14) - 1;
          if (!this.allowLegacyEntity() && f !== e.Semi)
            this.trieIndex += D;
          else {
            var _ = this.index - this.entityExcess + 1;
            _ > this.sectionStart && this.emitPartial(this.sectionStart, _), this.entityResult = this.trieIndex, this.trieIndex += D, this.entityExcess = 0, this.sectionStart = this.index + 1, D === 0 && this.emitNamedEntity();
          }
        }
      }, c.prototype.emitNamedEntity = function() {
        if (this.state = this.baseState, this.entityResult !== 0) {
          var f = (this.entityTrie[this.entityResult] & t.BinTrieFlags.VALUE_LENGTH) >> 14;
          switch (f) {
            case 1: {
              this.emitCodePoint(this.entityTrie[this.entityResult] & ~t.BinTrieFlags.VALUE_LENGTH);
              break;
            }
            case 2: {
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              break;
            }
            case 3:
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
        }
      }, c.prototype.stateBeforeNumericEntity = function(f) {
        (f | 32) === e.LowerX ? (this.entityExcess++, this.state = u.InHexEntity) : (this.state = u.InNumericEntity, this.stateInNumericEntity(f));
      }, c.prototype.emitNumericEntity = function(f) {
        var g = this.index - this.entityExcess - 1, D = g + 2 + +(this.state === u.InHexEntity);
        D !== this.index && (g > this.sectionStart && this.emitPartial(this.sectionStart, g), this.sectionStart = this.index + Number(f), this.emitCodePoint((0, t.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
      }, c.prototype.stateInNumericEntity = function(f) {
        f === e.Semi ? this.emitNumericEntity(!0) : o(f) ? (this.entityResult = this.entityResult * 10 + (f - e.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, c.prototype.stateInHexEntity = function(f) {
        f === e.Semi ? this.emitNumericEntity(!0) : o(f) ? (this.entityResult = this.entityResult * 16 + (f - e.Zero), this.entityExcess++) : i(f) ? (this.entityResult = this.entityResult * 16 + ((f | 32) - e.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, c.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === u.Text || this.baseState === u.InSpecialTag);
      }, c.prototype.cleanup = function() {
        this.running && this.sectionStart !== this.index && (this.state === u.Text || this.state === u.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === u.InAttributeValueDq || this.state === u.InAttributeValueSq || this.state === u.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
      }, c.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
      }, c.prototype.parse = function() {
        for (; this.shouldContinue(); ) {
          var f = this.buffer.charCodeAt(this.index - this.offset);
          switch (this.state) {
            case u.Text: {
              this.stateText(f);
              break;
            }
            case u.SpecialStartSequence: {
              this.stateSpecialStartSequence(f);
              break;
            }
            case u.InSpecialTag: {
              this.stateInSpecialTag(f);
              break;
            }
            case u.CDATASequence: {
              this.stateCDATASequence(f);
              break;
            }
            case u.InAttributeValueDq: {
              this.stateInAttributeValueDoubleQuotes(f);
              break;
            }
            case u.InAttributeName: {
              this.stateInAttributeName(f);
              break;
            }
            case u.InCommentLike: {
              this.stateInCommentLike(f);
              break;
            }
            case u.InSpecialComment: {
              this.stateInSpecialComment(f);
              break;
            }
            case u.BeforeAttributeName: {
              this.stateBeforeAttributeName(f);
              break;
            }
            case u.InTagName: {
              this.stateInTagName(f);
              break;
            }
            case u.InClosingTagName: {
              this.stateInClosingTagName(f);
              break;
            }
            case u.BeforeTagName: {
              this.stateBeforeTagName(f);
              break;
            }
            case u.AfterAttributeName: {
              this.stateAfterAttributeName(f);
              break;
            }
            case u.InAttributeValueSq: {
              this.stateInAttributeValueSingleQuotes(f);
              break;
            }
            case u.BeforeAttributeValue: {
              this.stateBeforeAttributeValue(f);
              break;
            }
            case u.BeforeClosingTagName: {
              this.stateBeforeClosingTagName(f);
              break;
            }
            case u.AfterClosingTagName: {
              this.stateAfterClosingTagName(f);
              break;
            }
            case u.BeforeSpecialS: {
              this.stateBeforeSpecialS(f);
              break;
            }
            case u.InAttributeValueNq: {
              this.stateInAttributeValueNoQuotes(f);
              break;
            }
            case u.InSelfClosingTag: {
              this.stateInSelfClosingTag(f);
              break;
            }
            case u.InDeclaration: {
              this.stateInDeclaration(f);
              break;
            }
            case u.BeforeDeclaration: {
              this.stateBeforeDeclaration(f);
              break;
            }
            case u.BeforeComment: {
              this.stateBeforeComment(f);
              break;
            }
            case u.InProcessingInstruction: {
              this.stateInProcessingInstruction(f);
              break;
            }
            case u.InNamedEntity: {
              this.stateInNamedEntity(f);
              break;
            }
            case u.BeforeEntity: {
              this.stateBeforeEntity(f);
              break;
            }
            case u.InHexEntity: {
              this.stateInHexEntity(f);
              break;
            }
            case u.InNumericEntity: {
              this.stateInNumericEntity(f);
              break;
            }
            default:
              this.stateBeforeNumericEntity(f);
          }
          this.index++;
        }
        this.cleanup();
      }, c.prototype.finish = function() {
        this.state === u.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
      }, c.prototype.handleTrailingData = function() {
        var f = this.buffer.length + this.offset;
        this.state === u.InCommentLike ? this.currentSequence === d.CdataEnd ? this.cbs.oncdata(this.sectionStart, f, 0) : this.cbs.oncomment(this.sectionStart, f, 0) : this.state === u.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === u.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === u.InTagName || this.state === u.BeforeAttributeName || this.state === u.BeforeAttributeValue || this.state === u.AfterAttributeName || this.state === u.InAttributeName || this.state === u.InAttributeValueSq || this.state === u.InAttributeValueDq || this.state === u.InAttributeValueNq || this.state === u.InClosingTagName || this.cbs.ontext(this.sectionStart, f);
      }, c.prototype.emitPartial = function(f, g) {
        this.baseState !== u.Text && this.baseState !== u.InSpecialTag ? this.cbs.onattribdata(f, g) : this.cbs.ontext(f, g);
      }, c.prototype.emitCodePoint = function(f) {
        this.baseState !== u.Text && this.baseState !== u.InSpecialTag ? this.cbs.onattribentity(f) : this.cbs.ontextentity(f);
      }, c;
    }()
  );
  r.default = h;
})(Xa);
var Ud = de && de.__createBinding || (Object.create ? function(r, t, e, u) {
  u === void 0 && (u = e);
  var n = Object.getOwnPropertyDescriptor(t, e);
  (!n || ("get" in n ? !t.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
    return t[e];
  } }), Object.defineProperty(r, u, n);
} : function(r, t, e, u) {
  u === void 0 && (u = e), r[u] = t[e];
}), zd = de && de.__setModuleDefault || (Object.create ? function(r, t) {
  Object.defineProperty(r, "default", { enumerable: !0, value: t });
} : function(r, t) {
  r.default = t;
}), Gd = de && de.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var t = {};
  if (r != null)
    for (var e in r)
      e !== "default" && Object.prototype.hasOwnProperty.call(r, e) && Ud(t, r, e);
  return zd(t, r), t;
};
Object.defineProperty(cu, "__esModule", { value: !0 });
cu.Parser = void 0;
var Ru = Gd(Xa), Ui = du, yr = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), Ee = /* @__PURE__ */ new Set(["p"]), zi = /* @__PURE__ */ new Set(["thead", "tbody"]), Gi = /* @__PURE__ */ new Set(["dd", "dt"]), Wi = /* @__PURE__ */ new Set(["rt", "rp"]), Wd = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", Ee],
  ["h1", Ee],
  ["h2", Ee],
  ["h3", Ee],
  ["h4", Ee],
  ["h5", Ee],
  ["h6", Ee],
  ["select", yr],
  ["input", yr],
  ["output", yr],
  ["button", yr],
  ["datalist", yr],
  ["textarea", yr],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", Gi],
  ["dt", Gi],
  ["address", Ee],
  ["article", Ee],
  ["aside", Ee],
  ["blockquote", Ee],
  ["details", Ee],
  ["div", Ee],
  ["dl", Ee],
  ["fieldset", Ee],
  ["figcaption", Ee],
  ["figure", Ee],
  ["footer", Ee],
  ["form", Ee],
  ["header", Ee],
  ["hr", Ee],
  ["main", Ee],
  ["nav", Ee],
  ["ol", Ee],
  ["pre", Ee],
  ["section", Ee],
  ["table", Ee],
  ["ul", Ee],
  ["rt", Wi],
  ["rp", Wi],
  ["tbody", zi],
  ["tfoot", zi]
]), Yd = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), Yi = /* @__PURE__ */ new Set(["math", "svg"]), Zi = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), Zd = /\s|\//, Kd = (
  /** @class */
  function() {
    function r(t, e) {
      e === void 0 && (e = {});
      var u, n, a, o, s;
      this.options = e, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = t ?? {}, this.lowerCaseTagNames = (u = e.lowerCaseTags) !== null && u !== void 0 ? u : !e.xmlMode, this.lowerCaseAttributeNames = (n = e.lowerCaseAttributeNames) !== null && n !== void 0 ? n : !e.xmlMode, this.tokenizer = new ((a = e.Tokenizer) !== null && a !== void 0 ? a : Ru.default)(this.options, this), (s = (o = this.cbs).onparserinit) === null || s === void 0 || s.call(o, this);
    }
    return r.prototype.ontext = function(t, e) {
      var u, n, a = this.getSlice(t, e);
      this.endIndex = e - 1, (n = (u = this.cbs).ontext) === null || n === void 0 || n.call(u, a), this.startIndex = e;
    }, r.prototype.ontextentity = function(t) {
      var e, u, n = this.tokenizer.getSectionStart();
      this.endIndex = n - 1, (u = (e = this.cbs).ontext) === null || u === void 0 || u.call(e, (0, Ui.fromCodePoint)(t)), this.startIndex = n;
    }, r.prototype.isVoidElement = function(t) {
      return !this.options.xmlMode && Yd.has(t);
    }, r.prototype.onopentagname = function(t, e) {
      this.endIndex = e;
      var u = this.getSlice(t, e);
      this.lowerCaseTagNames && (u = u.toLowerCase()), this.emitOpenTag(u);
    }, r.prototype.emitOpenTag = function(t) {
      var e, u, n, a;
      this.openTagStart = this.startIndex, this.tagname = t;
      var o = !this.options.xmlMode && Wd.get(t);
      if (o)
        for (; this.stack.length > 0 && o.has(this.stack[this.stack.length - 1]); ) {
          var s = this.stack.pop();
          (u = (e = this.cbs).onclosetag) === null || u === void 0 || u.call(e, s, !0);
        }
      this.isVoidElement(t) || (this.stack.push(t), Yi.has(t) ? this.foreignContext.push(!0) : Zi.has(t) && this.foreignContext.push(!1)), (a = (n = this.cbs).onopentagname) === null || a === void 0 || a.call(n, t), this.cbs.onopentag && (this.attribs = {});
    }, r.prototype.endOpenTag = function(t) {
      var e, u;
      this.startIndex = this.openTagStart, this.attribs && ((u = (e = this.cbs).onopentag) === null || u === void 0 || u.call(e, this.tagname, this.attribs, t), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
    }, r.prototype.onopentagend = function(t) {
      this.endIndex = t, this.endOpenTag(!1), this.startIndex = t + 1;
    }, r.prototype.onclosetag = function(t, e) {
      var u, n, a, o, s, i;
      this.endIndex = e;
      var l = this.getSlice(t, e);
      if (this.lowerCaseTagNames && (l = l.toLowerCase()), (Yi.has(l) || Zi.has(l)) && this.foreignContext.pop(), this.isVoidElement(l))
        !this.options.xmlMode && l === "br" && ((n = (u = this.cbs).onopentagname) === null || n === void 0 || n.call(u, "br"), (o = (a = this.cbs).onopentag) === null || o === void 0 || o.call(a, "br", {}, !0), (i = (s = this.cbs).onclosetag) === null || i === void 0 || i.call(s, "br", !1));
      else {
        var d = this.stack.lastIndexOf(l);
        if (d !== -1)
          if (this.cbs.onclosetag)
            for (var h = this.stack.length - d; h--; )
              this.cbs.onclosetag(this.stack.pop(), h !== 0);
          else
            this.stack.length = d;
        else
          !this.options.xmlMode && l === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
      }
      this.startIndex = e + 1;
    }, r.prototype.onselfclosingtag = function(t) {
      this.endIndex = t, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = t + 1) : this.onopentagend(t);
    }, r.prototype.closeCurrentTag = function(t) {
      var e, u, n = this.tagname;
      this.endOpenTag(t), this.stack[this.stack.length - 1] === n && ((u = (e = this.cbs).onclosetag) === null || u === void 0 || u.call(e, n, !t), this.stack.pop());
    }, r.prototype.onattribname = function(t, e) {
      this.startIndex = t;
      var u = this.getSlice(t, e);
      this.attribname = this.lowerCaseAttributeNames ? u.toLowerCase() : u;
    }, r.prototype.onattribdata = function(t, e) {
      this.attribvalue += this.getSlice(t, e);
    }, r.prototype.onattribentity = function(t) {
      this.attribvalue += (0, Ui.fromCodePoint)(t);
    }, r.prototype.onattribend = function(t, e) {
      var u, n;
      this.endIndex = e, (n = (u = this.cbs).onattribute) === null || n === void 0 || n.call(u, this.attribname, this.attribvalue, t === Ru.QuoteType.Double ? '"' : t === Ru.QuoteType.Single ? "'" : t === Ru.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
    }, r.prototype.getInstructionName = function(t) {
      var e = t.search(Zd), u = e < 0 ? t : t.substr(0, e);
      return this.lowerCaseTagNames && (u = u.toLowerCase()), u;
    }, r.prototype.ondeclaration = function(t, e) {
      this.endIndex = e;
      var u = this.getSlice(t, e);
      if (this.cbs.onprocessinginstruction) {
        var n = this.getInstructionName(u);
        this.cbs.onprocessinginstruction("!".concat(n), "!".concat(u));
      }
      this.startIndex = e + 1;
    }, r.prototype.onprocessinginstruction = function(t, e) {
      this.endIndex = e;
      var u = this.getSlice(t, e);
      if (this.cbs.onprocessinginstruction) {
        var n = this.getInstructionName(u);
        this.cbs.onprocessinginstruction("?".concat(n), "?".concat(u));
      }
      this.startIndex = e + 1;
    }, r.prototype.oncomment = function(t, e, u) {
      var n, a, o, s;
      this.endIndex = e, (a = (n = this.cbs).oncomment) === null || a === void 0 || a.call(n, this.getSlice(t, e - u)), (s = (o = this.cbs).oncommentend) === null || s === void 0 || s.call(o), this.startIndex = e + 1;
    }, r.prototype.oncdata = function(t, e, u) {
      var n, a, o, s, i, l, d, h, c, f;
      this.endIndex = e;
      var g = this.getSlice(t, e - u);
      this.options.xmlMode || this.options.recognizeCDATA ? ((a = (n = this.cbs).oncdatastart) === null || a === void 0 || a.call(n), (s = (o = this.cbs).ontext) === null || s === void 0 || s.call(o, g), (l = (i = this.cbs).oncdataend) === null || l === void 0 || l.call(i)) : ((h = (d = this.cbs).oncomment) === null || h === void 0 || h.call(d, "[CDATA[".concat(g, "]]")), (f = (c = this.cbs).oncommentend) === null || f === void 0 || f.call(c)), this.startIndex = e + 1;
    }, r.prototype.onend = function() {
      var t, e;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (var u = this.stack.length; u > 0; this.cbs.onclosetag(this.stack[--u], !0))
          ;
      }
      (e = (t = this.cbs).onend) === null || e === void 0 || e.call(t);
    }, r.prototype.reset = function() {
      var t, e, u, n;
      (e = (t = this.cbs).onreset) === null || e === void 0 || e.call(t), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (n = (u = this.cbs).onparserinit) === null || n === void 0 || n.call(u, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
    }, r.prototype.parseComplete = function(t) {
      this.reset(), this.end(t);
    }, r.prototype.getSlice = function(t, e) {
      for (; t - this.bufferOffset >= this.buffers[0].length; )
        this.shiftBuffer();
      for (var u = this.buffers[0].slice(t - this.bufferOffset, e - this.bufferOffset); e - this.bufferOffset > this.buffers[0].length; )
        this.shiftBuffer(), u += this.buffers[0].slice(0, e - this.bufferOffset);
      return u;
    }, r.prototype.shiftBuffer = function() {
      this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
    }, r.prototype.write = function(t) {
      var e, u;
      if (this.ended) {
        (u = (e = this.cbs).onerror) === null || u === void 0 || u.call(e, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(t), this.tokenizer.running && (this.tokenizer.write(t), this.writeIndex++);
    }, r.prototype.end = function(t) {
      var e, u;
      if (this.ended) {
        (u = (e = this.cbs).onerror) === null || u === void 0 || u.call(e, new Error(".end() after done!"));
        return;
      }
      t && this.write(t), this.ended = !0, this.tokenizer.end();
    }, r.prototype.pause = function() {
      this.tokenizer.pause();
    }, r.prototype.resume = function() {
      for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      this.ended && this.tokenizer.end();
    }, r.prototype.parseChunk = function(t) {
      this.write(t);
    }, r.prototype.done = function(t) {
      this.end(t);
    }, r;
  }()
);
cu.Parser = Kd;
var jt = {}, Or = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.Doctype = r.CDATA = r.Tag = r.Style = r.Script = r.Comment = r.Directive = r.Text = r.Root = r.isTag = r.ElementType = void 0;
  var t;
  (function(u) {
    u.Root = "root", u.Text = "text", u.Directive = "directive", u.Comment = "comment", u.Script = "script", u.Style = "style", u.Tag = "tag", u.CDATA = "cdata", u.Doctype = "doctype";
  })(t = r.ElementType || (r.ElementType = {}));
  function e(u) {
    return u.type === t.Tag || u.type === t.Script || u.type === t.Style;
  }
  r.isTag = e, r.Root = t.Root, r.Text = t.Text, r.Directive = t.Directive, r.Comment = t.Comment, r.Script = t.Script, r.Style = t.Style, r.Tag = t.Tag, r.CDATA = t.CDATA, r.Doctype = t.Doctype;
})(Or);
var Ce = {}, Xt = de && de.__extends || function() {
  var r = function(t, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, n) {
      u.__proto__ = n;
    } || function(u, n) {
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (u[a] = n[a]);
    }, r(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(t, e);
    function u() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (u.prototype = e.prototype, new u());
  };
}(), tu = de && de.__assign || function() {
  return tu = Object.assign || function(r) {
    for (var t, e = 1, u = arguments.length; e < u; e++) {
      t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
    }
    return r;
  }, tu.apply(this, arguments);
};
Object.defineProperty(Ce, "__esModule", { value: !0 });
Ce.cloneNode = Ce.hasChildren = Ce.isDocument = Ce.isDirective = Ce.isComment = Ce.isText = Ce.isCDATA = Ce.isTag = Ce.Element = Ce.Document = Ce.CDATA = Ce.NodeWithChildren = Ce.ProcessingInstruction = Ce.Comment = Ce.Text = Ce.DataNode = Ce.Node = void 0;
var et = Or, ei = (
  /** @class */
  function() {
    function r() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(r.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(t) {
        this.parent = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(t) {
        this.prev = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(t) {
        this.next = t;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.cloneNode = function(t) {
      return t === void 0 && (t = !1), ti(this, t);
    }, r;
  }()
);
Ce.Node = ei;
var kn = (
  /** @class */
  function(r) {
    Xt(t, r);
    function t(e) {
      var u = r.call(this) || this;
      return u.data = e, u;
    }
    return Object.defineProperty(t.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(e) {
        this.data = e;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(ei)
);
Ce.DataNode = kn;
var Ws = (
  /** @class */
  function(r) {
    Xt(t, r);
    function t() {
      var e = r !== null && r.apply(this, arguments) || this;
      return e.type = et.ElementType.Text, e;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(kn)
);
Ce.Text = Ws;
var Ys = (
  /** @class */
  function(r) {
    Xt(t, r);
    function t() {
      var e = r !== null && r.apply(this, arguments) || this;
      return e.type = et.ElementType.Comment, e;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(kn)
);
Ce.Comment = Ys;
var Zs = (
  /** @class */
  function(r) {
    Xt(t, r);
    function t(e, u) {
      var n = r.call(this, u) || this;
      return n.name = e, n.type = et.ElementType.Directive, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(kn)
);
Ce.ProcessingInstruction = Zs;
var Sn = (
  /** @class */
  function(r) {
    Xt(t, r);
    function t(e) {
      var u = r.call(this) || this;
      return u.children = e, u;
    }
    return Object.defineProperty(t.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var e;
        return (e = this.children[0]) !== null && e !== void 0 ? e : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(e) {
        this.children = e;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(ei)
);
Ce.NodeWithChildren = Sn;
var Ks = (
  /** @class */
  function(r) {
    Xt(t, r);
    function t() {
      var e = r !== null && r.apply(this, arguments) || this;
      return e.type = et.ElementType.CDATA, e;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Sn)
);
Ce.CDATA = Ks;
var Xs = (
  /** @class */
  function(r) {
    Xt(t, r);
    function t() {
      var e = r !== null && r.apply(this, arguments) || this;
      return e.type = et.ElementType.Root, e;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Sn)
);
Ce.Document = Xs;
var Js = (
  /** @class */
  function(r) {
    Xt(t, r);
    function t(e, u, n, a) {
      n === void 0 && (n = []), a === void 0 && (a = e === "script" ? et.ElementType.Script : e === "style" ? et.ElementType.Style : et.ElementType.Tag);
      var o = r.call(this, n) || this;
      return o.name = e, o.attribs = u, o.type = a, o;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(e) {
        this.name = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "attributes", {
      get: function() {
        var e = this;
        return Object.keys(this.attribs).map(function(u) {
          var n, a;
          return {
            name: u,
            value: e.attribs[u],
            namespace: (n = e["x-attribsNamespace"]) === null || n === void 0 ? void 0 : n[u],
            prefix: (a = e["x-attribsPrefix"]) === null || a === void 0 ? void 0 : a[u]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Sn)
);
Ce.Element = Js;
function Qs(r) {
  return (0, et.isTag)(r);
}
Ce.isTag = Qs;
function el(r) {
  return r.type === et.ElementType.CDATA;
}
Ce.isCDATA = el;
function tl(r) {
  return r.type === et.ElementType.Text;
}
Ce.isText = tl;
function rl(r) {
  return r.type === et.ElementType.Comment;
}
Ce.isComment = rl;
function ul(r) {
  return r.type === et.ElementType.Directive;
}
Ce.isDirective = ul;
function nl(r) {
  return r.type === et.ElementType.Root;
}
Ce.isDocument = nl;
function Xd(r) {
  return Object.prototype.hasOwnProperty.call(r, "children");
}
Ce.hasChildren = Xd;
function ti(r, t) {
  t === void 0 && (t = !1);
  var e;
  if (tl(r))
    e = new Ws(r.data);
  else if (rl(r))
    e = new Ys(r.data);
  else if (Qs(r)) {
    var u = t ? Gn(r.children) : [], n = new Js(r.name, tu({}, r.attribs), u);
    u.forEach(function(i) {
      return i.parent = n;
    }), r.namespace != null && (n.namespace = r.namespace), r["x-attribsNamespace"] && (n["x-attribsNamespace"] = tu({}, r["x-attribsNamespace"])), r["x-attribsPrefix"] && (n["x-attribsPrefix"] = tu({}, r["x-attribsPrefix"])), e = n;
  } else if (el(r)) {
    var u = t ? Gn(r.children) : [], a = new Ks(u);
    u.forEach(function(l) {
      return l.parent = a;
    }), e = a;
  } else if (nl(r)) {
    var u = t ? Gn(r.children) : [], o = new Xs(u);
    u.forEach(function(l) {
      return l.parent = o;
    }), r["x-mode"] && (o["x-mode"] = r["x-mode"]), e = o;
  } else if (ul(r)) {
    var s = new Zs(r.name, r.data);
    r["x-name"] != null && (s["x-name"] = r["x-name"], s["x-publicId"] = r["x-publicId"], s["x-systemId"] = r["x-systemId"]), e = s;
  } else
    throw new Error("Not implemented yet: ".concat(r.type));
  return e.startIndex = r.startIndex, e.endIndex = r.endIndex, r.sourceCodeLocation != null && (e.sourceCodeLocation = r.sourceCodeLocation), e;
}
Ce.cloneNode = ti;
function Gn(r) {
  for (var t = r.map(function(u) {
    return ti(u, !0);
  }), e = 1; e < t.length; e++)
    t[e].prev = t[e - 1], t[e - 1].next = t[e];
  return t;
}
(function(r) {
  var t = de && de.__createBinding || (Object.create ? function(s, i, l, d) {
    d === void 0 && (d = l);
    var h = Object.getOwnPropertyDescriptor(i, l);
    (!h || ("get" in h ? !i.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return i[l];
    } }), Object.defineProperty(s, d, h);
  } : function(s, i, l, d) {
    d === void 0 && (d = l), s[d] = i[l];
  }), e = de && de.__exportStar || function(s, i) {
    for (var l in s)
      l !== "default" && !Object.prototype.hasOwnProperty.call(i, l) && t(i, s, l);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.DomHandler = void 0;
  var u = Or, n = Ce;
  e(Ce, r);
  var a = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, o = (
    /** @class */
    function() {
      function s(i, l, d) {
        this.dom = [], this.root = new n.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof l == "function" && (d = l, l = a), typeof i == "object" && (l = i, i = void 0), this.callback = i ?? null, this.options = l ?? a, this.elementCB = d ?? null;
      }
      return s.prototype.onparserinit = function(i) {
        this.parser = i;
      }, s.prototype.onreset = function() {
        this.dom = [], this.root = new n.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, s.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, s.prototype.onerror = function(i) {
        this.handleCallback(i);
      }, s.prototype.onclosetag = function() {
        this.lastNode = null;
        var i = this.tagStack.pop();
        this.options.withEndIndices && (i.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(i);
      }, s.prototype.onopentag = function(i, l) {
        var d = this.options.xmlMode ? u.ElementType.Tag : void 0, h = new n.Element(i, l, void 0, d);
        this.addNode(h), this.tagStack.push(h);
      }, s.prototype.ontext = function(i) {
        var l = this.lastNode;
        if (l && l.type === u.ElementType.Text)
          l.data += i, this.options.withEndIndices && (l.endIndex = this.parser.endIndex);
        else {
          var d = new n.Text(i);
          this.addNode(d), this.lastNode = d;
        }
      }, s.prototype.oncomment = function(i) {
        if (this.lastNode && this.lastNode.type === u.ElementType.Comment) {
          this.lastNode.data += i;
          return;
        }
        var l = new n.Comment(i);
        this.addNode(l), this.lastNode = l;
      }, s.prototype.oncommentend = function() {
        this.lastNode = null;
      }, s.prototype.oncdatastart = function() {
        var i = new n.Text(""), l = new n.CDATA([i]);
        this.addNode(l), i.parent = l, this.lastNode = i;
      }, s.prototype.oncdataend = function() {
        this.lastNode = null;
      }, s.prototype.onprocessinginstruction = function(i, l) {
        var d = new n.ProcessingInstruction(i, l);
        this.addNode(d);
      }, s.prototype.handleCallback = function(i) {
        if (typeof this.callback == "function")
          this.callback(i, this.dom);
        else if (i)
          throw i;
      }, s.prototype.addNode = function(i) {
        var l = this.tagStack[this.tagStack.length - 1], d = l.children[l.children.length - 1];
        this.options.withStartIndices && (i.startIndex = this.parser.startIndex), this.options.withEndIndices && (i.endIndex = this.parser.endIndex), l.children.push(i), d && (i.prev = d, d.next = i), i.parent = l, this.lastNode = null;
      }, s;
    }()
  );
  r.DomHandler = o, r.default = o;
})(jt);
var tn = {}, at = {}, ku = {}, al = {}, ir = {}, ri = {};
Object.defineProperty(ri, "__esModule", { value: !0 });
function Vu(r) {
  for (var t = 1; t < r.length; t++)
    r[t][0] += r[t - 1][0] + 1;
  return r;
}
ri.default = new Map(/* @__PURE__ */ Vu([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ Vu([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ Vu([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ Vu([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var fn = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.escapeText = r.escapeAttribute = r.escapeUTF8 = r.escape = r.encodeXML = r.getCodePoint = r.xmlReplacer = void 0, r.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
  var t = /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [39, "&apos;"],
    [60, "&lt;"],
    [62, "&gt;"]
  ]);
  r.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? function(n, a) {
    return n.codePointAt(a);
  } : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    function(n, a) {
      return (n.charCodeAt(a) & 64512) === 55296 ? (n.charCodeAt(a) - 55296) * 1024 + n.charCodeAt(a + 1) - 56320 + 65536 : n.charCodeAt(a);
    }
  );
  function e(n) {
    for (var a = "", o = 0, s; (s = r.xmlReplacer.exec(n)) !== null; ) {
      var i = s.index, l = n.charCodeAt(i), d = t.get(l);
      d !== void 0 ? (a += n.substring(o, i) + d, o = i + 1) : (a += "".concat(n.substring(o, i), "&#x").concat((0, r.getCodePoint)(n, i).toString(16), ";"), o = r.xmlReplacer.lastIndex += +((l & 64512) === 55296));
    }
    return a + n.substr(o);
  }
  r.encodeXML = e, r.escape = e;
  function u(n, a) {
    return function(s) {
      for (var i, l = 0, d = ""; i = n.exec(s); )
        l !== i.index && (d += s.substring(l, i.index)), d += a.get(i[0].charCodeAt(0)), l = i.index + 1;
      return d + s.substring(l);
    };
  }
  r.escapeUTF8 = u(/[&<>'"]/g, t), r.escapeAttribute = u(/["&\u00A0]/g, /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [160, "&nbsp;"]
  ])), r.escapeText = u(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
    [38, "&amp;"],
    [60, "&lt;"],
    [62, "&gt;"],
    [160, "&nbsp;"]
  ]));
})(fn);
var Jd = de && de.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(ir, "__esModule", { value: !0 });
ir.encodeNonAsciiHTML = ir.encodeHTML = void 0;
var Qd = Jd(ri), il = fn, e2 = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function t2(r) {
  return ol(e2, r);
}
ir.encodeHTML = t2;
function r2(r) {
  return ol(il.xmlReplacer, r);
}
ir.encodeNonAsciiHTML = r2;
function ol(r, t) {
  for (var e = "", u = 0, n; (n = r.exec(t)) !== null; ) {
    var a = n.index;
    e += t.substring(u, a);
    var o = t.charCodeAt(a), s = Qd.default.get(o);
    if (typeof s == "object") {
      if (a + 1 < t.length) {
        var i = t.charCodeAt(a + 1), l = typeof s.n == "number" ? s.n === i ? s.o : void 0 : s.n.get(i);
        if (l !== void 0) {
          e += l, u = r.lastIndex += 1;
          continue;
        }
      }
      s = s.v;
    }
    if (s !== void 0)
      e += s, u = a + 1;
    else {
      var d = (0, il.getCodePoint)(t, a);
      e += "&#x".concat(d.toString(16), ";"), u = r.lastIndex += +(d !== o);
    }
  }
  return e + t.substr(u);
}
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.decodeXMLStrict = r.decodeHTML5Strict = r.decodeHTML4Strict = r.decodeHTML5 = r.decodeHTML4 = r.decodeHTMLAttribute = r.decodeHTMLStrict = r.decodeHTML = r.decodeXML = r.DecodingMode = r.EntityDecoder = r.encodeHTML5 = r.encodeHTML4 = r.encodeNonAsciiHTML = r.encodeHTML = r.escapeText = r.escapeAttribute = r.escapeUTF8 = r.escape = r.encodeXML = r.encode = r.decodeStrict = r.decode = r.EncodingMode = r.EntityLevel = void 0;
  var t = du, e = ir, u = fn, n;
  (function(c) {
    c[c.XML = 0] = "XML", c[c.HTML = 1] = "HTML";
  })(n = r.EntityLevel || (r.EntityLevel = {}));
  var a;
  (function(c) {
    c[c.UTF8 = 0] = "UTF8", c[c.ASCII = 1] = "ASCII", c[c.Extensive = 2] = "Extensive", c[c.Attribute = 3] = "Attribute", c[c.Text = 4] = "Text";
  })(a = r.EncodingMode || (r.EncodingMode = {}));
  function o(c, f) {
    f === void 0 && (f = n.XML);
    var g = typeof f == "number" ? f : f.level;
    if (g === n.HTML) {
      var D = typeof f == "object" ? f.mode : void 0;
      return (0, t.decodeHTML)(c, D);
    }
    return (0, t.decodeXML)(c);
  }
  r.decode = o;
  function s(c, f) {
    var g;
    f === void 0 && (f = n.XML);
    var D = typeof f == "number" ? { level: f } : f;
    return (g = D.mode) !== null && g !== void 0 || (D.mode = t.DecodingMode.Strict), o(c, D);
  }
  r.decodeStrict = s;
  function i(c, f) {
    f === void 0 && (f = n.XML);
    var g = typeof f == "number" ? { level: f } : f;
    return g.mode === a.UTF8 ? (0, u.escapeUTF8)(c) : g.mode === a.Attribute ? (0, u.escapeAttribute)(c) : g.mode === a.Text ? (0, u.escapeText)(c) : g.level === n.HTML ? g.mode === a.ASCII ? (0, e.encodeNonAsciiHTML)(c) : (0, e.encodeHTML)(c) : (0, u.encodeXML)(c);
  }
  r.encode = i;
  var l = fn;
  Object.defineProperty(r, "encodeXML", { enumerable: !0, get: function() {
    return l.encodeXML;
  } }), Object.defineProperty(r, "escape", { enumerable: !0, get: function() {
    return l.escape;
  } }), Object.defineProperty(r, "escapeUTF8", { enumerable: !0, get: function() {
    return l.escapeUTF8;
  } }), Object.defineProperty(r, "escapeAttribute", { enumerable: !0, get: function() {
    return l.escapeAttribute;
  } }), Object.defineProperty(r, "escapeText", { enumerable: !0, get: function() {
    return l.escapeText;
  } });
  var d = ir;
  Object.defineProperty(r, "encodeHTML", { enumerable: !0, get: function() {
    return d.encodeHTML;
  } }), Object.defineProperty(r, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
    return d.encodeNonAsciiHTML;
  } }), Object.defineProperty(r, "encodeHTML4", { enumerable: !0, get: function() {
    return d.encodeHTML;
  } }), Object.defineProperty(r, "encodeHTML5", { enumerable: !0, get: function() {
    return d.encodeHTML;
  } });
  var h = du;
  Object.defineProperty(r, "EntityDecoder", { enumerable: !0, get: function() {
    return h.EntityDecoder;
  } }), Object.defineProperty(r, "DecodingMode", { enumerable: !0, get: function() {
    return h.DecodingMode;
  } }), Object.defineProperty(r, "decodeXML", { enumerable: !0, get: function() {
    return h.decodeXML;
  } }), Object.defineProperty(r, "decodeHTML", { enumerable: !0, get: function() {
    return h.decodeHTML;
  } }), Object.defineProperty(r, "decodeHTMLStrict", { enumerable: !0, get: function() {
    return h.decodeHTMLStrict;
  } }), Object.defineProperty(r, "decodeHTMLAttribute", { enumerable: !0, get: function() {
    return h.decodeHTMLAttribute;
  } }), Object.defineProperty(r, "decodeHTML4", { enumerable: !0, get: function() {
    return h.decodeHTML;
  } }), Object.defineProperty(r, "decodeHTML5", { enumerable: !0, get: function() {
    return h.decodeHTML;
  } }), Object.defineProperty(r, "decodeHTML4Strict", { enumerable: !0, get: function() {
    return h.decodeHTMLStrict;
  } }), Object.defineProperty(r, "decodeHTML5Strict", { enumerable: !0, get: function() {
    return h.decodeHTMLStrict;
  } }), Object.defineProperty(r, "decodeXMLStrict", { enumerable: !0, get: function() {
    return h.decodeXML;
  } });
})(al);
var Sr = {};
Object.defineProperty(Sr, "__esModule", { value: !0 });
Sr.attributeNames = Sr.elementNames = void 0;
Sr.elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map(function(r) {
  return [r.toLowerCase(), r];
}));
Sr.attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map(function(r) {
  return [r.toLowerCase(), r];
}));
var wr = de && de.__assign || function() {
  return wr = Object.assign || function(r) {
    for (var t, e = 1, u = arguments.length; e < u; e++) {
      t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
    }
    return r;
  }, wr.apply(this, arguments);
}, u2 = de && de.__createBinding || (Object.create ? function(r, t, e, u) {
  u === void 0 && (u = e);
  var n = Object.getOwnPropertyDescriptor(t, e);
  (!n || ("get" in n ? !t.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
    return t[e];
  } }), Object.defineProperty(r, u, n);
} : function(r, t, e, u) {
  u === void 0 && (u = e), r[u] = t[e];
}), n2 = de && de.__setModuleDefault || (Object.create ? function(r, t) {
  Object.defineProperty(r, "default", { enumerable: !0, value: t });
} : function(r, t) {
  r.default = t;
}), a2 = de && de.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var t = {};
  if (r != null)
    for (var e in r)
      e !== "default" && Object.prototype.hasOwnProperty.call(r, e) && u2(t, r, e);
  return n2(t, r), t;
};
Object.defineProperty(ku, "__esModule", { value: !0 });
ku.render = void 0;
var Ft = a2(Or), pn = al, sl = Sr, i2 = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function o2(r) {
  return r.replace(/"/g, "&quot;");
}
function s2(r, t) {
  var e;
  if (r) {
    var u = ((e = t.encodeEntities) !== null && e !== void 0 ? e : t.decodeEntities) === !1 ? o2 : t.xmlMode || t.encodeEntities !== "utf8" ? pn.encodeXML : pn.escapeAttribute;
    return Object.keys(r).map(function(n) {
      var a, o, s = (a = r[n]) !== null && a !== void 0 ? a : "";
      return t.xmlMode === "foreign" && (n = (o = sl.attributeNames.get(n)) !== null && o !== void 0 ? o : n), !t.emptyAttrs && !t.xmlMode && s === "" ? n : "".concat(n, '="').concat(u(s), '"');
    }).join(" ");
  }
}
var Ki = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function Tn(r, t) {
  t === void 0 && (t = {});
  for (var e = ("length" in r) ? r : [r], u = "", n = 0; n < e.length; n++)
    u += l2(e[n], t);
  return u;
}
ku.render = Tn;
ku.default = Tn;
function l2(r, t) {
  switch (r.type) {
    case Ft.Root:
      return Tn(r.children, t);
    case Ft.Doctype:
    case Ft.Directive:
      return p2(r);
    case Ft.Comment:
      return v2(r);
    case Ft.CDATA:
      return m2(r);
    case Ft.Script:
    case Ft.Style:
    case Ft.Tag:
      return f2(r, t);
    case Ft.Text:
      return h2(r, t);
  }
}
var c2 = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), d2 = /* @__PURE__ */ new Set(["svg", "math"]);
function f2(r, t) {
  var e;
  t.xmlMode === "foreign" && (r.name = (e = sl.elementNames.get(r.name)) !== null && e !== void 0 ? e : r.name, r.parent && c2.has(r.parent.name) && (t = wr(wr({}, t), { xmlMode: !1 }))), !t.xmlMode && d2.has(r.name) && (t = wr(wr({}, t), { xmlMode: "foreign" }));
  var u = "<".concat(r.name), n = s2(r.attribs, t);
  return n && (u += " ".concat(n)), r.children.length === 0 && (t.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    t.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    t.selfClosingTags && Ki.has(r.name)
  )) ? (t.xmlMode || (u += " "), u += "/>") : (u += ">", r.children.length > 0 && (u += Tn(r.children, t)), (t.xmlMode || !Ki.has(r.name)) && (u += "</".concat(r.name, ">"))), u;
}
function p2(r) {
  return "<".concat(r.data, ">");
}
function h2(r, t) {
  var e, u = r.data || "";
  return ((e = t.encodeEntities) !== null && e !== void 0 ? e : t.decodeEntities) !== !1 && !(!t.xmlMode && r.parent && i2.has(r.parent.name)) && (u = t.xmlMode || t.encodeEntities !== "utf8" ? (0, pn.encodeXML)(u) : (0, pn.escapeText)(u)), u;
}
function m2(r) {
  return "<![CDATA[".concat(r.children[0].data, "]]>");
}
function v2(r) {
  return "<!--".concat(r.data, "-->");
}
var g2 = de && de.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(at, "__esModule", { value: !0 });
at.innerText = at.textContent = at.getText = at.getInnerHTML = at.getOuterHTML = void 0;
var xt = jt, b2 = g2(ku), y2 = Or;
function ll(r, t) {
  return (0, b2.default)(r, t);
}
at.getOuterHTML = ll;
function _2(r, t) {
  return (0, xt.hasChildren)(r) ? r.children.map(function(e) {
    return ll(e, t);
  }).join("") : "";
}
at.getInnerHTML = _2;
function rn(r) {
  return Array.isArray(r) ? r.map(rn).join("") : (0, xt.isTag)(r) ? r.name === "br" ? `
` : rn(r.children) : (0, xt.isCDATA)(r) ? rn(r.children) : (0, xt.isText)(r) ? r.data : "";
}
at.getText = rn;
function pa(r) {
  return Array.isArray(r) ? r.map(pa).join("") : (0, xt.hasChildren)(r) && !(0, xt.isComment)(r) ? pa(r.children) : (0, xt.isText)(r) ? r.data : "";
}
at.textContent = pa;
function ha(r) {
  return Array.isArray(r) ? r.map(ha).join("") : (0, xt.hasChildren)(r) && (r.type === y2.ElementType.Tag || (0, xt.isCDATA)(r)) ? ha(r.children) : (0, xt.isText)(r) ? r.data : "";
}
at.innerText = ha;
var Re = {};
Object.defineProperty(Re, "__esModule", { value: !0 });
Re.prevElementSibling = Re.nextElementSibling = Re.getName = Re.hasAttrib = Re.getAttributeValue = Re.getSiblings = Re.getParent = Re.getChildren = void 0;
var ui = jt;
function cl(r) {
  return (0, ui.hasChildren)(r) ? r.children : [];
}
Re.getChildren = cl;
function dl(r) {
  return r.parent || null;
}
Re.getParent = dl;
function w2(r) {
  var t, e, u = dl(r);
  if (u != null)
    return cl(u);
  for (var n = [r], a = r.prev, o = r.next; a != null; )
    n.unshift(a), t = a, a = t.prev;
  for (; o != null; )
    n.push(o), e = o, o = e.next;
  return n;
}
Re.getSiblings = w2;
function C2(r, t) {
  var e;
  return (e = r.attribs) === null || e === void 0 ? void 0 : e[t];
}
Re.getAttributeValue = C2;
function D2(r, t) {
  return r.attribs != null && Object.prototype.hasOwnProperty.call(r.attribs, t) && r.attribs[t] != null;
}
Re.hasAttrib = D2;
function A2(r) {
  return r.name;
}
Re.getName = A2;
function x2(r) {
  for (var t, e = r.next; e !== null && !(0, ui.isTag)(e); )
    t = e, e = t.next;
  return e;
}
Re.nextElementSibling = x2;
function E2(r) {
  for (var t, e = r.prev; e !== null && !(0, ui.isTag)(e); )
    t = e, e = t.prev;
  return e;
}
Re.prevElementSibling = E2;
var Ke = {};
Object.defineProperty(Ke, "__esModule", { value: !0 });
Ke.prepend = Ke.prependChild = Ke.append = Ke.appendChild = Ke.replaceElement = Ke.removeElement = void 0;
function Su(r) {
  if (r.prev && (r.prev.next = r.next), r.next && (r.next.prev = r.prev), r.parent) {
    var t = r.parent.children, e = t.lastIndexOf(r);
    e >= 0 && t.splice(e, 1);
  }
  r.next = null, r.prev = null, r.parent = null;
}
Ke.removeElement = Su;
function k2(r, t) {
  var e = t.prev = r.prev;
  e && (e.next = t);
  var u = t.next = r.next;
  u && (u.prev = t);
  var n = t.parent = r.parent;
  if (n) {
    var a = n.children;
    a[a.lastIndexOf(r)] = t, r.parent = null;
  }
}
Ke.replaceElement = k2;
function S2(r, t) {
  if (Su(t), t.next = null, t.parent = r, r.children.push(t) > 1) {
    var e = r.children[r.children.length - 2];
    e.next = t, t.prev = e;
  } else
    t.prev = null;
}
Ke.appendChild = S2;
function T2(r, t) {
  Su(t);
  var e = r.parent, u = r.next;
  if (t.next = u, t.prev = r, r.next = t, t.parent = e, u) {
    if (u.prev = t, e) {
      var n = e.children;
      n.splice(n.lastIndexOf(u), 0, t);
    }
  } else
    e && e.children.push(t);
}
Ke.append = T2;
function B2(r, t) {
  if (Su(t), t.parent = r, t.prev = null, r.children.unshift(t) !== 1) {
    var e = r.children[1];
    e.prev = t, t.next = e;
  } else
    t.next = null;
}
Ke.prependChild = B2;
function $2(r, t) {
  Su(t);
  var e = r.parent;
  if (e) {
    var u = e.children;
    u.splice(u.indexOf(r), 0, t);
  }
  r.prev && (r.prev.next = t), t.parent = e, t.prev = r.prev, t.next = r, r.prev = t;
}
Ke.prepend = $2;
var Ge = {};
Object.defineProperty(Ge, "__esModule", { value: !0 });
Ge.findAll = Ge.existsOne = Ge.findOne = Ge.findOneChild = Ge.find = Ge.filter = void 0;
var Bn = jt;
function M2(r, t, e, u) {
  return e === void 0 && (e = !0), u === void 0 && (u = 1 / 0), fl(r, Array.isArray(t) ? t : [t], e, u);
}
Ge.filter = M2;
function fl(r, t, e, u) {
  for (var n = [], a = [t], o = [0]; ; ) {
    if (o[0] >= a[0].length) {
      if (o.length === 1)
        return n;
      a.shift(), o.shift();
      continue;
    }
    var s = a[0][o[0]++];
    if (r(s) && (n.push(s), --u <= 0))
      return n;
    e && (0, Bn.hasChildren)(s) && s.children.length > 0 && (o.unshift(0), a.unshift(s.children));
  }
}
Ge.find = fl;
function O2(r, t) {
  return t.find(r);
}
Ge.findOneChild = O2;
function pl(r, t, e) {
  e === void 0 && (e = !0);
  for (var u = null, n = 0; n < t.length && !u; n++) {
    var a = t[n];
    if ((0, Bn.isTag)(a))
      r(a) ? u = a : e && a.children.length > 0 && (u = pl(r, a.children, !0));
    else
      continue;
  }
  return u;
}
Ge.findOne = pl;
function hl(r, t) {
  return t.some(function(e) {
    return (0, Bn.isTag)(e) && (r(e) || hl(r, e.children));
  });
}
Ge.existsOne = hl;
function L2(r, t) {
  for (var e = [], u = [t], n = [0]; ; ) {
    if (n[0] >= u[0].length) {
      if (u.length === 1)
        return e;
      u.shift(), n.shift();
      continue;
    }
    var a = u[0][n[0]++];
    (0, Bn.isTag)(a) && (r(a) && e.push(a), a.children.length > 0 && (n.unshift(0), u.unshift(a.children)));
  }
}
Ge.findAll = L2;
var it = {};
Object.defineProperty(it, "__esModule", { value: !0 });
it.getElementsByTagType = it.getElementsByTagName = it.getElementById = it.getElements = it.testElement = void 0;
var er = jt, $n = Ge, hn = {
  tag_name: function(r) {
    return typeof r == "function" ? function(t) {
      return (0, er.isTag)(t) && r(t.name);
    } : r === "*" ? er.isTag : function(t) {
      return (0, er.isTag)(t) && t.name === r;
    };
  },
  tag_type: function(r) {
    return typeof r == "function" ? function(t) {
      return r(t.type);
    } : function(t) {
      return t.type === r;
    };
  },
  tag_contains: function(r) {
    return typeof r == "function" ? function(t) {
      return (0, er.isText)(t) && r(t.data);
    } : function(t) {
      return (0, er.isText)(t) && t.data === r;
    };
  }
};
function ml(r, t) {
  return typeof t == "function" ? function(e) {
    return (0, er.isTag)(e) && t(e.attribs[r]);
  } : function(e) {
    return (0, er.isTag)(e) && e.attribs[r] === t;
  };
}
function F2(r, t) {
  return function(e) {
    return r(e) || t(e);
  };
}
function vl(r) {
  var t = Object.keys(r).map(function(e) {
    var u = r[e];
    return Object.prototype.hasOwnProperty.call(hn, e) ? hn[e](u) : ml(e, u);
  });
  return t.length === 0 ? null : t.reduce(F2);
}
function I2(r, t) {
  var e = vl(r);
  return e ? e(t) : !0;
}
it.testElement = I2;
function N2(r, t, e, u) {
  u === void 0 && (u = 1 / 0);
  var n = vl(r);
  return n ? (0, $n.filter)(n, t, e, u) : [];
}
it.getElements = N2;
function q2(r, t, e) {
  return e === void 0 && (e = !0), Array.isArray(t) || (t = [t]), (0, $n.findOne)(ml("id", r), t, e);
}
it.getElementById = q2;
function P2(r, t, e, u) {
  return e === void 0 && (e = !0), u === void 0 && (u = 1 / 0), (0, $n.filter)(hn.tag_name(r), t, e, u);
}
it.getElementsByTagName = P2;
function R2(r, t, e, u) {
  return e === void 0 && (e = !0), u === void 0 && (u = 1 / 0), (0, $n.filter)(hn.tag_type(r), t, e, u);
}
it.getElementsByTagType = R2;
var gl = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.uniqueSort = r.compareDocumentPosition = r.DocumentPosition = r.removeSubsets = void 0;
  var t = jt;
  function e(o) {
    for (var s = o.length; --s >= 0; ) {
      var i = o[s];
      if (s > 0 && o.lastIndexOf(i, s - 1) >= 0) {
        o.splice(s, 1);
        continue;
      }
      for (var l = i.parent; l; l = l.parent)
        if (o.includes(l)) {
          o.splice(s, 1);
          break;
        }
    }
    return o;
  }
  r.removeSubsets = e;
  var u;
  (function(o) {
    o[o.DISCONNECTED = 1] = "DISCONNECTED", o[o.PRECEDING = 2] = "PRECEDING", o[o.FOLLOWING = 4] = "FOLLOWING", o[o.CONTAINS = 8] = "CONTAINS", o[o.CONTAINED_BY = 16] = "CONTAINED_BY";
  })(u = r.DocumentPosition || (r.DocumentPosition = {}));
  function n(o, s) {
    var i = [], l = [];
    if (o === s)
      return 0;
    for (var d = (0, t.hasChildren)(o) ? o : o.parent; d; )
      i.unshift(d), d = d.parent;
    for (d = (0, t.hasChildren)(s) ? s : s.parent; d; )
      l.unshift(d), d = d.parent;
    for (var h = Math.min(i.length, l.length), c = 0; c < h && i[c] === l[c]; )
      c++;
    if (c === 0)
      return u.DISCONNECTED;
    var f = i[c - 1], g = f.children, D = i[c], _ = l[c];
    return g.indexOf(D) > g.indexOf(_) ? f === s ? u.FOLLOWING | u.CONTAINED_BY : u.FOLLOWING : f === o ? u.PRECEDING | u.CONTAINS : u.PRECEDING;
  }
  r.compareDocumentPosition = n;
  function a(o) {
    return o = o.filter(function(s, i, l) {
      return !l.includes(s, i + 1);
    }), o.sort(function(s, i) {
      var l = n(s, i);
      return l & u.PRECEDING ? -1 : l & u.FOLLOWING ? 1 : 0;
    }), o;
  }
  r.uniqueSort = a;
})(gl);
var Mn = {};
Object.defineProperty(Mn, "__esModule", { value: !0 });
Mn.getFeed = void 0;
var V2 = at, Tu = it;
function j2(r) {
  var t = mn(W2, r);
  return t ? t.name === "feed" ? H2(t) : U2(t) : null;
}
Mn.getFeed = j2;
function H2(r) {
  var t, e = r.children, u = {
    type: "atom",
    items: (0, Tu.getElementsByTagName)("entry", e).map(function(o) {
      var s, i = o.children, l = { media: bl(i) };
      We(l, "id", "id", i), We(l, "title", "title", i);
      var d = (s = mn("link", i)) === null || s === void 0 ? void 0 : s.attribs.href;
      d && (l.link = d);
      var h = zt("summary", i) || zt("content", i);
      h && (l.description = h);
      var c = zt("updated", i);
      return c && (l.pubDate = new Date(c)), l;
    })
  };
  We(u, "id", "id", e), We(u, "title", "title", e);
  var n = (t = mn("link", e)) === null || t === void 0 ? void 0 : t.attribs.href;
  n && (u.link = n), We(u, "description", "subtitle", e);
  var a = zt("updated", e);
  return a && (u.updated = new Date(a)), We(u, "author", "email", e, !0), u;
}
function U2(r) {
  var t, e, u = (e = (t = mn("channel", r.children)) === null || t === void 0 ? void 0 : t.children) !== null && e !== void 0 ? e : [], n = {
    type: r.name.substr(0, 3),
    id: "",
    items: (0, Tu.getElementsByTagName)("item", r.children).map(function(o) {
      var s = o.children, i = { media: bl(s) };
      We(i, "id", "guid", s), We(i, "title", "title", s), We(i, "link", "link", s), We(i, "description", "description", s);
      var l = zt("pubDate", s) || zt("dc:date", s);
      return l && (i.pubDate = new Date(l)), i;
    })
  };
  We(n, "title", "title", u), We(n, "link", "link", u), We(n, "description", "description", u);
  var a = zt("lastBuildDate", u);
  return a && (n.updated = new Date(a)), We(n, "author", "managingEditor", u, !0), n;
}
var z2 = ["url", "type", "lang"], G2 = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function bl(r) {
  return (0, Tu.getElementsByTagName)("media:content", r).map(function(t) {
    for (var e = t.attribs, u = {
      medium: e.medium,
      isDefault: !!e.isDefault
    }, n = 0, a = z2; n < a.length; n++) {
      var o = a[n];
      e[o] && (u[o] = e[o]);
    }
    for (var s = 0, i = G2; s < i.length; s++) {
      var o = i[s];
      e[o] && (u[o] = parseInt(e[o], 10));
    }
    return e.expression && (u.expression = e.expression), u;
  });
}
function mn(r, t) {
  return (0, Tu.getElementsByTagName)(r, t, !0, 1)[0];
}
function zt(r, t, e) {
  return e === void 0 && (e = !1), (0, V2.textContent)((0, Tu.getElementsByTagName)(r, t, e, 1)).trim();
}
function We(r, t, e, u, n) {
  n === void 0 && (n = !1);
  var a = zt(e, u, n);
  a && (r[t] = a);
}
function W2(r) {
  return r === "rss" || r === "feed" || r === "rdf:RDF";
}
(function(r) {
  var t = de && de.__createBinding || (Object.create ? function(n, a, o, s) {
    s === void 0 && (s = o);
    var i = Object.getOwnPropertyDescriptor(a, o);
    (!i || ("get" in i ? !a.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
      return a[o];
    } }), Object.defineProperty(n, s, i);
  } : function(n, a, o, s) {
    s === void 0 && (s = o), n[s] = a[o];
  }), e = de && de.__exportStar || function(n, a) {
    for (var o in n)
      o !== "default" && !Object.prototype.hasOwnProperty.call(a, o) && t(a, n, o);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.hasChildren = r.isDocument = r.isComment = r.isText = r.isCDATA = r.isTag = void 0, e(at, r), e(Re, r), e(Ke, r), e(Ge, r), e(it, r), e(gl, r), e(Mn, r);
  var u = jt;
  Object.defineProperty(r, "isTag", { enumerable: !0, get: function() {
    return u.isTag;
  } }), Object.defineProperty(r, "isCDATA", { enumerable: !0, get: function() {
    return u.isCDATA;
  } }), Object.defineProperty(r, "isText", { enumerable: !0, get: function() {
    return u.isText;
  } }), Object.defineProperty(r, "isComment", { enumerable: !0, get: function() {
    return u.isComment;
  } }), Object.defineProperty(r, "isDocument", { enumerable: !0, get: function() {
    return u.isDocument;
  } }), Object.defineProperty(r, "hasChildren", { enumerable: !0, get: function() {
    return u.hasChildren;
  } });
})(tn);
(function(r) {
  var t = de && de.__createBinding || (Object.create ? function(O, M, L, q) {
    q === void 0 && (q = L);
    var z = Object.getOwnPropertyDescriptor(M, L);
    (!z || ("get" in z ? !M.__esModule : z.writable || z.configurable)) && (z = { enumerable: !0, get: function() {
      return M[L];
    } }), Object.defineProperty(O, q, z);
  } : function(O, M, L, q) {
    q === void 0 && (q = L), O[q] = M[L];
  }), e = de && de.__setModuleDefault || (Object.create ? function(O, M) {
    Object.defineProperty(O, "default", { enumerable: !0, value: M });
  } : function(O, M) {
    O.default = M;
  }), u = de && de.__importStar || function(O) {
    if (O && O.__esModule)
      return O;
    var M = {};
    if (O != null)
      for (var L in O)
        L !== "default" && Object.prototype.hasOwnProperty.call(O, L) && t(M, O, L);
    return e(M, O), M;
  }, n = de && de.__importDefault || function(O) {
    return O && O.__esModule ? O : { default: O };
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.DomUtils = r.parseFeed = r.getFeed = r.ElementType = r.Tokenizer = r.createDomStream = r.parseDOM = r.parseDocument = r.DefaultHandler = r.DomHandler = r.Parser = void 0;
  var a = cu, o = cu;
  Object.defineProperty(r, "Parser", { enumerable: !0, get: function() {
    return o.Parser;
  } });
  var s = jt, i = jt;
  Object.defineProperty(r, "DomHandler", { enumerable: !0, get: function() {
    return i.DomHandler;
  } }), Object.defineProperty(r, "DefaultHandler", { enumerable: !0, get: function() {
    return i.DomHandler;
  } });
  function l(O, M) {
    var L = new s.DomHandler(void 0, M);
    return new a.Parser(L, M).end(O), L.root;
  }
  r.parseDocument = l;
  function d(O, M) {
    return l(O, M).children;
  }
  r.parseDOM = d;
  function h(O, M, L) {
    var q = new s.DomHandler(O, M, L);
    return new a.Parser(q, M);
  }
  r.createDomStream = h;
  var c = Xa;
  Object.defineProperty(r, "Tokenizer", { enumerable: !0, get: function() {
    return n(c).default;
  } }), r.ElementType = u(Or);
  var f = tn, g = tn;
  Object.defineProperty(r, "getFeed", { enumerable: !0, get: function() {
    return g.getFeed;
  } });
  var D = { xmlMode: !0 };
  function _(O, M) {
    return M === void 0 && (M = D), (0, f.getFeed)(d(O, M));
  }
  r.parseFeed = _, r.DomUtils = u(tn);
})(Gs);
var Y2 = (r) => {
  if (typeof r != "string")
    throw new TypeError("Expected a string");
  return r.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}, ni = {};
Object.defineProperty(ni, "__esModule", { value: !0 });
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function Xi(r) {
  return Object.prototype.toString.call(r) === "[object Object]";
}
function Z2(r) {
  var t, e;
  return Xi(r) === !1 ? !1 : (t = r.constructor, t === void 0 ? !0 : (e = t.prototype, !(Xi(e) === !1 || e.hasOwnProperty("isPrototypeOf") === !1)));
}
ni.isPlainObject = Z2;
var K2 = function(t) {
  return X2(t) && !J2(t);
};
function X2(r) {
  return !!r && typeof r == "object";
}
function J2(r) {
  var t = Object.prototype.toString.call(r);
  return t === "[object RegExp]" || t === "[object Date]" || tf(r);
}
var Q2 = typeof Symbol == "function" && Symbol.for, ef = Q2 ? Symbol.for("react.element") : 60103;
function tf(r) {
  return r.$$typeof === ef;
}
function rf(r) {
  return Array.isArray(r) ? [] : {};
}
function fu(r, t) {
  return t.clone !== !1 && t.isMergeableObject(r) ? Tr(rf(r), r, t) : r;
}
function uf(r, t, e) {
  return r.concat(t).map(function(u) {
    return fu(u, e);
  });
}
function nf(r, t) {
  if (!t.customMerge)
    return Tr;
  var e = t.customMerge(r);
  return typeof e == "function" ? e : Tr;
}
function af(r) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(r).filter(function(t) {
    return Object.propertyIsEnumerable.call(r, t);
  }) : [];
}
function Ji(r) {
  return Object.keys(r).concat(af(r));
}
function yl(r, t) {
  try {
    return t in r;
  } catch {
    return !1;
  }
}
function of(r, t) {
  return yl(r, t) && !(Object.hasOwnProperty.call(r, t) && Object.propertyIsEnumerable.call(r, t));
}
function sf(r, t, e) {
  var u = {};
  return e.isMergeableObject(r) && Ji(r).forEach(function(n) {
    u[n] = fu(r[n], e);
  }), Ji(t).forEach(function(n) {
    of(r, n) || (yl(r, n) && e.isMergeableObject(t[n]) ? u[n] = nf(n, e)(r[n], t[n], e) : u[n] = fu(t[n], e));
  }), u;
}
function Tr(r, t, e) {
  e = e || {}, e.arrayMerge = e.arrayMerge || uf, e.isMergeableObject = e.isMergeableObject || K2, e.cloneUnlessOtherwiseSpecified = fu;
  var u = Array.isArray(t), n = Array.isArray(r), a = u === n;
  return a ? u ? e.arrayMerge(r, t, e) : sf(r, t, e) : fu(t, e);
}
Tr.all = function(t, e) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(u, n) {
    return Tr(u, n, e);
  }, {});
};
var lf = Tr, cf = lf, _l = { exports: {} };
(function(r) {
  (function(t, e) {
    r.exports ? r.exports = e() : t.parseSrcset = e();
  })(de, function() {
    return function(t) {
      function e(q) {
        return q === " " || // space
        q === "	" || // horizontal tab
        q === `
` || // new line
        q === "\f" || // form feed
        q === "\r";
      }
      function u(q) {
        var z, X = q.exec(t.substring(_));
        if (X)
          return z = X[0], _ += z.length, z;
      }
      for (var n = t.length, a = /^[ \t\n\r\u000c]+/, o = /^[, \t\n\r\u000c]+/, s = /^[^ \t\n\r\u000c]+/, i = /[,]+$/, l = /^\d+$/, d = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, h, c, f, g, D, _ = 0, O = []; ; ) {
        if (u(o), _ >= n)
          return O;
        h = u(s), c = [], h.slice(-1) === "," ? (h = h.replace(i, ""), L()) : M();
      }
      function M() {
        for (u(a), f = "", g = "in descriptor"; ; ) {
          if (D = t.charAt(_), g === "in descriptor")
            if (e(D))
              f && (c.push(f), f = "", g = "after descriptor");
            else if (D === ",") {
              _ += 1, f && c.push(f), L();
              return;
            } else if (D === "(")
              f = f + D, g = "in parens";
            else if (D === "") {
              f && c.push(f), L();
              return;
            } else
              f = f + D;
          else if (g === "in parens")
            if (D === ")")
              f = f + D, g = "in descriptor";
            else if (D === "") {
              c.push(f), L();
              return;
            } else
              f = f + D;
          else if (g === "after descriptor" && !e(D))
            if (D === "") {
              L();
              return;
            } else
              g = "in descriptor", _ -= 1;
          _ += 1;
        }
      }
      function L() {
        var q = !1, z, X, ee, V, oe = {}, W, A, E, S, $;
        for (V = 0; V < c.length; V++)
          W = c[V], A = W[W.length - 1], E = W.substring(0, W.length - 1), S = parseInt(E, 10), $ = parseFloat(E), l.test(E) && A === "w" ? ((z || X) && (q = !0), S === 0 ? q = !0 : z = S) : d.test(E) && A === "x" ? ((z || X || ee) && (q = !0), $ < 0 ? q = !0 : X = $) : l.test(E) && A === "h" ? ((ee || X) && (q = !0), S === 0 ? q = !0 : ee = S) : q = !0;
        q ? console && console.log && console.log("Invalid srcset descriptor found in '" + t + "' at '" + W + "'.") : (oe.url = h, z && (oe.w = z), X && (oe.d = X), ee && (oe.h = ee), O.push(oe));
      }
    };
  });
})(_l);
var df = _l.exports, ai = { exports: {} }, ve = String, wl = function() {
  return { isColorSupported: !1, reset: ve, bold: ve, dim: ve, italic: ve, underline: ve, inverse: ve, hidden: ve, strikethrough: ve, black: ve, red: ve, green: ve, yellow: ve, blue: ve, magenta: ve, cyan: ve, white: ve, gray: ve, bgBlack: ve, bgRed: ve, bgGreen: ve, bgYellow: ve, bgBlue: ve, bgMagenta: ve, bgCyan: ve, bgWhite: ve, blackBright: ve, redBright: ve, greenBright: ve, yellowBright: ve, blueBright: ve, magentaBright: ve, cyanBright: ve, whiteBright: ve, bgBlackBright: ve, bgRedBright: ve, bgGreenBright: ve, bgYellowBright: ve, bgBlueBright: ve, bgMagentaBright: ve, bgCyanBright: ve, bgWhiteBright: ve };
};
ai.exports = wl();
ai.exports.createColors = wl;
var ff = ai.exports;
const pf = {}, hf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pf
}, Symbol.toStringTag, { value: "Module" })), _t = /* @__PURE__ */ Id(hf);
let Qi = ff, eo = _t, ma = class Cl extends Error {
  constructor(t, e, u, n, a, o) {
    super(t), this.name = "CssSyntaxError", this.reason = t, a && (this.file = a), n && (this.source = n), o && (this.plugin = o), typeof e < "u" && typeof u < "u" && (typeof e == "number" ? (this.line = e, this.column = u) : (this.line = e.line, this.column = e.column, this.endLine = u.line, this.endColumn = u.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, Cl);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(t) {
    if (!this.source)
      return "";
    let e = this.source;
    t == null && (t = Qi.isColorSupported);
    let u = (d) => d, n = (d) => d, a = (d) => d;
    if (t) {
      let { bold: d, gray: h, red: c } = Qi.createColors(!0);
      n = (f) => d(c(f)), u = (f) => h(f), eo && (a = (f) => eo(f));
    }
    let o = e.split(/\r?\n/), s = Math.max(this.line - 3, 0), i = Math.min(this.line + 2, o.length), l = String(i).length;
    return o.slice(s, i).map((d, h) => {
      let c = s + 1 + h, f = " " + (" " + c).slice(-l) + " | ";
      if (c === this.line) {
        if (d.length > 160) {
          let D = 20, _ = Math.max(0, this.column - D), O = Math.max(
            this.column + D,
            this.endColumn + D
          ), M = d.slice(_, O), L = u(f.replace(/\d/g, " ")) + d.slice(0, Math.min(this.column - 1, D - 1)).replace(/[^\t]/g, " ");
          return n(">") + u(f) + a(M) + `
 ` + L + n("^");
        }
        let g = u(f.replace(/\d/g, " ")) + d.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return n(">") + u(f) + a(d) + `
 ` + g + n("^");
      }
      return " " + u(f) + a(d);
    }).join(`
`);
  }
  toString() {
    let t = this.showSourceCode();
    return t && (t = `

` + t + `
`), this.name + ": " + this.message + t;
  }
};
var ii = ma;
ma.default = ma;
const to = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function mf(r) {
  return r[0].toUpperCase() + r.slice(1);
}
let va = class {
  constructor(t) {
    this.builder = t;
  }
  atrule(t, e) {
    let u = "@" + t.name, n = t.params ? this.rawValue(t, "params") : "";
    if (typeof t.raws.afterName < "u" ? u += t.raws.afterName : n && (u += " "), t.nodes)
      this.block(t, u + n);
    else {
      let a = (t.raws.between || "") + (e ? ";" : "");
      this.builder(u + n + a, t);
    }
  }
  beforeAfter(t, e) {
    let u;
    t.type === "decl" ? u = this.raw(t, null, "beforeDecl") : t.type === "comment" ? u = this.raw(t, null, "beforeComment") : e === "before" ? u = this.raw(t, null, "beforeRule") : u = this.raw(t, null, "beforeClose");
    let n = t.parent, a = 0;
    for (; n && n.type !== "root"; )
      a += 1, n = n.parent;
    if (u.includes(`
`)) {
      let o = this.raw(t, null, "indent");
      if (o.length)
        for (let s = 0; s < a; s++)
          u += o;
    }
    return u;
  }
  block(t, e) {
    let u = this.raw(t, "between", "beforeOpen");
    this.builder(e + u + "{", t, "start");
    let n;
    t.nodes && t.nodes.length ? (this.body(t), n = this.raw(t, "after")) : n = this.raw(t, "after", "emptyBody"), n && this.builder(n), this.builder("}", t, "end");
  }
  body(t) {
    let e = t.nodes.length - 1;
    for (; e > 0 && t.nodes[e].type === "comment"; )
      e -= 1;
    let u = this.raw(t, "semicolon");
    for (let n = 0; n < t.nodes.length; n++) {
      let a = t.nodes[n], o = this.raw(a, "before");
      o && this.builder(o), this.stringify(a, e !== n || u);
    }
  }
  comment(t) {
    let e = this.raw(t, "left", "commentLeft"), u = this.raw(t, "right", "commentRight");
    this.builder("/*" + e + t.text + u + "*/", t);
  }
  decl(t, e) {
    let u = this.raw(t, "between", "colon"), n = t.prop + u + this.rawValue(t, "value");
    t.important && (n += t.raws.important || " !important"), e && (n += ";"), this.builder(n, t);
  }
  document(t) {
    this.body(t);
  }
  raw(t, e, u) {
    let n;
    if (u || (u = e), e && (n = t.raws[e], typeof n < "u"))
      return n;
    let a = t.parent;
    if (u === "before" && (!a || a.type === "root" && a.first === t || a && a.type === "document"))
      return "";
    if (!a)
      return to[u];
    let o = t.root();
    if (o.rawCache || (o.rawCache = {}), typeof o.rawCache[u] < "u")
      return o.rawCache[u];
    if (u === "before" || u === "after")
      return this.beforeAfter(t, u);
    {
      let s = "raw" + mf(u);
      this[s] ? n = this[s](o, t) : o.walk((i) => {
        if (n = i.raws[e], typeof n < "u")
          return !1;
      });
    }
    return typeof n > "u" && (n = to[u]), o.rawCache[u] = n, n;
  }
  rawBeforeClose(t) {
    let e;
    return t.walk((u) => {
      if (u.nodes && u.nodes.length > 0 && typeof u.raws.after < "u")
        return e = u.raws.after, e.includes(`
`) && (e = e.replace(/[^\n]+$/, "")), !1;
    }), e && (e = e.replace(/\S/g, "")), e;
  }
  rawBeforeComment(t, e) {
    let u;
    return t.walkComments((n) => {
      if (typeof n.raws.before < "u")
        return u = n.raws.before, u.includes(`
`) && (u = u.replace(/[^\n]+$/, "")), !1;
    }), typeof u > "u" ? u = this.raw(e, null, "beforeDecl") : u && (u = u.replace(/\S/g, "")), u;
  }
  rawBeforeDecl(t, e) {
    let u;
    return t.walkDecls((n) => {
      if (typeof n.raws.before < "u")
        return u = n.raws.before, u.includes(`
`) && (u = u.replace(/[^\n]+$/, "")), !1;
    }), typeof u > "u" ? u = this.raw(e, null, "beforeRule") : u && (u = u.replace(/\S/g, "")), u;
  }
  rawBeforeOpen(t) {
    let e;
    return t.walk((u) => {
      if (u.type !== "decl" && (e = u.raws.between, typeof e < "u"))
        return !1;
    }), e;
  }
  rawBeforeRule(t) {
    let e;
    return t.walk((u) => {
      if (u.nodes && (u.parent !== t || t.first !== u) && typeof u.raws.before < "u")
        return e = u.raws.before, e.includes(`
`) && (e = e.replace(/[^\n]+$/, "")), !1;
    }), e && (e = e.replace(/\S/g, "")), e;
  }
  rawColon(t) {
    let e;
    return t.walkDecls((u) => {
      if (typeof u.raws.between < "u")
        return e = u.raws.between.replace(/[^\s:]/g, ""), !1;
    }), e;
  }
  rawEmptyBody(t) {
    let e;
    return t.walk((u) => {
      if (u.nodes && u.nodes.length === 0 && (e = u.raws.after, typeof e < "u"))
        return !1;
    }), e;
  }
  rawIndent(t) {
    if (t.raws.indent)
      return t.raws.indent;
    let e;
    return t.walk((u) => {
      let n = u.parent;
      if (n && n !== t && n.parent && n.parent === t && typeof u.raws.before < "u") {
        let a = u.raws.before.split(`
`);
        return e = a[a.length - 1], e = e.replace(/\S/g, ""), !1;
      }
    }), e;
  }
  rawSemicolon(t) {
    let e;
    return t.walk((u) => {
      if (u.nodes && u.nodes.length && u.last.type === "decl" && (e = u.raws.semicolon, typeof e < "u"))
        return !1;
    }), e;
  }
  rawValue(t, e) {
    let u = t[e], n = t.raws[e];
    return n && n.value === u ? n.raw : u;
  }
  root(t) {
    this.body(t), t.raws.after && this.builder(t.raws.after);
  }
  rule(t) {
    this.block(t, this.rawValue(t, "selector")), t.raws.ownSemicolon && this.builder(t.raws.ownSemicolon, t, "end");
  }
  stringify(t, e) {
    if (!this[t.type])
      throw new Error(
        "Unknown AST node type " + t.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[t.type](t, e);
  }
};
var Dl = va;
va.default = va;
let vf = Dl;
function ga(r, t) {
  new vf(t).stringify(r);
}
var On = ga;
ga.default = ga;
var Bu = {};
Bu.isClean = Symbol("isClean");
Bu.my = Symbol("my");
let gf = ii, bf = Dl, yf = On, { isClean: Wr, my: _f } = Bu;
function ba(r, t) {
  let e = new r.constructor();
  for (let u in r) {
    if (!Object.prototype.hasOwnProperty.call(r, u) || u === "proxyCache")
      continue;
    let n = r[u], a = typeof n;
    u === "parent" && a === "object" ? t && (e[u] = t) : u === "source" ? e[u] = n : Array.isArray(n) ? e[u] = n.map((o) => ba(o, e)) : (a === "object" && n !== null && (n = ba(n)), e[u] = n);
  }
  return e;
}
function It(r, t) {
  if (t && typeof t.offset < "u")
    return t.offset;
  let e = 1, u = 1, n = 0;
  for (let a = 0; a < r.length; a++) {
    if (u === t.line && e === t.column) {
      n = a;
      break;
    }
    r[a] === `
` ? (e = 1, u += 1) : e += 1;
  }
  return n;
}
let ya = class {
  get proxyOf() {
    return this;
  }
  constructor(t = {}) {
    this.raws = {}, this[Wr] = !1, this[_f] = !0;
    for (let e in t)
      if (e === "nodes") {
        this.nodes = [];
        for (let u of t[e])
          typeof u.clone == "function" ? this.append(u.clone()) : this.append(u);
      } else
        this[e] = t[e];
  }
  addToError(t) {
    if (t.postcssNode = this, t.stack && this.source && /\n\s{4}at /.test(t.stack)) {
      let e = this.source;
      t.stack = t.stack.replace(
        /\n\s{4}at /,
        `$&${e.input.from}:${e.start.line}:${e.start.column}$&`
      );
    }
    return t;
  }
  after(t) {
    return this.parent.insertAfter(this, t), this;
  }
  assign(t = {}) {
    for (let e in t)
      this[e] = t[e];
    return this;
  }
  before(t) {
    return this.parent.insertBefore(this, t), this;
  }
  cleanRaws(t) {
    delete this.raws.before, delete this.raws.after, t || delete this.raws.between;
  }
  clone(t = {}) {
    let e = ba(this);
    for (let u in t)
      e[u] = t[u];
    return e;
  }
  cloneAfter(t = {}) {
    let e = this.clone(t);
    return this.parent.insertAfter(this, e), e;
  }
  cloneBefore(t = {}) {
    let e = this.clone(t);
    return this.parent.insertBefore(this, e), e;
  }
  error(t, e = {}) {
    if (this.source) {
      let { end: u, start: n } = this.rangeBy(e);
      return this.source.input.error(
        t,
        { column: n.column, line: n.line },
        { column: u.column, line: u.line },
        e
      );
    }
    return new gf(t);
  }
  getProxyProcessor() {
    return {
      get(t, e) {
        return e === "proxyOf" ? t : e === "root" ? () => t.root().toProxy() : t[e];
      },
      set(t, e, u) {
        return t[e] === u || (t[e] = u, (e === "prop" || e === "value" || e === "name" || e === "params" || e === "important" || /* c8 ignore next */
        e === "text") && t.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[Wr] = !0;
  }
  markDirty() {
    if (this[Wr]) {
      this[Wr] = !1;
      let t = this;
      for (; t = t.parent; )
        t[Wr] = !1;
    }
  }
  next() {
    if (!this.parent)
      return;
    let t = this.parent.index(this);
    return this.parent.nodes[t + 1];
  }
  positionBy(t = {}) {
    let e = this.source.start;
    if (t.index)
      e = this.positionInside(t.index);
    else if (t.word) {
      let u = "document" in this.source.input ? this.source.input.document : this.source.input.css, a = u.slice(
        It(u, this.source.start),
        It(u, this.source.end)
      ).indexOf(t.word);
      a !== -1 && (e = this.positionInside(a));
    }
    return e;
  }
  positionInside(t) {
    let e = this.source.start.column, u = this.source.start.line, n = "document" in this.source.input ? this.source.input.document : this.source.input.css, a = It(n, this.source.start), o = a + t;
    for (let s = a; s < o; s++)
      n[s] === `
` ? (e = 1, u += 1) : e += 1;
    return { column: e, line: u, offset: o };
  }
  prev() {
    if (!this.parent)
      return;
    let t = this.parent.index(this);
    return this.parent.nodes[t - 1];
  }
  rangeBy(t = {}) {
    let e = "document" in this.source.input ? this.source.input.document : this.source.input.css, u = {
      column: this.source.start.column,
      line: this.source.start.line,
      offset: It(e, this.source.start)
    }, n = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line,
      offset: typeof this.source.end.offset == "number" ? (
        // `source.end.offset` is exclusive, so we don't need to add 1
        this.source.end.offset
      ) : (
        // Since line/column in this.source.end is inclusive,
        // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
        // So, we add 1 to convert it to exclusive.
        It(e, this.source.end) + 1
      )
    } : {
      column: u.column + 1,
      line: u.line,
      offset: u.offset + 1
    };
    if (t.word) {
      let o = e.slice(
        It(e, this.source.start),
        It(e, this.source.end)
      ).indexOf(t.word);
      o !== -1 && (u = this.positionInside(o), n = this.positionInside(o + t.word.length));
    } else
      t.start ? u = {
        column: t.start.column,
        line: t.start.line,
        offset: It(e, t.start)
      } : t.index && (u = this.positionInside(t.index)), t.end ? n = {
        column: t.end.column,
        line: t.end.line,
        offset: It(e, t.end)
      } : typeof t.endIndex == "number" ? n = this.positionInside(t.endIndex) : t.index && (n = this.positionInside(t.index + 1));
    return (n.line < u.line || n.line === u.line && n.column <= u.column) && (n = {
      column: u.column + 1,
      line: u.line,
      offset: u.offset + 1
    }), { end: n, start: u };
  }
  raw(t, e) {
    return new bf().raw(this, t, e);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...t) {
    if (this.parent) {
      let e = this, u = !1;
      for (let n of t)
        n === this ? u = !0 : u ? (this.parent.insertAfter(e, n), e = n) : this.parent.insertBefore(e, n);
      u || this.remove();
    }
    return this;
  }
  root() {
    let t = this;
    for (; t.parent && t.parent.type !== "document"; )
      t = t.parent;
    return t;
  }
  toJSON(t, e) {
    let u = {}, n = e == null;
    e = e || /* @__PURE__ */ new Map();
    let a = 0;
    for (let o in this) {
      if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache")
        continue;
      let s = this[o];
      if (Array.isArray(s))
        u[o] = s.map((i) => typeof i == "object" && i.toJSON ? i.toJSON(null, e) : i);
      else if (typeof s == "object" && s.toJSON)
        u[o] = s.toJSON(null, e);
      else if (o === "source") {
        if (s == null)
          continue;
        let i = e.get(s.input);
        i == null && (i = a, e.set(s.input, a), a++), u[o] = {
          end: s.end,
          inputId: i,
          start: s.start
        };
      } else
        u[o] = s;
    }
    return n && (u.inputs = [...e.keys()].map((o) => o.toJSON())), u;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(t = yf) {
    t.stringify && (t = t.stringify);
    let e = "";
    return t(this, (u) => {
      e += u;
    }), e;
  }
  warn(t, e, u = {}) {
    let n = { node: this };
    for (let a in u)
      n[a] = u[a];
    return t.warn(e, n);
  }
};
var Ln = ya;
ya.default = ya;
let wf = Ln, _a = class extends wf {
  constructor(t) {
    super(t), this.type = "comment";
  }
};
var Fn = _a;
_a.default = _a;
let Cf = Ln, wa = class extends Cf {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(t) {
    t && typeof t.value < "u" && typeof t.value != "string" && (t = { ...t, value: String(t.value) }), super(t), this.type = "decl";
  }
};
var In = wa;
wa.default = wa;
let Al = Fn, xl = In, Df = Ln, { isClean: El, my: kl } = Bu, oi, Sl, Tl, si;
function Bl(r) {
  return r.map((t) => (t.nodes && (t.nodes = Bl(t.nodes)), delete t.source, t));
}
function $l(r) {
  if (r[El] = !1, r.proxyOf.nodes)
    for (let t of r.proxyOf.nodes)
      $l(t);
}
let Ht = class Ml extends Df {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...t) {
    for (let e of t) {
      let u = this.normalize(e, this.last);
      for (let n of u)
        this.proxyOf.nodes.push(n);
    }
    return this.markDirty(), this;
  }
  cleanRaws(t) {
    if (super.cleanRaws(t), this.nodes)
      for (let e of this.nodes)
        e.cleanRaws(t);
  }
  each(t) {
    if (!this.proxyOf.nodes)
      return;
    let e = this.getIterator(), u, n;
    for (; this.indexes[e] < this.proxyOf.nodes.length && (u = this.indexes[e], n = t(this.proxyOf.nodes[u], u), n !== !1); )
      this.indexes[e] += 1;
    return delete this.indexes[e], n;
  }
  every(t) {
    return this.nodes.every(t);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let t = this.lastEach;
    return this.indexes[t] = 0, t;
  }
  getProxyProcessor() {
    return {
      get(t, e) {
        return e === "proxyOf" ? t : t[e] ? e === "each" || typeof e == "string" && e.startsWith("walk") ? (...u) => t[e](
          ...u.map((n) => typeof n == "function" ? (a, o) => n(a.toProxy(), o) : n)
        ) : e === "every" || e === "some" ? (u) => t[e](
          (n, ...a) => u(n.toProxy(), ...a)
        ) : e === "root" ? () => t.root().toProxy() : e === "nodes" ? t.nodes.map((u) => u.toProxy()) : e === "first" || e === "last" ? t[e].toProxy() : t[e] : t[e];
      },
      set(t, e, u) {
        return t[e] === u || (t[e] = u, (e === "name" || e === "params" || e === "selector") && t.markDirty()), !0;
      }
    };
  }
  index(t) {
    return typeof t == "number" ? t : (t.proxyOf && (t = t.proxyOf), this.proxyOf.nodes.indexOf(t));
  }
  insertAfter(t, e) {
    let u = this.index(t), n = this.normalize(e, this.proxyOf.nodes[u]).reverse();
    u = this.index(t);
    for (let o of n)
      this.proxyOf.nodes.splice(u + 1, 0, o);
    let a;
    for (let o in this.indexes)
      a = this.indexes[o], u < a && (this.indexes[o] = a + n.length);
    return this.markDirty(), this;
  }
  insertBefore(t, e) {
    let u = this.index(t), n = u === 0 ? "prepend" : !1, a = this.normalize(
      e,
      this.proxyOf.nodes[u],
      n
    ).reverse();
    u = this.index(t);
    for (let s of a)
      this.proxyOf.nodes.splice(u, 0, s);
    let o;
    for (let s in this.indexes)
      o = this.indexes[s], u <= o && (this.indexes[s] = o + a.length);
    return this.markDirty(), this;
  }
  normalize(t, e) {
    if (typeof t == "string")
      t = Bl(Sl(t).nodes);
    else if (typeof t > "u")
      t = [];
    else if (Array.isArray(t)) {
      t = t.slice(0);
      for (let n of t)
        n.parent && n.parent.removeChild(n, "ignore");
    } else if (t.type === "root" && this.type !== "document") {
      t = t.nodes.slice(0);
      for (let n of t)
        n.parent && n.parent.removeChild(n, "ignore");
    } else if (t.type)
      t = [t];
    else if (t.prop) {
      if (typeof t.value > "u")
        throw new Error("Value field is missed in node creation");
      typeof t.value != "string" && (t.value = String(t.value)), t = [new xl(t)];
    } else if (t.selector || t.selectors)
      t = [new si(t)];
    else if (t.name)
      t = [new oi(t)];
    else if (t.text)
      t = [new Al(t)];
    else
      throw new Error("Unknown node type in node creation");
    return t.map((n) => (n[kl] || Ml.rebuild(n), n = n.proxyOf, n.parent && n.parent.removeChild(n), n[El] && $l(n), n.raws || (n.raws = {}), typeof n.raws.before > "u" && e && typeof e.raws.before < "u" && (n.raws.before = e.raws.before.replace(/\S/g, "")), n.parent = this.proxyOf, n));
  }
  prepend(...t) {
    t = t.reverse();
    for (let e of t) {
      let u = this.normalize(e, this.first, "prepend").reverse();
      for (let n of u)
        this.proxyOf.nodes.unshift(n);
      for (let n in this.indexes)
        this.indexes[n] = this.indexes[n] + u.length;
    }
    return this.markDirty(), this;
  }
  push(t) {
    return t.parent = this, this.proxyOf.nodes.push(t), this;
  }
  removeAll() {
    for (let t of this.proxyOf.nodes)
      t.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(t) {
    t = this.index(t), this.proxyOf.nodes[t].parent = void 0, this.proxyOf.nodes.splice(t, 1);
    let e;
    for (let u in this.indexes)
      e = this.indexes[u], e >= t && (this.indexes[u] = e - 1);
    return this.markDirty(), this;
  }
  replaceValues(t, e, u) {
    return u || (u = e, e = {}), this.walkDecls((n) => {
      e.props && !e.props.includes(n.prop) || e.fast && !n.value.includes(e.fast) || (n.value = n.value.replace(t, u));
    }), this.markDirty(), this;
  }
  some(t) {
    return this.nodes.some(t);
  }
  walk(t) {
    return this.each((e, u) => {
      let n;
      try {
        n = t(e, u);
      } catch (a) {
        throw e.addToError(a);
      }
      return n !== !1 && e.walk && (n = e.walk(t)), n;
    });
  }
  walkAtRules(t, e) {
    return e ? t instanceof RegExp ? this.walk((u, n) => {
      if (u.type === "atrule" && t.test(u.name))
        return e(u, n);
    }) : this.walk((u, n) => {
      if (u.type === "atrule" && u.name === t)
        return e(u, n);
    }) : (e = t, this.walk((u, n) => {
      if (u.type === "atrule")
        return e(u, n);
    }));
  }
  walkComments(t) {
    return this.walk((e, u) => {
      if (e.type === "comment")
        return t(e, u);
    });
  }
  walkDecls(t, e) {
    return e ? t instanceof RegExp ? this.walk((u, n) => {
      if (u.type === "decl" && t.test(u.prop))
        return e(u, n);
    }) : this.walk((u, n) => {
      if (u.type === "decl" && u.prop === t)
        return e(u, n);
    }) : (e = t, this.walk((u, n) => {
      if (u.type === "decl")
        return e(u, n);
    }));
  }
  walkRules(t, e) {
    return e ? t instanceof RegExp ? this.walk((u, n) => {
      if (u.type === "rule" && t.test(u.selector))
        return e(u, n);
    }) : this.walk((u, n) => {
      if (u.type === "rule" && u.selector === t)
        return e(u, n);
    }) : (e = t, this.walk((u, n) => {
      if (u.type === "rule")
        return e(u, n);
    }));
  }
};
Ht.registerParse = (r) => {
  Sl = r;
};
Ht.registerRule = (r) => {
  si = r;
};
Ht.registerAtRule = (r) => {
  oi = r;
};
Ht.registerRoot = (r) => {
  Tl = r;
};
var lr = Ht;
Ht.default = Ht;
Ht.rebuild = (r) => {
  r.type === "atrule" ? Object.setPrototypeOf(r, oi.prototype) : r.type === "rule" ? Object.setPrototypeOf(r, si.prototype) : r.type === "decl" ? Object.setPrototypeOf(r, xl.prototype) : r.type === "comment" ? Object.setPrototypeOf(r, Al.prototype) : r.type === "root" && Object.setPrototypeOf(r, Tl.prototype), r[kl] = !0, r.nodes && r.nodes.forEach((t) => {
    Ht.rebuild(t);
  });
};
let Ol = lr, vn = class extends Ol {
  constructor(t) {
    super(t), this.type = "atrule";
  }
  append(...t) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...t);
  }
  prepend(...t) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...t);
  }
};
var li = vn;
vn.default = vn;
Ol.registerAtRule(vn);
let Af = lr, Ll, Fl, pu = class extends Af {
  constructor(t) {
    super({ type: "document", ...t }), this.nodes || (this.nodes = []);
  }
  toResult(t = {}) {
    return new Ll(new Fl(), this, t).stringify();
  }
};
pu.registerLazyResult = (r) => {
  Ll = r;
};
pu.registerProcessor = (r) => {
  Fl = r;
};
var ci = pu;
pu.default = pu;
let xf = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", Ef = (r, t = 21) => (e = t) => {
  let u = "", n = e | 0;
  for (; n--; )
    u += r[Math.random() * r.length | 0];
  return u;
}, kf = (r = 21) => {
  let t = "", e = r | 0;
  for (; e--; )
    t += xf[Math.random() * 64 | 0];
  return t;
};
var Sf = { nanoid: kf, customAlphabet: Ef };
let { existsSync: Tf, readFileSync: Bf } = _t, { dirname: Wn, join: $f } = _t, { SourceMapConsumer: ro, SourceMapGenerator: uo } = _t;
function Mf(r) {
  return Buffer ? Buffer.from(r, "base64").toString() : window.atob(r);
}
let Ca = class {
  constructor(t, e) {
    if (e.map === !1)
      return;
    this.loadAnnotation(t), this.inline = this.startWith(this.annotation, "data:");
    let u = e.map ? e.map.prev : void 0, n = this.loadMap(e.from, u);
    !this.mapFile && e.from && (this.mapFile = e.from), this.mapFile && (this.root = Wn(this.mapFile)), n && (this.text = n);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new ro(this.text)), this.consumerCache;
  }
  decodeInline(t) {
    let e = /^data:application\/json;charset=utf-?8;base64,/, u = /^data:application\/json;base64,/, n = /^data:application\/json;charset=utf-?8,/, a = /^data:application\/json,/, o = t.match(n) || t.match(a);
    if (o)
      return decodeURIComponent(t.substr(o[0].length));
    let s = t.match(e) || t.match(u);
    if (s)
      return Mf(t.substr(s[0].length));
    let i = t.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + i);
  }
  getAnnotationURL(t) {
    return t.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(t) {
    return typeof t != "object" ? !1 : typeof t.mappings == "string" || typeof t._mappings == "string" || Array.isArray(t.sections);
  }
  loadAnnotation(t) {
    let e = t.match(/\/\*\s*# sourceMappingURL=/g);
    if (!e)
      return;
    let u = t.lastIndexOf(e.pop()), n = t.indexOf("*/", u);
    u > -1 && n > -1 && (this.annotation = this.getAnnotationURL(t.substring(u, n)));
  }
  loadFile(t) {
    if (this.root = Wn(t), Tf(t))
      return this.mapFile = t, Bf(t, "utf-8").toString().trim();
  }
  loadMap(t, e) {
    if (e === !1)
      return !1;
    if (e) {
      if (typeof e == "string")
        return e;
      if (typeof e == "function") {
        let u = e(t);
        if (u) {
          let n = this.loadFile(u);
          if (!n)
            throw new Error(
              "Unable to load previous source map: " + u.toString()
            );
          return n;
        }
      } else {
        if (e instanceof ro)
          return uo.fromSourceMap(e).toString();
        if (e instanceof uo)
          return e.toString();
        if (this.isMap(e))
          return JSON.stringify(e);
        throw new Error(
          "Unsupported previous source map format: " + e.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let u = this.annotation;
        return t && (u = $f(Wn(t), u)), this.loadFile(u);
      }
    }
  }
  startWith(t, e) {
    return t ? t.substr(0, e.length) === e : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var Il = Ca;
Ca.default = Ca;
let { nanoid: Of } = Sf, { isAbsolute: Da, resolve: Aa } = _t, { SourceMapConsumer: Lf, SourceMapGenerator: Ff } = _t, { fileURLToPath: no, pathToFileURL: ju } = _t, ao = ii, If = Il, Yn = _t, Zn = Symbol("lineToIndexCache"), Nf = !!(Lf && Ff), io = !!(Aa && Da);
function oo(r) {
  if (r[Zn])
    return r[Zn];
  let t = r.css.split(`
`), e = new Array(t.length), u = 0;
  for (let n = 0, a = t.length; n < a; n++)
    e[n] = u, u += t[n].length + 1;
  return r[Zn] = e, e;
}
let gn = class {
  get from() {
    return this.file || this.id;
  }
  constructor(t, e = {}) {
    if (t === null || typeof t > "u" || typeof t == "object" && !t.toString)
      throw new Error(`PostCSS received ${t} instead of CSS string`);
    if (this.css = t.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, e.document && (this.document = e.document.toString()), e.from && (!io || /^\w+:\/\//.test(e.from) || Da(e.from) ? this.file = e.from : this.file = Aa(e.from)), io && Nf) {
      let u = new If(this.css, e);
      if (u.text) {
        this.map = u;
        let n = u.consumer().file;
        !this.file && n && (this.file = this.mapResolve(n));
      }
    }
    this.file || (this.id = "<input css " + Of(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(t, e, u, n = {}) {
    let a, o, s, i, l;
    if (e && typeof e == "object") {
      let h = e, c = u;
      if (typeof h.offset == "number") {
        i = h.offset;
        let f = this.fromOffset(i);
        e = f.line, u = f.col;
      } else
        e = h.line, u = h.column, i = this.fromLineAndColumn(e, u);
      if (typeof c.offset == "number") {
        s = c.offset;
        let f = this.fromOffset(s);
        o = f.line, a = f.col;
      } else
        o = c.line, a = c.column, s = this.fromLineAndColumn(c.line, c.column);
    } else if (u)
      i = this.fromLineAndColumn(e, u);
    else {
      i = e;
      let h = this.fromOffset(i);
      e = h.line, u = h.col;
    }
    let d = this.origin(e, u, o, a);
    return d ? l = new ao(
      t,
      d.endLine === void 0 ? d.line : { column: d.column, line: d.line },
      d.endLine === void 0 ? d.column : { column: d.endColumn, line: d.endLine },
      d.source,
      d.file,
      n.plugin
    ) : l = new ao(
      t,
      o === void 0 ? e : { column: u, line: e },
      o === void 0 ? u : { column: a, line: o },
      this.css,
      this.file,
      n.plugin
    ), l.input = { column: u, endColumn: a, endLine: o, endOffset: s, line: e, offset: i, source: this.css }, this.file && (ju && (l.input.url = ju(this.file).toString()), l.input.file = this.file), l;
  }
  fromLineAndColumn(t, e) {
    return oo(this)[t - 1] + e - 1;
  }
  fromOffset(t) {
    let e = oo(this), u = e[e.length - 1], n = 0;
    if (t >= u)
      n = e.length - 1;
    else {
      let a = e.length - 2, o;
      for (; n < a; )
        if (o = n + (a - n >> 1), t < e[o])
          a = o - 1;
        else if (t >= e[o + 1])
          n = o + 1;
        else {
          n = o;
          break;
        }
    }
    return {
      col: t - e[n] + 1,
      line: n + 1
    };
  }
  mapResolve(t) {
    return /^\w+:\/\//.test(t) ? t : Aa(this.map.consumer().sourceRoot || this.map.root || ".", t);
  }
  origin(t, e, u, n) {
    if (!this.map)
      return !1;
    let a = this.map.consumer(), o = a.originalPositionFor({ column: e, line: t });
    if (!o.source)
      return !1;
    let s;
    typeof u == "number" && (s = a.originalPositionFor({ column: n, line: u }));
    let i;
    Da(o.source) ? i = ju(o.source) : i = new URL(
      o.source,
      this.map.consumer().sourceRoot || ju(this.map.mapFile)
    );
    let l = {
      column: o.column,
      endColumn: s && s.column,
      endLine: s && s.line,
      line: o.line,
      url: i.toString()
    };
    if (i.protocol === "file:")
      if (no)
        l.file = no(i);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let d = a.sourceContentFor(o.source);
    return d && (l.source = d), l;
  }
  toJSON() {
    let t = {};
    for (let e of ["hasBOM", "css", "file", "id"])
      this[e] != null && (t[e] = this[e]);
    return this.map && (t.map = { ...this.map }, t.map.consumerCache && (t.map.consumerCache = void 0)), t;
  }
};
var Nn = gn;
gn.default = gn;
Yn && Yn.registerInput && Yn.registerInput(gn);
let Nl = lr, ql, Pl, Br = class extends Nl {
  constructor(t) {
    super(t), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(t, e, u) {
    let n = super.normalize(t);
    if (e) {
      if (u === "prepend")
        this.nodes.length > 1 ? e.raws.before = this.nodes[1].raws.before : delete e.raws.before;
      else if (this.first !== e)
        for (let a of n)
          a.raws.before = e.raws.before;
    }
    return n;
  }
  removeChild(t, e) {
    let u = this.index(t);
    return !e && u === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[u].raws.before), super.removeChild(t);
  }
  toResult(t = {}) {
    return new ql(new Pl(), this, t).stringify();
  }
};
Br.registerLazyResult = (r) => {
  ql = r;
};
Br.registerProcessor = (r) => {
  Pl = r;
};
var $u = Br;
Br.default = Br;
Nl.registerRoot(Br);
let hu = {
  comma(r) {
    return hu.split(r, [","], !0);
  },
  space(r) {
    let t = [" ", `
`, "	"];
    return hu.split(r, t);
  },
  split(r, t, e) {
    let u = [], n = "", a = !1, o = 0, s = !1, i = "", l = !1;
    for (let d of r)
      l ? l = !1 : d === "\\" ? l = !0 : s ? d === i && (s = !1) : d === '"' || d === "'" ? (s = !0, i = d) : d === "(" ? o += 1 : d === ")" ? o > 0 && (o -= 1) : o === 0 && t.includes(d) && (a = !0), a ? (n !== "" && u.push(n.trim()), n = "", a = !1) : n += d;
    return (e || n !== "") && u.push(n.trim()), u;
  }
};
var Rl = hu;
hu.default = hu;
let Vl = lr, qf = Rl, bn = class extends Vl {
  get selectors() {
    return qf.comma(this.selector);
  }
  set selectors(t) {
    let e = this.selector ? this.selector.match(/,\s*/) : null, u = e ? e[0] : "," + this.raw("between", "beforeOpen");
    this.selector = t.join(u);
  }
  constructor(t) {
    super(t), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var di = bn;
bn.default = bn;
Vl.registerRule(bn);
let Pf = li, Rf = Fn, Vf = In, jf = Nn, Hf = Il, Uf = $u, zf = di;
function mu(r, t) {
  if (Array.isArray(r))
    return r.map((n) => mu(n));
  let { inputs: e, ...u } = r;
  if (e) {
    t = [];
    for (let n of e) {
      let a = { ...n, __proto__: jf.prototype };
      a.map && (a.map = {
        ...a.map,
        __proto__: Hf.prototype
      }), t.push(a);
    }
  }
  if (u.nodes && (u.nodes = r.nodes.map((n) => mu(n, t))), u.source) {
    let { inputId: n, ...a } = u.source;
    u.source = a, n != null && (u.source.input = t[n]);
  }
  if (u.type === "root")
    return new Uf(u);
  if (u.type === "decl")
    return new Vf(u);
  if (u.type === "rule")
    return new zf(u);
  if (u.type === "comment")
    return new Rf(u);
  if (u.type === "atrule")
    return new Pf(u);
  throw new Error("Unknown node type: " + r.type);
}
var Gf = mu;
mu.default = mu;
let { dirname: un, relative: jl, resolve: Hl, sep: Ul } = _t, { SourceMapConsumer: zl, SourceMapGenerator: nn } = _t, { pathToFileURL: so } = _t, Wf = Nn, Yf = !!(zl && nn), Zf = !!(un && Hl && jl && Ul), Kf = class {
  constructor(t, e, u, n) {
    this.stringify = t, this.mapOpts = u.map || {}, this.root = e, this.opts = u, this.css = n, this.originalCSS = n, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let t;
    this.isInline() ? t = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? t = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? t = this.mapOpts.annotation(this.opts.to, this.root) : t = this.outputFile() + ".map";
    let e = `
`;
    this.css.includes(`\r
`) && (e = `\r
`), this.css += e + "/*# sourceMappingURL=" + t + " */";
  }
  applyPrevMaps() {
    for (let t of this.previous()) {
      let e = this.toUrl(this.path(t.file)), u = t.root || un(t.file), n;
      this.mapOpts.sourcesContent === !1 ? (n = new zl(t.text), n.sourcesContent && (n.sourcesContent = null)) : n = t.consumer(), this.map.applySourceMap(n, e, this.toUrl(this.path(u)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let t;
        for (let e = this.root.nodes.length - 1; e >= 0; e--)
          t = this.root.nodes[e], t.type === "comment" && t.text.startsWith("# sourceMappingURL=") && this.root.removeChild(e);
      } else
        this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), Zf && Yf && this.isMap())
      return this.generateMap();
    {
      let t = "";
      return this.stringify(this.root, (e) => {
        t += e;
      }), [t];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let t = this.previous()[0].consumer();
      t.file = this.outputFile(), this.map = nn.fromSourceMap(t, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new nn({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new nn({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let t = 1, e = 1, u = "<no source>", n = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, a, o;
    this.stringify(this.root, (s, i, l) => {
      if (this.css += s, i && l !== "end" && (n.generated.line = t, n.generated.column = e - 1, i.source && i.source.start ? (n.source = this.sourcePath(i), n.original.line = i.source.start.line, n.original.column = i.source.start.column - 1, this.map.addMapping(n)) : (n.source = u, n.original.line = 1, n.original.column = 0, this.map.addMapping(n))), o = s.match(/\n/g), o ? (t += o.length, a = s.lastIndexOf(`
`), e = s.length - a) : e += s.length, i && l !== "start") {
        let d = i.parent || { raws: {} };
        (!(i.type === "decl" || i.type === "atrule" && !i.nodes) || i !== d.last || d.raws.semicolon) && (i.source && i.source.end ? (n.source = this.sourcePath(i), n.original.line = i.source.end.line, n.original.column = i.source.end.column - 1, n.generated.line = t, n.generated.column = e - 2, this.map.addMapping(n)) : (n.source = u, n.original.line = 1, n.original.column = 0, n.generated.line = t, n.generated.column = e - 1, this.map.addMapping(n)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((t) => t.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline < "u")
      return this.mapOpts.inline;
    let t = this.mapOpts.annotation;
    return typeof t < "u" && t !== !0 ? !1 : this.previous().length ? this.previous().some((e) => e.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((t) => t.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(t) {
    if (this.mapOpts.absolute || t.charCodeAt(0) === 60 || /^\w+:\/\//.test(t))
      return t;
    let e = this.memoizedPaths.get(t);
    if (e)
      return e;
    let u = this.opts.to ? un(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (u = un(Hl(u, this.mapOpts.annotation)));
    let n = jl(u, t);
    return this.memoizedPaths.set(t, n), n;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((t) => {
          if (t.source && t.source.input.map) {
            let e = t.source.input.map;
            this.previousMaps.includes(e) || this.previousMaps.push(e);
          }
        });
      else {
        let t = new Wf(this.originalCSS, this.opts);
        t.map && this.previousMaps.push(t.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let t = {};
    if (this.root)
      this.root.walk((e) => {
        if (e.source) {
          let u = e.source.input.from;
          if (u && !t[u]) {
            t[u] = !0;
            let n = this.usesFileUrls ? this.toFileUrl(u) : this.toUrl(this.path(u));
            this.map.setSourceContent(n, e.source.input.css);
          }
        }
      });
    else if (this.css) {
      let e = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(e, this.css);
    }
  }
  sourcePath(t) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(t.source.input.from) : this.toUrl(this.path(t.source.input.from));
  }
  toBase64(t) {
    return Buffer ? Buffer.from(t).toString("base64") : window.btoa(unescape(encodeURIComponent(t)));
  }
  toFileUrl(t) {
    let e = this.memoizedFileURLs.get(t);
    if (e)
      return e;
    if (so) {
      let u = so(t).toString();
      return this.memoizedFileURLs.set(t, u), u;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(t) {
    let e = this.memoizedURLs.get(t);
    if (e)
      return e;
    Ul === "\\" && (t = t.replace(/\\/g, "/"));
    let u = encodeURI(t).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(t, u), u;
  }
};
var Gl = Kf;
const Kn = "'".charCodeAt(0), lo = '"'.charCodeAt(0), Hu = "\\".charCodeAt(0), co = "/".charCodeAt(0), Uu = `
`.charCodeAt(0), Yr = " ".charCodeAt(0), zu = "\f".charCodeAt(0), Gu = "	".charCodeAt(0), Wu = "\r".charCodeAt(0), Xf = "[".charCodeAt(0), Jf = "]".charCodeAt(0), Qf = "(".charCodeAt(0), ep = ")".charCodeAt(0), tp = "{".charCodeAt(0), rp = "}".charCodeAt(0), up = ";".charCodeAt(0), np = "*".charCodeAt(0), ap = ":".charCodeAt(0), ip = "@".charCodeAt(0), Yu = /[\t\n\f\r "#'()/;[\\\]{}]/g, Zu = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, op = /.[\r\n"'(/\\]/, fo = /[\da-f]/i;
var sp = function(t, e = {}) {
  let u = t.css.valueOf(), n = e.ignoreErrors, a, o, s, i, l, d, h, c, f, g, D = u.length, _ = 0, O = [], M = [];
  function L() {
    return _;
  }
  function q(V) {
    throw t.error("Unclosed " + V, _);
  }
  function z() {
    return M.length === 0 && _ >= D;
  }
  function X(V) {
    if (M.length)
      return M.pop();
    if (_ >= D)
      return;
    let oe = V ? V.ignoreUnclosed : !1;
    switch (a = u.charCodeAt(_), a) {
      case Uu:
      case Yr:
      case Gu:
      case Wu:
      case zu: {
        i = _;
        do
          i += 1, a = u.charCodeAt(i);
        while (a === Yr || a === Uu || a === Gu || a === Wu || a === zu);
        d = ["space", u.slice(_, i)], _ = i - 1;
        break;
      }
      case Xf:
      case Jf:
      case tp:
      case rp:
      case ap:
      case up:
      case ep: {
        let W = String.fromCharCode(a);
        d = [W, W, _];
        break;
      }
      case Qf: {
        if (g = O.length ? O.pop()[1] : "", f = u.charCodeAt(_ + 1), g === "url" && f !== Kn && f !== lo && f !== Yr && f !== Uu && f !== Gu && f !== zu && f !== Wu) {
          i = _;
          do {
            if (h = !1, i = u.indexOf(")", i + 1), i === -1)
              if (n || oe) {
                i = _;
                break;
              } else
                q("bracket");
            for (c = i; u.charCodeAt(c - 1) === Hu; )
              c -= 1, h = !h;
          } while (h);
          d = ["brackets", u.slice(_, i + 1), _, i], _ = i;
        } else
          i = u.indexOf(")", _ + 1), o = u.slice(_, i + 1), i === -1 || op.test(o) ? d = ["(", "(", _] : (d = ["brackets", o, _, i], _ = i);
        break;
      }
      case Kn:
      case lo: {
        l = a === Kn ? "'" : '"', i = _;
        do {
          if (h = !1, i = u.indexOf(l, i + 1), i === -1)
            if (n || oe) {
              i = _ + 1;
              break;
            } else
              q("string");
          for (c = i; u.charCodeAt(c - 1) === Hu; )
            c -= 1, h = !h;
        } while (h);
        d = ["string", u.slice(_, i + 1), _, i], _ = i;
        break;
      }
      case ip: {
        Yu.lastIndex = _ + 1, Yu.test(u), Yu.lastIndex === 0 ? i = u.length - 1 : i = Yu.lastIndex - 2, d = ["at-word", u.slice(_, i + 1), _, i], _ = i;
        break;
      }
      case Hu: {
        for (i = _, s = !0; u.charCodeAt(i + 1) === Hu; )
          i += 1, s = !s;
        if (a = u.charCodeAt(i + 1), s && a !== co && a !== Yr && a !== Uu && a !== Gu && a !== Wu && a !== zu && (i += 1, fo.test(u.charAt(i)))) {
          for (; fo.test(u.charAt(i + 1)); )
            i += 1;
          u.charCodeAt(i + 1) === Yr && (i += 1);
        }
        d = ["word", u.slice(_, i + 1), _, i], _ = i;
        break;
      }
      default: {
        a === co && u.charCodeAt(_ + 1) === np ? (i = u.indexOf("*/", _ + 2) + 1, i === 0 && (n || oe ? i = u.length : q("comment")), d = ["comment", u.slice(_, i + 1), _, i], _ = i) : (Zu.lastIndex = _ + 1, Zu.test(u), Zu.lastIndex === 0 ? i = u.length - 1 : i = Zu.lastIndex - 2, d = ["word", u.slice(_, i + 1), _, i], O.push(d), _ = i);
        break;
      }
    }
    return _++, d;
  }
  function ee(V) {
    M.push(V);
  }
  return {
    back: ee,
    endOfFile: z,
    nextToken: X,
    position: L
  };
};
let lp = li, cp = Fn, dp = In, fp = $u, po = di, pp = sp;
const ho = {
  empty: !0,
  space: !0
};
function hp(r) {
  for (let t = r.length - 1; t >= 0; t--) {
    let e = r[t], u = e[3] || e[2];
    if (u)
      return u;
  }
}
let mp = class {
  constructor(t) {
    this.input = t, this.root = new fp(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: t, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(t) {
    let e = new lp();
    e.name = t[1].slice(1), e.name === "" && this.unnamedAtrule(e, t), this.init(e, t[2]);
    let u, n, a, o = !1, s = !1, i = [], l = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (t = this.tokenizer.nextToken(), u = t[0], u === "(" || u === "[" ? l.push(u === "(" ? ")" : "]") : u === "{" && l.length > 0 ? l.push("}") : u === l[l.length - 1] && l.pop(), l.length === 0)
        if (u === ";") {
          e.source.end = this.getPosition(t[2]), e.source.end.offset++, this.semicolon = !0;
          break;
        } else if (u === "{") {
          s = !0;
          break;
        } else if (u === "}") {
          if (i.length > 0) {
            for (a = i.length - 1, n = i[a]; n && n[0] === "space"; )
              n = i[--a];
            n && (e.source.end = this.getPosition(n[3] || n[2]), e.source.end.offset++);
          }
          this.end(t);
          break;
        } else
          i.push(t);
      else
        i.push(t);
      if (this.tokenizer.endOfFile()) {
        o = !0;
        break;
      }
    }
    e.raws.between = this.spacesAndCommentsFromEnd(i), i.length ? (e.raws.afterName = this.spacesAndCommentsFromStart(i), this.raw(e, "params", i), o && (t = i[i.length - 1], e.source.end = this.getPosition(t[3] || t[2]), e.source.end.offset++, this.spaces = e.raws.between, e.raws.between = "")) : (e.raws.afterName = "", e.params = ""), s && (e.nodes = [], this.current = e);
  }
  checkMissedSemicolon(t) {
    let e = this.colon(t);
    if (e === !1)
      return;
    let u = 0, n;
    for (let a = e - 1; a >= 0 && (n = t[a], !(n[0] !== "space" && (u += 1, u === 2))); a--)
      ;
    throw this.input.error(
      "Missed semicolon",
      n[0] === "word" ? n[3] + 1 : n[2]
    );
  }
  colon(t) {
    let e = 0, u, n, a;
    for (let [o, s] of t.entries()) {
      if (n = s, a = n[0], a === "(" && (e += 1), a === ")" && (e -= 1), e === 0 && a === ":")
        if (!u)
          this.doubleColon(n);
        else {
          if (u[0] === "word" && u[1] === "progid")
            continue;
          return o;
        }
      u = n;
    }
    return !1;
  }
  comment(t) {
    let e = new cp();
    this.init(e, t[2]), e.source.end = this.getPosition(t[3] || t[2]), e.source.end.offset++;
    let u = t[1].slice(2, -2);
    if (/^\s*$/.test(u))
      e.text = "", e.raws.left = u, e.raws.right = "";
    else {
      let n = u.match(/^(\s*)([^]*\S)(\s*)$/);
      e.text = n[2], e.raws.left = n[1], e.raws.right = n[3];
    }
  }
  createTokenizer() {
    this.tokenizer = pp(this.input);
  }
  decl(t, e) {
    let u = new dp();
    this.init(u, t[0][2]);
    let n = t[t.length - 1];
    for (n[0] === ";" && (this.semicolon = !0, t.pop()), u.source.end = this.getPosition(
      n[3] || n[2] || hp(t)
    ), u.source.end.offset++; t[0][0] !== "word"; )
      t.length === 1 && this.unknownWord(t), u.raws.before += t.shift()[1];
    for (u.source.start = this.getPosition(t[0][2]), u.prop = ""; t.length; ) {
      let l = t[0][0];
      if (l === ":" || l === "space" || l === "comment")
        break;
      u.prop += t.shift()[1];
    }
    u.raws.between = "";
    let a;
    for (; t.length; )
      if (a = t.shift(), a[0] === ":") {
        u.raws.between += a[1];
        break;
      } else
        a[0] === "word" && /\w/.test(a[1]) && this.unknownWord([a]), u.raws.between += a[1];
    (u.prop[0] === "_" || u.prop[0] === "*") && (u.raws.before += u.prop[0], u.prop = u.prop.slice(1));
    let o = [], s;
    for (; t.length && (s = t[0][0], !(s !== "space" && s !== "comment")); )
      o.push(t.shift());
    this.precheckMissedSemicolon(t);
    for (let l = t.length - 1; l >= 0; l--) {
      if (a = t[l], a[1].toLowerCase() === "!important") {
        u.important = !0;
        let d = this.stringFrom(t, l);
        d = this.spacesFromEnd(t) + d, d !== " !important" && (u.raws.important = d);
        break;
      } else if (a[1].toLowerCase() === "important") {
        let d = t.slice(0), h = "";
        for (let c = l; c > 0; c--) {
          let f = d[c][0];
          if (h.trim().startsWith("!") && f !== "space")
            break;
          h = d.pop()[1] + h;
        }
        h.trim().startsWith("!") && (u.important = !0, u.raws.important = h, t = d);
      }
      if (a[0] !== "space" && a[0] !== "comment")
        break;
    }
    t.some((l) => l[0] !== "space" && l[0] !== "comment") && (u.raws.between += o.map((l) => l[1]).join(""), o = []), this.raw(u, "value", o.concat(t), e), u.value.includes(":") && !e && this.checkMissedSemicolon(t);
  }
  doubleColon(t) {
    throw this.input.error(
      "Double colon",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
  emptyRule(t) {
    let e = new po();
    this.init(e, t[2]), e.selector = "", e.raws.between = "", this.current = e;
  }
  end(t) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(t[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(t);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(t) {
    if (this.spaces += t[1], this.current.nodes) {
      let e = this.current.nodes[this.current.nodes.length - 1];
      e && e.type === "rule" && !e.raws.ownSemicolon && (e.raws.ownSemicolon = this.spaces, this.spaces = "", e.source.end = this.getPosition(t[2]), e.source.end.offset += e.raws.ownSemicolon.length);
    }
  }
  // Helpers
  getPosition(t) {
    let e = this.input.fromOffset(t);
    return {
      column: e.col,
      line: e.line,
      offset: t
    };
  }
  init(t, e) {
    this.current.push(t), t.source = {
      input: this.input,
      start: this.getPosition(e)
    }, t.raws.before = this.spaces, this.spaces = "", t.type !== "comment" && (this.semicolon = !1);
  }
  other(t) {
    let e = !1, u = null, n = !1, a = null, o = [], s = t[1].startsWith("--"), i = [], l = t;
    for (; l; ) {
      if (u = l[0], i.push(l), u === "(" || u === "[")
        a || (a = l), o.push(u === "(" ? ")" : "]");
      else if (s && n && u === "{")
        a || (a = l), o.push("}");
      else if (o.length === 0)
        if (u === ";")
          if (n) {
            this.decl(i, s);
            return;
          } else
            break;
        else if (u === "{") {
          this.rule(i);
          return;
        } else if (u === "}") {
          this.tokenizer.back(i.pop()), e = !0;
          break;
        } else
          u === ":" && (n = !0);
      else
        u === o[o.length - 1] && (o.pop(), o.length === 0 && (a = null));
      l = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (e = !0), o.length > 0 && this.unclosedBracket(a), e && n) {
      if (!s)
        for (; i.length && (l = i[i.length - 1][0], !(l !== "space" && l !== "comment")); )
          this.tokenizer.back(i.pop());
      this.decl(i, s);
    } else
      this.unknownWord(i);
  }
  parse() {
    let t;
    for (; !this.tokenizer.endOfFile(); )
      switch (t = this.tokenizer.nextToken(), t[0]) {
        case "space":
          this.spaces += t[1];
          break;
        case ";":
          this.freeSemicolon(t);
          break;
        case "}":
          this.end(t);
          break;
        case "comment":
          this.comment(t);
          break;
        case "at-word":
          this.atrule(t);
          break;
        case "{":
          this.emptyRule(t);
          break;
        default:
          this.other(t);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(t, e, u, n) {
    let a, o, s = u.length, i = "", l = !0, d, h;
    for (let c = 0; c < s; c += 1)
      a = u[c], o = a[0], o === "space" && c === s - 1 && !n ? l = !1 : o === "comment" ? (h = u[c - 1] ? u[c - 1][0] : "empty", d = u[c + 1] ? u[c + 1][0] : "empty", !ho[h] && !ho[d] ? i.slice(-1) === "," ? l = !1 : i += a[1] : l = !1) : i += a[1];
    if (!l) {
      let c = u.reduce((f, g) => f + g[1], "");
      t.raws[e] = { raw: c, value: i };
    }
    t[e] = i;
  }
  rule(t) {
    t.pop();
    let e = new po();
    this.init(e, t[0][2]), e.raws.between = this.spacesAndCommentsFromEnd(t), this.raw(e, "selector", t), this.current = e;
  }
  spacesAndCommentsFromEnd(t) {
    let e, u = "";
    for (; t.length && (e = t[t.length - 1][0], !(e !== "space" && e !== "comment")); )
      u = t.pop()[1] + u;
    return u;
  }
  // Errors
  spacesAndCommentsFromStart(t) {
    let e, u = "";
    for (; t.length && (e = t[0][0], !(e !== "space" && e !== "comment")); )
      u += t.shift()[1];
    return u;
  }
  spacesFromEnd(t) {
    let e, u = "";
    for (; t.length && (e = t[t.length - 1][0], e === "space"); )
      u = t.pop()[1] + u;
    return u;
  }
  stringFrom(t, e) {
    let u = "";
    for (let n = e; n < t.length; n++)
      u += t[n][1];
    return t.splice(e, t.length - e), u;
  }
  unclosedBlock() {
    let t = this.current.source.start;
    throw this.input.error("Unclosed block", t.line, t.column);
  }
  unclosedBracket(t) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: t[2] },
      { offset: t[2] + 1 }
    );
  }
  unexpectedClose(t) {
    throw this.input.error(
      "Unexpected }",
      { offset: t[2] },
      { offset: t[2] + 1 }
    );
  }
  unknownWord(t) {
    throw this.input.error(
      "Unknown word " + t[0][1],
      { offset: t[0][2] },
      { offset: t[0][2] + t[0][1].length }
    );
  }
  unnamedAtrule(t, e) {
    throw this.input.error(
      "At-rule without name",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
};
var vp = mp;
let gp = lr, bp = Nn, yp = vp;
function yn(r, t) {
  let e = new bp(r, t), u = new yp(e);
  try {
    u.parse();
  } catch (n) {
    throw process.env.NODE_ENV !== "production" && n.name === "CssSyntaxError" && t && t.from && (/\.scss$/i.test(t.from) ? n.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(t.from) ? n.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(t.from) && (n.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), n;
  }
  return u.root;
}
var fi = yn;
yn.default = yn;
gp.registerParse(yn);
let xa = class {
  constructor(t, e = {}) {
    if (this.type = "warning", this.text = t, e.node && e.node.source) {
      let u = e.node.rangeBy(e);
      this.line = u.start.line, this.column = u.start.column, this.endLine = u.end.line, this.endColumn = u.end.column;
    }
    for (let u in e)
      this[u] = e[u];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var Wl = xa;
xa.default = xa;
let _p = Wl, Ea = class {
  get content() {
    return this.css;
  }
  constructor(t, e, u) {
    this.processor = t, this.messages = [], this.root = e, this.opts = u, this.css = "", this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(t, e = {}) {
    e.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (e.plugin = this.lastPlugin.postcssPlugin);
    let u = new _p(t, e);
    return this.messages.push(u), u;
  }
  warnings() {
    return this.messages.filter((t) => t.type === "warning");
  }
};
var pi = Ea;
Ea.default = Ea;
let mo = {};
var Yl = function(t) {
  mo[t] || (mo[t] = !0, typeof console < "u" && console.warn && console.warn(t));
};
let wp = lr, Cp = ci, Dp = Gl, Ap = fi, vo = pi, xp = $u, Ep = On, { isClean: Ct, my: kp } = Bu, Sp = Yl;
const Tp = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, Bp = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, $p = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, $r = 0;
function Zr(r) {
  return typeof r == "object" && typeof r.then == "function";
}
function Zl(r) {
  let t = !1, e = Tp[r.type];
  return r.type === "decl" ? t = r.prop.toLowerCase() : r.type === "atrule" && (t = r.name.toLowerCase()), t && r.append ? [
    e,
    e + "-" + t,
    $r,
    e + "Exit",
    e + "Exit-" + t
  ] : t ? [e, e + "-" + t, e + "Exit", e + "Exit-" + t] : r.append ? [e, $r, e + "Exit"] : [e, e + "Exit"];
}
function go(r) {
  let t;
  return r.type === "document" ? t = ["Document", $r, "DocumentExit"] : r.type === "root" ? t = ["Root", $r, "RootExit"] : t = Zl(r), {
    eventIndex: 0,
    events: t,
    iterator: 0,
    node: r,
    visitorIndex: 0,
    visitors: []
  };
}
function ka(r) {
  return r[Ct] = !1, r.nodes && r.nodes.forEach((t) => ka(t)), r;
}
let Sa = {}, Mr = class Kl {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(t, e, u) {
    this.stringified = !1, this.processed = !1;
    let n;
    if (typeof e == "object" && e !== null && (e.type === "root" || e.type === "document"))
      n = ka(e);
    else if (e instanceof Kl || e instanceof vo)
      n = ka(e.root), e.map && (typeof u.map > "u" && (u.map = {}), u.map.inline || (u.map.inline = !1), u.map.prev = e.map);
    else {
      let a = Ap;
      u.syntax && (a = u.syntax.parse), u.parser && (a = u.parser), a.parse && (a = a.parse);
      try {
        n = a(e, u);
      } catch (o) {
        this.processed = !0, this.error = o;
      }
      n && !n[kp] && wp.rebuild(n);
    }
    this.result = new vo(t, n, u), this.helpers = { ...Sa, postcss: Sa, result: this.result }, this.plugins = this.processor.plugins.map((a) => typeof a == "object" && a.prepare ? { ...a, ...a.prepare(this.result) } : a);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(t) {
    return this.async().catch(t);
  }
  finally(t) {
    return this.async().then(t, t);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(t, e) {
    let u = this.result.lastPlugin;
    try {
      if (e && e.addToError(t), this.error = t, t.name === "CssSyntaxError" && !t.plugin)
        t.plugin = u.postcssPlugin, t.setMessage();
      else if (u.postcssVersion && process.env.NODE_ENV !== "production") {
        let n = u.postcssPlugin, a = u.postcssVersion, o = this.result.processor.version, s = a.split("."), i = o.split(".");
        (s[0] !== i[0] || parseInt(s[1]) > parseInt(i[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + o + ", but " + n + " uses " + a + ". Perhaps this is the source of the error below."
        );
      }
    } catch (n) {
      console && console.error && console.error(n);
    }
    return t;
  }
  prepareVisitors() {
    this.listeners = {};
    let t = (e, u, n) => {
      this.listeners[u] || (this.listeners[u] = []), this.listeners[u].push([e, n]);
    };
    for (let e of this.plugins)
      if (typeof e == "object")
        for (let u in e) {
          if (!Bp[u] && /^[A-Z]/.test(u))
            throw new Error(
              `Unknown event ${u} in ${e.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!$p[u])
            if (typeof e[u] == "object")
              for (let n in e[u])
                n === "*" ? t(e, u, e[u][n]) : t(
                  e,
                  u + "-" + n.toLowerCase(),
                  e[u][n]
                );
            else
              typeof e[u] == "function" && t(e, u, e[u]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let t = 0; t < this.plugins.length; t++) {
      let e = this.plugins[t], u = this.runOnRoot(e);
      if (Zr(u))
        try {
          await u;
        } catch (n) {
          throw this.handleError(n);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let t = this.result.root;
      for (; !t[Ct]; ) {
        t[Ct] = !0;
        let e = [go(t)];
        for (; e.length > 0; ) {
          let u = this.visitTick(e);
          if (Zr(u))
            try {
              await u;
            } catch (n) {
              let a = e[e.length - 1].node;
              throw this.handleError(n, a);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [e, u] of this.listeners.OnceExit) {
          this.result.lastPlugin = e;
          try {
            if (t.type === "document") {
              let n = t.nodes.map(
                (a) => u(a, this.helpers)
              );
              await Promise.all(n);
            } else
              await u(t, this.helpers);
          } catch (n) {
            throw this.handleError(n);
          }
        }
    }
    return this.processed = !0, this.stringify();
  }
  runOnRoot(t) {
    this.result.lastPlugin = t;
    try {
      if (typeof t == "object" && t.Once) {
        if (this.result.root.type === "document") {
          let e = this.result.root.nodes.map(
            (u) => t.Once(u, this.helpers)
          );
          return Zr(e[0]) ? Promise.all(e) : e;
        }
        return t.Once(this.result.root, this.helpers);
      } else if (typeof t == "function")
        return t(this.result.root, this.result);
    } catch (e) {
      throw this.handleError(e);
    }
  }
  stringify() {
    if (this.error)
      throw this.error;
    if (this.stringified)
      return this.result;
    this.stringified = !0, this.sync();
    let t = this.result.opts, e = Ep;
    t.syntax && (e = t.syntax.stringify), t.stringifier && (e = t.stringifier), e.stringify && (e = e.stringify);
    let n = new Dp(e, this.result.root, this.result.opts).generate();
    return this.result.css = n[0], this.result.map = n[1], this.result;
  }
  sync() {
    if (this.error)
      throw this.error;
    if (this.processed)
      return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let t of this.plugins) {
      let e = this.runOnRoot(t);
      if (Zr(e))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let t = this.result.root;
      for (; !t[Ct]; )
        t[Ct] = !0, this.walkSync(t);
      if (this.listeners.OnceExit)
        if (t.type === "document")
          for (let e of t.nodes)
            this.visitSync(this.listeners.OnceExit, e);
        else
          this.visitSync(this.listeners.OnceExit, t);
    }
    return this.result;
  }
  then(t, e) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || Sp(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(t, e);
  }
  toString() {
    return this.css;
  }
  visitSync(t, e) {
    for (let [u, n] of t) {
      this.result.lastPlugin = u;
      let a;
      try {
        a = n(e, this.helpers);
      } catch (o) {
        throw this.handleError(o, e.proxyOf);
      }
      if (e.type !== "root" && e.type !== "document" && !e.parent)
        return !0;
      if (Zr(a))
        throw this.getAsyncError();
    }
  }
  visitTick(t) {
    let e = t[t.length - 1], { node: u, visitors: n } = e;
    if (u.type !== "root" && u.type !== "document" && !u.parent) {
      t.pop();
      return;
    }
    if (n.length > 0 && e.visitorIndex < n.length) {
      let [o, s] = n[e.visitorIndex];
      e.visitorIndex += 1, e.visitorIndex === n.length && (e.visitors = [], e.visitorIndex = 0), this.result.lastPlugin = o;
      try {
        return s(u.toProxy(), this.helpers);
      } catch (i) {
        throw this.handleError(i, u);
      }
    }
    if (e.iterator !== 0) {
      let o = e.iterator, s;
      for (; s = u.nodes[u.indexes[o]]; )
        if (u.indexes[o] += 1, !s[Ct]) {
          s[Ct] = !0, t.push(go(s));
          return;
        }
      e.iterator = 0, delete u.indexes[o];
    }
    let a = e.events;
    for (; e.eventIndex < a.length; ) {
      let o = a[e.eventIndex];
      if (e.eventIndex += 1, o === $r) {
        u.nodes && u.nodes.length && (u[Ct] = !0, e.iterator = u.getIterator());
        return;
      } else if (this.listeners[o]) {
        e.visitors = this.listeners[o];
        return;
      }
    }
    t.pop();
  }
  walkSync(t) {
    t[Ct] = !0;
    let e = Zl(t);
    for (let u of e)
      if (u === $r)
        t.nodes && t.each((n) => {
          n[Ct] || this.walkSync(n);
        });
      else {
        let n = this.listeners[u];
        if (n && this.visitSync(n, t.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
Mr.registerPostcss = (r) => {
  Sa = r;
};
var Xl = Mr;
Mr.default = Mr;
xp.registerLazyResult(Mr);
Cp.registerLazyResult(Mr);
let Mp = Gl, Op = fi;
const Lp = pi;
let Fp = On, Ip = Yl, Ta = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let t, e = Op;
    try {
      t = e(this._css, this._opts);
    } catch (u) {
      this.error = u;
    }
    if (this.error)
      throw this.error;
    return this._root = t, t;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(t, e, u) {
    e = e.toString(), this.stringified = !1, this._processor = t, this._css = e, this._opts = u, this._map = void 0;
    let n, a = Fp;
    this.result = new Lp(this._processor, n, this._opts), this.result.css = e;
    let o = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return o.root;
      }
    });
    let s = new Mp(a, n, this._opts, e);
    if (s.isMap()) {
      let [i, l] = s.generate();
      i && (this.result.css = i), l && (this.result.map = l);
    } else
      s.clearAnnotation(), this.result.css = s.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(t) {
    return this.async().catch(t);
  }
  finally(t) {
    return this.async().then(t, t);
  }
  sync() {
    if (this.error)
      throw this.error;
    return this.result;
  }
  then(t, e) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || Ip(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(t, e);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var Np = Ta;
Ta.default = Ta;
let qp = ci, Pp = Xl, Rp = Np, Vp = $u, vu = class {
  constructor(t = []) {
    this.version = "8.5.6", this.plugins = this.normalize(t);
  }
  normalize(t) {
    let e = [];
    for (let u of t)
      if (u.postcss === !0 ? u = u() : u.postcss && (u = u.postcss), typeof u == "object" && Array.isArray(u.plugins))
        e = e.concat(u.plugins);
      else if (typeof u == "object" && u.postcssPlugin)
        e.push(u);
      else if (typeof u == "function")
        e.push(u);
      else if (typeof u == "object" && (u.parse || u.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(u + " is not a PostCSS plugin");
    return e;
  }
  process(t, e = {}) {
    return !this.plugins.length && !e.parser && !e.stringifier && !e.syntax ? new Rp(this, t, e) : new Pp(this, t, e);
  }
  use(t) {
    return this.plugins = this.plugins.concat(this.normalize([t])), this;
  }
};
var jp = vu;
vu.default = vu;
Vp.registerProcessor(vu);
qp.registerProcessor(vu);
let Jl = li, Ql = Fn, Hp = lr, Up = ii, ec = In, tc = ci, zp = Gf, Gp = Nn, Wp = Xl, Yp = Rl, Zp = Ln, Kp = fi, hi = jp, Xp = pi, rc = $u, uc = di, Jp = On, Qp = Wl;
function xe(...r) {
  return r.length === 1 && Array.isArray(r[0]) && (r = r[0]), new hi(r);
}
xe.plugin = function(t, e) {
  let u = !1;
  function n(...o) {
    console && console.warn && !u && (u = !0, console.warn(
      t + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      t + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let s = e(...o);
    return s.postcssPlugin = t, s.postcssVersion = new hi().version, s;
  }
  let a;
  return Object.defineProperty(n, "postcss", {
    get() {
      return a || (a = n()), a;
    }
  }), n.process = function(o, s, i) {
    return xe([n(i)]).process(o, s);
  }, n;
};
xe.stringify = Jp;
xe.parse = Kp;
xe.fromJSON = zp;
xe.list = Yp;
xe.comment = (r) => new Ql(r);
xe.atRule = (r) => new Jl(r);
xe.decl = (r) => new ec(r);
xe.rule = (r) => new uc(r);
xe.root = (r) => new rc(r);
xe.document = (r) => new tc(r);
xe.CssSyntaxError = Up;
xe.Declaration = ec;
xe.Container = Hp;
xe.Processor = hi;
xe.Document = tc;
xe.Comment = Ql;
xe.Warning = Qp;
xe.AtRule = Jl;
xe.Result = Xp;
xe.Input = Gp;
xe.Rule = uc;
xe.Root = rc;
xe.Node = Zp;
Wp.registerPostcss(xe);
var e3 = xe;
xe.default = xe;
const t3 = Gs, bo = Y2, { isPlainObject: r3 } = ni, yo = cf, u3 = df, { parse: n3 } = e3, a3 = [
  "img",
  "audio",
  "video",
  "picture",
  "svg",
  "object",
  "map",
  "iframe",
  "embed"
], i3 = ["script", "style"];
function Xr(r, t) {
  r && Object.keys(r).forEach(function(e) {
    t(r[e], e);
  });
}
function Nt(r, t) {
  return {}.hasOwnProperty.call(r, t);
}
function _o(r, t) {
  const e = [];
  return Xr(r, function(u) {
    t(u) && e.push(u);
  }), e;
}
function o3(r) {
  for (const t in r)
    if (Nt(r, t))
      return !1;
  return !0;
}
function s3(r) {
  return r.map(function(t) {
    if (!t.url)
      throw new Error("URL missing");
    return t.url + (t.w ? ` ${t.w}w` : "") + (t.h ? ` ${t.h}h` : "") + (t.d ? ` ${t.d}x` : "");
  }).join(", ");
}
var l3 = gu;
const c3 = /^[^\0\t\n\f\r /<=>]+$/;
function gu(r, t, e) {
  if (r == null)
    return "";
  typeof r == "number" && (r = r.toString());
  let u = "", n = "";
  function a(w, k) {
    const T = this;
    this.tag = w, this.attribs = k || {}, this.tagPosition = u.length, this.text = "", this.mediaChildren = [], this.updateParentNodeText = function() {
      if (_.length) {
        const F = _[_.length - 1];
        F.text += T.text;
      }
    }, this.updateParentNodeMediaChildren = function() {
      _.length && a3.includes(this.tag) && _[_.length - 1].mediaChildren.push(this.tag);
    };
  }
  t = Object.assign({}, gu.defaults, t), t.parser = Object.assign({}, d3, t.parser);
  const o = function(w) {
    return t.allowedTags === !1 || (t.allowedTags || []).indexOf(w) > -1;
  };
  i3.forEach(function(w) {
    o(w) && !t.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${w}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
  });
  const s = t.nonTextTags || [
    "script",
    "style",
    "textarea",
    "option"
  ];
  let i, l;
  t.allowedAttributes && (i = {}, l = {}, Xr(t.allowedAttributes, function(w, k) {
    i[k] = [];
    const T = [];
    w.forEach(function(F) {
      typeof F == "string" && F.indexOf("*") >= 0 ? T.push(bo(F).replace(/\\\*/g, ".*")) : i[k].push(F);
    }), T.length && (l[k] = new RegExp("^(" + T.join("|") + ")$"));
  }));
  const d = {}, h = {}, c = {};
  Xr(t.allowedClasses, function(w, k) {
    if (i && (Nt(i, k) || (i[k] = []), i[k].push("class")), d[k] = w, Array.isArray(w)) {
      const T = [];
      d[k] = [], c[k] = [], w.forEach(function(F) {
        typeof F == "string" && F.indexOf("*") >= 0 ? T.push(bo(F).replace(/\\\*/g, ".*")) : F instanceof RegExp ? c[k].push(F) : d[k].push(F);
      }), T.length && (h[k] = new RegExp("^(" + T.join("|") + ")$"));
    }
  });
  const f = {};
  let g;
  Xr(t.transformTags, function(w, k) {
    let T;
    typeof w == "function" ? T = w : typeof w == "string" && (T = gu.simpleTransform(w)), k === "*" ? g = T : f[k] = T;
  });
  let D, _, O, M, L, q, z = !1;
  ee();
  const X = new t3.Parser({
    onopentag: function(w, k) {
      if (t.enforceHtmlBoundary && w === "html" && ee(), L) {
        q++;
        return;
      }
      const T = new a(w, k);
      _.push(T);
      let F = !1;
      const I = !!T.text;
      let P;
      if (Nt(f, w) && (P = f[w](w, k), T.attribs = k = P.attribs, P.text !== void 0 && (T.innerText = P.text), w !== P.tagName && (T.name = w = P.tagName, M[D] = P.tagName)), g && (P = g(w, k), T.attribs = k = P.attribs, w !== P.tagName && (T.name = w = P.tagName, M[D] = P.tagName)), (!o(w) || t.disallowedTagsMode === "recursiveEscape" && !o3(O) || t.nestingLimit != null && D >= t.nestingLimit) && (F = !0, O[D] = !0, (t.disallowedTagsMode === "discard" || t.disallowedTagsMode === "completelyDiscard") && s.indexOf(w) !== -1 && (L = !0, q = 1), O[D] = !0), D++, F) {
        if (t.disallowedTagsMode === "discard" || t.disallowedTagsMode === "completelyDiscard")
          return;
        n = u, u = "";
      }
      u += "<" + w, w === "script" && (t.allowedScriptHostnames || t.allowedScriptDomains) && (T.innerText = ""), (!i || Nt(i, w) || i["*"]) && Xr(k, function(Y, te) {
        if (!c3.test(te)) {
          delete T.attribs[te];
          return;
        }
        if (Y === "" && !t.allowedEmptyAttributes.includes(te) && (t.nonBooleanAttributes.includes(te) || t.nonBooleanAttributes.includes("*"))) {
          delete T.attribs[te];
          return;
        }
        let we = !1;
        if (!i || Nt(i, w) && i[w].indexOf(te) !== -1 || i["*"] && i["*"].indexOf(te) !== -1 || Nt(l, w) && l[w].test(te) || l["*"] && l["*"].test(te))
          we = !0;
        else if (i && i[w]) {
          for (const se of i[w])
            if (r3(se) && se.name && se.name === te) {
              we = !0;
              let ae = "";
              if (se.multiple === !0) {
                const De = Y.split(" ");
                for (const he of De)
                  se.values.indexOf(he) !== -1 && (ae === "" ? ae = he : ae += " " + he);
              } else
                se.values.indexOf(Y) >= 0 && (ae = Y);
              Y = ae;
            }
        }
        if (we) {
          if (t.allowedSchemesAppliedToAttributes.indexOf(te) !== -1 && oe(w, Y)) {
            delete T.attribs[te];
            return;
          }
          if (w === "script" && te === "src") {
            let se = !0;
            try {
              const ae = W(Y);
              if (t.allowedScriptHostnames || t.allowedScriptDomains) {
                const De = (t.allowedScriptHostnames || []).find(function(ye) {
                  return ye === ae.url.hostname;
                }), he = (t.allowedScriptDomains || []).find(function(ye) {
                  return ae.url.hostname === ye || ae.url.hostname.endsWith(`.${ye}`);
                });
                se = De || he;
              }
            } catch {
              se = !1;
            }
            if (!se) {
              delete T.attribs[te];
              return;
            }
          }
          if (w === "iframe" && te === "src") {
            let se = !0;
            try {
              const ae = W(Y);
              if (ae.isRelativeUrl)
                se = Nt(t, "allowIframeRelativeUrls") ? t.allowIframeRelativeUrls : !t.allowedIframeHostnames && !t.allowedIframeDomains;
              else if (t.allowedIframeHostnames || t.allowedIframeDomains) {
                const De = (t.allowedIframeHostnames || []).find(function(ye) {
                  return ye === ae.url.hostname;
                }), he = (t.allowedIframeDomains || []).find(function(ye) {
                  return ae.url.hostname === ye || ae.url.hostname.endsWith(`.${ye}`);
                });
                se = De || he;
              }
            } catch {
              se = !1;
            }
            if (!se) {
              delete T.attribs[te];
              return;
            }
          }
          if (te === "srcset")
            try {
              let se = u3(Y);
              if (se.forEach(function(ae) {
                oe("srcset", ae.url) && (ae.evil = !0);
              }), se = _o(se, function(ae) {
                return !ae.evil;
              }), se.length)
                Y = s3(_o(se, function(ae) {
                  return !ae.evil;
                })), T.attribs[te] = Y;
              else {
                delete T.attribs[te];
                return;
              }
            } catch {
              delete T.attribs[te];
              return;
            }
          if (te === "class") {
            const se = d[w], ae = d["*"], De = h[w], he = c[w], ye = h["*"], $e = [
              De,
              ye
            ].concat(he).filter(function(Me) {
              return Me;
            });
            if (se && ae ? Y = $(Y, yo(se, ae), $e) : Y = $(Y, se || ae, $e), !Y.length) {
              delete T.attribs[te];
              return;
            }
          }
          if (te === "style") {
            if (t.parseStyleAttributes)
              try {
                const se = n3(w + " {" + Y + "}", { map: !1 }), ae = A(se, t.allowedStyles);
                if (Y = E(ae), Y.length === 0) {
                  delete T.attribs[te];
                  return;
                }
              } catch {
                typeof window < "u" && console.warn('Failed to parse "' + w + " {" + Y + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete T.attribs[te];
                return;
              }
            else if (t.allowedStyles)
              throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
          }
          u += " " + te, Y && Y.length ? u += '="' + V(Y, !0) + '"' : t.allowedEmptyAttributes.includes(te) && (u += '=""');
        } else
          delete T.attribs[te];
      }), t.selfClosing.indexOf(w) !== -1 ? u += " />" : (u += ">", T.innerText && !I && !t.textFilter && (u += V(T.innerText), z = !0)), F && (u = n + V(u), n = "");
    },
    ontext: function(w) {
      if (L)
        return;
      const k = _[_.length - 1];
      let T;
      if (k && (T = k.tag, w = k.innerText !== void 0 ? k.innerText : w), t.disallowedTagsMode === "completelyDiscard" && !o(T))
        w = "";
      else if ((t.disallowedTagsMode === "discard" || t.disallowedTagsMode === "completelyDiscard") && (T === "script" || T === "style"))
        u += w;
      else {
        const F = V(w, !1);
        t.textFilter && !z ? u += t.textFilter(F, T) : z || (u += F);
      }
      if (_.length) {
        const F = _[_.length - 1];
        F.text += w;
      }
    },
    onclosetag: function(w, k) {
      if (L)
        if (q--, !q)
          L = !1;
        else
          return;
      const T = _.pop();
      if (!T)
        return;
      if (T.tag !== w) {
        _.push(T);
        return;
      }
      L = t.enforceHtmlBoundary ? w === "html" : !1, D--;
      const F = O[D];
      if (F) {
        if (delete O[D], t.disallowedTagsMode === "discard" || t.disallowedTagsMode === "completelyDiscard") {
          T.updateParentNodeText();
          return;
        }
        n = u, u = "";
      }
      if (M[D] && (w = M[D], delete M[D]), t.exclusiveFilter && t.exclusiveFilter(T)) {
        u = u.substr(0, T.tagPosition);
        return;
      }
      if (T.updateParentNodeMediaChildren(), T.updateParentNodeText(), // Already output />
      t.selfClosing.indexOf(w) !== -1 || // Escaped tag, closing tag is implied
      k && !o(w) && ["escape", "recursiveEscape"].indexOf(t.disallowedTagsMode) >= 0) {
        F && (u = n, n = "");
        return;
      }
      u += "</" + w + ">", F && (u = n + V(u), n = ""), z = !1;
    }
  }, t.parser);
  return X.write(r), X.end(), u;
  function ee() {
    u = "", D = 0, _ = [], O = {}, M = {}, L = !1, q = 0;
  }
  function V(w, k) {
    return typeof w != "string" && (w = w + ""), t.parser.decodeEntities && (w = w.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), k && (w = w.replace(/"/g, "&quot;"))), w = w.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), k && (w = w.replace(/"/g, "&quot;")), w;
  }
  function oe(w, k) {
    for (k = k.replace(/[\x00-\x20]+/g, ""); ; ) {
      const I = k.indexOf("<!--");
      if (I === -1)
        break;
      const P = k.indexOf("-->", I + 4);
      if (P === -1)
        break;
      k = k.substring(0, I) + k.substring(P + 3);
    }
    const T = k.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!T)
      return k.match(/^[/\\]{2}/) ? !t.allowProtocolRelative : !1;
    const F = T[1].toLowerCase();
    return Nt(t.allowedSchemesByTag, w) ? t.allowedSchemesByTag[w].indexOf(F) === -1 : !t.allowedSchemes || t.allowedSchemes.indexOf(F) === -1;
  }
  function W(w) {
    if (w = w.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), w.startsWith("relative:"))
      throw new Error("relative: exploit attempt");
    let k = "relative://relative-site";
    for (let I = 0; I < 100; I++)
      k += `/${I}`;
    const T = new URL(w, k);
    return {
      isRelativeUrl: T && T.hostname === "relative-site" && T.protocol === "relative:",
      url: T
    };
  }
  function A(w, k) {
    if (!k)
      return w;
    const T = w.nodes[0];
    let F;
    return k[T.selector] && k["*"] ? F = yo(
      k[T.selector],
      k["*"]
    ) : F = k[T.selector] || k["*"], F && (w.nodes[0].nodes = T.nodes.reduce(S(F), [])), w;
  }
  function E(w) {
    return w.nodes[0].nodes.reduce(function(k, T) {
      return k.push(
        `${T.prop}:${T.value}${T.important ? " !important" : ""}`
      ), k;
    }, []).join(";");
  }
  function S(w) {
    return function(k, T) {
      return Nt(w, T.prop) && w[T.prop].some(function(I) {
        return I.test(T.value);
      }) && k.push(T), k;
    };
  }
  function $(w, k, T) {
    return k ? (w = w.split(/\s+/), w.filter(function(F) {
      return k.indexOf(F) !== -1 || T.some(function(I) {
        return I.test(F);
      });
    }).join(" ")) : w;
  }
}
const d3 = {
  decodeEntities: !0
};
gu.defaults = {
  allowedTags: [
    // Sections derived from MDN element categories and limited to the more
    // benign categories.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
    // Content sectioning
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hgroup",
    "main",
    "nav",
    "section",
    // Text content
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "main",
    "ol",
    "p",
    "pre",
    "ul",
    // Inline text semantics
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    // Table content
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr"
  ],
  // Tags that cannot be boolean
  nonBooleanAttributes: [
    "abbr",
    "accept",
    "accept-charset",
    "accesskey",
    "action",
    "allow",
    "alt",
    "as",
    "autocapitalize",
    "autocomplete",
    "blocking",
    "charset",
    "cite",
    "class",
    "color",
    "cols",
    "colspan",
    "content",
    "contenteditable",
    "coords",
    "crossorigin",
    "data",
    "datetime",
    "decoding",
    "dir",
    "dirname",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "fetchpriority",
    "for",
    "form",
    "formaction",
    "formenctype",
    "formmethod",
    "formtarget",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "http-equiv",
    "id",
    "imagesizes",
    "imagesrcset",
    "inputmode",
    "integrity",
    "is",
    "itemid",
    "itemprop",
    "itemref",
    "itemtype",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "name",
    "nonce",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "referrerpolicy",
    "rel",
    "rows",
    "rowspan",
    "sandbox",
    "scope",
    "shape",
    "size",
    "sizes",
    "slot",
    "span",
    "spellcheck",
    "src",
    "srcdoc",
    "srclang",
    "srcset",
    "start",
    "step",
    "style",
    "tabindex",
    "target",
    "title",
    "translate",
    "type",
    "usemap",
    "value",
    "width",
    "wrap",
    // Event handlers
    "onauxclick",
    "onafterprint",
    "onbeforematch",
    "onbeforeprint",
    "onbeforeunload",
    "onbeforetoggle",
    "onblur",
    "oncancel",
    "oncanplay",
    "oncanplaythrough",
    "onchange",
    "onclick",
    "onclose",
    "oncontextlost",
    "oncontextmenu",
    "oncontextrestored",
    "oncopy",
    "oncuechange",
    "oncut",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onended",
    "onerror",
    "onfocus",
    "onformdata",
    "onhashchange",
    "oninput",
    "oninvalid",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onlanguagechange",
    "onload",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onmessage",
    "onmessageerror",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onoffline",
    "ononline",
    "onpagehide",
    "onpageshow",
    "onpaste",
    "onpause",
    "onplay",
    "onplaying",
    "onpopstate",
    "onprogress",
    "onratechange",
    "onreset",
    "onresize",
    "onrejectionhandled",
    "onscroll",
    "onscrollend",
    "onsecuritypolicyviolation",
    "onseeked",
    "onseeking",
    "onselect",
    "onslotchange",
    "onstalled",
    "onstorage",
    "onsubmit",
    "onsuspend",
    "ontimeupdate",
    "ontoggle",
    "onunhandledrejection",
    "onunload",
    "onvolumechange",
    "onwaiting",
    "onwheel"
  ],
  disallowedTagsMode: "discard",
  allowedAttributes: {
    a: ["href", "name", "target"],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
  },
  allowedEmptyAttributes: [
    "alt"
  ],
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
  // URL schemes we permit
  allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
  allowProtocolRelative: !0,
  enforceHtmlBoundary: !1,
  parseStyleAttributes: !0
};
gu.simpleTransform = function(r, t, e) {
  return e = e === void 0 ? !0 : e, t = t || {}, function(u, n) {
    let a;
    if (e)
      for (a in t)
        n[a] = t[a];
    else
      n = t;
    return {
      tagName: r,
      attribs: n
    };
  };
};
const f3 = /* @__PURE__ */ xn(l3), nc = (r) => r ? f3(Us.decode(r), {
  allowedTags: [
    "span",
    "label",
    "p",
    "b",
    "ul",
    "ol",
    "li",
    "a",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "mark",
    "br"
  ],
  allowedAttributes: {
    span: ["class"],
    label: ["style"],
    a: ["href", "rel", "target"]
  },
  parser: {
    lowerCaseTags: !0
  }
}) : "", p3 = ["innerHTML"], h3 = /* @__PURE__ */ ue({
  __name: "VError",
  props: {
    error: { default: "" }
  },
  setup(r) {
    const t = En, e = be();
    return (u, n) => Xe((m(), x("div", {
      class: b(p(e)["v-error"]),
      innerHTML: p(nc)(u.error)
    }, null, 10, p3)), [
      [p(t), !u.error]
    ]);
  }
}), m3 = {
  "v-error": "_v-error_srl86_1"
}, v3 = {
  $style: m3
}, ac = /* @__PURE__ */ U(h3, [["__cssModules", v3]]), g3 = {}, b3 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "16",
  width: "16",
  viewBox: "0 0 16 16"
};
function y3(r, t) {
  return m(), x("svg", b3, t[0] || (t[0] = [
    C("g", {
      fill: "currentColor",
      class: "nc-icon-wrapper"
    }, [
      C("path", {
        d: "M15.8,12.526,9.483.88A1.668,1.668,0,0,0,8.8.2,1.693,1.693,0,0,0,6.516.88L.2,12.526A1.678,1.678,0,0,0,1.686,15H14.314a1.7,1.7,0,0,0,.8-.2,1.673,1.673,0,0,0,.687-2.274ZM8,13a1,1,0,1,1,1-1A1,1,0,0,1,8,13ZM9,9.5a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,7,9.5v-4A.5.5,0,0,1,7.5,5h1a.5.5,0,0,1,.5.5Z",
        fill: "currentColor"
      })
    ], -1)
  ]));
}
const _3 = /* @__PURE__ */ U(g3, [["render", y3]]), w3 = /* @__PURE__ */ ue({
  __name: "VWarning",
  props: {
    warning: { default: "" }
  },
  setup(r) {
    const t = En, e = be();
    return (u, n) => Xe((m(), x("div", {
      class: b(p(e)["v-warning"])
    }, [
      j(_3),
      ce(" " + ne(u.warning), 1)
    ], 2)), [
      [p(t), !u.warning]
    ]);
  }
}), C3 = {
  "v-warning": "_v-warning_19tkv_1"
}, D3 = {
  $style: C3
}, A3 = /* @__PURE__ */ U(w3, [["__cssModules", D3]]), x3 = /* @__PURE__ */ ue({
  __name: "VInfoText",
  props: {
    infoText: { default: "" }
  },
  setup(r) {
    const t = En, e = be();
    return (u, n) => Xe((m(), x("div", {
      class: b(p(e)["v-warning"])
    }, [
      ce(ne(u.infoText), 1)
    ], 2)), [
      [p(t), !u.infoText]
    ]);
  }
}), E3 = {
  "v-warning": "_v-warning_b650n_1"
}, k3 = {
  $style: E3
}, S3 = /* @__PURE__ */ U(x3, [["__cssModules", k3]]), ct = Object.freeze({
  label: "",
  showRequiredStar: !1,
  withError: !1,
  error: "",
  description: "",
  helpText: "",
  borderless: !0,
  placeholder: "",
  disabled: !1,
  color: "black",
  size: "medium",
  readonly: !1,
  warning: "",
  infoText: ""
}), T3 = ["innerHTML"], B3 = /* @__PURE__ */ ue({
  __name: "VFieldDescription",
  props: {
    description: { default: "" }
  },
  setup(r) {
    const t = En, e = be();
    return (u, n) => Xe((m(), x("div", {
      class: b(p(e)["v-field-description"]),
      innerHTML: p(nc)(u.description)
    }, null, 10, T3)), [
      [p(t), !u.description]
    ]);
  }
}), $3 = {
  "v-field-description": "_v-field-description_1sphy_1"
}, M3 = {
  $style: $3
}, O3 = /* @__PURE__ */ U(B3, [["__cssModules", M3]]), L3 = /* @__PURE__ */ ue({
  __name: "VBaseField",
  props: /* @__PURE__ */ lt({
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    helpText: {},
    description: {},
    borderless: { type: Boolean },
    placeholder: {},
    disabled: { type: Boolean },
    size: {},
    color: {},
    warning: {},
    infoText: {},
    inputMode: {}
  }, ct),
  setup(r) {
    const t = r, e = G(() => !!t.label), u = G(() => !!t.description), n = be();
    return (a, o) => (m(), x("div", null, [
      e.value ? (m(), H(p(zs), {
        key: 0,
        "show-required-star": a.showRequiredStar,
        color: a.color,
        "help-text": a.helpText,
        class: b(p(n)["v-base-field__label"])
      }, {
        "label-right": J(() => [
          K(a.$slots, "label-right")
        ]),
        default: J(() => [
          ce(ne(a.label) + " ", 1)
        ]),
        _: 3
      }, 8, ["show-required-star", "color", "help-text", "class"])) : R("", !0),
      K(a.$slots, "default"),
      u.value ? (m(), H(O3, {
        key: 1,
        description: a.description
      }, null, 8, ["description"])) : R("", !0),
      a.withError ? (m(), H(p(ac), {
        key: 2,
        error: a.error
      }, null, 8, ["error"])) : R("", !0),
      a.warning ? (m(), H(p(A3), {
        key: 3,
        warning: a.warning
      }, null, 8, ["warning"])) : R("", !0),
      a.infoText ? (m(), H(p(S3), {
        key: 4,
        "info-text": a.infoText
      }, null, 8, ["info-text"])) : R("", !0)
    ]));
  }
}), F3 = {
  "v-base-field__label": "_v-base-field__label_bx6cu_1"
}, I3 = {
  $style: F3
}, Lr = /* @__PURE__ */ U(L3, [["__cssModules", I3]]), N3 = ["type", "disabled", "placeholder", "inputmode"], q3 = /* @__PURE__ */ ue({
  __name: "VInput",
  props: /* @__PURE__ */ lt({
    modelValue: {},
    placeholder: {},
    prefixIcon: {},
    suffixIcon: {},
    foreground: { type: Boolean },
    type: {},
    min: {},
    disabled: { type: Boolean },
    isNumber: { type: Boolean },
    borderless: { type: Boolean },
    readonly: { type: Boolean },
    autofocus: { type: Boolean },
    resizable: { type: Boolean },
    inputMode: {},
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    helpText: {},
    description: {},
    size: {},
    color: {},
    warning: {},
    infoText: {}
  }, {
    prefixIcon: null,
    suffixIcon: null,
    foreground: !1,
    borderless: !0,
    type: "",
    isNumber: !1,
    autofocus: !1,
    resizable: !1,
    ...ct
  }),
  emits: ["update:model-value", "focus", "blur", "click", "paste"],
  setup(r, { expose: t, emit: e }) {
    const u = r, n = e, a = G({
      get() {
        return u.modelValue;
      },
      set(L) {
        n("update:model-value", L);
      }
    }), o = G(() => u.prefixIcon !== null), s = G(() => u.suffixIcon !== null), i = be(), l = Q(null), d = Q(!1), h = Q(!1), c = G(() => h.value && !d.value), f = () => {
      const L = l.value;
      L && (h.value = L.scrollWidth > L.clientWidth);
    };
    Ha(l, () => {
      f();
    });
    const g = (L) => {
      u.isNumber && (L.key.match(/[^0-9.-]/g) && L.preventDefault(), !(L.key === "." && !u.modelValue.length) && (L.key === "." && (u.modelValue.includes(".") || !u.modelValue.length) && L.preventDefault(), L.key === "-" && L.target.selectionStart && L.preventDefault()));
    };
    qe(() => a.value, () => {
      Pe(f);
    }), wu(() => {
      if (!u.autofocus) {
        Pe(f);
        return;
      }
      Pe(() => {
        D();
      });
    });
    const D = () => {
      var L;
      (L = l.value) == null || L.focus();
    }, _ = () => {
      l.value && D();
    }, O = () => {
      d.value = !0, n("focus");
    }, M = () => {
      d.value = !1, n("blur");
    };
    return t({
      inputField: l,
      handleFocus: D
    }), (L, q) => (m(), H(p(Lr), {
      class: b([
        p(i)["v-input"],
        {
          [p(i)["v-input--borderless"]]: L.borderless
        }
      ]),
      error: L.error,
      label: L.label,
      "show-required-star": L.showRequiredStar,
      "with-error": L.withError,
      "aria-label": L.label,
      color: L.color,
      description: L.description,
      "help-text": L.helpText,
      warning: L.warning,
      "info-text": L.infoText
    }, {
      "label-right": J(() => [
        K(L.$slots, "label-right")
      ]),
      default: J(() => [
        C("div", {
          class: b([
            p(i)["v-input__input-wrapper"],
            {
              [p(i)["v-input__input-wrapper--resizable"]]: L.resizable
            }
          ])
        }, [
          o.value ? (m(), x("div", {
            key: 0,
            class: b([
              p(i)["v-input__icon"],
              p(i)["v-input__icon--prefix"]
            ]),
            onClick: _
          }, [
            o.value ? (m(), H(He(L.prefixIcon), {
              key: 0,
              height: "16px",
              width: "16px"
            })) : R("", !0)
          ], 2)) : R("", !0),
          j(p(Ve), {
            content: a.value,
            disabled: !c.value,
            placement: "top",
            "max-width": "400px"
          }, {
            default: J(() => [
              Xe(C("input", Te({
                ref_key: "inputField",
                ref: l,
                "onUpdate:modelValue": q[0] || (q[0] = (z) => a.value = z)
              }, L.label ? { name: L.label } : {}, {
                type: L.type,
                class: [
                  p(i)["v-input__input"],
                  p(i)[`v-input__input--${L.size}`],
                  {
                    [p(i)["v-input__input--foreground"]]: L.foreground,
                    [p(i)["v-input__input--with-suffix-icon"]]: s.value,
                    [p(i)["v-input__input--with-prefix-icon"]]: o.value
                  }
                ],
                disabled: L.disabled,
                placeholder: L.placeholder,
                inputmode: L.inputMode,
                onFocus: O,
                onBlur: M,
                onClick: q[1] || (q[1] = (z) => n("click", z)),
                onPaste: q[2] || (q[2] = (z) => n("paste", z)),
                onKeypress: q[3] || (q[3] = (z) => g(z))
              }), null, 16, N3), [
                [g0, a.value]
              ])
            ]),
            _: 1
          }, 8, ["content", "disabled"]),
          s.value ? (m(), x("div", {
            key: 1,
            class: b([
              p(i)["v-input__icon"],
              p(i)["v-input__icon--suffix"]
            ]),
            onClick: _
          }, [
            (m(), H(He(L.suffixIcon), {
              height: "16px",
              width: "16px"
            }))
          ], 2)) : R("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["class", "error", "label", "show-required-star", "with-error", "aria-label", "color", "description", "help-text", "warning", "info-text"]));
  }
}), P3 = {
  "v-input": "_v-input_1xatk_1",
  "v-input__input": "_v-input__input_1xatk_4",
  "v-input__input-wrapper": "_v-input__input-wrapper_1xatk_8",
  "v-input__input--medium": "_v-input__input--medium_1xatk_39",
  "v-input__input--large": "_v-input__input--large_1xatk_43",
  "v-input--borderless": "_v-input--borderless_1xatk_49",
  "v-input__icon--prefix": "_v-input__icon--prefix_1xatk_55",
  "v-input__icon--suffix": "_v-input__icon--suffix_1xatk_59",
  "v-input__input--with-prefix-icon": "_v-input__input--with-prefix-icon_1xatk_63",
  "v-input__input--with-suffix-icon": "_v-input__input--with-suffix-icon_1xatk_66",
  "v-input__input--foreground": "_v-input__input--foreground_1xatk_78",
  "v-input__icon": "_v-input__icon_1xatk_55",
  "v-input__input-wrapper--resizable": "_v-input__input-wrapper--resizable_1xatk_107"
}, R3 = {
  $style: P3
}, Fr = /* @__PURE__ */ U(q3, [["__cssModules", R3]]), V3 = ["placeholder", "rows"], j3 = /* @__PURE__ */ ue({
  __name: "VTextarea",
  props: /* @__PURE__ */ lt({
    modelValue: {},
    foreground: { type: Boolean },
    placeholder: {},
    rows: {},
    autofocus: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    helpText: {},
    description: {},
    borderless: { type: Boolean },
    disabled: { type: Boolean },
    size: {},
    color: {},
    warning: {},
    infoText: {},
    inputMode: {}
  }, {
    modelValue: "",
    foreground: !1,
    rows: 5,
    autofocus: !1,
    ...ct
  }),
  emits: ["update:modelValue", "keydown:enter"],
  setup(r, { expose: t, emit: e }) {
    const u = r, n = Cs("textareaField"), a = G({
      get() {
        return u.modelValue;
      },
      set(l) {
        o("update:modelValue", l);
      }
    }), o = e, s = be();
    wu(() => {
      u.autofocus && Pe(() => {
        var l, d;
        (d = (l = n.value) == null ? void 0 : l.focus) == null || d.call(l), i();
      });
    });
    const i = () => {
      var l;
      (l = n.value) == null || l.focus();
    };
    return t({
      handleFocus: i
    }), (l, d) => (m(), H(p(Lr), {
      class: b(p(s)["v-textarea"]),
      error: l.error,
      label: l.label,
      "show-required-star": l.showRequiredStar,
      "with-error": l.withError,
      color: l.color,
      disabled: l.disabled,
      description: l.description,
      "help-text": l.helpText,
      warning: l.warning,
      "info-text": l.infoText
    }, {
      default: J(() => [
        Xe(C("textarea", {
          ref_key: "textareaField",
          ref: n,
          "onUpdate:modelValue": d[0] || (d[0] = (h) => a.value = h),
          class: b([
            p(s)["v-textarea__textarea"],
            {
              [p(s)["v-textarea__textarea--foreground"]]: l.foreground
            }
          ]),
          placeholder: l.placeholder,
          rows: l.rows,
          onKeydown: d[1] || (d[1] = b0((h) => o("keydown:enter", h), ["enter"]))
        }, null, 42, V3), [
          [y0, a.value]
        ])
      ]),
      _: 1
    }, 8, ["class", "error", "label", "show-required-star", "with-error", "color", "disabled", "description", "help-text", "warning", "info-text"]));
  }
}), H3 = {
  "v-textarea__textarea": "_v-textarea__textarea_3dlnr_1",
  "v-textarea__textarea--foreground": "_v-textarea__textarea--foreground_3dlnr_24"
}, U3 = {
  $style: H3
}, Ix = /* @__PURE__ */ U(j3, [["__cssModules", U3]]), z3 = {}, G3 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function W3(r, t) {
  return m(), x("svg", G3, t[0] || (t[0] = [
    sr('<g clip-path="url(#clip0_28270_7566)"><path d="M3.33328 5.83464C3.33328 5.39261 3.50888 4.96868 3.82144 4.65612C4.134 4.34356 4.55792 4.16797 4.99995 4.16797H14.9999C15.442 4.16797 15.8659 4.34356 16.1785 4.65612C16.491 4.96868 16.6666 5.39261 16.6666 5.83464V15.8346C16.6666 16.2767 16.491 16.7006 16.1785 17.0131C15.8659 17.3257 15.442 17.5013 14.9999 17.5013H4.99995C4.55792 17.5013 4.134 17.3257 3.82144 17.0131C3.50888 16.7006 3.33328 16.2767 3.33328 15.8346V5.83464Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.3333 2.5V5.83333" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.66666 2.5V5.83333" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.33328 9.16797H16.6666" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.83328 11.668H5.84412" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.34167 11.668H8.34501" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.8417 11.668H10.845" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.3458 11.668H13.3491" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.8458 14.168H10.8491" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.84167 14.168H5.84501" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.34167 14.168H8.34501" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_28270_7566"><rect width="20" height="20" fill="white"></rect></clipPath></defs>', 2)
  ]));
}
const Y3 = /* @__PURE__ */ U(z3, [["render", W3]]);
var Xn = [
  "onChange",
  "onClose",
  "onDayCreate",
  "onDestroy",
  "onKeyDown",
  "onMonthChange",
  "onOpen",
  "onParseConfig",
  "onReady",
  "onValueUpdate",
  "onYearChange",
  "onPreCalendarPosition"
], Cr = {
  _disable: [],
  allowInput: !1,
  allowInvalidPreload: !1,
  altFormat: "F j, Y",
  altInput: !1,
  altInputClass: "form-control input",
  animate: typeof window == "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: !0,
  clickOpens: !0,
  closeOnSelect: !0,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: !1,
  enableSeconds: !1,
  enableTime: !1,
  errorHandler: function(r) {
    return typeof console < "u" && console.warn(r);
  },
  getWeek: function(r) {
    var t = new Date(r.getTime());
    t.setHours(0, 0, 0, 0), t.setDate(t.getDate() + 3 - (t.getDay() + 6) % 7);
    var e = new Date(t.getFullYear(), 0, 4);
    return 1 + Math.round(((t.getTime() - e.getTime()) / 864e5 - 3 + (e.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: !1,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: !1,
  now: /* @__PURE__ */ new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: void 0,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: !1,
  showMonths: 1,
  static: !1,
  time_24hr: !1,
  weekNumbers: !1,
  wrap: !1
}, bu = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  months: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function(r) {
    var t = r % 100;
    if (t > 3 && t < 21)
      return "th";
    switch (t % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: !1
}, Ye = function(r, t) {
  return t === void 0 && (t = 2), ("000" + r).slice(t * -1);
}, ft = function(r) {
  return r === !0 ? 1 : 0;
};
function wo(r, t) {
  var e;
  return function() {
    var u = this, n = arguments;
    clearTimeout(e), e = setTimeout(function() {
      return r.apply(u, n);
    }, t);
  };
}
var Jn = function(r) {
  return r instanceof Array ? r : [r];
};
function ze(r, t, e) {
  if (e === !0)
    return r.classList.add(t);
  r.classList.remove(t);
}
function Ae(r, t, e) {
  var u = window.document.createElement(r);
  return t = t || "", e = e || "", u.className = t, e !== void 0 && (u.textContent = e), u;
}
function Ku(r) {
  for (; r.firstChild; )
    r.removeChild(r.firstChild);
}
function ic(r, t) {
  if (t(r))
    return r;
  if (r.parentNode)
    return ic(r.parentNode, t);
}
function Xu(r, t) {
  var e = Ae("div", "numInputWrapper"), u = Ae("input", "numInput " + r), n = Ae("span", "arrowUp"), a = Ae("span", "arrowDown");
  if (navigator.userAgent.indexOf("MSIE 9.0") === -1 ? u.type = "number" : (u.type = "text", u.pattern = "\\d*"), t !== void 0)
    for (var o in t)
      u.setAttribute(o, t[o]);
  return e.appendChild(u), e.appendChild(n), e.appendChild(a), e;
}
function ut(r) {
  try {
    if (typeof r.composedPath == "function") {
      var t = r.composedPath();
      return t[0];
    }
    return r.target;
  } catch {
    return r.target;
  }
}
var Qn = function() {
}, _n = function(r, t, e) {
  return e.months[t ? "shorthand" : "longhand"][r];
}, Z3 = {
  D: Qn,
  F: function(r, t, e) {
    r.setMonth(e.months.longhand.indexOf(t));
  },
  G: function(r, t) {
    r.setHours((r.getHours() >= 12 ? 12 : 0) + parseFloat(t));
  },
  H: function(r, t) {
    r.setHours(parseFloat(t));
  },
  J: function(r, t) {
    r.setDate(parseFloat(t));
  },
  K: function(r, t, e) {
    r.setHours(r.getHours() % 12 + 12 * ft(new RegExp(e.amPM[1], "i").test(t)));
  },
  M: function(r, t, e) {
    r.setMonth(e.months.shorthand.indexOf(t));
  },
  S: function(r, t) {
    r.setSeconds(parseFloat(t));
  },
  U: function(r, t) {
    return new Date(parseFloat(t) * 1e3);
  },
  W: function(r, t, e) {
    var u = parseInt(t), n = new Date(r.getFullYear(), 0, 2 + (u - 1) * 7, 0, 0, 0, 0);
    return n.setDate(n.getDate() - n.getDay() + e.firstDayOfWeek), n;
  },
  Y: function(r, t) {
    r.setFullYear(parseFloat(t));
  },
  Z: function(r, t) {
    return new Date(t);
  },
  d: function(r, t) {
    r.setDate(parseFloat(t));
  },
  h: function(r, t) {
    r.setHours((r.getHours() >= 12 ? 12 : 0) + parseFloat(t));
  },
  i: function(r, t) {
    r.setMinutes(parseFloat(t));
  },
  j: function(r, t) {
    r.setDate(parseFloat(t));
  },
  l: Qn,
  m: function(r, t) {
    r.setMonth(parseFloat(t) - 1);
  },
  n: function(r, t) {
    r.setMonth(parseFloat(t) - 1);
  },
  s: function(r, t) {
    r.setSeconds(parseFloat(t));
  },
  u: function(r, t) {
    return new Date(parseFloat(t));
  },
  w: Qn,
  y: function(r, t) {
    r.setFullYear(2e3 + parseFloat(t));
  }
}, tr = {
  D: "",
  F: "",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
}, ru = {
  Z: function(r) {
    return r.toISOString();
  },
  D: function(r, t, e) {
    return t.weekdays.shorthand[ru.w(r, t, e)];
  },
  F: function(r, t, e) {
    return _n(ru.n(r, t, e) - 1, !1, t);
  },
  G: function(r, t, e) {
    return Ye(ru.h(r, t, e));
  },
  H: function(r) {
    return Ye(r.getHours());
  },
  J: function(r, t) {
    return t.ordinal !== void 0 ? r.getDate() + t.ordinal(r.getDate()) : r.getDate();
  },
  K: function(r, t) {
    return t.amPM[ft(r.getHours() > 11)];
  },
  M: function(r, t) {
    return _n(r.getMonth(), !0, t);
  },
  S: function(r) {
    return Ye(r.getSeconds());
  },
  U: function(r) {
    return r.getTime() / 1e3;
  },
  W: function(r, t, e) {
    return e.getWeek(r);
  },
  Y: function(r) {
    return Ye(r.getFullYear(), 4);
  },
  d: function(r) {
    return Ye(r.getDate());
  },
  h: function(r) {
    return r.getHours() % 12 ? r.getHours() % 12 : 12;
  },
  i: function(r) {
    return Ye(r.getMinutes());
  },
  j: function(r) {
    return r.getDate();
  },
  l: function(r, t) {
    return t.weekdays.longhand[r.getDay()];
  },
  m: function(r) {
    return Ye(r.getMonth() + 1);
  },
  n: function(r) {
    return r.getMonth() + 1;
  },
  s: function(r) {
    return r.getSeconds();
  },
  u: function(r) {
    return r.getTime();
  },
  w: function(r) {
    return r.getDay();
  },
  y: function(r) {
    return String(r.getFullYear()).substring(2);
  }
}, oc = function(r) {
  var t = r.config, e = t === void 0 ? Cr : t, u = r.l10n, n = u === void 0 ? bu : u, a = r.isMobile, o = a === void 0 ? !1 : a;
  return function(s, i, l) {
    var d = l || n;
    return e.formatDate !== void 0 && !o ? e.formatDate(s, i, d) : i.split("").map(function(h, c, f) {
      return ru[h] && f[c - 1] !== "\\" ? ru[h](s, d, e) : h !== "\\" ? h : "";
    }).join("");
  };
}, Ba = function(r) {
  var t = r.config, e = t === void 0 ? Cr : t, u = r.l10n, n = u === void 0 ? bu : u;
  return function(a, o, s, i) {
    if (!(a !== 0 && !a)) {
      var l = i || n, d, h = a;
      if (a instanceof Date)
        d = new Date(a.getTime());
      else if (typeof a != "string" && a.toFixed !== void 0)
        d = new Date(a);
      else if (typeof a == "string") {
        var c = o || (e || Cr).dateFormat, f = String(a).trim();
        if (f === "today")
          d = /* @__PURE__ */ new Date(), s = !0;
        else if (e && e.parseDate)
          d = e.parseDate(a, c);
        else if (/Z$/.test(f) || /GMT$/.test(f))
          d = new Date(a);
        else {
          for (var g = void 0, D = [], _ = 0, O = 0, M = ""; _ < c.length; _++) {
            var L = c[_], q = L === "\\", z = c[_ - 1] === "\\" || q;
            if (tr[L] && !z) {
              M += tr[L];
              var X = new RegExp(M).exec(a);
              X && (g = !0) && D[L !== "Y" ? "push" : "unshift"]({
                fn: Z3[L],
                val: X[++O]
              });
            } else
              q || (M += ".");
          }
          d = !e || !e.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0)), D.forEach(function(ee) {
            var V = ee.fn, oe = ee.val;
            return d = V(d, oe, l) || d;
          }), d = g ? d : void 0;
        }
      }
      if (!(d instanceof Date && !isNaN(d.getTime()))) {
        e.errorHandler(new Error("Invalid date provided: " + h));
        return;
      }
      return s === !0 && d.setHours(0, 0, 0, 0), d;
    }
  };
};
function nt(r, t, e) {
  return e === void 0 && (e = !0), e !== !1 ? new Date(r.getTime()).setHours(0, 0, 0, 0) - new Date(t.getTime()).setHours(0, 0, 0, 0) : r.getTime() - t.getTime();
}
var K3 = function(r, t, e) {
  return r > Math.min(t, e) && r < Math.max(t, e);
}, ea = function(r, t, e) {
  return r * 3600 + t * 60 + e;
}, X3 = function(r) {
  var t = Math.floor(r / 3600), e = (r - t * 3600) / 60;
  return [t, e, r - t * 3600 - e * 60];
}, J3 = {
  DAY: 864e5
};
function ta(r) {
  var t = r.defaultHour, e = r.defaultMinute, u = r.defaultSeconds;
  if (r.minDate !== void 0) {
    var n = r.minDate.getHours(), a = r.minDate.getMinutes(), o = r.minDate.getSeconds();
    t < n && (t = n), t === n && e < a && (e = a), t === n && e === a && u < o && (u = r.minDate.getSeconds());
  }
  if (r.maxDate !== void 0) {
    var s = r.maxDate.getHours(), i = r.maxDate.getMinutes();
    t = Math.min(t, s), t === s && (e = Math.min(i, e)), t === s && e === i && (u = r.maxDate.getSeconds());
  }
  return { hours: t, minutes: e, seconds: u };
}
typeof Object.assign != "function" && (Object.assign = function(r) {
  for (var t = [], e = 1; e < arguments.length; e++)
    t[e - 1] = arguments[e];
  if (!r)
    throw TypeError("Cannot convert undefined or null to object");
  for (var u = function(s) {
    s && Object.keys(s).forEach(function(i) {
      return r[i] = s[i];
    });
  }, n = 0, a = t; n < a.length; n++) {
    var o = a[n];
    u(o);
  }
  return r;
});
var Ue = globalThis && globalThis.__assign || function() {
  return Ue = Object.assign || function(r) {
    for (var t, e = 1, u = arguments.length; e < u; e++) {
      t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
    }
    return r;
  }, Ue.apply(this, arguments);
}, Co = globalThis && globalThis.__spreadArrays || function() {
  for (var r = 0, t = 0, e = arguments.length; t < e; t++)
    r += arguments[t].length;
  for (var u = Array(r), n = 0, t = 0; t < e; t++)
    for (var a = arguments[t], o = 0, s = a.length; o < s; o++, n++)
      u[n] = a[o];
  return u;
}, Q3 = 300;
function eh(r, t) {
  var e = {
    config: Ue(Ue({}, Cr), Fe.defaultConfig),
    l10n: bu
  };
  e.parseDate = Ba({ config: e.config, l10n: e.l10n }), e._handlers = [], e.pluginElements = [], e.loadedPlugins = [], e._bind = D, e._setHoursFromDate = c, e._positionCalendar = hr, e.changeMonth = Y, e.changeYear = he, e.clear = te, e.close = we, e.onMouseOver = je, e._createElement = Ae, e.createDay = X, e.destroy = se, e.isEnabled = ye, e.jumpToDate = M, e.updateValue = Lt, e.open = pr, e.redraw = Hr, e.set = Iu, e.setDate = Nu, e.toggle = n0;
  function u() {
    e.utils = {
      getDaysInMonth: function(v, y) {
        return v === void 0 && (v = e.currentMonth), y === void 0 && (y = e.currentYear), v === 1 && (y % 4 === 0 && y % 100 !== 0 || y % 400 === 0) ? 29 : e.l10n.daysInMonth[v];
      }
    };
  }
  function n() {
    e.element = e.input = r, e.isOpen = !1, Mt(), Fu(), r0(), t0(), u(), e.isMobile || z(), O(), (e.selectedDates.length || e.config.noCalendar) && (e.config.enableTime && c(e.config.noCalendar ? e.latestSelectedDateObj : void 0), Lt(!1)), s();
    var v = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    !e.isMobile && v && hr(), Oe("onReady");
  }
  function a() {
    var v;
    return ((v = e.calendarContainer) === null || v === void 0 ? void 0 : v.getRootNode()).activeElement || document.activeElement;
  }
  function o(v) {
    return v.bind(e);
  }
  function s() {
    var v = e.config;
    v.weekNumbers === !1 && v.showMonths === 1 || v.noCalendar !== !0 && window.requestAnimationFrame(function() {
      if (e.calendarContainer !== void 0 && (e.calendarContainer.style.visibility = "hidden", e.calendarContainer.style.display = "block"), e.daysContainer !== void 0) {
        var y = (e.days.offsetWidth + 1) * v.showMonths;
        e.daysContainer.style.width = y + "px", e.calendarContainer.style.width = y + (e.weekWrapper !== void 0 ? e.weekWrapper.offsetWidth : 0) + "px", e.calendarContainer.style.removeProperty("visibility"), e.calendarContainer.style.removeProperty("display");
      }
    });
  }
  function i(v) {
    if (e.selectedDates.length === 0) {
      var y = e.config.minDate === void 0 || nt(/* @__PURE__ */ new Date(), e.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(e.config.minDate.getTime()), B = ta(e.config);
      y.setHours(B.hours, B.minutes, B.seconds, y.getMilliseconds()), e.selectedDates = [y], e.latestSelectedDateObj = y;
    }
    v !== void 0 && v.type !== "blur" && o0(v);
    var N = e._input.value;
    h(), Lt(), e._input.value !== N && e._debouncedChange();
  }
  function l(v, y) {
    return v % 12 + 12 * ft(y === e.l10n.amPM[1]);
  }
  function d(v) {
    switch (v % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return v % 12;
    }
  }
  function h() {
    if (!(e.hourElement === void 0 || e.minuteElement === void 0)) {
      var v = (parseInt(e.hourElement.value.slice(-2), 10) || 0) % 24, y = (parseInt(e.minuteElement.value, 10) || 0) % 60, B = e.secondElement !== void 0 ? (parseInt(e.secondElement.value, 10) || 0) % 60 : 0;
      e.amPM !== void 0 && (v = l(v, e.amPM.textContent));
      var N = e.config.minTime !== void 0 || e.config.minDate && e.minDateHasTime && e.latestSelectedDateObj && nt(e.latestSelectedDateObj, e.config.minDate, !0) === 0, Z = e.config.maxTime !== void 0 || e.config.maxDate && e.maxDateHasTime && e.latestSelectedDateObj && nt(e.latestSelectedDateObj, e.config.maxDate, !0) === 0;
      if (e.config.maxTime !== void 0 && e.config.minTime !== void 0 && e.config.minTime > e.config.maxTime) {
        var re = ea(e.config.minTime.getHours(), e.config.minTime.getMinutes(), e.config.minTime.getSeconds()), me = ea(e.config.maxTime.getHours(), e.config.maxTime.getMinutes(), e.config.maxTime.getSeconds()), le = ea(v, y, B);
        if (le > me && le < re) {
          var _e = X3(re);
          v = _e[0], y = _e[1], B = _e[2];
        }
      } else {
        if (Z) {
          var ie = e.config.maxTime !== void 0 ? e.config.maxTime : e.config.maxDate;
          v = Math.min(v, ie.getHours()), v === ie.getHours() && (y = Math.min(y, ie.getMinutes())), y === ie.getMinutes() && (B = Math.min(B, ie.getSeconds()));
        }
        if (N) {
          var fe = e.config.minTime !== void 0 ? e.config.minTime : e.config.minDate;
          v = Math.max(v, fe.getHours()), v === fe.getHours() && y < fe.getMinutes() && (y = fe.getMinutes()), y === fe.getMinutes() && (B = Math.max(B, fe.getSeconds()));
        }
      }
      f(v, y, B);
    }
  }
  function c(v) {
    var y = v || e.latestSelectedDateObj;
    y && y instanceof Date && f(y.getHours(), y.getMinutes(), y.getSeconds());
  }
  function f(v, y, B) {
    e.latestSelectedDateObj !== void 0 && e.latestSelectedDateObj.setHours(v % 24, y, B || 0, 0), !(!e.hourElement || !e.minuteElement || e.isMobile) && (e.hourElement.value = Ye(e.config.time_24hr ? v : (12 + v) % 12 + 12 * ft(v % 12 === 0)), e.minuteElement.value = Ye(y), e.amPM !== void 0 && (e.amPM.textContent = e.l10n.amPM[ft(v >= 12)]), e.secondElement !== void 0 && (e.secondElement.value = Ye(B)));
  }
  function g(v) {
    var y = ut(v), B = parseInt(y.value) + (v.delta || 0);
    (B / 1e3 > 1 || v.key === "Enter" && !/[^\d]/.test(B.toString())) && he(B);
  }
  function D(v, y, B, N) {
    if (y instanceof Array)
      return y.forEach(function(Z) {
        return D(v, Z, B, N);
      });
    if (v instanceof Array)
      return v.forEach(function(Z) {
        return D(Z, y, B, N);
      });
    v.addEventListener(y, B, N), e._handlers.push({
      remove: function() {
        return v.removeEventListener(y, B, N);
      }
    });
  }
  function _() {
    Oe("onChange");
  }
  function O() {
    if (e.config.wrap && ["open", "close", "toggle", "clear"].forEach(function(B) {
      Array.prototype.forEach.call(e.element.querySelectorAll("[data-" + B + "]"), function(N) {
        return D(N, "click", e[B]);
      });
    }), e.isMobile) {
      u0();
      return;
    }
    var v = wo(dt, 50);
    if (e._debouncedChange = wo(_, Q3), e.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && D(e.daysContainer, "mouseover", function(B) {
      e.config.mode === "range" && je(ut(B));
    }), D(e._input, "keydown", Ie), e.calendarContainer !== void 0 && D(e.calendarContainer, "keydown", Ie), !e.config.inline && !e.config.static && D(window, "resize", v), window.ontouchstart !== void 0 ? D(window.document, "touchstart", De) : D(window.document, "mousedown", De), D(window.document, "focus", De, { capture: !0 }), e.config.clickOpens === !0 && (D(e._input, "focus", e.open), D(e._input, "click", e.open)), e.daysContainer !== void 0 && (D(e.monthNav, "click", i0), D(e.monthNav, ["keyup", "increment"], g), D(e.daysContainer, "click", gr)), e.timeContainer !== void 0 && e.minuteElement !== void 0 && e.hourElement !== void 0) {
      var y = function(B) {
        return ut(B).select();
      };
      D(e.timeContainer, ["increment"], i), D(e.timeContainer, "blur", i, { capture: !0 }), D(e.timeContainer, "click", L), D([e.hourElement, e.minuteElement], ["focus", "click"], y), e.secondElement !== void 0 && D(e.secondElement, "focus", function() {
        return e.secondElement && e.secondElement.select();
      }), e.amPM !== void 0 && D(e.amPM, "click", function(B) {
        i(B);
      });
    }
    e.config.allowInput && D(e._input, "blur", Me);
  }
  function M(v, y) {
    var B = v !== void 0 ? e.parseDate(v) : e.latestSelectedDateObj || (e.config.minDate && e.config.minDate > e.now ? e.config.minDate : e.config.maxDate && e.config.maxDate < e.now ? e.config.maxDate : e.now), N = e.currentYear, Z = e.currentMonth;
    try {
      B !== void 0 && (e.currentYear = B.getFullYear(), e.currentMonth = B.getMonth());
    } catch (re) {
      re.message = "Invalid date supplied: " + B, e.config.errorHandler(re);
    }
    y && e.currentYear !== N && (Oe("onYearChange"), S()), y && (e.currentYear !== N || e.currentMonth !== Z) && Oe("onMonthChange"), e.redraw();
  }
  function L(v) {
    var y = ut(v);
    ~y.className.indexOf("arrow") && q(v, y.classList.contains("arrowUp") ? 1 : -1);
  }
  function q(v, y, B) {
    var N = v && ut(v), Z = B || N && N.parentNode && N.parentNode.firstChild, re = jn("increment");
    re.delta = y, Z && Z.dispatchEvent(re);
  }
  function z() {
    var v = window.document.createDocumentFragment();
    if (e.calendarContainer = Ae("div", "flatpickr-calendar"), e.calendarContainer.tabIndex = -1, !e.config.noCalendar) {
      if (v.appendChild(k()), e.innerContainer = Ae("div", "flatpickr-innerContainer"), e.config.weekNumbers) {
        var y = P(), B = y.weekWrapper, N = y.weekNumbers;
        e.innerContainer.appendChild(B), e.weekNumbers = N, e.weekWrapper = B;
      }
      e.rContainer = Ae("div", "flatpickr-rContainer"), e.rContainer.appendChild(F()), e.daysContainer || (e.daysContainer = Ae("div", "flatpickr-days"), e.daysContainer.tabIndex = -1), E(), e.rContainer.appendChild(e.daysContainer), e.innerContainer.appendChild(e.rContainer), v.appendChild(e.innerContainer);
    }
    e.config.enableTime && v.appendChild(T()), ze(e.calendarContainer, "rangeMode", e.config.mode === "range"), ze(e.calendarContainer, "animate", e.config.animate === !0), ze(e.calendarContainer, "multiMonth", e.config.showMonths > 1), e.calendarContainer.appendChild(v);
    var Z = e.config.appendTo !== void 0 && e.config.appendTo.nodeType !== void 0;
    if ((e.config.inline || e.config.static) && (e.calendarContainer.classList.add(e.config.inline ? "inline" : "static"), e.config.inline && (!Z && e.element.parentNode ? e.element.parentNode.insertBefore(e.calendarContainer, e._input.nextSibling) : e.config.appendTo !== void 0 && e.config.appendTo.appendChild(e.calendarContainer)), e.config.static)) {
      var re = Ae("div", "flatpickr-wrapper");
      e.element.parentNode && e.element.parentNode.insertBefore(re, e.element), re.appendChild(e.element), e.altInput && re.appendChild(e.altInput), re.appendChild(e.calendarContainer);
    }
    !e.config.static && !e.config.inline && (e.config.appendTo !== void 0 ? e.config.appendTo : window.document.body).appendChild(e.calendarContainer);
  }
  function X(v, y, B, N) {
    var Z = ye(y, !0), re = Ae("span", v, y.getDate().toString());
    return re.dateObj = y, re.$i = N, re.setAttribute("aria-label", e.formatDate(y, e.config.ariaDateFormat)), v.indexOf("hidden") === -1 && nt(y, e.now) === 0 && (e.todayDateElem = re, re.classList.add("today"), re.setAttribute("aria-current", "date")), Z ? (re.tabIndex = -1, Hn(y) && (re.classList.add("selected"), e.selectedDateElem = re, e.config.mode === "range" && (ze(re, "startRange", e.selectedDates[0] && nt(y, e.selectedDates[0], !0) === 0), ze(re, "endRange", e.selectedDates[1] && nt(y, e.selectedDates[1], !0) === 0), v === "nextMonthDay" && re.classList.add("inRange")))) : re.classList.add("flatpickr-disabled"), e.config.mode === "range" && a0(y) && !Hn(y) && re.classList.add("inRange"), e.weekNumbers && e.config.showMonths === 1 && v !== "prevMonthDay" && N % 7 === 6 && e.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + e.config.getWeek(y) + "</span>"), Oe("onDayCreate", re), re;
  }
  function ee(v) {
    v.focus(), e.config.mode === "range" && je(v);
  }
  function V(v) {
    for (var y = v > 0 ? 0 : e.config.showMonths - 1, B = v > 0 ? e.config.showMonths : -1, N = y; N != B; N += v)
      for (var Z = e.daysContainer.children[N], re = v > 0 ? 0 : Z.children.length - 1, me = v > 0 ? Z.children.length : -1, le = re; le != me; le += v) {
        var _e = Z.children[le];
        if (_e.className.indexOf("hidden") === -1 && ye(_e.dateObj))
          return _e;
      }
  }
  function oe(v, y) {
    for (var B = v.className.indexOf("Month") === -1 ? v.dateObj.getMonth() : e.currentMonth, N = y > 0 ? e.config.showMonths : -1, Z = y > 0 ? 1 : -1, re = B - e.currentMonth; re != N; re += Z)
      for (var me = e.daysContainer.children[re], le = B - e.currentMonth === re ? v.$i + y : y < 0 ? me.children.length - 1 : 0, _e = me.children.length, ie = le; ie >= 0 && ie < _e && ie != (y > 0 ? _e : -1); ie += Z) {
        var fe = me.children[ie];
        if (fe.className.indexOf("hidden") === -1 && ye(fe.dateObj) && Math.abs(v.$i - ie) >= Math.abs(y))
          return ee(fe);
      }
    e.changeMonth(Z), W(V(Z), 0);
  }
  function W(v, y) {
    var B = a(), N = $e(B || document.body), Z = v !== void 0 ? v : N ? B : e.selectedDateElem !== void 0 && $e(e.selectedDateElem) ? e.selectedDateElem : e.todayDateElem !== void 0 && $e(e.todayDateElem) ? e.todayDateElem : V(y > 0 ? 1 : -1);
    Z === void 0 ? e._input.focus() : N ? oe(Z, y) : ee(Z);
  }
  function A(v, y) {
    for (var B = (new Date(v, y, 1).getDay() - e.l10n.firstDayOfWeek + 7) % 7, N = e.utils.getDaysInMonth((y - 1 + 12) % 12, v), Z = e.utils.getDaysInMonth(y, v), re = window.document.createDocumentFragment(), me = e.config.showMonths > 1, le = me ? "prevMonthDay hidden" : "prevMonthDay", _e = me ? "nextMonthDay hidden" : "nextMonthDay", ie = N + 1 - B, fe = 0; ie <= N; ie++, fe++)
      re.appendChild(X("flatpickr-day " + le, new Date(v, y - 1, ie), ie, fe));
    for (ie = 1; ie <= Z; ie++, fe++)
      re.appendChild(X("flatpickr-day", new Date(v, y, ie), ie, fe));
    for (var ke = Z + 1; ke <= 42 - B && (e.config.showMonths === 1 || fe % 7 !== 0); ke++, fe++)
      re.appendChild(X("flatpickr-day " + _e, new Date(v, y + 1, ke % Z), ke, fe));
    var wt = Ae("div", "dayContainer");
    return wt.appendChild(re), wt;
  }
  function E() {
    if (e.daysContainer !== void 0) {
      Ku(e.daysContainer), e.weekNumbers && Ku(e.weekNumbers);
      for (var v = document.createDocumentFragment(), y = 0; y < e.config.showMonths; y++) {
        var B = new Date(e.currentYear, e.currentMonth, 1);
        B.setMonth(e.currentMonth + y), v.appendChild(A(B.getFullYear(), B.getMonth()));
      }
      e.daysContainer.appendChild(v), e.days = e.daysContainer.firstChild, e.config.mode === "range" && e.selectedDates.length === 1 && je();
    }
  }
  function S() {
    if (!(e.config.showMonths > 1 || e.config.monthSelectorType !== "dropdown")) {
      var v = function(N) {
        return e.config.minDate !== void 0 && e.currentYear === e.config.minDate.getFullYear() && N < e.config.minDate.getMonth() ? !1 : !(e.config.maxDate !== void 0 && e.currentYear === e.config.maxDate.getFullYear() && N > e.config.maxDate.getMonth());
      };
      e.monthsDropdownContainer.tabIndex = -1, e.monthsDropdownContainer.innerHTML = "";
      for (var y = 0; y < 12; y++)
        if (v(y)) {
          var B = Ae("option", "flatpickr-monthDropdown-month");
          B.value = new Date(e.currentYear, y).getMonth().toString(), B.textContent = _n(y, e.config.shorthandCurrentMonth, e.l10n), B.tabIndex = -1, e.currentMonth === y && (B.selected = !0), e.monthsDropdownContainer.appendChild(B);
        }
    }
  }
  function $() {
    var v = Ae("div", "flatpickr-month"), y = window.document.createDocumentFragment(), B;
    e.config.showMonths > 1 || e.config.monthSelectorType === "static" ? B = Ae("span", "cur-month") : (e.monthsDropdownContainer = Ae("select", "flatpickr-monthDropdown-months"), e.monthsDropdownContainer.setAttribute("aria-label", e.l10n.monthAriaLabel), D(e.monthsDropdownContainer, "change", function(me) {
      var le = ut(me), _e = parseInt(le.value, 10);
      e.changeMonth(_e - e.currentMonth), Oe("onMonthChange");
    }), S(), B = e.monthsDropdownContainer);
    var N = Xu("cur-year", { tabindex: "-1" }), Z = N.getElementsByTagName("input")[0];
    Z.setAttribute("aria-label", e.l10n.yearAriaLabel), e.config.minDate && Z.setAttribute("min", e.config.minDate.getFullYear().toString()), e.config.maxDate && (Z.setAttribute("max", e.config.maxDate.getFullYear().toString()), Z.disabled = !!e.config.minDate && e.config.minDate.getFullYear() === e.config.maxDate.getFullYear());
    var re = Ae("div", "flatpickr-current-month");
    return re.appendChild(B), re.appendChild(N), y.appendChild(re), v.appendChild(y), {
      container: v,
      yearElement: Z,
      monthElement: B
    };
  }
  function w() {
    Ku(e.monthNav), e.monthNav.appendChild(e.prevMonthNav), e.config.showMonths && (e.yearElements = [], e.monthElements = []);
    for (var v = e.config.showMonths; v--; ) {
      var y = $();
      e.yearElements.push(y.yearElement), e.monthElements.push(y.monthElement), e.monthNav.appendChild(y.container);
    }
    e.monthNav.appendChild(e.nextMonthNav);
  }
  function k() {
    return e.monthNav = Ae("div", "flatpickr-months"), e.yearElements = [], e.monthElements = [], e.prevMonthNav = Ae("span", "flatpickr-prev-month"), e.prevMonthNav.innerHTML = e.config.prevArrow, e.nextMonthNav = Ae("span", "flatpickr-next-month"), e.nextMonthNav.innerHTML = e.config.nextArrow, w(), Object.defineProperty(e, "_hidePrevMonthArrow", {
      get: function() {
        return e.__hidePrevMonthArrow;
      },
      set: function(v) {
        e.__hidePrevMonthArrow !== v && (ze(e.prevMonthNav, "flatpickr-disabled", v), e.__hidePrevMonthArrow = v);
      }
    }), Object.defineProperty(e, "_hideNextMonthArrow", {
      get: function() {
        return e.__hideNextMonthArrow;
      },
      set: function(v) {
        e.__hideNextMonthArrow !== v && (ze(e.nextMonthNav, "flatpickr-disabled", v), e.__hideNextMonthArrow = v);
      }
    }), e.currentYearElement = e.yearElements[0], qu(), e.monthNav;
  }
  function T() {
    e.calendarContainer.classList.add("hasTime"), e.config.noCalendar && e.calendarContainer.classList.add("noCalendar");
    var v = ta(e.config);
    e.timeContainer = Ae("div", "flatpickr-time"), e.timeContainer.tabIndex = -1;
    var y = Ae("span", "flatpickr-time-separator", ":"), B = Xu("flatpickr-hour", {
      "aria-label": e.l10n.hourAriaLabel
    });
    e.hourElement = B.getElementsByTagName("input")[0];
    var N = Xu("flatpickr-minute", {
      "aria-label": e.l10n.minuteAriaLabel
    });
    if (e.minuteElement = N.getElementsByTagName("input")[0], e.hourElement.tabIndex = e.minuteElement.tabIndex = -1, e.hourElement.value = Ye(e.latestSelectedDateObj ? e.latestSelectedDateObj.getHours() : e.config.time_24hr ? v.hours : d(v.hours)), e.minuteElement.value = Ye(e.latestSelectedDateObj ? e.latestSelectedDateObj.getMinutes() : v.minutes), e.hourElement.setAttribute("step", e.config.hourIncrement.toString()), e.minuteElement.setAttribute("step", e.config.minuteIncrement.toString()), e.hourElement.setAttribute("min", e.config.time_24hr ? "0" : "1"), e.hourElement.setAttribute("max", e.config.time_24hr ? "23" : "12"), e.hourElement.setAttribute("maxlength", "2"), e.minuteElement.setAttribute("min", "0"), e.minuteElement.setAttribute("max", "59"), e.minuteElement.setAttribute("maxlength", "2"), e.timeContainer.appendChild(B), e.timeContainer.appendChild(y), e.timeContainer.appendChild(N), e.config.time_24hr && e.timeContainer.classList.add("time24hr"), e.config.enableSeconds) {
      e.timeContainer.classList.add("hasSeconds");
      var Z = Xu("flatpickr-second");
      e.secondElement = Z.getElementsByTagName("input")[0], e.secondElement.value = Ye(e.latestSelectedDateObj ? e.latestSelectedDateObj.getSeconds() : v.seconds), e.secondElement.setAttribute("step", e.minuteElement.getAttribute("step")), e.secondElement.setAttribute("min", "0"), e.secondElement.setAttribute("max", "59"), e.secondElement.setAttribute("maxlength", "2"), e.timeContainer.appendChild(Ae("span", "flatpickr-time-separator", ":")), e.timeContainer.appendChild(Z);
    }
    return e.config.time_24hr || (e.amPM = Ae("span", "flatpickr-am-pm", e.l10n.amPM[ft((e.latestSelectedDateObj ? e.hourElement.value : e.config.defaultHour) > 11)]), e.amPM.title = e.l10n.toggleTitle, e.amPM.tabIndex = -1, e.timeContainer.appendChild(e.amPM)), e.timeContainer;
  }
  function F() {
    e.weekdayContainer ? Ku(e.weekdayContainer) : e.weekdayContainer = Ae("div", "flatpickr-weekdays");
    for (var v = e.config.showMonths; v--; ) {
      var y = Ae("div", "flatpickr-weekdaycontainer");
      e.weekdayContainer.appendChild(y);
    }
    return I(), e.weekdayContainer;
  }
  function I() {
    if (e.weekdayContainer) {
      var v = e.l10n.firstDayOfWeek, y = Co(e.l10n.weekdays.shorthand);
      v > 0 && v < y.length && (y = Co(y.splice(v, y.length), y.splice(0, v)));
      for (var B = e.config.showMonths; B--; )
        e.weekdayContainer.children[B].innerHTML = `
      <span class='flatpickr-weekday'>
        ` + y.join("</span><span class='flatpickr-weekday'>") + `
      </span>
      `;
    }
  }
  function P() {
    e.calendarContainer.classList.add("hasWeeks");
    var v = Ae("div", "flatpickr-weekwrapper");
    v.appendChild(Ae("span", "flatpickr-weekday", e.l10n.weekAbbreviation));
    var y = Ae("div", "flatpickr-weeks");
    return v.appendChild(y), {
      weekWrapper: v,
      weekNumbers: y
    };
  }
  function Y(v, y) {
    y === void 0 && (y = !0);
    var B = y ? v : v - e.currentMonth;
    B < 0 && e._hidePrevMonthArrow === !0 || B > 0 && e._hideNextMonthArrow === !0 || (e.currentMonth += B, (e.currentMonth < 0 || e.currentMonth > 11) && (e.currentYear += e.currentMonth > 11 ? 1 : -1, e.currentMonth = (e.currentMonth + 12) % 12, Oe("onYearChange"), S()), E(), Oe("onMonthChange"), qu());
  }
  function te(v, y) {
    if (v === void 0 && (v = !0), y === void 0 && (y = !0), e.input.value = "", e.altInput !== void 0 && (e.altInput.value = ""), e.mobileInput !== void 0 && (e.mobileInput.value = ""), e.selectedDates = [], e.latestSelectedDateObj = void 0, y === !0 && (e.currentYear = e._initialDate.getFullYear(), e.currentMonth = e._initialDate.getMonth()), e.config.enableTime === !0) {
      var B = ta(e.config), N = B.hours, Z = B.minutes, re = B.seconds;
      f(N, Z, re);
    }
    e.redraw(), v && Oe("onChange");
  }
  function we() {
    e.isOpen = !1, e.isMobile || (e.calendarContainer !== void 0 && e.calendarContainer.classList.remove("open"), e._input !== void 0 && e._input.classList.remove("active")), Oe("onClose");
  }
  function se() {
    e.config !== void 0 && Oe("onDestroy");
    for (var v = e._handlers.length; v--; )
      e._handlers[v].remove();
    if (e._handlers = [], e.mobileInput)
      e.mobileInput.parentNode && e.mobileInput.parentNode.removeChild(e.mobileInput), e.mobileInput = void 0;
    else if (e.calendarContainer && e.calendarContainer.parentNode)
      if (e.config.static && e.calendarContainer.parentNode) {
        var y = e.calendarContainer.parentNode;
        if (y.lastChild && y.removeChild(y.lastChild), y.parentNode) {
          for (; y.firstChild; )
            y.parentNode.insertBefore(y.firstChild, y);
          y.parentNode.removeChild(y);
        }
      } else
        e.calendarContainer.parentNode.removeChild(e.calendarContainer);
    e.altInput && (e.input.type = "text", e.altInput.parentNode && e.altInput.parentNode.removeChild(e.altInput), delete e.altInput), e.input && (e.input.type = e.input._type, e.input.classList.remove("flatpickr-input"), e.input.removeAttribute("readonly")), [
      "_showTimeInput",
      "latestSelectedDateObj",
      "_hideNextMonthArrow",
      "_hidePrevMonthArrow",
      "__hideNextMonthArrow",
      "__hidePrevMonthArrow",
      "isMobile",
      "isOpen",
      "selectedDateElem",
      "minDateHasTime",
      "maxDateHasTime",
      "days",
      "daysContainer",
      "_input",
      "_positionElement",
      "innerContainer",
      "rContainer",
      "monthNav",
      "todayDateElem",
      "calendarContainer",
      "weekdayContainer",
      "prevMonthNav",
      "nextMonthNav",
      "monthsDropdownContainer",
      "currentMonthElement",
      "currentYearElement",
      "navigationCurrentMonth",
      "selectedDateElem",
      "config"
    ].forEach(function(B) {
      try {
        delete e[B];
      } catch {
      }
    });
  }
  function ae(v) {
    return e.calendarContainer.contains(v);
  }
  function De(v) {
    if (e.isOpen && !e.config.inline) {
      var y = ut(v), B = ae(y), N = y === e.input || y === e.altInput || e.element.contains(y) || v.path && v.path.indexOf && (~v.path.indexOf(e.input) || ~v.path.indexOf(e.altInput)), Z = !N && !B && !ae(v.relatedTarget), re = !e.config.ignoredFocusElements.some(function(me) {
        return me.contains(y);
      });
      Z && re && (e.config.allowInput && e.setDate(e._input.value, !1, e.config.altInput ? e.config.altFormat : e.config.dateFormat), e.timeContainer !== void 0 && e.minuteElement !== void 0 && e.hourElement !== void 0 && e.input.value !== "" && e.input.value !== void 0 && i(), e.close(), e.config && e.config.mode === "range" && e.selectedDates.length === 1 && e.clear(!1));
    }
  }
  function he(v) {
    if (!(!v || e.config.minDate && v < e.config.minDate.getFullYear() || e.config.maxDate && v > e.config.maxDate.getFullYear())) {
      var y = v, B = e.currentYear !== y;
      e.currentYear = y || e.currentYear, e.config.maxDate && e.currentYear === e.config.maxDate.getFullYear() ? e.currentMonth = Math.min(e.config.maxDate.getMonth(), e.currentMonth) : e.config.minDate && e.currentYear === e.config.minDate.getFullYear() && (e.currentMonth = Math.max(e.config.minDate.getMonth(), e.currentMonth)), B && (e.redraw(), Oe("onYearChange"), S());
    }
  }
  function ye(v, y) {
    var B;
    y === void 0 && (y = !0);
    var N = e.parseDate(v, void 0, y);
    if (e.config.minDate && N && nt(N, e.config.minDate, y !== void 0 ? y : !e.minDateHasTime) < 0 || e.config.maxDate && N && nt(N, e.config.maxDate, y !== void 0 ? y : !e.maxDateHasTime) > 0)
      return !1;
    if (!e.config.enable && e.config.disable.length === 0)
      return !0;
    if (N === void 0)
      return !1;
    for (var Z = !!e.config.enable, re = (B = e.config.enable) !== null && B !== void 0 ? B : e.config.disable, me = 0, le = void 0; me < re.length; me++) {
      if (le = re[me], typeof le == "function" && le(N))
        return Z;
      if (le instanceof Date && N !== void 0 && le.getTime() === N.getTime())
        return Z;
      if (typeof le == "string") {
        var _e = e.parseDate(le, void 0, !0);
        return _e && _e.getTime() === N.getTime() ? Z : !Z;
      } else if (typeof le == "object" && N !== void 0 && le.from && le.to && N.getTime() >= le.from.getTime() && N.getTime() <= le.to.getTime())
        return Z;
    }
    return !Z;
  }
  function $e(v) {
    return e.daysContainer !== void 0 ? v.className.indexOf("hidden") === -1 && v.className.indexOf("flatpickr-disabled") === -1 && e.daysContainer.contains(v) : !1;
  }
  function Me(v) {
    var y = v.target === e._input, B = e._input.value.trimEnd() !== Un();
    y && B && !(v.relatedTarget && ae(v.relatedTarget)) && e.setDate(e._input.value, !0, v.target === e.altInput ? e.config.altFormat : e.config.dateFormat);
  }
  function Ie(v) {
    var y = ut(v), B = e.config.wrap ? r.contains(y) : y === e._input, N = e.config.allowInput, Z = e.isOpen && (!N || !B), re = e.config.inline && B && !N;
    if (v.keyCode === 13 && B) {
      if (N)
        return e.setDate(e._input.value, !0, y === e.altInput ? e.config.altFormat : e.config.dateFormat), e.close(), y.blur();
      e.open();
    } else if (ae(y) || Z || re) {
      var me = !!e.timeContainer && e.timeContainer.contains(y);
      switch (v.keyCode) {
        case 13:
          me ? (v.preventDefault(), i(), vr()) : gr(v);
          break;
        case 27:
          v.preventDefault(), vr();
          break;
        case 8:
        case 46:
          B && !e.config.allowInput && (v.preventDefault(), e.clear());
          break;
        case 37:
        case 39:
          if (!me && !B) {
            v.preventDefault();
            var le = a();
            if (e.daysContainer !== void 0 && (N === !1 || le && $e(le))) {
              var _e = v.keyCode === 39 ? 1 : -1;
              v.ctrlKey ? (v.stopPropagation(), Y(_e), W(V(1), 0)) : W(void 0, _e);
            }
          } else
            e.hourElement && e.hourElement.focus();
          break;
        case 38:
        case 40:
          v.preventDefault();
          var ie = v.keyCode === 40 ? 1 : -1;
          e.daysContainer && y.$i !== void 0 || y === e.input || y === e.altInput ? v.ctrlKey ? (v.stopPropagation(), he(e.currentYear - ie), W(V(1), 0)) : me || W(void 0, ie * 7) : y === e.currentYearElement ? he(e.currentYear - ie) : e.config.enableTime && (!me && e.hourElement && e.hourElement.focus(), i(v), e._debouncedChange());
          break;
        case 9:
          if (me) {
            var fe = [
              e.hourElement,
              e.minuteElement,
              e.secondElement,
              e.amPM
            ].concat(e.pluginElements).filter(function(rt) {
              return rt;
            }), ke = fe.indexOf(y);
            if (ke !== -1) {
              var wt = fe[ke + (v.shiftKey ? -1 : 1)];
              v.preventDefault(), (wt || e._input).focus();
            }
          } else
            !e.config.noCalendar && e.daysContainer && e.daysContainer.contains(y) && v.shiftKey && (v.preventDefault(), e._input.focus());
          break;
      }
    }
    if (e.amPM !== void 0 && y === e.amPM)
      switch (v.key) {
        case e.l10n.amPM[0].charAt(0):
        case e.l10n.amPM[0].charAt(0).toLowerCase():
          e.amPM.textContent = e.l10n.amPM[0], h(), Lt();
          break;
        case e.l10n.amPM[1].charAt(0):
        case e.l10n.amPM[1].charAt(0).toLowerCase():
          e.amPM.textContent = e.l10n.amPM[1], h(), Lt();
          break;
      }
    (B || ae(y)) && Oe("onKeyDown", v);
  }
  function je(v, y) {
    if (y === void 0 && (y = "flatpickr-day"), !(e.selectedDates.length !== 1 || v && (!v.classList.contains(y) || v.classList.contains("flatpickr-disabled")))) {
      for (var B = v ? v.dateObj.getTime() : e.days.firstElementChild.dateObj.getTime(), N = e.parseDate(e.selectedDates[0], void 0, !0).getTime(), Z = Math.min(B, e.selectedDates[0].getTime()), re = Math.max(B, e.selectedDates[0].getTime()), me = !1, le = 0, _e = 0, ie = Z; ie < re; ie += J3.DAY)
        ye(new Date(ie), !0) || (me = me || ie > Z && ie < re, ie < N && (!le || ie > le) ? le = ie : ie > N && (!_e || ie < _e) && (_e = ie));
      var fe = Array.from(e.rContainer.querySelectorAll("*:nth-child(-n+" + e.config.showMonths + ") > ." + y));
      fe.forEach(function(ke) {
        var wt = ke.dateObj, rt = wt.getTime(), zr = le > 0 && rt < le || _e > 0 && rt > _e;
        if (zr) {
          ke.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach(function(br) {
            ke.classList.remove(br);
          });
          return;
        } else if (me && !zr)
          return;
        ["startRange", "inRange", "endRange", "notAllowed"].forEach(function(br) {
          ke.classList.remove(br);
        }), v !== void 0 && (v.classList.add(B <= e.selectedDates[0].getTime() ? "startRange" : "endRange"), N < B && rt === N ? ke.classList.add("startRange") : N > B && rt === N && ke.classList.add("endRange"), rt >= le && (_e === 0 || rt <= _e) && K3(rt, N, B) && ke.classList.add("inRange"));
      });
    }
  }
  function dt() {
    e.isOpen && !e.config.static && !e.config.inline && hr();
  }
  function pr(v, y) {
    if (y === void 0 && (y = e._positionElement), e.isMobile === !0) {
      if (v) {
        v.preventDefault();
        var B = ut(v);
        B && B.blur();
      }
      e.mobileInput !== void 0 && (e.mobileInput.focus(), e.mobileInput.click()), Oe("onOpen");
      return;
    } else if (e._input.disabled || e.config.inline)
      return;
    var N = e.isOpen;
    e.isOpen = !0, N || (e.calendarContainer.classList.add("open"), e._input.classList.add("active"), Oe("onOpen"), hr(y)), e.config.enableTime === !0 && e.config.noCalendar === !0 && e.config.allowInput === !1 && (v === void 0 || !e.timeContainer.contains(v.relatedTarget)) && setTimeout(function() {
      return e.hourElement.select();
    }, 50);
  }
  function $t(v) {
    return function(y) {
      var B = e.config["_" + v + "Date"] = e.parseDate(y, e.config.dateFormat), N = e.config["_" + (v === "min" ? "max" : "min") + "Date"];
      B !== void 0 && (e[v === "min" ? "minDateHasTime" : "maxDateHasTime"] = B.getHours() > 0 || B.getMinutes() > 0 || B.getSeconds() > 0), e.selectedDates && (e.selectedDates = e.selectedDates.filter(function(Z) {
        return ye(Z);
      }), !e.selectedDates.length && v === "min" && c(B), Lt()), e.daysContainer && (Hr(), B !== void 0 ? e.currentYearElement[v] = B.getFullYear().toString() : e.currentYearElement.removeAttribute(v), e.currentYearElement.disabled = !!N && B !== void 0 && N.getFullYear() === B.getFullYear());
    };
  }
  function Mt() {
    var v = [
      "wrap",
      "weekNumbers",
      "allowInput",
      "allowInvalidPreload",
      "clickOpens",
      "time_24hr",
      "enableTime",
      "noCalendar",
      "altInput",
      "shorthandCurrentMonth",
      "inline",
      "static",
      "enableSeconds",
      "disableMobile"
    ], y = Ue(Ue({}, JSON.parse(JSON.stringify(r.dataset || {}))), t), B = {};
    e.config.parseDate = y.parseDate, e.config.formatDate = y.formatDate, Object.defineProperty(e.config, "enable", {
      get: function() {
        return e.config._enable;
      },
      set: function(fe) {
        e.config._enable = $i(fe);
      }
    }), Object.defineProperty(e.config, "disable", {
      get: function() {
        return e.config._disable;
      },
      set: function(fe) {
        e.config._disable = $i(fe);
      }
    });
    var N = y.mode === "time";
    if (!y.dateFormat && (y.enableTime || N)) {
      var Z = Fe.defaultConfig.dateFormat || Cr.dateFormat;
      B.dateFormat = y.noCalendar || N ? "H:i" + (y.enableSeconds ? ":S" : "") : Z + " H:i" + (y.enableSeconds ? ":S" : "");
    }
    if (y.altInput && (y.enableTime || N) && !y.altFormat) {
      var re = Fe.defaultConfig.altFormat || Cr.altFormat;
      B.altFormat = y.noCalendar || N ? "h:i" + (y.enableSeconds ? ":S K" : " K") : re + (" h:i" + (y.enableSeconds ? ":S" : "") + " K");
    }
    Object.defineProperty(e.config, "minDate", {
      get: function() {
        return e.config._minDate;
      },
      set: $t("min")
    }), Object.defineProperty(e.config, "maxDate", {
      get: function() {
        return e.config._maxDate;
      },
      set: $t("max")
    });
    var me = function(fe) {
      return function(ke) {
        e.config[fe === "min" ? "_minTime" : "_maxTime"] = e.parseDate(ke, "H:i:S");
      };
    };
    Object.defineProperty(e.config, "minTime", {
      get: function() {
        return e.config._minTime;
      },
      set: me("min")
    }), Object.defineProperty(e.config, "maxTime", {
      get: function() {
        return e.config._maxTime;
      },
      set: me("max")
    }), y.mode === "time" && (e.config.noCalendar = !0, e.config.enableTime = !0), Object.assign(e.config, B, y);
    for (var le = 0; le < v.length; le++)
      e.config[v[le]] = e.config[v[le]] === !0 || e.config[v[le]] === "true";
    Xn.filter(function(fe) {
      return e.config[fe] !== void 0;
    }).forEach(function(fe) {
      e.config[fe] = Jn(e.config[fe] || []).map(o);
    }), e.isMobile = !e.config.disableMobile && !e.config.inline && e.config.mode === "single" && !e.config.disable.length && !e.config.enable && !e.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    for (var le = 0; le < e.config.plugins.length; le++) {
      var _e = e.config.plugins[le](e) || {};
      for (var ie in _e)
        Xn.indexOf(ie) > -1 ? e.config[ie] = Jn(_e[ie]).map(o).concat(e.config[ie]) : typeof y[ie] > "u" && (e.config[ie] = _e[ie]);
    }
    y.altInputClass || (e.config.altInputClass = jr().className + " " + e.config.altInputClass), Oe("onParseConfig");
  }
  function jr() {
    return e.config.wrap ? r.querySelector("[data-input]") : r;
  }
  function Fu() {
    typeof e.config.locale != "object" && typeof Fe.l10ns[e.config.locale] > "u" && e.config.errorHandler(new Error("flatpickr: invalid locale " + e.config.locale)), e.l10n = Ue(Ue({}, Fe.l10ns.default), typeof e.config.locale == "object" ? e.config.locale : e.config.locale !== "default" ? Fe.l10ns[e.config.locale] : void 0), tr.D = "(" + e.l10n.weekdays.shorthand.join("|") + ")", tr.l = "(" + e.l10n.weekdays.longhand.join("|") + ")", tr.M = "(" + e.l10n.months.shorthand.join("|") + ")", tr.F = "(" + e.l10n.months.longhand.join("|") + ")", tr.K = "(" + e.l10n.amPM[0] + "|" + e.l10n.amPM[1] + "|" + e.l10n.amPM[0].toLowerCase() + "|" + e.l10n.amPM[1].toLowerCase() + ")";
    var v = Ue(Ue({}, t), JSON.parse(JSON.stringify(r.dataset || {})));
    v.time_24hr === void 0 && Fe.defaultConfig.time_24hr === void 0 && (e.config.time_24hr = e.l10n.time_24hr), e.formatDate = oc(e), e.parseDate = Ba({ config: e.config, l10n: e.l10n });
  }
  function hr(v) {
    if (typeof e.config.position == "function")
      return void e.config.position(e, v);
    if (e.calendarContainer !== void 0) {
      Oe("onPreCalendarPosition");
      var y = v || e._positionElement, B = Array.prototype.reduce.call(e.calendarContainer.children, function(m0, v0) {
        return m0 + v0.offsetHeight;
      }, 0), N = e.calendarContainer.offsetWidth, Z = e.config.position.split(" "), re = Z[0], me = Z.length > 1 ? Z[1] : null, le = y.getBoundingClientRect(), _e = window.innerHeight - le.bottom, ie = re === "above" || re !== "below" && _e < B && le.top > B, fe = window.pageYOffset + le.top + (ie ? -B - 2 : y.offsetHeight + 2);
      if (ze(e.calendarContainer, "arrowTop", !ie), ze(e.calendarContainer, "arrowBottom", ie), !e.config.inline) {
        var ke = window.pageXOffset + le.left, wt = !1, rt = !1;
        me === "center" ? (ke -= (N - le.width) / 2, wt = !0) : me === "right" && (ke -= N - le.width, rt = !0), ze(e.calendarContainer, "arrowLeft", !wt && !rt), ze(e.calendarContainer, "arrowCenter", wt), ze(e.calendarContainer, "arrowRight", rt);
        var zr = window.document.body.offsetWidth - (window.pageXOffset + le.right), br = ke + N > window.document.body.offsetWidth, s0 = zr + N > window.document.body.offsetWidth;
        if (ze(e.calendarContainer, "rightMost", br), !e.config.static)
          if (e.calendarContainer.style.top = fe + "px", !br)
            e.calendarContainer.style.left = ke + "px", e.calendarContainer.style.right = "auto";
          else if (!s0)
            e.calendarContainer.style.left = "auto", e.calendarContainer.style.right = zr + "px";
          else {
            var zn = Ot();
            if (zn === void 0)
              return;
            var l0 = window.document.body.offsetWidth, c0 = Math.max(0, l0 / 2 - N / 2), d0 = ".flatpickr-calendar.centerMost:before", f0 = ".flatpickr-calendar.centerMost:after", p0 = zn.cssRules.length, h0 = "{left:" + le.left + "px;right:auto;}";
            ze(e.calendarContainer, "rightMost", !1), ze(e.calendarContainer, "centerMost", !0), zn.insertRule(d0 + "," + f0 + h0, p0), e.calendarContainer.style.left = c0 + "px", e.calendarContainer.style.right = "auto";
          }
      }
    }
  }
  function Ot() {
    for (var v = null, y = 0; y < document.styleSheets.length; y++) {
      var B = document.styleSheets[y];
      if (B.cssRules) {
        try {
          B.cssRules;
        } catch {
          continue;
        }
        v = B;
        break;
      }
    }
    return v ?? mr();
  }
  function mr() {
    var v = document.createElement("style");
    return document.head.appendChild(v), v.sheet;
  }
  function Hr() {
    e.config.noCalendar || e.isMobile || (S(), qu(), E());
  }
  function vr() {
    e._input.focus(), window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0 ? setTimeout(e.close, 0) : e.close();
  }
  function gr(v) {
    v.preventDefault(), v.stopPropagation();
    var y = function(fe) {
      return fe.classList && fe.classList.contains("flatpickr-day") && !fe.classList.contains("flatpickr-disabled") && !fe.classList.contains("notAllowed");
    }, B = ic(ut(v), y);
    if (B !== void 0) {
      var N = B, Z = e.latestSelectedDateObj = new Date(N.dateObj.getTime()), re = (Z.getMonth() < e.currentMonth || Z.getMonth() > e.currentMonth + e.config.showMonths - 1) && e.config.mode !== "range";
      if (e.selectedDateElem = N, e.config.mode === "single")
        e.selectedDates = [Z];
      else if (e.config.mode === "multiple") {
        var me = Hn(Z);
        me ? e.selectedDates.splice(parseInt(me), 1) : e.selectedDates.push(Z);
      } else
        e.config.mode === "range" && (e.selectedDates.length === 2 && e.clear(!1, !1), e.latestSelectedDateObj = Z, e.selectedDates.push(Z), nt(Z, e.selectedDates[0], !0) !== 0 && e.selectedDates.sort(function(fe, ke) {
          return fe.getTime() - ke.getTime();
        }));
      if (h(), re) {
        var le = e.currentYear !== Z.getFullYear();
        e.currentYear = Z.getFullYear(), e.currentMonth = Z.getMonth(), le && (Oe("onYearChange"), S()), Oe("onMonthChange");
      }
      if (qu(), E(), Lt(), !re && e.config.mode !== "range" && e.config.showMonths === 1 ? ee(N) : e.selectedDateElem !== void 0 && e.hourElement === void 0 && e.selectedDateElem && e.selectedDateElem.focus(), e.hourElement !== void 0 && e.hourElement !== void 0 && e.hourElement.focus(), e.config.closeOnSelect) {
        var _e = e.config.mode === "single" && !e.config.enableTime, ie = e.config.mode === "range" && e.selectedDates.length === 2 && !e.config.enableTime;
        (_e || ie) && vr();
      }
      _();
    }
  }
  var Jt = {
    locale: [Fu, I],
    showMonths: [w, s, F],
    minDate: [M],
    maxDate: [M],
    positionElement: [Mi],
    clickOpens: [
      function() {
        e.config.clickOpens === !0 ? (D(e._input, "focus", e.open), D(e._input, "click", e.open)) : (e._input.removeEventListener("focus", e.open), e._input.removeEventListener("click", e.open));
      }
    ]
  };
  function Iu(v, y) {
    if (v !== null && typeof v == "object") {
      Object.assign(e.config, v);
      for (var B in v)
        Jt[B] !== void 0 && Jt[B].forEach(function(N) {
          return N();
        });
    } else
      e.config[v] = y, Jt[v] !== void 0 ? Jt[v].forEach(function(N) {
        return N();
      }) : Xn.indexOf(v) > -1 && (e.config[v] = Jn(y));
    e.redraw(), Lt(!0);
  }
  function Ur(v, y) {
    var B = [];
    if (v instanceof Array)
      B = v.map(function(N) {
        return e.parseDate(N, y);
      });
    else if (v instanceof Date || typeof v == "number")
      B = [e.parseDate(v, y)];
    else if (typeof v == "string")
      switch (e.config.mode) {
        case "single":
        case "time":
          B = [e.parseDate(v, y)];
          break;
        case "multiple":
          B = v.split(e.config.conjunction).map(function(N) {
            return e.parseDate(N, y);
          });
          break;
        case "range":
          B = v.split(e.l10n.rangeSeparator).map(function(N) {
            return e.parseDate(N, y);
          });
          break;
      }
    else
      e.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(v)));
    e.selectedDates = e.config.allowInvalidPreload ? B : B.filter(function(N) {
      return N instanceof Date && ye(N, !1);
    }), e.config.mode === "range" && e.selectedDates.sort(function(N, Z) {
      return N.getTime() - Z.getTime();
    });
  }
  function Nu(v, y, B) {
    if (y === void 0 && (y = !1), B === void 0 && (B = e.config.dateFormat), v !== 0 && !v || v instanceof Array && v.length === 0)
      return e.clear(y);
    Ur(v, B), e.latestSelectedDateObj = e.selectedDates[e.selectedDates.length - 1], e.redraw(), M(void 0, y), c(), e.selectedDates.length === 0 && e.clear(!1), Lt(y), y && Oe("onChange");
  }
  function $i(v) {
    return v.slice().map(function(y) {
      return typeof y == "string" || typeof y == "number" || y instanceof Date ? e.parseDate(y, void 0, !0) : y && typeof y == "object" && y.from && y.to ? {
        from: e.parseDate(y.from, void 0),
        to: e.parseDate(y.to, void 0)
      } : y;
    }).filter(function(y) {
      return y;
    });
  }
  function t0() {
    e.selectedDates = [], e.now = e.parseDate(e.config.now) || /* @__PURE__ */ new Date();
    var v = e.config.defaultDate || ((e.input.nodeName === "INPUT" || e.input.nodeName === "TEXTAREA") && e.input.placeholder && e.input.value === e.input.placeholder ? null : e.input.value);
    v && Ur(v, e.config.dateFormat), e._initialDate = e.selectedDates.length > 0 ? e.selectedDates[0] : e.config.minDate && e.config.minDate.getTime() > e.now.getTime() ? e.config.minDate : e.config.maxDate && e.config.maxDate.getTime() < e.now.getTime() ? e.config.maxDate : e.now, e.currentYear = e._initialDate.getFullYear(), e.currentMonth = e._initialDate.getMonth(), e.selectedDates.length > 0 && (e.latestSelectedDateObj = e.selectedDates[0]), e.config.minTime !== void 0 && (e.config.minTime = e.parseDate(e.config.minTime, "H:i")), e.config.maxTime !== void 0 && (e.config.maxTime = e.parseDate(e.config.maxTime, "H:i")), e.minDateHasTime = !!e.config.minDate && (e.config.minDate.getHours() > 0 || e.config.minDate.getMinutes() > 0 || e.config.minDate.getSeconds() > 0), e.maxDateHasTime = !!e.config.maxDate && (e.config.maxDate.getHours() > 0 || e.config.maxDate.getMinutes() > 0 || e.config.maxDate.getSeconds() > 0);
  }
  function r0() {
    if (e.input = jr(), !e.input) {
      e.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }
    e.input._type = e.input.type, e.input.type = "text", e.input.classList.add("flatpickr-input"), e._input = e.input, e.config.altInput && (e.altInput = Ae(e.input.nodeName, e.config.altInputClass), e._input = e.altInput, e.altInput.placeholder = e.input.placeholder, e.altInput.disabled = e.input.disabled, e.altInput.required = e.input.required, e.altInput.tabIndex = e.input.tabIndex, e.altInput.type = "text", e.input.setAttribute("type", "hidden"), !e.config.static && e.input.parentNode && e.input.parentNode.insertBefore(e.altInput, e.input.nextSibling)), e.config.allowInput || e._input.setAttribute("readonly", "readonly"), Mi();
  }
  function Mi() {
    e._positionElement = e.config.positionElement || e._input;
  }
  function u0() {
    var v = e.config.enableTime ? e.config.noCalendar ? "time" : "datetime-local" : "date";
    e.mobileInput = Ae("input", e.input.className + " flatpickr-mobile"), e.mobileInput.tabIndex = 1, e.mobileInput.type = v, e.mobileInput.disabled = e.input.disabled, e.mobileInput.required = e.input.required, e.mobileInput.placeholder = e.input.placeholder, e.mobileFormatStr = v === "datetime-local" ? "Y-m-d\\TH:i:S" : v === "date" ? "Y-m-d" : "H:i:S", e.selectedDates.length > 0 && (e.mobileInput.defaultValue = e.mobileInput.value = e.formatDate(e.selectedDates[0], e.mobileFormatStr)), e.config.minDate && (e.mobileInput.min = e.formatDate(e.config.minDate, "Y-m-d")), e.config.maxDate && (e.mobileInput.max = e.formatDate(e.config.maxDate, "Y-m-d")), e.input.getAttribute("step") && (e.mobileInput.step = String(e.input.getAttribute("step"))), e.input.type = "hidden", e.altInput !== void 0 && (e.altInput.type = "hidden");
    try {
      e.input.parentNode && e.input.parentNode.insertBefore(e.mobileInput, e.input.nextSibling);
    } catch {
    }
    D(e.mobileInput, "change", function(y) {
      e.setDate(ut(y).value, !1, e.mobileFormatStr), Oe("onChange"), Oe("onClose");
    });
  }
  function n0(v) {
    if (e.isOpen === !0)
      return e.close();
    e.open(v);
  }
  function Oe(v, y) {
    if (e.config !== void 0) {
      var B = e.config[v];
      if (B !== void 0 && B.length > 0)
        for (var N = 0; B[N] && N < B.length; N++)
          B[N](e.selectedDates, e.input.value, e, y);
      v === "onChange" && (e.input.dispatchEvent(jn("change")), e.input.dispatchEvent(jn("input")));
    }
  }
  function jn(v) {
    var y = document.createEvent("Event");
    return y.initEvent(v, !0, !0), y;
  }
  function Hn(v) {
    for (var y = 0; y < e.selectedDates.length; y++) {
      var B = e.selectedDates[y];
      if (B instanceof Date && nt(B, v) === 0)
        return "" + y;
    }
    return !1;
  }
  function a0(v) {
    return e.config.mode !== "range" || e.selectedDates.length < 2 ? !1 : nt(v, e.selectedDates[0]) >= 0 && nt(v, e.selectedDates[1]) <= 0;
  }
  function qu() {
    e.config.noCalendar || e.isMobile || !e.monthNav || (e.yearElements.forEach(function(v, y) {
      var B = new Date(e.currentYear, e.currentMonth, 1);
      B.setMonth(e.currentMonth + y), e.config.showMonths > 1 || e.config.monthSelectorType === "static" ? e.monthElements[y].textContent = _n(B.getMonth(), e.config.shorthandCurrentMonth, e.l10n) + " " : e.monthsDropdownContainer.value = B.getMonth().toString(), v.value = B.getFullYear().toString();
    }), e._hidePrevMonthArrow = e.config.minDate !== void 0 && (e.currentYear === e.config.minDate.getFullYear() ? e.currentMonth <= e.config.minDate.getMonth() : e.currentYear < e.config.minDate.getFullYear()), e._hideNextMonthArrow = e.config.maxDate !== void 0 && (e.currentYear === e.config.maxDate.getFullYear() ? e.currentMonth + 1 > e.config.maxDate.getMonth() : e.currentYear > e.config.maxDate.getFullYear()));
  }
  function Un(v) {
    var y = v || (e.config.altInput ? e.config.altFormat : e.config.dateFormat);
    return e.selectedDates.map(function(B) {
      return e.formatDate(B, y);
    }).filter(function(B, N, Z) {
      return e.config.mode !== "range" || e.config.enableTime || Z.indexOf(B) === N;
    }).join(e.config.mode !== "range" ? e.config.conjunction : e.l10n.rangeSeparator);
  }
  function Lt(v) {
    v === void 0 && (v = !0), e.mobileInput !== void 0 && e.mobileFormatStr && (e.mobileInput.value = e.latestSelectedDateObj !== void 0 ? e.formatDate(e.latestSelectedDateObj, e.mobileFormatStr) : ""), e.input.value = Un(e.config.dateFormat), e.altInput !== void 0 && (e.altInput.value = Un(e.config.altFormat)), v !== !1 && Oe("onValueUpdate");
  }
  function i0(v) {
    var y = ut(v), B = e.prevMonthNav.contains(y), N = e.nextMonthNav.contains(y);
    B || N ? Y(B ? -1 : 1) : e.yearElements.indexOf(y) >= 0 ? y.select() : y.classList.contains("arrowUp") ? e.changeYear(e.currentYear + 1) : y.classList.contains("arrowDown") && e.changeYear(e.currentYear - 1);
  }
  function o0(v) {
    v.preventDefault();
    var y = v.type === "keydown", B = ut(v), N = B;
    e.amPM !== void 0 && B === e.amPM && (e.amPM.textContent = e.l10n.amPM[ft(e.amPM.textContent === e.l10n.amPM[0])]);
    var Z = parseFloat(N.getAttribute("min")), re = parseFloat(N.getAttribute("max")), me = parseFloat(N.getAttribute("step")), le = parseInt(N.value, 10), _e = v.delta || (y ? v.which === 38 ? 1 : -1 : 0), ie = le + me * _e;
    if (typeof N.value < "u" && N.value.length === 2) {
      var fe = N === e.hourElement, ke = N === e.minuteElement;
      ie < Z ? (ie = re + ie + ft(!fe) + (ft(fe) && ft(!e.amPM)), ke && q(void 0, -1, e.hourElement)) : ie > re && (ie = N === e.hourElement ? ie - re - ft(!e.amPM) : Z, ke && q(void 0, 1, e.hourElement)), e.amPM && fe && (me === 1 ? ie + le === 23 : Math.abs(ie - le) > me) && (e.amPM.textContent = e.l10n.amPM[ft(e.amPM.textContent === e.l10n.amPM[0])]), N.value = Ye(ie);
    }
  }
  return n(), e;
}
function Dr(r, t) {
  for (var e = Array.prototype.slice.call(r).filter(function(o) {
    return o instanceof HTMLElement;
  }), u = [], n = 0; n < e.length; n++) {
    var a = e[n];
    try {
      if (a.getAttribute("data-fp-omit") !== null)
        continue;
      a._flatpickr !== void 0 && (a._flatpickr.destroy(), a._flatpickr = void 0), a._flatpickr = eh(a, t || {}), u.push(a._flatpickr);
    } catch (o) {
      console.error(o);
    }
  }
  return u.length === 1 ? u[0] : u;
}
typeof HTMLElement < "u" && typeof HTMLCollection < "u" && typeof NodeList < "u" && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(r) {
  return Dr(this, r);
}, HTMLElement.prototype.flatpickr = function(r) {
  return Dr([this], r);
});
var Fe = function(r, t) {
  return typeof r == "string" ? Dr(window.document.querySelectorAll(r), t) : r instanceof Node ? Dr([r], t) : Dr(r, t);
};
Fe.defaultConfig = {};
Fe.l10ns = {
  en: Ue({}, bu),
  default: Ue({}, bu)
};
Fe.localize = function(r) {
  Fe.l10ns.default = Ue(Ue({}, Fe.l10ns.default), r);
};
Fe.setDefaults = function(r) {
  Fe.defaultConfig = Ue(Ue({}, Fe.defaultConfig), r);
};
Fe.parseDate = Ba({});
Fe.formatDate = oc({});
Fe.compareDates = nt;
typeof jQuery < "u" && typeof jQuery.fn < "u" && (jQuery.fn.flatpickr = function(r) {
  return Dr(this, r);
});
Date.prototype.fp_incr = function(r) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof r == "string" ? parseInt(r, 10) : r));
};
typeof window < "u" && (window.flatpickr = Fe);
const sc = [
  "onChange",
  "onClose",
  "onDestroy",
  "onMonthChange",
  "onOpen",
  "onYearChange"
], th = [
  "onValueUpdate",
  "onDayCreate",
  "onParseConfig",
  "onReady",
  "onPreCalendarPosition",
  "onKeyDown"
];
function Do(r) {
  return r.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function Ao(r) {
  return r instanceof Array ? r : [r];
}
function ra(r) {
  return r && r.length ? r : null;
}
const xo = [...sc, ...th], rh = ["locale", "showMonths"], lc = ue({
  name: "FlatPickr",
  compatConfig: {
    MODE: 3
  },
  render() {
    return Ze("input", {
      type: "text",
      "data-input": !0,
      disabled: this.disabled,
      onInput: this.onInput
    });
  },
  emits: [
    "blur",
    "update:modelValue",
    ...xo.map(Do)
  ],
  props: {
    modelValue: {
      type: [String, Number, Date, Array, null],
      required: !0
    },
    // https://flatpickr.js.org/options/
    config: {
      type: Object,
      default: () => ({
        defaultDate: null,
        wrap: !1
      })
    },
    events: {
      type: Array,
      default: () => sc
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      fp: null
      //todo make it non-reactive
    };
  },
  mounted() {
    this.fp || (this.fp = Fe(this.getElem(), this.prepareConfig()), this.fpInput().addEventListener("blur", this.onBlur), this.$watch("disabled", this.watchDisabled, {
      immediate: !0
    }));
  },
  methods: {
    prepareConfig() {
      let r = Object.assign({}, this.config);
      this.events.forEach((e) => {
        let u = Fe.defaultConfig[e] || [], n = (...a) => {
          this.$emit(Do(e), ...a);
        };
        r[e] = Ao(r[e] || []).concat(u, n);
      });
      const t = this.onClose.bind(this);
      return r.onClose = Ao(r.onClose || []).concat(t), r.defaultDate = this.modelValue || r.defaultDate, r;
    },
    /**
     * Get the HTML node where flatpickr to be attached
     * Bind on parent element if wrap is true
     */
    getElem() {
      return this.config.wrap ? this.$el.parentNode : this.$el;
    },
    /**
     * Watch for value changed by date-picker itself and notify parent component
     */
    onInput(r) {
      const t = r.target;
      Pe().then(() => {
        this.$emit("update:modelValue", ra(t.value));
      });
    },
    fpInput() {
      return this.fp.altInput || this.fp.input;
    },
    /**
     * Blur event is required by many validation libraries
     */
    onBlur(r) {
      this.$emit("blur", ra(r.target.value));
    },
    /**
     * Flatpickr does not emit input event in some cases
     */
    onClose(r, t) {
      this.$emit("update:modelValue", t);
    },
    /**
     * Watch for the disabled property and sets the value to the real input.
     */
    watchDisabled(r) {
      r ? this.fpInput().setAttribute("disabled", "") : this.fpInput().removeAttribute("disabled");
    }
  },
  watch: {
    /**
     * Watch for any config changes and redraw date-picker
     */
    config: {
      deep: !0,
      handler(r) {
        if (!this.fp)
          return;
        let t = Object.assign({}, r);
        xo.forEach((e) => {
          delete t[e];
        }), this.fp.set(t), rh.forEach((e) => {
          typeof t[e] < "u" && this.fp.set(e, t[e]);
        });
      }
    },
    /**
     * Watch for changes from parent component and update DOM
     */
    modelValue(r) {
      var t;
      !this.$el || r === ra(this.$el.value) || (t = this.fp) === null || t === void 0 || t.setDate(r, !0);
    }
  },
  beforeUnmount() {
    this.fp && (this.fpInput().removeEventListener("blur", this.onBlur), this.fp.destroy(), this.fp = null);
  }
});
var cc = { exports: {} };
(function(r, t) {
  (function(e, u) {
    r.exports = u();
  })(de, function() {
    var e = 1e3, u = 6e4, n = 36e5, a = "millisecond", o = "second", s = "minute", i = "hour", l = "day", d = "week", h = "month", c = "quarter", f = "year", g = "date", D = "Invalid Date", _ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, O = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function($) {
      var w = ["th", "st", "nd", "rd"], k = $ % 100;
      return "[" + $ + (w[(k - 20) % 10] || w[k] || w[0]) + "]";
    } }, L = function($, w, k) {
      var T = String($);
      return !T || T.length >= w ? $ : "" + Array(w + 1 - T.length).join(k) + $;
    }, q = { s: L, z: function($) {
      var w = -$.utcOffset(), k = Math.abs(w), T = Math.floor(k / 60), F = k % 60;
      return (w <= 0 ? "+" : "-") + L(T, 2, "0") + ":" + L(F, 2, "0");
    }, m: function $(w, k) {
      if (w.date() < k.date())
        return -$(k, w);
      var T = 12 * (k.year() - w.year()) + (k.month() - w.month()), F = w.clone().add(T, h), I = k - F < 0, P = w.clone().add(T + (I ? -1 : 1), h);
      return +(-(T + (k - F) / (I ? F - P : P - F)) || 0);
    }, a: function($) {
      return $ < 0 ? Math.ceil($) || 0 : Math.floor($);
    }, p: function($) {
      return { M: h, y: f, w: d, d: l, D: g, h: i, m: s, s: o, ms: a, Q: c }[$] || String($ || "").toLowerCase().replace(/s$/, "");
    }, u: function($) {
      return $ === void 0;
    } }, z = "en", X = {};
    X[z] = M;
    var ee = "$isDayjsObject", V = function($) {
      return $ instanceof E || !(!$ || !$[ee]);
    }, oe = function $(w, k, T) {
      var F;
      if (!w)
        return z;
      if (typeof w == "string") {
        var I = w.toLowerCase();
        X[I] && (F = I), k && (X[I] = k, F = I);
        var P = w.split("-");
        if (!F && P.length > 1)
          return $(P[0]);
      } else {
        var Y = w.name;
        X[Y] = w, F = Y;
      }
      return !T && F && (z = F), F || !T && z;
    }, W = function($, w) {
      if (V($))
        return $.clone();
      var k = typeof w == "object" ? w : {};
      return k.date = $, k.args = arguments, new E(k);
    }, A = q;
    A.l = oe, A.i = V, A.w = function($, w) {
      return W($, { locale: w.$L, utc: w.$u, x: w.$x, $offset: w.$offset });
    };
    var E = function() {
      function $(k) {
        this.$L = oe(k.locale, null, !0), this.parse(k), this.$x = this.$x || k.x || {}, this[ee] = !0;
      }
      var w = $.prototype;
      return w.parse = function(k) {
        this.$d = function(T) {
          var F = T.date, I = T.utc;
          if (F === null)
            return /* @__PURE__ */ new Date(NaN);
          if (A.u(F))
            return /* @__PURE__ */ new Date();
          if (F instanceof Date)
            return new Date(F);
          if (typeof F == "string" && !/Z$/i.test(F)) {
            var P = F.match(_);
            if (P) {
              var Y = P[2] - 1 || 0, te = (P[7] || "0").substring(0, 3);
              return I ? new Date(Date.UTC(P[1], Y, P[3] || 1, P[4] || 0, P[5] || 0, P[6] || 0, te)) : new Date(P[1], Y, P[3] || 1, P[4] || 0, P[5] || 0, P[6] || 0, te);
            }
          }
          return new Date(F);
        }(k), this.init();
      }, w.init = function() {
        var k = this.$d;
        this.$y = k.getFullYear(), this.$M = k.getMonth(), this.$D = k.getDate(), this.$W = k.getDay(), this.$H = k.getHours(), this.$m = k.getMinutes(), this.$s = k.getSeconds(), this.$ms = k.getMilliseconds();
      }, w.$utils = function() {
        return A;
      }, w.isValid = function() {
        return this.$d.toString() !== D;
      }, w.isSame = function(k, T) {
        var F = W(k);
        return this.startOf(T) <= F && F <= this.endOf(T);
      }, w.isAfter = function(k, T) {
        return W(k) < this.startOf(T);
      }, w.isBefore = function(k, T) {
        return this.endOf(T) < W(k);
      }, w.$g = function(k, T, F) {
        return A.u(k) ? this[T] : this.set(F, k);
      }, w.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, w.valueOf = function() {
        return this.$d.getTime();
      }, w.startOf = function(k, T) {
        var F = this, I = !!A.u(T) || T, P = A.p(k), Y = function($e, Me) {
          var Ie = A.w(F.$u ? Date.UTC(F.$y, Me, $e) : new Date(F.$y, Me, $e), F);
          return I ? Ie : Ie.endOf(l);
        }, te = function($e, Me) {
          return A.w(F.toDate()[$e].apply(F.toDate("s"), (I ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Me)), F);
        }, we = this.$W, se = this.$M, ae = this.$D, De = "set" + (this.$u ? "UTC" : "");
        switch (P) {
          case f:
            return I ? Y(1, 0) : Y(31, 11);
          case h:
            return I ? Y(1, se) : Y(0, se + 1);
          case d:
            var he = this.$locale().weekStart || 0, ye = (we < he ? we + 7 : we) - he;
            return Y(I ? ae - ye : ae + (6 - ye), se);
          case l:
          case g:
            return te(De + "Hours", 0);
          case i:
            return te(De + "Minutes", 1);
          case s:
            return te(De + "Seconds", 2);
          case o:
            return te(De + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, w.endOf = function(k) {
        return this.startOf(k, !1);
      }, w.$set = function(k, T) {
        var F, I = A.p(k), P = "set" + (this.$u ? "UTC" : ""), Y = (F = {}, F[l] = P + "Date", F[g] = P + "Date", F[h] = P + "Month", F[f] = P + "FullYear", F[i] = P + "Hours", F[s] = P + "Minutes", F[o] = P + "Seconds", F[a] = P + "Milliseconds", F)[I], te = I === l ? this.$D + (T - this.$W) : T;
        if (I === h || I === f) {
          var we = this.clone().set(g, 1);
          we.$d[Y](te), we.init(), this.$d = we.set(g, Math.min(this.$D, we.daysInMonth())).$d;
        } else
          Y && this.$d[Y](te);
        return this.init(), this;
      }, w.set = function(k, T) {
        return this.clone().$set(k, T);
      }, w.get = function(k) {
        return this[A.p(k)]();
      }, w.add = function(k, T) {
        var F, I = this;
        k = Number(k);
        var P = A.p(T), Y = function(se) {
          var ae = W(I);
          return A.w(ae.date(ae.date() + Math.round(se * k)), I);
        };
        if (P === h)
          return this.set(h, this.$M + k);
        if (P === f)
          return this.set(f, this.$y + k);
        if (P === l)
          return Y(1);
        if (P === d)
          return Y(7);
        var te = (F = {}, F[s] = u, F[i] = n, F[o] = e, F)[P] || 1, we = this.$d.getTime() + k * te;
        return A.w(we, this);
      }, w.subtract = function(k, T) {
        return this.add(-1 * k, T);
      }, w.format = function(k) {
        var T = this, F = this.$locale();
        if (!this.isValid())
          return F.invalidDate || D;
        var I = k || "YYYY-MM-DDTHH:mm:ssZ", P = A.z(this), Y = this.$H, te = this.$m, we = this.$M, se = F.weekdays, ae = F.months, De = F.meridiem, he = function(Me, Ie, je, dt) {
          return Me && (Me[Ie] || Me(T, I)) || je[Ie].slice(0, dt);
        }, ye = function(Me) {
          return A.s(Y % 12 || 12, Me, "0");
        }, $e = De || function(Me, Ie, je) {
          var dt = Me < 12 ? "AM" : "PM";
          return je ? dt.toLowerCase() : dt;
        };
        return I.replace(O, function(Me, Ie) {
          return Ie || function(je) {
            switch (je) {
              case "YY":
                return String(T.$y).slice(-2);
              case "YYYY":
                return A.s(T.$y, 4, "0");
              case "M":
                return we + 1;
              case "MM":
                return A.s(we + 1, 2, "0");
              case "MMM":
                return he(F.monthsShort, we, ae, 3);
              case "MMMM":
                return he(ae, we);
              case "D":
                return T.$D;
              case "DD":
                return A.s(T.$D, 2, "0");
              case "d":
                return String(T.$W);
              case "dd":
                return he(F.weekdaysMin, T.$W, se, 2);
              case "ddd":
                return he(F.weekdaysShort, T.$W, se, 3);
              case "dddd":
                return se[T.$W];
              case "H":
                return String(Y);
              case "HH":
                return A.s(Y, 2, "0");
              case "h":
                return ye(1);
              case "hh":
                return ye(2);
              case "a":
                return $e(Y, te, !0);
              case "A":
                return $e(Y, te, !1);
              case "m":
                return String(te);
              case "mm":
                return A.s(te, 2, "0");
              case "s":
                return String(T.$s);
              case "ss":
                return A.s(T.$s, 2, "0");
              case "SSS":
                return A.s(T.$ms, 3, "0");
              case "Z":
                return P;
            }
            return null;
          }(Me) || P.replace(":", "");
        });
      }, w.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, w.diff = function(k, T, F) {
        var I, P = this, Y = A.p(T), te = W(k), we = (te.utcOffset() - this.utcOffset()) * u, se = this - te, ae = function() {
          return A.m(P, te);
        };
        switch (Y) {
          case f:
            I = ae() / 12;
            break;
          case h:
            I = ae();
            break;
          case c:
            I = ae() / 3;
            break;
          case d:
            I = (se - we) / 6048e5;
            break;
          case l:
            I = (se - we) / 864e5;
            break;
          case i:
            I = se / n;
            break;
          case s:
            I = se / u;
            break;
          case o:
            I = se / e;
            break;
          default:
            I = se;
        }
        return F ? I : A.a(I);
      }, w.daysInMonth = function() {
        return this.endOf(h).$D;
      }, w.$locale = function() {
        return X[this.$L];
      }, w.locale = function(k, T) {
        if (!k)
          return this.$L;
        var F = this.clone(), I = oe(k, T, !0);
        return I && (F.$L = I), F;
      }, w.clone = function() {
        return A.w(this.$d, this);
      }, w.toDate = function() {
        return new Date(this.valueOf());
      }, w.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, w.toISOString = function() {
        return this.$d.toISOString();
      }, w.toString = function() {
        return this.$d.toUTCString();
      }, $;
    }(), S = E.prototype;
    return W.prototype = S, [["$ms", a], ["$s", o], ["$m", s], ["$H", i], ["$W", l], ["$M", h], ["$y", f], ["$D", g]].forEach(function($) {
      S[$[1]] = function(w) {
        return this.$g(w, $[0], $[1]);
      };
    }), W.extend = function($, w) {
      return $.$i || ($(w, E, W), $.$i = !0), W;
    }, W.locale = oe, W.isDayjs = V, W.unix = function($) {
      return W(1e3 * $);
    }, W.en = X[z], W.Ls = X, W.p = {}, W;
  });
})(cc);
var uh = cc.exports;
const ur = /* @__PURE__ */ xn(uh), nh = /* @__PURE__ */ ue({
  __name: "VDateField",
  props: /* @__PURE__ */ lt({
    withTime: { type: Boolean },
    parentConfig: {},
    modelValue: {},
    placeholder: {},
    foreground: { type: Boolean },
    borderless: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    helpText: {},
    description: {},
    disabled: { type: Boolean },
    size: {},
    color: {},
    warning: {},
    infoText: {},
    inputMode: {}
  }, {
    withTime: !1,
    modelValue: "",
    foreground: !1,
    parentConfig: () => ({}),
    ...ct,
    placeholder: ""
  }),
  emits: ["update:modelValue", "paste"],
  setup(r, { emit: t }) {
    const e = r, u = G(() => e.placeholder ? e.placeholder : e.withTime ? "" : "mm/dd/yyyy"), n = t, a = G(() => ({
      allowInput: !e.withTime,
      altFormat: e.withTime ? "Y/m/d H:i:S" : "m/d/Y",
      dateFormat: e.withTime ? "Y/m/d H:i:S" : "m/d/Y",
      altInput: !0,
      wrap: !0,
      enableTime: e.withTime,
      disableMobile: !0,
      time_24hr: !1,
      minuteIncrement: 1,
      ...e.parentConfig
    })), o = G({
      get() {
        const h = ur(e.modelValue, e.withTime ? [
          "YYYY-MM-DD HH:mm:ss"
        ] : [
          "YYYY-MM-DD",
          "MM/DD/YYYY"
        ]);
        return h.isValid() ? h.format(e.withTime ? "YYYY-MM-DD HH:mm:ss" : "MM-DD-YYYY") : "";
      },
      set(h) {
        const c = ur(h), f = c.isValid();
        if (!(f && e.modelValue === c.format(e.withTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD")))
          return f ? n("update:modelValue", c.format(e.withTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD")) : n("update:modelValue", h);
      }
    }), s = Q(null);
    wu(() => {
      var h, c;
      (c = (h = s.value) == null ? void 0 : h.fp) != null && c.altInput && s.value.fp.altInput.addEventListener("paste", (f) => {
        n("paste", f);
      });
    });
    const i = () => {
      o.value = "";
    }, l = () => {
      o.value = ur().toISOString();
    }, d = be();
    return (h, c) => (m(), H(p(Lr), {
      class: b([
        p(d)["v-date-field"],
        p(d)[`v-date-field--${h.size}`]
      ]),
      label: h.label,
      "with-error": h.withError,
      error: h.error,
      "show-required-star": h.showRequiredStar,
      color: h.color,
      description: h.description,
      disabled: h.disabled,
      "help-text": h.helpText,
      warning: h.warning,
      "info-text": h.infoText
    }, {
      default: J(() => [
        C("div", {
          class: b([
            p(d)["v-date-field__field-wrapper"],
            {
              [p(d)["v-date-field__field-wrapper--foreground"]]: h.foreground,
              [p(d)["v-date-field__field-wrapper--disabled"]]: h.disabled
            }
          ])
        }, [
          C("div", {
            class: b(p(d)["v-date-field__flat-icon-wrapper"])
          }, [
            j(Y3, {
              height: "20",
              width: "20"
            })
          ], 2),
          j(p(lc), {
            ref_key: "flatpickr",
            ref: s,
            modelValue: o.value,
            "onUpdate:modelValue": c[0] || (c[0] = (f) => o.value = f),
            class: b([
              p(d)["v-date-field__flat-pickr"],
              {
                [p(d)["v-date-field__flat-pickr--disabled"]]: h.disabled
              }
            ]),
            config: a.value,
            disabled: h.disabled,
            placeholder: u.value
          }, null, 8, ["modelValue", "class", "config", "disabled", "placeholder"]),
          o.value ? (m(), H(Wt, {
            key: 0,
            class: b([
              p(d)["v-date-field__flat-close"],
              {
                [p(d)["v-date-field__flat-close--hide"]]: h.disabled
              }
            ]),
            height: "12",
            width: "12",
            onClick: i
          }, null, 8, ["class"])) : h.withTime ? (m(), H(p(vt), {
            key: 1,
            class: b([
              p(d)["v-date-field__flat-now"],
              {
                [p(d)["v-date-field__flat-now--hide"]]: h.disabled
              }
            ]),
            size: p(Pt).EXTRA_SMALL,
            disabled: h.disabled,
            onClick: l
          }, {
            default: J(() => c[1] || (c[1] = [
              ce(" Now ", -1)
            ])),
            _: 1,
            __: [1]
          }, 8, ["class", "size", "disabled"])) : R("", !0)
        ], 2)
      ]),
      _: 1
    }, 8, ["class", "label", "with-error", "error", "show-required-star", "color", "description", "disabled", "help-text", "warning", "info-text"]));
  }
}), ah = {
  "v-date-field": "_v-date-field_1xqwy_1",
  "v-date-field__flat-pickr": "_v-date-field__flat-pickr_1xqwy_1",
  "v-date-field__flat-pickr--disabled": "_v-date-field__flat-pickr--disabled_1xqwy_24",
  "v-date-field__field-wrapper": "_v-date-field__field-wrapper_1xqwy_40",
  "v-date-field__field-wrapper--disabled": "_v-date-field__field-wrapper--disabled_1xqwy_43",
  "v-date-field__field-wrapper--foreground": "_v-date-field__field-wrapper--foreground_1xqwy_52",
  "v-date-field__flat-icon-wrapper": "_v-date-field__flat-icon-wrapper_1xqwy_58",
  "v-date-field__flat-close": "_v-date-field__flat-close_1xqwy_70",
  "v-date-field__flat-close--hide": "_v-date-field__flat-close--hide_1xqwy_79",
  "v-date-field__flat-now": "_v-date-field__flat-now_1xqwy_83",
  "v-date-field__flat-now--hide": "_v-date-field__flat-now--hide_1xqwy_91",
  "v-date-field--medium": "_v-date-field--medium_1xqwy_96",
  "v-date-field--large": "_v-date-field--large_1xqwy_100"
}, ih = {
  $style: ah
}, oh = /* @__PURE__ */ U(nh, [["__cssModules", ih]]), Nx = /* @__PURE__ */ ue({
  __name: "VDatetimeField",
  props: /* @__PURE__ */ lt({
    parentConfig: {},
    modelValue: {},
    placeholder: {},
    foreground: { type: Boolean },
    borderless: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    helpText: {},
    description: {},
    disabled: { type: Boolean },
    size: {},
    color: {},
    warning: {},
    infoText: {},
    inputMode: {}
  }, {
    modelValue: "",
    foreground: !1,
    parentConfig: () => ({}),
    ...ct,
    placeholder: ""
  }),
  emits: ["update:modelValue"],
  setup(r, { emit: t }) {
    const e = r, u = t;
    return (n, a) => (m(), H(p(oh), Te(e, {
      "model-value": n.modelValue,
      "with-time": "",
      "onUpdate:modelValue": a[0] || (a[0] = (o) => u("update:modelValue", o))
    }), null, 16, ["model-value"]));
  }
}), sh = {}, lh = {
  width: "18",
  height: "12",
  viewBox: "0 0 18 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ch(r, t) {
  return m(), x("svg", lh, t[0] || (t[0] = [
    C("path", {
      d: "M4.98125 0.818182V11H3.44005V2.35938H3.38039L0.944314 3.95028V2.47869L3.4848 0.818182H4.98125ZM8.14691 11.0945C7.87513 11.0945 7.64146 10.9983 7.44591 10.8061C7.25036 10.6106 7.15259 10.3752 7.15259 10.1001C7.15259 9.82836 7.25036 9.59635 7.44591 9.40412C7.64146 9.20857 7.87513 9.1108 8.14691 9.1108C8.41869 9.1108 8.65235 9.20857 8.8479 9.40412C9.04345 9.59635 9.14122 9.82836 9.14122 10.1001C9.14122 10.2824 9.09482 10.4498 9.00202 10.6023C8.91253 10.7514 8.79321 10.8707 8.64407 10.9602C8.49492 11.0497 8.3292 11.0945 8.14691 11.0945ZM11.1125 11V9.88636L14.5578 6.31676C14.9257 5.92898 15.2289 5.58925 15.4676 5.29759C15.7095 5.0026 15.8902 4.72254 16.0095 4.45739C16.1288 4.19223 16.1885 3.91051 16.1885 3.61222C16.1885 3.27415 16.1089 2.98248 15.9498 2.73722C15.7907 2.48864 15.5736 2.29806 15.2985 2.16548C15.0234 2.02959 14.7135 1.96165 14.3689 1.96165C14.0043 1.96165 13.6861 2.03622 13.4143 2.18537C13.1425 2.33452 12.9337 2.54498 12.7879 2.81676C12.6421 3.08854 12.5691 3.40672 12.5691 3.77131H11.1025C11.1025 3.15151 11.245 2.60961 11.5301 2.1456C11.8151 1.68158 12.2062 1.32197 12.7034 1.06676C13.2005 0.808238 13.7656 0.678977 14.3987 0.678977C15.0384 0.678977 15.6018 0.806581 16.089 1.06179C16.5796 1.31368 16.9624 1.65838 17.2375 2.09588C17.5126 2.53007 17.6501 3.0206 17.6501 3.56747C17.6501 3.94531 17.5788 4.31487 17.4363 4.67614C17.2971 5.0374 17.0535 5.4401 16.7055 5.88423C16.3575 6.32505 15.8736 6.86032 15.2538 7.49006L13.2304 9.60795V9.68253H17.8142V11H11.1125Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const dh = /* @__PURE__ */ U(sh, [["render", ch]]), dc = /* @__PURE__ */ ue({
  __name: "VNumberField",
  props: /* @__PURE__ */ lt({
    modelValue: {},
    foreground: { type: Boolean },
    suffixIcon: {},
    prefixIcon: {},
    borderless: { type: Boolean },
    allowPositiveNumbers: { type: Boolean },
    skipFormatting: { type: Boolean },
    autofocus: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    helpText: {},
    description: {},
    placeholder: {},
    disabled: { type: Boolean },
    size: {},
    color: {},
    warning: {},
    infoText: {},
    inputMode: {}
  }, {
    foreground: !1,
    suffixIcon: null,
    prefixIcon: dh,
    allowPositiveNumbers: !1,
    skipFormatting: !1,
    ...ct
  }),
  emits: ["update:modelValue", "paste"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = (i) => i.replaceAll(",", ""), a = G({
      get() {
        if (e.skipFormatting)
          return String(e.modelValue || "");
        if (typeof e.modelValue == "object")
          return "";
        if (e.modelValue === "-")
          return e.modelValue;
        const i = `${e.modelValue}`;
        if (i != null && i.length) {
          const [l, d] = i.replaceAll("%", "").split("."), h = Intl.NumberFormat(
            "en-EN",
            { minimumFractionDigits: 0, maximumFractionDigits: 0 }
          ).format(Number(n(l)));
          return typeof d == "string" ? `${h}.${d || ""}` : h;
        }
        return "";
      },
      set(i) {
        i === "-" ? u("update:modelValue", "-") : Number.isNaN(Number(n(i))) || u("update:modelValue", n(i));
      }
    }), o = Q(null), s = (i) => {
      var f;
      e.allowPositiveNumbers && (i = i.replace(/[^0-9.]/g, ""));
      const l = (f = o.value) == null ? void 0 : f.inputField, d = (l == null ? void 0 : l.selectionStart) || 0, h = a.value.slice(0, d).split(",").length;
      if (i.startsWith(".") ? a.value = `0.${i.slice(1)}` : i.startsWith("-.") ? a.value = `-0.${i.slice(2)}` : a.value = i, !d && !l)
        return;
      const c = [".", "-."].some((g) => i.startsWith(g));
      Pe(() => {
        const D = h !== a.value.slice(0, d).split(",").length || c ? d + 1 : d;
        l.focus(), l.setSelectionRange(D, D);
      });
    };
    return (i, l) => (m(), H(p(Fr), {
      ref_key: "numberField",
      ref: o,
      "model-value": a.value,
      label: i.label,
      foreground: i.foreground,
      "show-required-star": i.showRequiredStar,
      error: i.error,
      "with-error": i.withError,
      "is-number": "",
      disabled: i.disabled,
      "suffix-icon": i.suffixIcon,
      "prefix-icon": i.prefixIcon,
      borderless: i.borderless,
      color: i.color,
      description: i.description,
      "help-text": i.helpText,
      size: i.size,
      autofocus: i.autofocus,
      inputMode: "decimal",
      "onUpdate:modelValue": l[0] || (l[0] = (d) => s(d)),
      onPaste: l[1] || (l[1] = (d) => u("paste", d))
    }, null, 8, ["model-value", "label", "foreground", "show-required-star", "error", "with-error", "disabled", "suffix-icon", "prefix-icon", "borderless", "color", "description", "help-text", "size", "autofocus"]));
  }
}), fh = {}, ph = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "16",
  width: "16",
  viewBox: "0 0 16 16"
};
function hh(r, t) {
  return m(), x("svg", ph, t[0] || (t[0] = [
    C("g", {
      "stroke-width": "1",
      "stroke-linejoin": "round",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round"
    }, [
      C("line", {
        x1: "3",
        y1: "14.5",
        x2: "13",
        y2: "1.5",
        stroke: "currentColor"
      }),
      C("circle", {
        cx: "4.5",
        cy: "4",
        r: "2.5"
      }),
      C("circle", {
        cx: "11.5",
        cy: "12",
        r: "2.5"
      })
    ], -1)
  ]));
}
const mh = /* @__PURE__ */ U(fh, [["render", hh]]), qx = /* @__PURE__ */ ue({
  __name: "VPercentField",
  props: /* @__PURE__ */ lt({
    modelValue: {},
    foreground: { type: Boolean },
    prefixIcon: {},
    borderless: { type: Boolean },
    allowPositiveNumbers: { type: Boolean },
    skipFormatting: { type: Boolean },
    autofocus: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    helpText: {},
    description: {},
    placeholder: {},
    disabled: { type: Boolean },
    size: {},
    color: {},
    warning: {},
    infoText: {},
    inputMode: {}
  }, {
    foreground: !1,
    autofocus: !1,
    ...ct
  }),
  emits: ["update:model-value", "paste"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G({
      get() {
        return e.modelValue;
      },
      set(a) {
        u("update:model-value", a);
      }
    });
    return (a, o) => (m(), H(p(dc), {
      modelValue: n.value,
      "onUpdate:modelValue": o[0] || (o[0] = (s) => n.value = s),
      error: a.error,
      "show-required-star": a.showRequiredStar,
      "with-error": a.withError,
      label: a.label,
      foreground: a.foreground,
      disabled: a.disabled,
      borderless: a.borderless,
      color: a.color,
      description: a.description,
      "help-text": a.helpText,
      size: a.size,
      "prefix-icon": null,
      "suffix-icon": mh,
      autofocus: a.autofocus,
      onPaste: o[1] || (o[1] = (s) => u("paste", s))
    }, null, 8, ["modelValue", "error", "show-required-star", "with-error", "label", "foreground", "disabled", "borderless", "color", "description", "help-text", "size", "autofocus"]));
  }
}), vh = {}, gh = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "16",
  width: "16",
  viewBox: "0 0 16 16"
};
function bh(r, t) {
  return m(), x("svg", gh, t[0] || (t[0] = [
    C("g", {
      "stroke-width": "1",
      "stroke-linejoin": "round",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round"
    }, [
      C("line", {
        x1: "8",
        y1: "0.5",
        x2: "8",
        y2: "15.5",
        stroke: "currentColor"
      }),
      C("path", { d: "M11.5,3C9.5,1.992,4,1.539,4,5c0,3.525,8,2.005,8,6,0,3.387-5.716,3.2-8,2" })
    ], -1)
  ]));
}
const yh = /* @__PURE__ */ U(vh, [["render", bh]]), Px = /* @__PURE__ */ ue({
  __name: "VCurrencyField",
  props: /* @__PURE__ */ lt({
    modelValue: {},
    foreground: { type: Boolean },
    prefixIcon: {},
    borderless: { type: Boolean },
    allowPositiveNumbers: { type: Boolean },
    skipFormatting: { type: Boolean },
    autofocus: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    helpText: {},
    description: {},
    placeholder: {},
    disabled: { type: Boolean },
    size: {},
    color: {},
    warning: {},
    infoText: {},
    inputMode: {}
  }, {
    foreground: !1,
    ...ct
  }),
  emits: ["update:model-value", "paste"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G({
      get() {
        return e.modelValue;
      },
      set(a) {
        u("update:model-value", a);
      }
    });
    return (a, o) => (m(), H(p(dc), {
      modelValue: n.value,
      "onUpdate:modelValue": o[0] || (o[0] = (s) => n.value = s),
      error: a.error,
      "show-required-star": a.showRequiredStar,
      "with-error": a.withError,
      borderless: a.borderless,
      label: a.label,
      foreground: a.foreground,
      disabled: a.disabled,
      color: a.color,
      size: a.size,
      description: a.description,
      "help-text": a.helpText,
      autofocus: a.autofocus,
      "prefix-icon": yh,
      onPaste: o[1] || (o[1] = (s) => u("paste", s))
    }, null, 8, ["modelValue", "error", "show-required-star", "with-error", "borderless", "label", "foreground", "disabled", "color", "size", "description", "help-text", "autofocus"]));
  }
});
var _h = Object.defineProperty, wh = Object.defineProperties, Ch = Object.getOwnPropertyDescriptors, Eo = Object.getOwnPropertySymbols, Dh = Object.prototype.hasOwnProperty, Ah = Object.prototype.propertyIsEnumerable, ko = (r, t, e) => t in r ? _h(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, _r = (r, t) => {
  for (var e in t || (t = {}))
    Dh.call(t, e) && ko(r, e, t[e]);
  if (Eo)
    for (var e of Eo(t))
      Ah.call(t, e) && ko(r, e, t[e]);
  return r;
}, So = (r, t) => wh(r, Ch(t));
const xh = {
  props: {
    autoscroll: {
      type: Boolean,
      default: !0
    }
  },
  watch: {
    typeAheadPointer() {
      this.autoscroll && this.maybeAdjustScroll();
    },
    open(r) {
      this.autoscroll && r && this.$nextTick(() => this.maybeAdjustScroll());
    }
  },
  methods: {
    maybeAdjustScroll() {
      var r;
      const t = ((r = this.$refs.dropdownMenu) == null ? void 0 : r.children[this.typeAheadPointer]) || !1;
      if (t) {
        const e = this.getDropdownViewport(), { top: u, bottom: n, height: a } = t.getBoundingClientRect();
        if (u < e.top)
          return this.$refs.dropdownMenu.scrollTop = t.offsetTop;
        if (n > e.bottom)
          return this.$refs.dropdownMenu.scrollTop = t.offsetTop - (e.height - a);
      }
    },
    getDropdownViewport() {
      return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : {
        height: 0,
        top: 0,
        bottom: 0
      };
    }
  }
}, Eh = {
  data() {
    return {
      typeAheadPointer: -1
    };
  },
  watch: {
    filteredOptions() {
      for (let r = 0; r < this.filteredOptions.length; r++)
        if (this.selectable(this.filteredOptions[r])) {
          this.typeAheadPointer = r;
          break;
        }
    },
    open(r) {
      r && this.typeAheadToLastSelected();
    },
    selectedValue() {
      this.open && this.typeAheadToLastSelected();
    }
  },
  methods: {
    typeAheadUp() {
      for (let r = this.typeAheadPointer - 1; r >= 0; r--)
        if (this.selectable(this.filteredOptions[r])) {
          this.typeAheadPointer = r;
          break;
        }
    },
    typeAheadDown() {
      for (let r = this.typeAheadPointer + 1; r < this.filteredOptions.length; r++)
        if (this.selectable(this.filteredOptions[r])) {
          this.typeAheadPointer = r;
          break;
        }
    },
    typeAheadSelect() {
      const r = this.filteredOptions[this.typeAheadPointer];
      r && this.selectable(r) && this.select(r);
    },
    typeAheadToLastSelected() {
      this.typeAheadPointer = this.selectedValue.length !== 0 ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;
    }
  }
}, kh = {
  props: {
    loading: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      mutableLoading: !1
    };
  },
  watch: {
    search() {
      this.$emit("search", this.search, this.toggleLoading);
    },
    loading(r) {
      this.mutableLoading = r;
    }
  },
  methods: {
    toggleLoading(r = null) {
      return r == null ? this.mutableLoading = !this.mutableLoading : this.mutableLoading = r;
    }
  }
}, mi = (r, t) => {
  const e = r.__vccOpts || r;
  for (const [u, n] of t)
    e[u] = n;
  return e;
}, Sh = {}, Th = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10"
}, Bh = /* @__PURE__ */ C("path", { d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" }, null, -1), $h = [
  Bh
];
function Mh(r, t) {
  return m(), x("svg", Th, $h);
}
const Oh = /* @__PURE__ */ mi(Sh, [["render", Mh]]), Lh = {}, Fh = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10"
}, Ih = /* @__PURE__ */ C("path", { d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z" }, null, -1), Nh = [
  Ih
];
function qh(r, t) {
  return m(), x("svg", Fh, Nh);
}
const Ph = /* @__PURE__ */ mi(Lh, [["render", qh]]), To = {
  Deselect: Oh,
  OpenIndicator: Ph
}, Rh = {
  mounted(r, { instance: t }) {
    if (t.appendToBody) {
      const {
        height: e,
        top: u,
        left: n,
        width: a
      } = t.$refs.toggle.getBoundingClientRect();
      let o = window.scrollX || window.pageXOffset, s = window.scrollY || window.pageYOffset;
      r.unbindPosition = t.calculatePosition(r, t, {
        width: a + "px",
        left: o + n + "px",
        top: s + u + e + "px"
      }), document.body.appendChild(r);
    }
  },
  unmounted(r, { instance: t }) {
    t.appendToBody && (r.unbindPosition && typeof r.unbindPosition == "function" && r.unbindPosition(), r.parentNode && r.parentNode.removeChild(r));
  }
};
function Vh(r) {
  const t = {};
  return Object.keys(r).sort().forEach((e) => {
    t[e] = r[e];
  }), JSON.stringify(t);
}
let jh = 0;
function Hh() {
  return ++jh;
}
const Uh = {
  components: _r({}, To),
  directives: { appendToBody: Rh },
  mixins: [xh, Eh, kh],
  compatConfig: {
    MODE: 3
  },
  emits: [
    "open",
    "close",
    "update:modelValue",
    "search",
    "search:compositionstart",
    "search:compositionend",
    "search:keydown",
    "search:blur",
    "search:focus",
    "search:input",
    "option:created",
    "option:selecting",
    "option:selected",
    "option:deselecting",
    "option:deselected"
  ],
  props: {
    modelValue: {},
    components: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !0
    },
    deselectFromDropdown: {
      type: Boolean,
      default: !1
    },
    searchable: {
      type: Boolean,
      default: !0
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    transition: {
      type: String,
      default: "vs__fade"
    },
    clearSearchOnSelect: {
      type: Boolean,
      default: !0
    },
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    label: {
      type: String,
      default: "label"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    reduce: {
      type: Function,
      default: (r) => r
    },
    selectable: {
      type: Function,
      default: (r) => !0
    },
    getOptionLabel: {
      type: Function,
      default(r) {
        return typeof r == "object" ? r.hasOwnProperty(this.label) ? r[this.label] : console.warn(`[vue-select warn]: Label key "option.${this.label}" does not exist in options object ${JSON.stringify(r)}.
https://vue-select.org/api/props.html#getoptionlabel`) : r;
      }
    },
    getOptionKey: {
      type: Function,
      default(r) {
        if (typeof r != "object")
          return r;
        try {
          return r.hasOwnProperty("id") ? r.id : Vh(r);
        } catch (t) {
          return console.warn(`[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.
https://vue-select.org/api/props.html#getoptionkey`, r, t);
        }
      }
    },
    onTab: {
      type: Function,
      default: function() {
        this.selectOnTab && !this.isComposing && this.typeAheadSelect();
      }
    },
    taggable: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    pushTags: {
      type: Boolean,
      default: !1
    },
    filterable: {
      type: Boolean,
      default: !0
    },
    filterBy: {
      type: Function,
      default(r, t, e) {
        return (t || "").toLocaleLowerCase().indexOf(e.toLocaleLowerCase()) > -1;
      }
    },
    filter: {
      type: Function,
      default(r, t) {
        return r.filter((e) => {
          let u = this.getOptionLabel(e);
          return typeof u == "number" && (u = u.toString()), this.filterBy(e, u, t);
        });
      }
    },
    createOption: {
      type: Function,
      default(r) {
        return typeof this.optionList[0] == "object" ? { [this.label]: r } : r;
      }
    },
    resetOnOptionsChange: {
      default: !1,
      validator: (r) => ["function", "boolean"].includes(typeof r)
    },
    clearSearchOnBlur: {
      type: Function,
      default: function({ clearSearchOnSelect: r, multiple: t }) {
        return r && !t;
      }
    },
    noDrop: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String
    },
    dir: {
      type: String,
      default: "auto"
    },
    selectOnTab: {
      type: Boolean,
      default: !1
    },
    selectOnKeyCodes: {
      type: Array,
      default: () => [13]
    },
    searchInputQuerySelector: {
      type: String,
      default: "[type=search]"
    },
    mapKeydown: {
      type: Function,
      default: (r, t) => r
    },
    appendToBody: {
      type: Boolean,
      default: !1
    },
    calculatePosition: {
      type: Function,
      default(r, t, { width: e, top: u, left: n }) {
        r.style.top = u, r.style.left = n, r.style.width = e;
      }
    },
    dropdownShouldOpen: {
      type: Function,
      default({ noDrop: r, open: t, mutableLoading: e }) {
        return r ? !1 : t && !e;
      }
    },
    uid: {
      type: [String, Number],
      default: () => Hh()
    }
  },
  data() {
    return {
      search: "",
      open: !1,
      isComposing: !1,
      pushedTags: [],
      _value: [],
      deselectButtons: []
    };
  },
  computed: {
    isReducingValues() {
      return this.$props.reduce !== this.$options.props.reduce.default;
    },
    isTrackingValues() {
      return typeof this.modelValue > "u" || this.isReducingValues;
    },
    selectedValue() {
      let r = this.modelValue;
      return this.isTrackingValues && (r = this.$data._value), r != null && r !== "" ? [].concat(r) : [];
    },
    optionList() {
      return this.options.concat(this.pushTags ? this.pushedTags : []);
    },
    searchEl() {
      return this.$slots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
    },
    scope() {
      const r = {
        search: this.search,
        loading: this.loading,
        searching: this.searching,
        filteredOptions: this.filteredOptions
      };
      return {
        search: {
          attributes: _r({
            disabled: this.disabled,
            placeholder: this.searchPlaceholder,
            tabindex: this.tabindex,
            readonly: !this.searchable,
            id: this.inputId,
            "aria-autocomplete": "list",
            "aria-labelledby": `vs${this.uid}__combobox`,
            "aria-controls": `vs${this.uid}__listbox`,
            ref: "search",
            type: "search",
            autocomplete: this.autocomplete,
            value: this.search
          }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? {
            "aria-activedescendant": `vs${this.uid}__option-${this.typeAheadPointer}`
          } : {}),
          events: {
            compositionstart: () => this.isComposing = !0,
            compositionend: () => this.isComposing = !1,
            keydown: this.onSearchKeyDown,
            blur: this.onSearchBlur,
            focus: this.onSearchFocus,
            input: (t) => this.search = t.target.value
          }
        },
        spinner: {
          loading: this.mutableLoading
        },
        noOptions: {
          search: this.search,
          loading: this.mutableLoading,
          searching: this.searching
        },
        openIndicator: {
          attributes: {
            ref: "openIndicator",
            role: "presentation",
            class: "vs__open-indicator"
          }
        },
        listHeader: r,
        listFooter: r,
        header: So(_r({}, r), { deselect: this.deselect }),
        footer: So(_r({}, r), { deselect: this.deselect })
      };
    },
    childComponents() {
      return _r(_r({}, To), this.components);
    },
    stateClasses() {
      return {
        "vs--open": this.dropdownOpen,
        "vs--single": !this.multiple,
        "vs--multiple": this.multiple,
        "vs--searching": this.searching && !this.noDrop,
        "vs--searchable": this.searchable && !this.noDrop,
        "vs--unsearchable": !this.searchable,
        "vs--loading": this.mutableLoading,
        "vs--disabled": this.disabled
      };
    },
    searching() {
      return !!this.search;
    },
    dropdownOpen() {
      return this.dropdownShouldOpen(this);
    },
    searchPlaceholder() {
      return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
    },
    filteredOptions() {
      const r = [].concat(this.optionList);
      if (!this.filterable && !this.taggable)
        return r;
      const t = this.search.length ? this.filter(r, this.search, this) : r;
      if (this.taggable && this.search.length) {
        const e = this.createOption(this.search);
        this.optionExists(e) || t.unshift(e);
      }
      return t;
    },
    isValueEmpty() {
      return this.selectedValue.length === 0;
    },
    showClearButton() {
      return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
    }
  },
  watch: {
    options(r, t) {
      const e = () => typeof this.resetOnOptionsChange == "function" ? this.resetOnOptionsChange(r, t, this.selectedValue) : this.resetOnOptionsChange;
      !this.taggable && e() && this.clearSelection(), this.modelValue && this.isTrackingValues && this.setInternalValueFromOptions(this.modelValue);
    },
    modelValue: {
      immediate: !0,
      handler(r) {
        this.isTrackingValues && this.setInternalValueFromOptions(r);
      }
    },
    multiple() {
      this.clearSelection();
    },
    open(r) {
      this.$emit(r ? "open" : "close");
    }
  },
  created() {
    this.mutableLoading = this.loading;
  },
  methods: {
    setInternalValueFromOptions(r) {
      Array.isArray(r) ? this.$data._value = r.map((t) => this.findOptionFromReducedValue(t)) : this.$data._value = this.findOptionFromReducedValue(r);
    },
    select(r) {
      this.$emit("option:selecting", r), this.isOptionSelected(r) ? this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1) && this.deselect(r) : (this.taggable && !this.optionExists(r) && (this.$emit("option:created", r), this.pushTag(r)), this.multiple && (r = this.selectedValue.concat(r)), this.updateValue(r), this.$emit("option:selected", r)), this.onAfterSelect(r);
    },
    deselect(r) {
      this.$emit("option:deselecting", r), this.updateValue(this.selectedValue.filter((t) => !this.optionComparator(t, r))), this.$emit("option:deselected", r);
    },
    clearSelection() {
      this.updateValue(this.multiple ? [] : null);
    },
    onAfterSelect(r) {
      this.closeOnSelect && (this.open = !this.open, this.searchEl.blur()), this.clearSearchOnSelect && (this.search = "");
    },
    updateValue(r) {
      typeof this.modelValue > "u" && (this.$data._value = r), r !== null && (Array.isArray(r) ? r = r.map((t) => this.reduce(t)) : r = this.reduce(r)), this.$emit("update:modelValue", r);
    },
    toggleDropdown(r) {
      const t = r.target !== this.searchEl;
      t && r.preventDefault();
      const e = [
        ...this.deselectButtons || [],
        this.$refs.clearButton
      ];
      if (this.searchEl === void 0 || e.filter(Boolean).some((u) => u.contains(r.target) || u === r.target)) {
        r.preventDefault();
        return;
      }
      this.open && t ? this.searchEl.blur() : this.disabled || (this.open = !0, this.searchEl.focus());
    },
    isOptionSelected(r) {
      return this.selectedValue.some((t) => this.optionComparator(t, r));
    },
    isOptionDeselectable(r) {
      return this.isOptionSelected(r) && this.deselectFromDropdown;
    },
    optionComparator(r, t) {
      return this.getOptionKey(r) === this.getOptionKey(t);
    },
    findOptionFromReducedValue(r) {
      const t = (u) => JSON.stringify(this.reduce(u)) === JSON.stringify(r), e = [...this.options, ...this.pushedTags].filter(t);
      return e.length === 1 ? e[0] : e.find((u) => this.optionComparator(u, this.$data._value)) || r;
    },
    closeSearchOptions() {
      this.open = !1, this.$emit("search:blur");
    },
    maybeDeleteValue() {
      if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
        let r = null;
        this.multiple && (r = [
          ...this.selectedValue.slice(0, this.selectedValue.length - 1)
        ]), this.updateValue(r);
      }
    },
    optionExists(r) {
      return this.optionList.some((t) => this.optionComparator(t, r));
    },
    normalizeOptionForSlot(r) {
      return typeof r == "object" ? r : { [this.label]: r };
    },
    pushTag(r) {
      this.pushedTags.push(r);
    },
    onEscape() {
      this.search.length ? this.search = "" : this.searchEl.blur();
    },
    onSearchBlur() {
      if (this.mousedown && !this.searching)
        this.mousedown = !1;
      else {
        const { clearSearchOnSelect: r, multiple: t } = this;
        this.clearSearchOnBlur({ clearSearchOnSelect: r, multiple: t }) && (this.search = ""), this.closeSearchOptions();
        return;
      }
      if (this.search.length === 0 && this.options.length === 0) {
        this.closeSearchOptions();
        return;
      }
    },
    onSearchFocus() {
      this.open = !0, this.$emit("search:focus");
    },
    onMousedown() {
      this.mousedown = !0;
    },
    onMouseUp() {
      this.mousedown = !1;
    },
    onSearchKeyDown(r) {
      const t = (n) => (n.preventDefault(), !this.isComposing && this.typeAheadSelect()), e = {
        8: (n) => this.maybeDeleteValue(),
        9: (n) => this.onTab(),
        27: (n) => this.onEscape(),
        38: (n) => (n.preventDefault(), this.typeAheadUp()),
        40: (n) => (n.preventDefault(), this.typeAheadDown())
      };
      this.selectOnKeyCodes.forEach((n) => e[n] = t);
      const u = this.mapKeydown(e, this);
      if (typeof u[r.keyCode] == "function")
        return u[r.keyCode](r);
    }
  }
}, zh = ["dir"], Gh = ["id", "aria-expanded", "aria-owns"], Wh = {
  ref: "selectedOptions",
  class: "vs__selected-options"
}, Yh = ["disabled", "title", "aria-label", "onClick"], Zh = {
  ref: "actions",
  class: "vs__actions"
}, Kh = ["disabled"], Xh = { class: "vs__spinner" }, Jh = ["id"], Qh = ["id", "aria-selected", "onMouseover", "onClick"], e4 = {
  key: 0,
  class: "vs__no-options"
}, t4 = /* @__PURE__ */ ce(" Sorry, no matching options. "), r4 = ["id"];
function u4(r, t, e, u, n, a) {
  const o = Ds("append-to-body");
  return m(), x("div", {
    dir: e.dir,
    class: b(["v-select", a.stateClasses])
  }, [
    K(r.$slots, "header", Le(Ne(a.scope.header))),
    C("div", {
      id: `vs${e.uid}__combobox`,
      ref: "toggle",
      class: "vs__dropdown-toggle",
      role: "combobox",
      "aria-expanded": a.dropdownOpen.toString(),
      "aria-owns": `vs${e.uid}__listbox`,
      "aria-label": "Search for option",
      onMousedown: t[1] || (t[1] = (s) => a.toggleDropdown(s))
    }, [
      C("div", Wh, [
        (m(!0), x(pe, null, ge(a.selectedValue, (s, i) => K(r.$slots, "selected-option-container", {
          option: a.normalizeOptionForSlot(s),
          deselect: a.deselect,
          multiple: e.multiple,
          disabled: e.disabled
        }, () => [
          (m(), x("span", {
            key: e.getOptionKey(s),
            class: "vs__selected"
          }, [
            K(r.$slots, "selected-option", Le(Ne(a.normalizeOptionForSlot(s))), () => [
              ce(ne(e.getOptionLabel(s)), 1)
            ]),
            e.multiple ? (m(), x("button", {
              key: 0,
              ref_for: !0,
              ref: (l) => n.deselectButtons[i] = l,
              disabled: e.disabled,
              type: "button",
              class: "vs__deselect",
              title: `Deselect ${e.getOptionLabel(s)}`,
              "aria-label": `Deselect ${e.getOptionLabel(s)}`,
              onClick: (l) => a.deselect(s)
            }, [
              (m(), H(He(a.childComponents.Deselect)))
            ], 8, Yh)) : R("", !0)
          ]))
        ])), 256)),
        K(r.$slots, "search", Le(Ne(a.scope.search)), () => [
          C("input", Te({ class: "vs__search" }, a.scope.search.attributes, As(a.scope.search.events)), null, 16)
        ])
      ], 512),
      C("div", Zh, [
        Xe(C("button", {
          ref: "clearButton",
          disabled: e.disabled,
          type: "button",
          class: "vs__clear",
          title: "Clear Selected",
          "aria-label": "Clear Selected",
          onClick: t[0] || (t[0] = (...s) => a.clearSelection && a.clearSelection(...s))
        }, [
          (m(), H(He(a.childComponents.Deselect)))
        ], 8, Kh), [
          [iu, a.showClearButton]
        ]),
        K(r.$slots, "open-indicator", Le(Ne(a.scope.openIndicator)), () => [
          e.noDrop ? R("", !0) : (m(), H(He(a.childComponents.OpenIndicator), Le(Te({ key: 0 }, a.scope.openIndicator.attributes)), null, 16))
        ]),
        K(r.$slots, "spinner", Le(Ne(a.scope.spinner)), () => [
          Xe(C("div", Xh, "Loading...", 512), [
            [iu, r.mutableLoading]
          ])
        ])
      ], 512)
    ], 40, Gh),
    j(_0, { name: e.transition }, {
      default: J(() => [
        a.dropdownOpen ? Xe((m(), x("ul", {
          id: `vs${e.uid}__listbox`,
          ref: "dropdownMenu",
          key: `vs${e.uid}__listbox`,
          class: "vs__dropdown-menu",
          role: "listbox",
          tabindex: "-1",
          onMousedown: t[2] || (t[2] = ot((...s) => a.onMousedown && a.onMousedown(...s), ["prevent"])),
          onMouseup: t[3] || (t[3] = (...s) => a.onMouseUp && a.onMouseUp(...s))
        }, [
          K(r.$slots, "list-header", Le(Ne(a.scope.listHeader))),
          (m(!0), x(pe, null, ge(a.filteredOptions, (s, i) => (m(), x("li", {
            id: `vs${e.uid}__option-${i}`,
            key: e.getOptionKey(s),
            role: "option",
            class: b(["vs__dropdown-option", {
              "vs__dropdown-option--deselect": a.isOptionDeselectable(s) && i === r.typeAheadPointer,
              "vs__dropdown-option--selected": a.isOptionSelected(s),
              "vs__dropdown-option--highlight": i === r.typeAheadPointer,
              "vs__dropdown-option--disabled": !e.selectable(s)
            }]),
            "aria-selected": i === r.typeAheadPointer ? !0 : null,
            onMouseover: (l) => e.selectable(s) ? r.typeAheadPointer = i : null,
            onClick: ot((l) => e.selectable(s) ? a.select(s) : null, ["prevent", "stop"])
          }, [
            K(r.$slots, "option", Le(Ne(a.normalizeOptionForSlot(s))), () => [
              ce(ne(e.getOptionLabel(s)), 1)
            ])
          ], 42, Qh))), 128)),
          a.filteredOptions.length === 0 ? (m(), x("li", e4, [
            K(r.$slots, "no-options", Le(Ne(a.scope.noOptions)), () => [
              t4
            ])
          ])) : R("", !0),
          K(r.$slots, "list-footer", Le(Ne(a.scope.listFooter)))
        ], 40, Jh)), [
          [o]
        ]) : (m(), x("ul", {
          key: 1,
          id: `vs${e.uid}__listbox`,
          role: "listbox",
          style: { display: "none", visibility: "hidden" }
        }, null, 8, r4))
      ]),
      _: 3
    }, 8, ["name"]),
    K(r.$slots, "footer", Le(Ne(a.scope.footer)))
  ], 10, zh);
}
const n4 = /* @__PURE__ */ mi(Uh, [["render", u4]]), a4 = /* @__PURE__ */ ue({
  __name: "VSelect",
  props: /* @__PURE__ */ lt({
    disabled: { type: Boolean },
    modelValue: { type: [Array, String, Boolean, Number, Object, null] },
    multiple: { type: Boolean },
    clearable: { type: Boolean },
    searchable: { type: Boolean },
    closeOnSelect: { type: Boolean },
    loading: { type: Boolean },
    prefixIcon: {},
    optionLabel: {},
    options: {},
    selectable: { type: Function },
    reduce: { type: Function },
    emptyValue: { type: Boolean },
    placeholder: {},
    filterable: { type: Boolean },
    foreground: { type: Boolean },
    borderless: { type: Boolean },
    appendToBody: { type: Boolean },
    taggable: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    helpText: {},
    description: {},
    size: {},
    color: {},
    warning: {},
    infoText: {},
    inputMode: {}
  }, {
    modelValue: "",
    multiple: !1,
    clearable: !1,
    searchable: !0,
    prefixIcon: null,
    closeOnSelect: !0,
    optionLabel: "label",
    loading: !1,
    emptyValue: !0,
    filterable: !0,
    foreground: !1,
    borderless: !0,
    appendToBody: !0,
    taggable: !1,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    selectable: (r) => !0,
    reduce: (r) => typeof r == "string" ? r : r.value,
    ...ct
  }),
  emits: ["update:model-value", "search", "option:created", "option:selecting", "option:deselecting", "paste"],
  setup(r, { expose: t, emit: e }) {
    const u = r, n = e, a = G({
      get() {
        return u.modelValue;
      },
      set(g) {
        n("update:model-value", g);
      }
    }), o = tt(), s = G(() => !!u.prefixIcon || o.prefixIcon), i = be(), l = (g, D, { width: _ }) => {
      g.style.width = _, g.classList.add(i["v-select__list"]);
      const O = Tt(D.$refs.toggle, g, {
        placement: "bottom",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1]
            }
          },
          {
            name: "toggleClass",
            enabled: !0,
            phase: "write",
            fn({ state: M }) {
              D.$el.classList.toggle(
                "drop-up",
                M.placement === "top"
              );
            }
          }
        ]
      });
      return () => O.destroy();
    }, d = Q(null);
    wu(() => {
      var D;
      if (!((D = d.value) != null && D.$el))
        return;
      const g = d.value.$el.getElementsByClassName("vs__search");
      g[0] && g[0].addEventListener("paste", (_) => {
        n("paste", _);
      });
    });
    const h = G(() => {
      const g = u.options ? u.options.map((D) => D || "") : [];
      return u.emptyValue ? g : g.filter((D) => D);
    }), c = Q(!1);
    return t({
      blur: () => {
        var g, D;
        (D = (g = d.value) == null ? void 0 : g.onSearchBlur) == null || D.call(g);
      }
    }), (g, D) => (m(), H(p(Lr), {
      class: b(p(i)["v-select"]),
      error: g.error,
      label: g.label,
      "show-required-star": g.showRequiredStar,
      "with-error": g.withError,
      color: g.color,
      description: g.description,
      "help-text": g.helpText,
      warning: g.warning,
      "info-text": g.infoText
    }, {
      default: J(() => [
        C("div", {
          class: b([
            p(i)["v-select__field-wrapper"],
            {
              [p(i)["v-select__field--foreground"]]: g.foreground
            }
          ])
        }, [
          s.value ? (m(), x("div", {
            key: 0,
            class: b([p(i)["v-select__icon"], p(i)["v-select__icon--prefix"]])
          }, [
            K(g.$slots, "prefixIcon", {}, () => [
              (m(), H(He(g.prefixIcon)))
            ])
          ], 2)) : R("", !0),
          j(p(n4), {
            ref_key: "vueSelect",
            ref: d,
            modelValue: a.value,
            "onUpdate:modelValue": D[0] || (D[0] = (_) => a.value = _),
            class: b([
              p(i)["v-select__field"],
              p(i)[`v-select__field--${g.size}`],
              {
                [p(i)["v-select__field--foreground"]]: g.foreground,
                [p(i)["v-select__field--open"]]: c.value,
                [p(i)["v-select__field--with-prefix-icon"]]: s.value
              }
            ]),
            selectable: g.selectable,
            reduce: g.reduce,
            clearable: g.clearable,
            disabled: g.disabled,
            multiple: g.multiple,
            label: g.optionLabel,
            searchable: g.searchable,
            "close-on-select": g.closeOnSelect,
            filterable: g.filterable,
            placeholder: g.placeholder,
            options: h.value,
            value: g.modelValue,
            loading: g.loading,
            "calculate-position": l,
            "append-to-body": g.appendToBody,
            taggable: g.taggable,
            onOpen: D[1] || (D[1] = (_) => c.value = !0),
            onClose: D[2] || (D[2] = (_) => c.value = !1),
            onSearch: D[3] || (D[3] = (_) => n("search", _)),
            "onOption:created": D[4] || (D[4] = (_) => n("option:created", _)),
            "onOption:selecting": D[5] || (D[5] = (_) => n("option:selecting", _)),
            "onOption:deselecting": D[6] || (D[6] = (_) => n("option:deselecting", _))
          }, {
            "selected-option": J((_) => [
              K(g.$slots, "selected-option", Le(Ne(typeof _ == "string" ? {} : _)), () => [
                typeof _ == "string" ? (m(), H(yt, {
                  key: 0,
                  content: _,
                  "auto-shrink": !0,
                  "tooltip-max-width": "400px"
                }, null, 8, ["content"])) : (m(), x("div", {
                  key: 1,
                  class: b(p(i)["v-select__option"])
                }, [
                  j(yt, {
                    content: _[g.optionLabel],
                    "auto-shrink": !0,
                    "tooltip-max-width": "400px"
                  }, null, 8, ["content"]),
                  _.helpText ? (m(), H(p(Ve), {
                    key: 0,
                    class: b(p(i)["v-select__option-tooltip"]),
                    content: _.helpText
                  }, null, 8, ["class", "content"])) : R("", !0)
                ], 2))
              ])
            ]),
            option: J((_) => [
              K(g.$slots, "option", Le(Ne(typeof _ == "string" ? {} : _)), () => [
                typeof _ == "string" ? (m(), x(pe, { key: 0 }, [
                  ce(ne(_ || "(Blank)"), 1)
                ], 64)) : (m(), x("div", {
                  key: 1,
                  class: b(p(i)["v-select__option"])
                }, [
                  ce(ne(_[g.optionLabel] || "(Blank)") + " ", 1),
                  _ != null && _.helpText ? (m(), H(p(Ve), {
                    key: 0,
                    class: b(p(i)["v-select__option-tooltip"]),
                    content: _.helpText
                  }, null, 8, ["class", "content"])) : R("", !0)
                ], 2))
              ])
            ]),
            "open-indicator": J(() => [
              j(kt, {
                class: b([
                  p(i)["v-select__toggle"],
                  {
                    [p(i)["v-select__toggle--open"]]: c.value
                  }
                ])
              }, null, 8, ["class"])
            ]),
            "no-options": J(({ search: _ }) => [
              K(g.$slots, "no-options", Le(Ne({
                search: _
              })), () => [
                D[7] || (D[7] = ce(" Sorry, no matching options. ", -1))
              ])
            ]),
            "list-footer": J(() => [
              K(g.$slots, "list-footer")
            ]),
            _: 3
          }, 8, ["modelValue", "class", "selectable", "reduce", "clearable", "disabled", "multiple", "label", "searchable", "close-on-select", "filterable", "placeholder", "options", "value", "loading", "append-to-body", "taggable"])
        ], 2)
      ]),
      _: 3
    }, 8, ["class", "error", "label", "show-required-star", "with-error", "color", "description", "help-text", "warning", "info-text"]));
  }
});
const i4 = "_vs__deselect_165oc_40", o4 = {
  "v-select": "_v-select_165oc_1",
  "v-select__field": "_v-select__field_165oc_5",
  vs__deselect: i4,
  "vs--open": "_vs--open_165oc_14",
  "v-select__field--medium": "_v-select__field--medium_165oc_105",
  "v-select__field--large": "_v-select__field--large_165oc_112",
  "v-select__field--foreground": "_v-select__field--foreground_165oc_119",
  "v-select__list": "_v-select__list_165oc_123",
  "v-select__field--open": "_v-select__field--open_165oc_155",
  "v-select__toggle": "_v-select__toggle_165oc_159",
  "v-select__toggle--open": "_v-select__toggle--open_165oc_171",
  "v-select__field-wrapper": "_v-select__field-wrapper_165oc_175",
  "v-select__option": "_v-select__option_165oc_179",
  "v-select__option-tooltip": "_v-select__option-tooltip_165oc_192",
  "v-select__field--with-prefix-icon": "_v-select__field--with-prefix-icon_165oc_196",
  "v-select__icon": "_v-select__icon_165oc_213"
}, s4 = {
  $style: o4
}, fc = /* @__PURE__ */ U(a4, [["__cssModules", s4]]), l4 = ["src"], c4 = /* @__PURE__ */ ue({
  __name: "VAvatar",
  props: {
    size: { default: Gt.MEDIUM },
    imageUrl: { default: "" },
    firstName: { default: "" },
    lastName: { default: "" },
    isLight: { type: Boolean, default: !1 },
    outline: { type: Boolean, default: !1 }
  },
  setup(r) {
    const t = r, e = G(() => !!t.imageUrl && !u.value), u = Q(!1), n = G(() => {
      const a = (t.firstName || "").replace(/[^a-zA-Z]/g, ""), o = (t.lastName || "").replace(/[^a-zA-Z]/g, "");
      return `${a.charAt(0)}${o.charAt(0)}`.toUpperCase();
    });
    return (a, o) => (m(), x("div", {
      class: b([
        a.$style["v-avatar"],
        a.$style[`v-avatar--${a.size}`],
        {
          [a.$style["v-avatar--light"]]: a.isLight,
          [a.$style["v-avatar--outline"]]: a.outline
        }
      ])
    }, [
      K(a.$slots, "content", {}, () => [
        e.value ? (m(), x("img", {
          key: 0,
          class: b(a.$style["v-avatar__image"]),
          src: a.imageUrl || "",
          alt: "avatar",
          onError: o[0] || (o[0] = (s) => u.value = !0)
        }, null, 42, l4)) : (m(), x(pe, { key: 1 }, [
          ce(ne(n.value), 1)
        ], 64))
      ])
    ], 2));
  }
}), d4 = {
  "v-avatar": "_v-avatar_1kith_1",
  "v-avatar--light": "_v-avatar--light_1kith_14",
  "v-avatar--outline": "_v-avatar--outline_1kith_18",
  "v-avatar--extra-small": "_v-avatar--extra-small_1kith_22",
  "v-avatar--small": "_v-avatar--small_1kith_28",
  "v-avatar--medium-small": "_v-avatar--medium-small_1kith_34",
  "v-avatar--medium": "_v-avatar--medium_1kith_34",
  "v-avatar--large": "_v-avatar--large_1kith_46",
  "v-avatar__image": "_v-avatar__image_1kith_52"
}, f4 = {
  $style: d4
}, nr = /* @__PURE__ */ U(c4, [["__cssModules", f4]]), yu = (r, t = " ") => r.filter(Boolean).join(t), p4 = {}, h4 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "16",
  width: "16",
  viewBox: "0 0 16 16"
};
function m4(r, t) {
  return m(), x("svg", h4, t[0] || (t[0] = [
    C("g", {
      "stroke-width": "1",
      "stroke-linejoin": "round",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round"
    }, [
      C("path", {
        d: "M2.562,10A4,4,0,0,0,.5,13.5v2h15v-2A4,4,0,0,0,13.438,10",
        "data-cap": "butt",
        stroke: "currentColor"
      }),
      C("rect", {
        x: "4.5",
        y: "0.5",
        width: "7",
        height: "9",
        rx: "3.5",
        ry: "3.5",
        "data-cap": "butt"
      })
    ], -1)
  ]));
}
const v4 = /* @__PURE__ */ U(p4, [["render", m4]]), g4 = /* @__PURE__ */ ue({
  __name: "VMarkedText",
  props: {
    content: { default: "" },
    variant: { default: lu.SECONDARY }
  },
  setup(r) {
    const t = be();
    return (e, u) => (m(), x("div", {
      class: b([
        p(t)["v-marked-text"],
        p(t)[`v-marked-text--${e.variant}`]
      ])
    }, [
      K(e.$slots, "content", {}, () => [
        ce(ne(e.content), 1)
      ])
    ], 2));
  }
}), b4 = {
  "v-marked-text": "_v-marked-text_37ano_1",
  "v-marked-text--status": "_v-marked-text--status_37ano_16",
  "v-marked-text--secondary": "_v-marked-text--secondary_37ano_27",
  "v-marked-text--primary": "_v-marked-text--primary_37ano_33"
}, y4 = {
  $style: b4
}, or = /* @__PURE__ */ U(g4, [["__cssModules", y4]]), _4 = /* @__PURE__ */ ue({
  __name: "VUserField",
  props: /* @__PURE__ */ lt({
    options: {},
    multiple: { type: Boolean },
    modelValue: {},
    foreground: { type: Boolean },
    loading: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    helpText: {},
    description: {},
    borderless: { type: Boolean },
    placeholder: {},
    disabled: { type: Boolean },
    size: {},
    color: {},
    warning: {},
    infoText: {},
    inputMode: {}
  }, {
    modelValue: null,
    foreground: !1,
    loading: !1,
    multiple: !1,
    ...ct
  }),
  emits: ["update:modelValue", "search"],
  setup(r, { emit: t }) {
    const e = fc, u = xs(v4), n = r, a = G(() => n.options.find((l) => l.value === n.modelValue) || null), o = t, s = (l) => l != null && l.expiresAt ? `Through ${ur(l == null ? void 0 : l.expiresAt).format("MM/DD/YYYY")}` : "", i = be();
    return (l, d) => (m(), x("div", {
      class: b(p(i)["v-user-field"])
    }, [
      j(p(e), Te(n, {
        "model-value": l.modelValue,
        options: l.options,
        searchable: "",
        filterable: !1,
        foreground: l.foreground,
        borderless: l.borderless,
        color: l.color,
        description: l.description,
        "help-text": l.helpText,
        size: l.size,
        warning: l.warning,
        "onUpdate:modelValue": d[0] || (d[0] = (h) => o("update:modelValue", h)),
        onSearch: d[1] || (d[1] = (h) => o("search", h))
      }), mt({
        "selected-option": J((h) => [
          C("div", {
            class: b([
              p(i)["v-user-field__option"]
            ])
          }, [
            ce(ne(p(yu)([h.firstName, h.lastName, h.isActive ? "" : "(inactive)"]) || h.email) + " ", 1),
            h != null && h.status ? (m(), H(p(Ve), {
              key: 0,
              content: s(h.status),
              placement: "top",
              size: "sm"
            }, {
              default: J(() => [
                j(p(or), {
                  variant: p(lu).STATUS
                }, {
                  content: J(() => d[2] || (d[2] = [
                    ce(" 🏠 Out of office ", -1)
                  ])),
                  _: 1
                }, 8, ["variant"])
              ]),
              _: 2
            }, 1032, ["content"])) : R("", !0)
          ], 2)
        ]),
        option: J((h) => {
          var c, f, g, D;
          return [
            h.value ? (m(), x("div", {
              key: 0,
              class: b([
                p(i)["v-user-field__option"]
              ])
            }, [
              j(p(nr), {
                size: p(Gt).EXTRA_SMALL,
                "last-name": ((c = h.forceInitials) == null ? void 0 : c[1]) || h.lastName || ((f = h.email) == null ? void 0 : f[0]),
                "first-name": ((g = h.forceInitials) == null ? void 0 : g[0]) || h.firstName || ((D = h.email) == null ? void 0 : D[1]),
                "image-url": h.avatar
              }, null, 8, ["size", "last-name", "first-name", "image-url"]),
              ce(" " + ne(p(yu)([h.firstName, h.lastName, h.isActive ? "" : "(inactive)"]) || h.email) + " ", 1),
              h != null && h.status ? (m(), H(p(Ve), {
                key: 0,
                content: s(h.status),
                placement: "top",
                size: "sm"
              }, {
                default: J(() => [
                  j(p(or), {
                    variant: p(lu).STATUS
                  }, {
                    content: J(() => d[3] || (d[3] = [
                      ce(" 🏠 Out of office ", -1)
                    ])),
                    _: 1
                  }, 8, ["variant"])
                ]),
                _: 2
              }, 1032, ["content"])) : R("", !0)
            ], 2)) : (m(), x(pe, { key: 1 }, [
              ce(ne(h.firstName), 1)
            ], 64))
          ];
        }),
        _: 2
      }, [
        l.multiple ? void 0 : {
          name: "prefixIcon",
          fn: J(() => {
            var h, c, f, g;
            return [
              a.value ? (m(), H(p(nr), {
                key: 0,
                size: p(Gt).EXTRA_SMALL,
                "last-name": ((h = a.value.forceInitials) == null ? void 0 : h[1]) || a.value.lastName || ((c = a.value.email) == null ? void 0 : c[0]),
                "first-name": ((f = a.value.forceInitials) == null ? void 0 : f[0]) || a.value.firstName || ((g = a.value.email) == null ? void 0 : g[1]),
                "image-url": a.value.avatar,
                "is-light": l.foreground
              }, null, 8, ["size", "last-name", "first-name", "image-url", "is-light"])) : (m(), H(p(u), { key: 1 }))
            ];
          }),
          key: "0"
        }
      ]), 1040, ["model-value", "options", "foreground", "borderless", "color", "description", "help-text", "size", "warning"])
    ], 2));
  }
}), w4 = {
  "v-user-field": "_v-user-field_1wa49_1",
  "v-user-field__option": "_v-user-field__option_1wa49_15"
}, C4 = {
  $style: w4
}, Rx = /* @__PURE__ */ U(_4, [["__cssModules", C4]]), D4 = {}, A4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
};
function x4(r, t) {
  return m(), x("svg", A4, t[0] || (t[0] = [
    C("path", {
      d: "M0.5 5L8 9L15.5 5",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      d: "M14 14.5H2C1.60218 14.5 1.22064 14.342 0.93934 14.0607C0.658035 13.7794 0.5 13.3978 0.5 13V3C0.5 2.60218 0.658035 2.22064 0.93934 1.93934C1.22064 1.65804 1.60218 1.5 2 1.5H14C14.3978 1.5 14.7794 1.65804 15.0607 1.93934C15.342 2.22064 15.5 2.60218 15.5 3V13C15.5 13.3978 15.342 13.7794 15.0607 14.0607C14.7794 14.342 14.3978 14.5 14 14.5Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const E4 = /* @__PURE__ */ U(D4, [["render", x4]]), Vx = /* @__PURE__ */ ue({
  __name: "VEmailField",
  props: /* @__PURE__ */ lt({
    modelValue: {},
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    helpText: {},
    description: {},
    borderless: { type: Boolean },
    placeholder: {},
    disabled: { type: Boolean },
    size: {},
    color: {},
    warning: {},
    infoText: {},
    inputMode: {}
  }, {
    modelValue: "",
    ...ct
  }),
  emits: ["update:modelValue", "paste"],
  setup(r, { emit: t }) {
    const e = xs(E4), u = r, n = t;
    return (a, o) => (m(), H(p(Fr), Te({ "prefix-icon": p(e) }, u, {
      "model-value": a.modelValue,
      "onUpdate:modelValue": o[0] || (o[0] = (s) => n("update:modelValue", s)),
      onPaste: o[1] || (o[1] = (s) => n("paste", s))
    }), null, 16, ["prefix-icon", "model-value"]));
  }
}), k4 = /* @__PURE__ */ ue({
  __name: "VAvatarGroup",
  props: {
    users: { default: () => [] },
    size: { default: Gt.SMALL },
    maxVisibleUsers: { default: 6 },
    additionalInfoAlign: { default: "right" },
    hideAdditionalInfo: { type: Boolean, default: !1 }
  },
  setup(r) {
    const t = r, e = G(() => t.users.slice(0, t.maxVisibleUsers)), u = G(() => t.users.slice(t.maxVisibleUsers)), n = G(() => t.users.length > t.maxVisibleUsers), a = be();
    return (o, s) => (m(), x("div", {
      class: b(p(a)["v-avatar-group"])
    }, [
      C("div", {
        class: b(p(a)["v-avatar-group__avatars"])
      }, [
        (m(!0), x(pe, null, ge(e.value, (i, l) => (m(), x("div", {
          key: l,
          class: b(p(a)["v-avatar-group__avatar-wrapper"])
        }, [
          j(p(nr), {
            class: b(p(a)["v-avatar-group__avatar"]),
            "first-name": i.firstName || "",
            "image-url": i.avatar || "",
            "last-name": i.lastName || "",
            size: o.size
          }, null, 8, ["class", "first-name", "image-url", "last-name", "size"]),
          o.hideAdditionalInfo ? R("", !0) : (m(), x("div", {
            key: 0,
            class: b([
              p(a)["v-avatar-group__additional-info-wrapper"],
              p(a)[`v-avatar-group__additional-info-wrapper--${o.additionalInfoAlign}`]
            ])
          }, [
            C("div", {
              class: b(p(a)["v-avatar-group__avatar-additional-info"])
            }, [
              j(p(nr), {
                "first-name": i.firstName || "",
                "image-url": i.avatar || "",
                "last-name": i.lastName || "",
                size: p(Gt).SMALL
              }, null, 8, ["first-name", "image-url", "last-name", "size"]),
              C("div", {
                class: b(p(a)["v-avatar-group__additional-info-content"])
              }, [
                C("h5", null, ne(i.firstName) + " " + ne(i.lastName), 1),
                C("p", null, ne(i.email), 1)
              ], 2)
            ], 2)
          ], 2))
        ], 2))), 128))
      ], 2),
      n.value ? (m(), x("div", {
        key: 0,
        class: b(p(a)["v-avatar-group__additional-info"])
      }, [
        ce(" +" + ne(u.value.length) + " ", 1),
        C("div", {
          class: b([
            p(a)["v-avatar-group__additional-info-wrapper"],
            p(a)[`v-avatar-group__additional-info-wrapper--${o.additionalInfoAlign}`]
          ])
        }, [
          (m(!0), x(pe, null, ge(u.value, (i, l) => (m(), x("div", {
            key: l,
            class: b(p(a)["v-avatar-group__avatar-additional-info"])
          }, [
            j(p(nr), {
              "first-name": i.firstName || "",
              "image-url": i.avatar || "",
              "last-name": i.lastName || "",
              size: p(Gt).SMALL
            }, null, 8, ["first-name", "image-url", "last-name", "size"]),
            C("div", {
              class: b(p(a)["v-avatar-group__additional-info-content"])
            }, [
              C("h5", null, ne(i.firstName) + " " + ne(i.lastName), 1),
              C("p", null, ne(i.email), 1)
            ], 2)
          ], 2))), 128))
        ], 2)
      ], 2)) : R("", !0)
    ], 2));
  }
}), S4 = {
  "v-avatar-group": "_v-avatar-group_1qn1n_1",
  "v-avatar-group__avatars": "_v-avatar-group__avatars_1qn1n_7",
  "v-avatar-group__avatar-wrapper": "_v-avatar-group__avatar-wrapper_1qn1n_12",
  "v-avatar-group__avatar": "_v-avatar-group__avatar_1qn1n_7",
  "v-avatar-group__additional-info": "_v-avatar-group__additional-info_1qn1n_21",
  "v-avatar-group__additional-info-wrapper": "_v-avatar-group__additional-info-wrapper_1qn1n_42",
  "v-avatar-group__avatar-additional-info": "_v-avatar-group__avatar-additional-info_1qn1n_53",
  "v-avatar-group__additional-info-wrapper--right": "_v-avatar-group__additional-info-wrapper--right_1qn1n_75",
  "v-avatar-group__additional-info-wrapper--left": "_v-avatar-group__additional-info-wrapper--left_1qn1n_80",
  "v-avatar-group__additional-info-content": "_v-avatar-group__additional-info-content_1qn1n_85"
}, T4 = {
  $style: S4
}, jx = /* @__PURE__ */ U(k4, [["__cssModules", T4]]), B4 = {}, $4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 12 12",
  fill: "none"
};
function M4(r, t) {
  return m(), x("svg", $4, t[0] || (t[0] = [
    sr('<g clip-path="url(#clip0_28137_7447)"><path d="M2.44434 3.77756C2.44434 3.54181 2.53799 3.31572 2.70469 3.14902C2.87138 2.98232 3.09748 2.88867 3.33322 2.88867H8.66656C8.90231 2.88867 9.1284 2.98232 9.2951 3.14902C9.4618 3.31572 9.55545 3.54181 9.55545 3.77756V9.11089C9.55545 9.34664 9.4618 9.57273 9.2951 9.73943C9.1284 9.90613 8.90231 9.99978 8.66656 9.99978H3.33322C3.09748 9.99978 2.87138 9.90613 2.70469 9.73943C2.53799 9.57273 2.44434 9.34664 2.44434 9.11089V3.77756Z" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.77771 2V3.77778" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.22217 2V3.77778" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.44434 5.55469H9.55545" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.77771 6.88867H3.78349" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.11548 6.88867H5.1177" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.44885 6.88867H6.45107" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.78442 6.88867H7.78665" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.45105 8.22266H6.45327" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.78223 8.22266H3.78445" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.11548 8.22266H5.1177" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_28137_7447"><rect width="10.6667" height="10.6667" fill="white" transform="translate(0.666626 0.666016)"></rect></clipPath></defs>', 2)
  ]));
}
const O4 = /* @__PURE__ */ U(B4, [["render", M4]]), L4 = /* @__PURE__ */ ue({
  __name: "VProfileStatus",
  props: {
    status: { default: null }
  },
  emits: ["update:status"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = (i) => {
      if (i)
        return u("update:status", {
          name: "Out of office",
          expiresAt: null
        });
      u("update:status", null);
    }, a = (i) => {
      u("update:status", {
        name: "Out of office",
        expiresAt: ur(i, "YYYY-MM-DD").endOf("day").toISOString()
      });
    }, o = G(() => {
      var i;
      return (i = e.status) != null && i.expiresAt ? ur(e.status.expiresAt).format("MM/DD/YYYY") : null;
    }), s = be();
    return (i, l) => (m(), x("div", {
      class: b(p(s)["v-profile-status"])
    }, [
      C("div", {
        class: b(p(s)["v-profile-status__checkbox-wrapper"])
      }, [
        j(p(Hs), {
          switch: "",
          size: p(xu).SMALL,
          value: !!i.status,
          "onUpdate:value": l[0] || (l[0] = (d) => n(d))
        }, null, 8, ["size", "value"]),
        C("div", null, "🏠 " + ne(i.status ? "Clear OOO" : "Set OOO"), 1)
      ], 2),
      i.status ? (m(), H(p(Ve), {
        key: 0,
        size: "sm",
        placement: "top",
        class: b(p(s)["v-profile-status__expires-wrapper"]),
        content: `Through ${o.value}`
      }, {
        default: J(() => {
          var d;
          return [
            ce(ne(o.value) + " ", 1),
            C("div", {
              class: b(p(s)["v-profile-status__calendar-wrapper"])
            }, [
              j(O4)
            ], 2),
            j(p(lc), {
              class: b(p(s)["v-profile-status__calendar"]),
              "model-value": ((d = i.status) == null ? void 0 : d.expiresAt) || null,
              config: {
                minDate: p(ur)().startOf("day").toISOString()
              },
              "onUpdate:modelValue": l[1] || (l[1] = (h) => a(h))
            }, null, 8, ["class", "model-value", "config"])
          ];
        }),
        _: 1
      }, 8, ["class", "content"])) : R("", !0)
    ], 2));
  }
}), F4 = {
  "v-profile-status": "_v-profile-status_1neov_1",
  "v-profile-status__checkbox-wrapper": "_v-profile-status__checkbox-wrapper_1neov_8",
  "v-profile-status__expires-wrapper": "_v-profile-status__expires-wrapper_1neov_19",
  "v-profile-status__calendar-wrapper": "_v-profile-status__calendar-wrapper_1neov_30",
  "v-profile-status__calendar": "_v-profile-status__calendar_1neov_30"
}, I4 = {
  $style: F4
}, pc = /* @__PURE__ */ U(L4, [["__cssModules", I4]]);
function hc(r) {
  return w0() ? (C0(r), !0) : !1;
}
function uu(r) {
  return typeof r == "function" ? r() : p(r);
}
const mc = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const N4 = Object.prototype.toString, q4 = (r) => N4.call(r) === "[object Object]", nu = () => {
}, $a = /* @__PURE__ */ P4();
function P4() {
  var r, t;
  return mc && ((r = window == null ? void 0 : window.navigator) == null ? void 0 : r.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
const Bo = {
  mounted: "mounted",
  updated: "updated",
  unmounted: "unmounted"
};
function R4(...r) {
  if (r.length !== 1)
    return D0(...r);
  const t = r[0];
  return typeof t == "function" ? A0(x0(() => ({ get: t, set: nu }))) : Q(t);
}
function Jr(r) {
  var t;
  const e = uu(r);
  return (t = e == null ? void 0 : e.$el) != null ? t : e;
}
const vc = mc ? window : void 0;
function an(...r) {
  let t, e, u, n;
  if (typeof r[0] == "string" || Array.isArray(r[0]) ? ([e, u, n] = r, t = vc) : [t, e, u, n] = r, !t)
    return nu;
  Array.isArray(e) || (e = [e]), Array.isArray(u) || (u = [u]);
  const a = [], o = () => {
    a.forEach((d) => d()), a.length = 0;
  }, s = (d, h, c, f) => (d.addEventListener(h, c, f), () => d.removeEventListener(h, c, f)), i = qe(
    () => [Jr(t), uu(n)],
    ([d, h]) => {
      if (o(), !d)
        return;
      const c = q4(h) ? { ...h } : h;
      a.push(
        ...e.flatMap((f) => u.map((g) => s(d, f, g, c)))
      );
    },
    { immediate: !0, flush: "post" }
  ), l = () => {
    i(), o();
  };
  return hc(l), l;
}
let $o = !1;
function Mo(r, t, e = {}) {
  const { window: u = vc, ignore: n = [], capture: a = !0, detectIframe: o = !1 } = e;
  if (!u)
    return nu;
  $a && !$o && ($o = !0, Array.from(u.document.body.children).forEach((c) => c.addEventListener("click", nu)), u.document.documentElement.addEventListener("click", nu));
  let s = !0;
  const i = (c) => n.some((f) => {
    if (typeof f == "string")
      return Array.from(u.document.querySelectorAll(f)).some((g) => g === c.target || c.composedPath().includes(g));
    {
      const g = Jr(f);
      return g && (c.target === g || c.composedPath().includes(g));
    }
  }), d = [
    an(u, "click", (c) => {
      const f = Jr(r);
      if (!(!f || f === c.target || c.composedPath().includes(f))) {
        if (c.detail === 0 && (s = !i(c)), !s) {
          s = !0;
          return;
        }
        t(c);
      }
    }, { passive: !0, capture: a }),
    an(u, "pointerdown", (c) => {
      const f = Jr(r);
      s = !i(c) && !!(f && !c.composedPath().includes(f));
    }, { passive: !0 }),
    o && an(u, "blur", (c) => {
      setTimeout(() => {
        var f;
        const g = Jr(r);
        ((f = u.document.activeElement) == null ? void 0 : f.tagName) === "IFRAME" && !(g != null && g.contains(u.document.activeElement)) && t(c);
      }, 0);
    })
  ].filter(Boolean);
  return () => d.forEach((c) => c());
}
const V4 = {
  [Bo.mounted](r, t) {
    const e = !t.modifiers.bubble;
    if (typeof t.value == "function")
      r.__onClickOutside_stop = Mo(r, t.value, { capture: e });
    else {
      const [u, n] = t.value;
      r.__onClickOutside_stop = Mo(r, u, Object.assign({ capture: e }, n));
    }
  },
  [Bo.unmounted](r) {
    r.__onClickOutside_stop();
  }
};
function ua(r) {
  return typeof Window < "u" && r instanceof Window ? r.document.documentElement : typeof Document < "u" && r instanceof Document ? r.documentElement : r;
}
function gc(r) {
  const t = window.getComputedStyle(r);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && r.clientWidth < r.scrollWidth || t.overflowY === "auto" && r.clientHeight < r.scrollHeight)
    return !0;
  {
    const e = r.parentNode;
    return !e || e.tagName === "BODY" ? !1 : gc(e);
  }
}
function j4(r) {
  const t = r || window.event, e = t.target;
  return gc(e) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const na = /* @__PURE__ */ new WeakMap();
function H4(r, t = !1) {
  const e = Q(t);
  let u = null, n = "";
  qe(R4(r), (s) => {
    const i = ua(uu(s));
    if (i) {
      const l = i;
      if (na.get(l) || na.set(l, l.style.overflow), l.style.overflow !== "hidden" && (n = l.style.overflow), l.style.overflow === "hidden")
        return e.value = !0;
      if (e.value)
        return l.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const a = () => {
    const s = ua(uu(r));
    !s || e.value || ($a && (u = an(
      s,
      "touchmove",
      (i) => {
        j4(i);
      },
      { passive: !1 }
    )), s.style.overflow = "hidden", e.value = !0);
  }, o = () => {
    const s = ua(uu(r));
    !s || !e.value || ($a && (u == null || u()), s.style.overflow = n, na.delete(s), e.value = !1);
  };
  return hc(o), G({
    get() {
      return e.value;
    },
    set(s) {
      s ? a() : o();
    }
  });
}
function U4() {
  let r = !1;
  const t = Q(!1);
  return (e, u) => {
    if (t.value = u.value, r)
      return;
    r = !0;
    const n = H4(e, u.value);
    qe(t, (a) => n.value = a);
  };
}
U4();
const z4 = { key: 0 }, G4 = 'div[class*="v-multi-select__options-list"]', W4 = /* @__PURE__ */ ue({
  __name: "VProfile",
  props: {
    firstName: { default: "" },
    lastName: { default: "" },
    imageUrl: { default: "" },
    jobTitle: { default: "" },
    email: { default: "" },
    actions: { default: () => [] },
    subtitle: { default: "" },
    simple: { type: Boolean, default: !1 },
    status: { default: null },
    hideStatus: { type: Boolean, default: !1 }
  },
  emits: ["click", "changeAvatar", "update:status"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G(() => yu([e.firstName, e.lastName])), a = Q(!1), o = () => {
      e.simple || (a.value = !1);
    }, s = () => {
      e.simple || (a.value = !a.value), u("click");
    }, i = be();
    return (l, d) => (m(), x("div", {
      class: b(p(i)["v-profile"])
    }, [
      C("div", {
        class: b(p(i)["v-profile__trigger"]),
        onClick: ot(s, ["stop"])
      }, [
        j(p(nr), {
          size: p(Gt).MEDIUM_SMALL,
          "first-name": l.firstName,
          "last-name": l.lastName,
          "image-url": l.imageUrl
        }, null, 8, ["size", "first-name", "last-name", "image-url"]),
        C("div", {
          class: b(p(i)["v-profile__user-info"])
        }, [
          C("h5", null, ne(n.value), 1),
          l.subtitle ? (m(), x("div", z4, ne(l.subtitle), 1)) : R("", !0)
        ], 2),
        K(l.$slots, "trigger-icon", {}, () => [
          j(kt, {
            class: b([
              p(i)["v-profile__toggle"],
              {
                [p(i)["v-profile__toggle--open"]]: a.value,
                [p(i)["v-profile__toggle--simple"]]: l.simple
              }
            ])
          }, null, 8, ["class"])
        ])
      ], 2),
      Xe((m(), x("div", {
        class: b([
          p(i)["v-profile__content"],
          {
            [p(i)["v-profile__content--open"]]: a.value
          }
        ])
      }, [
        C("div", {
          class: b(p(i)["v-profile__content-header"])
        }, [
          j(p(nr), {
            "first-name": l.firstName,
            "last-name": l.lastName,
            "image-url": l.imageUrl,
            onClick: d[0] || (d[0] = (h) => u("changeAvatar"))
          }, null, 8, ["first-name", "last-name", "image-url"]),
          C("h4", null, ne(n.value), 1),
          C("div", {
            class: b(p(i)["v-profile__email"])
          }, ne(l.email), 3),
          l.jobTitle ? (m(), x("div", {
            key: 0,
            class: b(p(i)["v-profile__job-title"])
          }, ne(l.jobTitle), 3)) : R("", !0),
          l.hideStatus ? R("", !0) : (m(), H(p(pc), {
            key: 1,
            status: l.status,
            "onUpdate:status": d[1] || (d[1] = (h) => u("update:status", h))
          }, null, 8, ["status"])),
          K(l.$slots, "outlook-integration")
        ], 2),
        C("div", {
          class: b(p(i)["v-profile__content-body"])
        }, [
          (m(!0), x(pe, null, ge(l.actions, (h, c) => (m(), H(He(h.openInNewTab ? "RouterLink" : "div"), {
            key: c,
            class: b([
              p(i)["v-profile__action"],
              {
                [p(i)[`v-profile__action--${h.type}`]]: h.type,
                [p(i)["v-profile__action--active"]]: h.active,
                [p(i)["v-profile__action--with-prefix-icon"]]: !!h.icon
              }
            ]),
            to: h != null && h.openInNewTab ? h.link : null,
            onClick: (f) => {
              var g;
              return h != null && h.openInNewTab ? null : (g = h.action) == null ? void 0 : g.call(h);
            }
          }, {
            default: J(() => [
              h.icon ? (m(), H(He(h.icon), { key: 0 })) : R("", !0),
              ce(" " + ne(h.title) + " ", 1),
              h.active ? (m(), H(Eu, { key: 1 })) : R("", !0)
            ]),
            _: 2
          }, 1032, ["class", "to", "onClick"]))), 128))
        ], 2)
      ], 2)), [
        [p(V4), [o, {
          ignore: [".vs__dropdown-menu", ".flatpickr-calendar", G4, ".vfm__content"]
        }]]
      ])
    ], 2));
  }
}), Y4 = {
  "v-profile": "_v-profile_3991w_1",
  "v-profile__trigger": "_v-profile__trigger_3991w_6",
  "v-profile-content__header": "_v-profile-content__header_3991w_13",
  "v-profile__content": "_v-profile__content_3991w_21",
  "v-profile__content--open": "_v-profile__content--open_3991w_25",
  "v-profile__toggle": "_v-profile__toggle_3991w_39",
  "v-profile__toggle--open": "_v-profile__toggle--open_3991w_46",
  "v-profile__toggle--simple": "_v-profile__toggle--simple_3991w_50",
  "v-profile__user-info": "_v-profile__user-info_3991w_54",
  "v-profile__content-header": "_v-profile__content-header_3991w_79",
  "v-profile__email": "_v-profile__email_3991w_94",
  "v-profile__job-title": "_v-profile__job-title_3991w_94",
  "v-profile__content-body": "_v-profile__content-body_3991w_104",
  "v-profile__action": "_v-profile__action_3991w_128",
  "v-profile__action--active": "_v-profile__action--active_3991w_146",
  "v-profile__action--danger": "_v-profile__action--danger_3991w_151",
  "v-profile__action--with-prefix-icon": "_v-profile__action--with-prefix-icon_3991w_157"
}, Z4 = {
  $style: Y4
}, Oo = /* @__PURE__ */ U(W4, [["__cssModules", Z4]]), K4 = /* @__PURE__ */ ue({
  __name: "VTopbar",
  props: {
    title: { default: "" }
  },
  setup(r) {
    return (t, e) => (m(), x("div", {
      class: b(t.$style["v-topbar"])
    }, [
      C("h4", {
        id: "v-topbar__title",
        class: b(t.$style["v-topbar__title"])
      }, [
        K(t.$slots, "title", {}, () => [
          ce(ne(t.title), 1)
        ])
      ], 2),
      C("div", {
        class: b(t.$style["v-topbar__content"])
      }, [
        K(t.$slots, "default")
      ], 2)
    ], 2));
  }
}), X4 = {
  "v-topbar": "_v-topbar_ll0xm_1",
  "v-topbar__content": "_v-topbar__content_ll0xm_12",
  "v-topbar__title": "_v-topbar__title_ll0xm_19"
}, J4 = {
  $style: X4
}, Hx = /* @__PURE__ */ U(K4, [["__cssModules", J4]]), Q4 = {}, e6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "70",
  height: "24",
  viewBox: "0 0 70 24",
  fill: "none"
};
function t6(r, t) {
  return m(), x("svg", e6, t[0] || (t[0] = [
    sr('<path d="M11.9977 12.3415L11.4217 13.5551C11.7088 12.9796 11.8041 12.3274 11.6936 11.6939L10.2402 8.60429C10.0412 8.18183 9.72669 7.82436 9.33297 7.57327C8.93924 7.32219 8.48245 7.18775 8.01547 7.18555H4.50293L9.46646 17.7273H14.5338L11.9977 12.3415Z" fill="currentColor"></path><path d="M21.4752 19.3657C20.0183 21.2393 18.0385 22.6389 15.7861 23.3875C13.5338 24.1361 11.11 24.2 8.82125 23.5711C6.53253 22.9423 4.4817 21.649 2.92809 19.8547C1.37447 18.0604 0.387847 15.8458 0.0929781 13.4908C-0.201891 11.1358 0.208237 8.74632 1.2715 6.62442C2.33476 4.50253 4.00341 2.74355 6.06643 1.56992C8.12945 0.39628 10.4942 -0.139299 12.8616 0.0309037C15.229 0.201106 17.4928 1.06945 19.3667 2.52612C21.8785 4.48034 23.5116 7.35182 23.9069 10.5095C24.3023 13.6671 23.4277 16.8526 21.4752 19.3657ZM18.6845 3.40109C16.9834 2.07863 14.9284 1.29028 12.7792 1.13575C10.6301 0.981226 8.48338 1.46746 6.61061 2.53297C4.73784 3.59847 3.22314 5.19538 2.25809 7.12173C1.29303 9.04807 0.920963 11.2173 1.18894 13.3551C1.45693 15.4929 2.35292 17.5032 3.7636 19.1318C5.17428 20.7604 7.03628 21.9341 9.11411 22.5045C11.1919 23.0748 13.3923 23.0162 15.4368 22.3361C17.4813 21.656 19.2782 20.3848 20.6002 18.6835C21.478 17.5543 22.1248 16.2632 22.5036 14.8841C22.8824 13.5049 22.9858 12.0647 22.8079 10.6455C22.63 9.22641 22.1743 7.85622 21.4668 6.61321C20.7593 5.3702 19.8139 4.27872 18.6845 3.40109Z" fill="currentColor"></path><path d="M11.5058 11.2959L10.2402 8.60429C10.0412 8.18183 9.72669 7.82436 9.33297 7.57327C8.93925 7.32219 8.48245 7.18775 8.01547 7.18555H4.50293L7.92648 14.4572C9.42091 13.8038 10.6728 12.6981 11.5058 11.2959Z" fill="currentColor"></path><path d="M9.46631 17.7248H14.5337L19.4972 7.18311H15.9204C15.4742 7.18315 15.0372 7.31004 14.6603 7.54898C14.2835 7.78793 13.9824 8.12908 13.7921 8.53264L9.46631 17.7248Z" fill="currentColor"></path><path d="M13.5276 9.09326L9.46631 17.7244H14.2964C15.3074 14.7608 16.0242 11.7034 13.5276 9.09326Z" fill="currentColor"></path><path d="M19.4974 7.18311H15.9206C15.4744 7.18315 15.0374 7.31004 14.6606 7.54898C14.2837 7.78793 13.9826 8.12908 13.7923 8.53264L13.5278 9.09371C16.0244 11.7038 15.3076 14.7613 14.2966 17.7248H14.5438L19.4974 7.18311Z" fill="currentColor"></path><path d="M11.9975 12.3414L11.4215 13.555C11.7086 12.9796 11.8039 12.3273 11.6934 11.6938L11.5055 11.2959C10.6725 12.6981 9.4207 13.8037 7.92627 14.4572L9.46625 17.7272H14.5336L11.9975 12.3414Z" fill="currentColor"></path><path d="M30.383 14.7882L28.0139 9.25955C28.004 9.23719 27.9993 9.21293 28.0001 9.18853C28.0001 9.12298 28.0414 9.09293 28.1213 9.09293H28.8403C28.8729 9.09139 28.9051 9.10119 28.9313 9.12064C28.9574 9.14008 28.9759 9.16795 28.9836 9.19946L30.8789 13.9332L32.7631 9.21039C32.7772 9.17497 32.802 9.14471 32.834 9.1237C32.866 9.10269 32.9038 9.09195 32.9422 9.09293H33.6364C33.7494 9.09293 33.7852 9.14756 33.7466 9.25955L31.372 14.7882C31.3624 14.8245 31.3404 14.8563 31.3098 14.8783C31.2791 14.9002 31.2417 14.9109 31.2039 14.9084H30.5676C30.5284 14.908 30.4902 14.8965 30.4574 14.8752C30.4247 14.8539 30.3989 14.8237 30.383 14.7882Z" fill="currentColor"></path><path d="M34.3336 14.3978C34.3205 14.3829 34.3106 14.3656 34.3045 14.3468C34.2983 14.328 34.2961 14.3082 34.2978 14.2886C34.2941 14.256 34.3019 14.2232 34.3198 14.1957L34.5953 13.7422C34.5931 13.737 34.5931 13.7311 34.5953 13.7259C34.5983 13.7246 34.6016 13.7239 34.6049 13.7239C34.6082 13.7239 34.6115 13.7246 34.6146 13.7259C34.6238 13.7124 34.6361 13.7011 34.6504 13.6931C34.6648 13.685 34.6808 13.6804 34.6972 13.6794C34.7114 13.68 34.7253 13.6835 34.7381 13.6896C34.7509 13.6957 34.7623 13.7043 34.7716 13.7149C34.9956 13.8523 35.2351 13.9632 35.4851 14.0454C35.7963 14.155 36.1245 14.2096 36.4548 14.2066C36.7957 14.2227 37.1343 14.1442 37.4327 13.9799C37.5421 13.9231 37.6339 13.838 37.6984 13.7337C37.763 13.6293 37.7977 13.5096 37.7991 13.3871C37.7984 13.2686 37.7671 13.1521 37.7083 13.0489C37.6495 12.9456 37.5651 12.859 37.463 12.7971C37.1179 12.6078 36.7467 12.4697 36.3611 12.3874C35.8229 12.2753 35.3166 12.0457 34.879 11.7154C34.7269 11.5767 34.6061 11.4076 34.5245 11.2193C34.4428 11.031 34.4022 10.8278 34.4052 10.6228C34.3922 10.3149 34.4801 10.0111 34.6559 9.75693C34.843 9.49361 35.1006 9.28737 35.3997 9.16146C35.7477 9.01411 36.1232 8.94149 36.5016 8.9484C37.137 8.93515 37.7596 9.12687 38.2757 9.4947C38.3308 9.52475 38.3446 9.58485 38.3115 9.67225V9.70776L38.0608 10.1831C38.0536 10.2022 38.0403 10.2184 38.0229 10.2293C38.0054 10.2402 37.9849 10.245 37.9644 10.2431C37.9479 10.2431 37.9286 10.2431 37.9038 10.2076C37.483 9.93437 36.9908 9.78909 36.4878 9.78971C36.1774 9.77609 35.8696 9.85098 35.6008 10.0055C35.5015 10.0595 35.4182 10.1383 35.3592 10.2342C35.3002 10.33 35.2676 10.4396 35.2647 10.5518C35.2599 10.6666 35.2851 10.7807 35.3376 10.8831C35.3902 10.9854 35.4685 11.0727 35.565 11.1364C35.9143 11.3284 36.2902 11.4683 36.6807 11.5516C37.2228 11.6832 37.7325 11.9219 38.1793 12.2536C38.3372 12.3933 38.4614 12.5666 38.5425 12.7605C38.6235 12.9544 38.6595 13.1639 38.6476 13.3735C38.6516 13.6066 38.5986 13.8373 38.493 14.0457C38.3875 14.254 38.2326 14.4339 38.0415 14.5699C37.5747 14.8935 37.0126 15.054 36.4437 15.0261C35.6909 15.0444 34.9517 14.8243 34.3336 14.3978Z" fill="currentColor"></path><path d="M40.0249 7.3258C39.9622 7.26266 39.9132 7.18741 39.8809 7.10471C39.8487 7.02201 39.834 6.93363 39.8376 6.84505C39.8335 6.75805 39.848 6.67117 39.8803 6.59017C39.9126 6.50918 39.9619 6.43591 40.0249 6.37523C40.1621 6.25551 40.3411 6.19374 40.5235 6.20314C40.6104 6.19612 40.6977 6.20791 40.7794 6.23769C40.8612 6.26746 40.9354 6.31451 40.997 6.37558C41.0586 6.43665 41.1061 6.51027 41.1361 6.59134C41.1661 6.6724 41.178 6.75898 41.1709 6.84505C41.1759 6.93387 41.1632 7.0228 41.1334 7.10671C41.1036 7.19063 41.0574 7.26787 40.9974 7.334C40.9348 7.39405 40.8604 7.44077 40.779 7.47131C40.6975 7.50184 40.6106 7.51553 40.5235 7.51155C40.4321 7.51591 40.3406 7.50168 40.2549 7.46974C40.1691 7.4378 40.0909 7.38882 40.0249 7.3258ZM40.1269 14.8648C40.115 14.8541 40.1054 14.841 40.0988 14.8265C40.0921 14.8119 40.0886 14.7961 40.0883 14.7802V9.21057C40.0859 9.19435 40.0874 9.17779 40.0927 9.16226C40.0979 9.14672 40.1069 9.13265 40.1187 9.12119C40.1305 9.10973 40.1449 9.10121 40.1607 9.09633C40.1765 9.09145 40.1932 9.09034 40.2095 9.09311H40.81C40.8277 9.09234 40.8453 9.09509 40.8619 9.10119C40.8784 9.10729 40.8936 9.11661 40.9065 9.12862C40.9283 9.15052 40.9411 9.17976 40.9423 9.21057V14.7884C40.9415 14.8201 40.9287 14.8503 40.9065 14.873C40.8799 14.8963 40.8455 14.909 40.81 14.9086H40.2205C40.2027 14.9079 40.1853 14.9037 40.1692 14.8962C40.1531 14.8887 40.1387 14.878 40.1269 14.8648Z" fill="currentColor"></path><path d="M42.9363 14.8647C42.9175 14.8405 42.9077 14.8105 42.9088 14.78V9.28413C42.9089 9.25952 42.9141 9.23519 42.924 9.21264C42.934 9.19009 42.9485 9.1698 42.9666 9.15302C42.9854 9.13348 43.0081 9.11804 43.0332 9.1077C43.0584 9.09735 43.0854 9.09232 43.1126 9.09293H43.4818C43.5082 9.09203 43.5345 9.09695 43.5588 9.10734C43.5831 9.11774 43.6048 9.13333 43.6223 9.15302C43.6564 9.1882 43.6752 9.23531 43.6746 9.28413V10.2456C43.8465 9.86676 44.1176 9.54043 44.4597 9.30052C44.8126 9.06846 45.2292 8.95016 45.6525 8.96181C46.0828 8.95016 46.5077 9.05903 46.8784 9.27594C47.2303 9.50026 47.4991 9.83198 47.6443 10.2211C47.8547 9.84688 48.1558 9.53053 48.5203 9.30052C48.8864 9.07283 49.3113 8.95518 49.7434 8.96181C50.0413 8.94617 50.3391 8.99555 50.6156 9.10646C50.8922 9.21738 51.1408 9.38712 51.344 9.60372C51.7315 10.0317 51.9252 10.6818 51.9252 11.554L51.939 14.7773C51.9402 14.7948 51.9376 14.8124 51.9314 14.8288C51.9252 14.8453 51.9155 14.8602 51.903 14.8727C51.8905 14.8851 51.8754 14.8947 51.8588 14.9009C51.8422 14.907 51.8244 14.9096 51.8068 14.9084H51.2062C51.1885 14.9096 51.1708 14.907 51.1542 14.9009C51.1376 14.8947 51.1225 14.8851 51.11 14.8727C51.0975 14.8602 51.0878 14.8453 51.0816 14.8288C51.0754 14.8124 51.0728 14.7948 51.074 14.7773V11.554C51.074 10.374 50.5947 9.78127 49.636 9.78127C49.4095 9.77873 49.1853 9.82648 48.9799 9.92101C48.7744 10.0155 48.5929 10.1545 48.4487 10.3276C48.1077 10.7391 47.8986 11.2423 47.8481 11.7726V14.7882C47.8482 14.819 47.8375 14.8489 47.8178 14.8729C47.8084 14.8841 47.7966 14.8931 47.7833 14.8992C47.7699 14.9054 47.7554 14.9085 47.7407 14.9084H47.1649C47.1304 14.907 47.0978 14.8923 47.074 14.8674C47.0491 14.8437 47.0343 14.8114 47.0327 14.7773V11.2809C46.9703 10.2811 46.4827 9.78127 45.5699 9.78127C45.2287 9.77787 44.8965 9.88961 44.6278 10.0981C44.3425 10.3211 44.1181 10.6112 43.9749 10.9422C43.8085 11.307 43.7149 11.7003 43.6994 12.1003V14.7773C43.7002 14.7948 43.6974 14.8122 43.6912 14.8286C43.6851 14.8451 43.6757 14.8601 43.6636 14.8729C43.6373 14.8966 43.6027 14.9093 43.5672 14.9084H43.0162C43.0005 14.9073 42.9852 14.9029 42.9714 14.8953C42.9575 14.8878 42.9456 14.8773 42.9363 14.8647Z" fill="currentColor"></path><path d="M53.9173 18.1422C53.8969 18.123 53.8809 18.0996 53.8704 18.0737C53.86 18.0477 53.8553 18.0199 53.8567 17.992V9.27018C53.8591 9.22038 53.8808 9.17342 53.9173 9.13907C53.9362 9.12061 53.9586 9.10605 53.9831 9.0962C54.0077 9.08636 54.034 9.08143 54.0605 9.08171H54.5178C54.5693 9.08338 54.6183 9.1038 54.6556 9.13907C54.6752 9.15511 54.6913 9.17507 54.7027 9.19766C54.7141 9.22025 54.7206 9.24495 54.7217 9.27018V10.1743C54.9488 9.78981 55.2787 9.47502 55.6749 9.26472C56.1069 9.04667 56.5869 8.93872 57.0715 8.95059C57.6124 8.93952 58.1465 9.07052 58.6197 9.33028C59.0642 9.58201 59.4258 9.95575 59.6611 10.4065C59.9154 10.8969 60.0432 11.4422 60.033 11.9935C60.0439 12.5432 59.9161 13.0869 59.6611 13.5751C59.4248 14.0237 59.0633 14.3955 58.6197 14.6458C58.1465 14.9056 57.6124 15.0366 57.0715 15.0255C56.587 15.0362 56.1073 14.9283 55.6749 14.7114C55.2738 14.5038 54.9361 14.1935 54.6969 13.8127V17.9865C54.6992 18.014 54.6955 18.0417 54.6859 18.0676C54.6764 18.0936 54.6614 18.1171 54.6418 18.1368C54.6218 18.1549 54.5983 18.1688 54.5728 18.1778C54.5472 18.1867 54.5201 18.1904 54.493 18.1887H54.0743C54.0463 18.1918 54.018 18.1893 53.991 18.1813C53.9641 18.1733 53.939 18.16 53.9173 18.1422ZM58.6005 13.5942C58.8041 13.3821 58.9627 13.1316 59.0668 12.8576C59.1709 12.5836 59.2184 12.2916 59.2065 11.999C59.2188 11.7059 59.1715 11.4134 59.0674 11.1389C58.9633 10.8644 58.8045 10.6134 58.6005 10.401C58.3909 10.1946 58.1405 10.0335 57.865 9.9277C57.5896 9.82193 57.295 9.77384 56.9999 9.78644C56.7019 9.77483 56.4045 9.8225 56.1254 9.92665C55.8463 10.0308 55.591 10.1893 55.3746 10.3928C54.9642 10.8276 54.7359 11.4008 54.7359 11.9963C54.7359 12.5917 54.9642 13.1649 55.3746 13.5997C55.5923 13.8025 55.8488 13.9602 56.1288 14.0634C56.4089 14.1666 56.7069 14.2132 57.0054 14.2006C57.2974 14.2097 57.5882 14.1602 57.8604 14.055C58.1326 13.9499 58.3806 13.7913 58.5894 13.5887L58.6005 13.5942Z" fill="currentColor"></path><path d="M61.57 14.8646C61.5585 14.8537 61.5493 14.8406 61.5432 14.826C61.537 14.8114 61.534 14.7957 61.5342 14.7799V5.9161C61.5342 5.84508 61.5728 5.80957 61.6526 5.80957H62.2532C62.3413 5.80957 62.3854 5.84508 62.3854 5.9161V14.7881C62.3798 14.8185 62.3631 14.8457 62.3386 14.8646C62.312 14.8879 62.2776 14.9005 62.2422 14.9001H61.6526C61.6218 14.8982 61.5925 14.8857 61.57 14.8646Z" fill="currentColor"></path><path d="M65.4079 14.657C64.9373 14.4129 64.548 14.0391 64.2867 13.5807C64.0119 13.0969 63.8731 12.5489 63.8845 11.9937C63.873 11.4427 64.0049 10.898 64.2674 10.4122C64.5153 9.96102 64.8881 9.58952 65.3418 9.3414C65.8297 9.08089 66.3773 8.95008 66.9313 8.96171C67.3454 8.9396 67.7596 9.00514 68.1462 9.15396C68.5328 9.30278 68.8831 9.53149 69.1737 9.82488C69.7247 10.3985 70.0001 11.1925 70.0001 12.2068C70.0001 12.3188 69.9561 12.3734 69.8679 12.3734H64.7467C64.8164 12.8965 65.088 13.3724 65.5043 13.7009C65.9541 14.0412 66.5092 14.216 67.0745 14.1953C67.3948 14.2168 67.716 14.1693 68.016 14.0562C68.3161 13.943 68.5879 13.7669 68.8128 13.5398C68.8403 13.5078 68.8784 13.4865 68.9203 13.4797C68.9389 13.4806 68.9572 13.4855 68.9738 13.494C68.9904 13.5025 69.005 13.5144 69.0167 13.5288L69.4492 13.9195C69.4877 13.9604 69.5098 13.9905 69.5098 14.0151C69.5085 14.0335 69.5034 14.0515 69.4949 14.0679C69.4864 14.0843 69.4746 14.0989 69.4602 14.1107C69.1806 14.418 68.8312 14.6549 68.4409 14.8017C68.0011 14.9667 67.5337 15.0474 67.0635 15.0394C66.4883 15.0494 65.9195 14.918 65.4079 14.657ZM69.1131 11.614C69.0518 11.0968 68.7972 10.6212 68.3996 10.281C67.9773 9.957 67.4584 9.78117 66.9244 9.78117C66.3904 9.78117 65.8715 9.957 65.4492 10.281C65.0536 10.6221 64.8011 11.0976 64.7412 11.614H69.1131Z" fill="currentColor"></path>', 14)
  ]));
}
const r6 = /* @__PURE__ */ U(Q4, [["render", t6]]), u6 = {}, n6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none"
};
function a6(r, t) {
  return m(), x("svg", n6, t[0] || (t[0] = [
    C("path", {
      d: "M19.5 19.5L15.15 15.15M17.5 9.5C17.5 13.9183 13.9183 17.5 9.5 17.5C5.08172 17.5 1.5 13.9183 1.5 9.5C1.5 5.08172 5.08172 1.5 9.5 1.5C13.9183 1.5 17.5 5.08172 17.5 9.5Z",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const bc = /* @__PURE__ */ U(u6, [["render", a6]]), i6 = {}, o6 = {
  id: "Capa_1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  "xml:space": "preserve"
};
function s6(r, t) {
  return m(), x("svg", o6, t[0] || (t[0] = [
    C("g", null, [
      C("g", null, [
        C("path", {
          fill: "currentColor",
          d: "M481.508,210.335L68.414,38.926c-17.403-7.222-37.063-4.045-51.309,8.287C2.859,59.547-3.099,78.55,1.557,96.808    L42.151,256L1.557,415.192c-4.656,18.258,1.301,37.261,15.547,49.595c14.273,12.358,33.938,15.495,51.31,8.287l413.094-171.409    C500.316,293.861,512,276.363,512,256C512,235.637,500.316,218.139,481.508,210.335z M470.009,273.955L56.916,445.364    c-6.947,2.881-14.488,1.665-20.175-3.259c-5.686-4.923-7.971-12.212-6.113-19.501L69.287,271h149.065    c8.285,0,15.001-6.716,15.001-15.001c0-8.285-6.716-15.001-15.001-15.001H69.288L30.628,89.396    c-1.858-7.288,0.427-14.578,6.113-19.501c5.686-4.923,13.225-6.141,20.174-3.259l413.094,171.409    c11.125,4.616,11.99,14.91,11.99,17.955S481.134,269.339,470.009,273.955z"
        })
      ])
    ], -1),
    C("g", null, null, -1),
    C("g", null, null, -1),
    C("g", null, null, -1),
    C("g", null, null, -1),
    C("g", null, null, -1),
    C("g", null, null, -1),
    C("g", null, null, -1),
    C("g", null, null, -1),
    C("g", null, null, -1),
    C("g", null, null, -1),
    C("g", null, null, -1),
    C("g", null, null, -1),
    C("g", null, null, -1),
    C("g", null, null, -1),
    C("g", null, null, -1)
  ]));
}
const l6 = /* @__PURE__ */ U(i6, [["render", s6]]), c6 = {}, d6 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function f6(r, t) {
  return m(), x("svg", d6, t[0] || (t[0] = [
    C("path", {
      d: "M25.3499 21.7253C24.7963 21.1498 24.1286 20.8421 23.421 20.8421C22.7191 20.8421 22.0457 21.1441 21.4693 21.7196L19.6659 23.5147C19.5175 23.4349 19.3691 23.3608 19.2265 23.2867C19.021 23.1842 18.827 23.0873 18.6615 22.9847C16.9723 21.9134 15.4371 20.5172 13.9648 18.7108C13.2514 17.8104 12.7721 17.0525 12.4239 16.2832C12.8919 15.8558 13.3256 15.4114 13.7479 14.984C13.9077 14.8244 14.0675 14.6591 14.2273 14.4996C15.4257 13.3029 15.4257 11.7529 14.2273 10.5562L12.6693 9.0005C12.4924 8.82384 12.3098 8.64149 12.1386 8.45914C11.7962 8.10583 11.4367 7.74112 11.0657 7.39921C10.5121 6.85215 9.85016 6.56152 9.15392 6.56152C8.45769 6.56152 7.78428 6.85215 7.2136 7.39921C7.20789 7.40491 7.20789 7.40491 7.20219 7.41061L5.26186 9.3652C4.53139 10.0946 4.11479 10.9836 4.02348 12.015C3.88652 13.679 4.37731 15.229 4.75396 16.2433C5.67846 18.7336 7.05952 21.0415 9.11968 23.5147C11.6193 26.495 14.6268 28.8485 18.0623 30.5068C19.3749 31.1279 21.1269 31.863 23.0843 31.9884C23.2041 31.9941 23.3297 31.9998 23.4438 31.9998C24.7621 31.9998 25.8692 31.5268 26.7367 30.5866C26.7424 30.5752 26.7538 30.5695 26.7595 30.5581C27.0562 30.1991 27.3987 29.8742 27.7582 29.5266C28.0036 29.293 28.2547 29.048 28.5001 28.7915C29.0651 28.2046 29.3618 27.5207 29.3618 26.8198C29.3618 26.1132 29.0593 25.4351 28.483 24.8652L25.3499 21.7253ZM27.393 27.7259C27.3872 27.7259 27.3872 27.7316 27.393 27.7259C27.1704 27.9652 26.9421 28.1818 26.6967 28.4211C26.3258 28.7744 25.9491 29.1448 25.5953 29.5608C25.0189 30.1763 24.3398 30.4669 23.4495 30.4669C23.3639 30.4669 23.2726 30.4669 23.187 30.4612C21.4921 30.3529 19.917 29.6919 18.7357 29.1277C15.5056 27.5663 12.6693 25.3496 10.3124 22.5402C8.36638 20.1981 7.06522 18.0327 6.20349 15.7077C5.67276 14.2887 5.47872 13.1832 5.56433 12.1404C5.6214 11.4737 5.8782 10.9209 6.35187 10.4479L8.2979 8.50472C8.57753 8.24259 8.87429 8.10013 9.16534 8.10013C9.52487 8.10013 9.81592 8.31667 9.99853 8.49903C10.0042 8.50472 10.0099 8.51042 10.0157 8.51612C10.3638 8.84094 10.6948 9.17715 11.0429 9.53616C11.2198 9.71851 11.4024 9.90087 11.585 10.0889L13.143 11.6446C13.7479 12.2487 13.7479 12.8071 13.143 13.4112C12.9775 13.5764 12.8177 13.7417 12.6522 13.9012C12.1728 14.3913 11.7163 14.8472 11.2198 15.2917C11.2084 15.3031 11.197 15.3088 11.1913 15.3202C10.7005 15.8102 10.7918 16.2889 10.8945 16.6137C10.9002 16.6308 10.9059 16.6479 10.9116 16.665C11.3168 17.6452 11.8875 18.5683 12.7549 19.6682L12.7606 19.6739C14.3357 21.6114 15.9964 23.1215 17.8283 24.2783C18.0623 24.4264 18.302 24.5461 18.5302 24.6601C18.7357 24.7627 18.9297 24.8595 19.0952 24.9621C19.118 24.9735 19.1409 24.9906 19.1637 25.002C19.3577 25.0989 19.5404 25.1445 19.7287 25.1445C20.2023 25.1445 20.4991 24.8481 20.5961 24.7513L22.5479 22.8024C22.7419 22.6086 23.0501 22.375 23.4096 22.375C23.7634 22.375 24.0545 22.5972 24.2314 22.791C24.2371 22.7967 24.2371 22.7967 24.2428 22.8024L27.3872 25.9422C27.975 26.5235 27.975 27.1218 27.393 27.7259Z",
      fill: "currentColor"
    }, null, -1),
    C("path", {
      d: "M18.5931 11.4226C20.0883 11.6733 21.4466 12.3799 22.5309 13.4627C23.6152 14.5454 24.3171 15.9016 24.5739 17.3947C24.6367 17.7708 24.962 18.0329 25.3329 18.0329C25.3786 18.0329 25.4185 18.0272 25.4642 18.0215C25.8865 17.9531 26.1661 17.5542 26.0976 17.1325C25.7895 15.3261 24.9334 13.6792 23.6266 12.3743C22.3197 11.0693 20.6704 10.2145 18.8614 9.90678C18.4391 9.8384 18.0453 10.1176 17.9711 10.5336C17.8969 10.9496 18.1708 11.3542 18.5931 11.4226Z",
      fill: "currentColor"
    }, null, -1),
    C("path", {
      d: "M30.9885 16.9103C30.4806 13.9356 29.0767 11.2288 26.9195 9.07479C24.7623 6.92074 22.0516 5.5189 19.0726 5.01173C18.656 4.93765 18.2622 5.22257 18.188 5.63857C18.1196 6.06026 18.3992 6.45346 18.8215 6.52754C21.4809 6.97772 23.9063 8.2371 25.8352 10.1575C27.7641 12.0836 29.0196 14.5055 29.4704 17.161C29.5332 17.5371 29.8585 17.7992 30.2295 17.7992C30.2751 17.7992 30.3151 17.7935 30.3607 17.7878C30.7773 17.7252 31.0627 17.3263 30.9885 16.9103Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const p6 = /* @__PURE__ */ U(c6, [["render", f6]]), h6 = {}, m6 = {
  width: "36",
  height: "37",
  viewBox: "0 0 36 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function v6(r, t) {
  return m(), x("svg", m6, t[0] || (t[0] = [
    C("path", {
      d: "M28.1309 2.5H19.3397H10.0592C7.82656 2.5041 6.01472 4.30142 6 6.52664V30.4732C6.01472 32.6984 7.82656 34.4957 10.0592 34.4998H28.1424C28.6389 34.5071 29.1177 34.3166 29.4725 33.9703C29.8111 33.6236 30.0004 33.1589 30 32.675V4.36285C29.9979 3.33485 29.1623 2.5021 28.1309 2.5ZM20.1118 4.0238H24.603V11.1704L23.0091 8.6371C22.9445 8.52987 22.8545 8.44006 22.7469 8.37577C22.3848 8.1593 21.9152 8.27625 21.698 8.6371L20.1118 11.159V4.0238ZM7.54802 6.52664C7.55432 5.14694 8.67492 4.03009 10.0592 4.0238H18.5829V11.7952C18.5541 12.4137 18.9438 12.9752 19.5346 13.1666C20.2074 13.3685 20.8113 12.9342 21.1706 12.3628L22.3593 10.458L23.548 12.3628C23.9035 12.9266 24.5074 13.3609 25.1992 13.1666C25.7873 12.9759 26.1762 12.4186 26.151 11.8028V4.04285H28.1424C28.3189 4.04494 28.4613 4.18694 28.4634 4.36285V26.4575C28.3574 26.4396 28.25 26.4307 28.1424 26.4313H10.0592C9.14735 26.431 8.26221 26.7385 7.54802 27.3037V6.52664Z",
      fill: "currentColor"
    }, null, -1),
    C("path", {
      d: "M8 30.5C8 29.1193 9.11929 28 10.5 28H28.5V33H10.5C9.11929 33 8 31.8807 8 30.5Z",
      fill: "#E5E6F5"
    }, null, -1)
  ]));
}
const g6 = /* @__PURE__ */ U(h6, [["render", v6]]), b6 = {}, y6 = {
  width: "36",
  height: "37",
  viewBox: "0 0 36 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _6(r, t) {
  return m(), x("svg", y6, t[0] || (t[0] = [
    C("path", {
      d: "M10.3 31.5C10.1677 31.5 10.0345 31.4694 9.9094 31.4081C9.5989 31.253 9.4 30.9289 9.4 30.5714V25.9286H6.7C5.2114 25.9286 4 24.6787 4 23.1429V8.28571C4 6.74986 5.2114 5.5 6.7 5.5H28.3C29.7886 5.5 31 6.74986 31 8.28571V23.1429C31 24.6787 29.7886 25.9286 28.3 25.9286H17.3659L10.8625 31.2966C10.6996 31.4313 10.5007 31.5 10.3 31.5ZM6.7 7.35714C6.2032 7.35714 5.8 7.77407 5.8 8.28571V23.1429C5.8 23.6545 6.2032 24.0714 6.7 24.0714H10.3C10.7977 24.0714 11.2 24.4865 11.2 25V28.64L16.4875 24.2748C16.6477 24.1429 16.8448 24.0714 17.05 24.0714H28.3C28.7968 24.0714 29.2 23.6545 29.2 23.1429V8.28571C29.2 7.77407 28.7968 7.35714 28.3 7.35714H6.7Z",
      fill: "#6B75D1"
    }, null, -1),
    C("path", {
      d: "M24.6999 14.7859H10.2999C9.8022 14.7859 9.3999 14.3699 9.3999 13.8573C9.3999 13.3447 9.8022 12.9287 10.2999 12.9287H24.6999C25.1976 12.9287 25.5999 13.3447 25.5999 13.8573C25.5999 14.3699 25.1976 14.7859 24.6999 14.7859Z",
      fill: "#6B75D1"
    }, null, -1),
    C("path", {
      d: "M17.4999 18.4997H10.2999C9.8022 18.4997 9.3999 18.0837 9.3999 17.5711C9.3999 17.0586 9.8022 16.6426 10.2999 16.6426H17.4999C17.9976 16.6426 18.3999 17.0586 18.3999 17.5711C18.3999 18.0837 17.9976 18.4997 17.4999 18.4997Z",
      fill: "#6B75D1"
    }, null, -1)
  ]));
}
const w6 = /* @__PURE__ */ U(b6, [["render", _6]]), C6 = /* @__PURE__ */ ue({
  __name: "VSupportCenter",
  props: {
    isModalShow: { type: Boolean }
  },
  emits: ["update:is-modal-show"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G({
      get() {
        return e.isModalShow;
      },
      set(a) {
        u("update:is-modal-show", a);
      }
    });
    return (a, o) => (m(), H(p(Ss), {
      modelValue: n.value,
      "onUpdate:modelValue": o[1] || (o[1] = (s) => n.value = s),
      class: b(a.$style["v-support-center"])
    }, {
      default: J(() => [
        C("div", {
          class: b(a.$style["v-support-center__header"])
        }, [
          C("div", {
            class: b(a.$style["v-support-center__header-title"])
          }, [
            j(r6),
            o[2] || (o[2] = C("div", null, " | Support Center", -1))
          ], 2),
          C("div", {
            class: b(a.$style["v-support-center__header-wrapper"])
          }, o[3] || (o[3] = [
            C("h2", null, "Got a question? We’re here to help", -1)
          ]), 2),
          C("div", {
            class: b(a.$style["v-support-center__close"]),
            onClick: o[0] || (o[0] = (s) => n.value = !1)
          }, [
            j(Wt)
          ], 2)
        ], 2),
        C("div", {
          class: b(a.$style["v-support-center__body"])
        }, [
          C("div", {
            class: b(a.$style["v-support-center__info-item"])
          }, [
            C("div", {
              class: b(a.$style["v-support-center__info-icon"])
            }, [
              j(p6)
            ], 2),
            C("div", {
              class: b(a.$style["v-support-center__info-content"])
            }, o[4] || (o[4] = [
              C("h5", null, "Give us a call", -1),
              ce(" We’re happy to assist you, whenever you need us. ", -1)
            ]), 2),
            C("div", {
              class: b([
                a.$style["v-support-center__info-content"],
                a.$style["v-support-center__info-content-action"]
              ])
            }, o[5] || (o[5] = [
              C("a", { href: "tel:(812) 909-9244" }, [
                C("b", null, "(812) 909-9244")
              ], -1),
              ce(" Mary Mittel | VSimple Agent ", -1)
            ]), 2)
          ], 2),
          C("div", {
            class: b(a.$style["v-support-center__info-item"])
          }, [
            C("div", {
              class: b(a.$style["v-support-center__info-icon"])
            }, [
              j(g6)
            ], 2),
            C("div", {
              class: b(a.$style["v-support-center__info-content"])
            }, o[6] || (o[6] = [
              C("h5", null, "Knowledge base", -1),
              ce(" Find answers to the most popular FAQs,", -1),
              C("br", null, null, -1),
              ce(" Read and learn from our knowledge base. ", -1)
            ]), 2),
            C("div", {
              class: b(a.$style["v-support-center__info-content-action"])
            }, [
              j(p(vt), {
                href: "https://docs.vsimple.com/",
                target: "_blank",
                tag: p(sn).LINK,
                rel: "noopener noreferrer"
              }, {
                icon: J(() => [
                  j(bc)
                ]),
                default: J(() => [
                  o[7] || (o[7] = ce(" View articles ", -1))
                ]),
                _: 1,
                __: [7]
              }, 8, ["tag"])
            ], 2)
          ], 2),
          C("div", {
            class: b(a.$style["v-support-center__info-item"])
          }, [
            C("div", {
              class: b(a.$style["v-support-center__info-icon"])
            }, [
              j(w6)
            ], 2),
            C("div", {
              class: b(a.$style["v-support-center__info-content"])
            }, o[8] || (o[8] = [
              C("h5", null, "Send us a message", -1),
              ce(" Get in touch with us and resolve", -1),
              C("br", null, null, -1),
              ce(" any questions you may have. ", -1)
            ]), 2),
            C("div", {
              class: b(a.$style["v-support-center__info-content-action"])
            }, [
              j(p(vt), {
                tag: p(sn).LINK,
                href: "mailto:support@vsimple.com"
              }, {
                icon: J(() => [
                  j(l6)
                ]),
                default: J(() => [
                  o[9] || (o[9] = ce(" Send message ", -1))
                ]),
                _: 1,
                __: [9]
              }, 8, ["tag"])
            ], 2)
          ], 2)
        ], 2)
      ]),
      _: 1
    }, 8, ["modelValue", "class"]));
  }
}), D6 = "_vfm__content_2fv97_2", A6 = {
  "v-support-center": "_v-support-center_2fv97_2",
  vfm__content: D6,
  "v-support-center__body": "_v-support-center__body_2fv97_6",
  "v-support-center__info-item": "_v-support-center__info-item_2fv97_30",
  "v-support-center__info-content-action": "_v-support-center__info-content-action_2fv97_37",
  "v-support-center__header-wrapper": "_v-support-center__header-wrapper_2fv97_37",
  "v-support-center__header": "_v-support-center__header_2fv97_37",
  "v-support-center__header-title": "_v-support-center__header-title_2fv97_50",
  "v-support-center__close": "_v-support-center__close_2fv97_61",
  "v-support-center__info-icon": "_v-support-center__info-icon_2fv97_122",
  "v-support-center__info-content": "_v-support-center__info-content_2fv97_37"
}, x6 = {
  $style: A6
}, Ux = /* @__PURE__ */ U(C6, [["__cssModules", x6]]), E6 = {}, k6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function S6(r, t) {
  return m(), x("svg", k6, t[0] || (t[0] = [
    C("rect", {
      x: "3",
      y: "5",
      width: "18",
      height: "1.6",
      rx: "0.8",
      fill: "currentColor"
    }, null, -1),
    C("rect", {
      x: "3",
      y: "11.1",
      width: "18",
      height: "1.6",
      rx: "0.8",
      fill: "currentColor"
    }, null, -1),
    C("rect", {
      x: "3",
      y: "17.2",
      width: "18",
      height: "1.6",
      rx: "0.8",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const T6 = /* @__PURE__ */ U(E6, [["render", S6]]), B6 = /* @__PURE__ */ ue({
  __name: "VTopbarMobile",
  props: {
    isOpen: { type: Boolean },
    hasNotification: { type: Boolean },
    hasTasks: { type: Boolean }
  },
  emits: ["update:isOpen"],
  setup(r, { emit: t }) {
    const e = t;
    return (u, n) => (m(), x("div", {
      class: b(u.$style["v-topbar-mobile"])
    }, [
      K(u.$slots, "search"),
      C("div", {
        class: b(u.$style["v-topbar-mobile__actions"])
      }, [
        u.hasTasks ? (m(), x("div", {
          key: 0,
          class: b(u.$style["v-topbar-mobile__icon"])
        }, [
          K(u.$slots, "tasks")
        ], 2)) : R("", !0),
        u.hasNotification ? (m(), x("div", {
          key: 1,
          class: b(u.$style["v-topbar-mobile__icon"])
        }, [
          K(u.$slots, "notification")
        ], 2)) : R("", !0),
        C("div", {
          class: b([
            u.$style["v-topbar-mobile__icon"],
            {
              [u.$style["v-topbar-mobile__icon--close"]]: u.isOpen
            }
          ]),
          onClick: n[0] || (n[0] = (a) => e("update:isOpen", !u.isOpen))
        }, [
          u.isOpen ? (m(), H(Wt, { key: 0 })) : (m(), H(T6, { key: 1 }))
        ], 2)
      ], 2)
    ], 2));
  }
}), $6 = {
  "v-topbar-mobile": "_v-topbar-mobile_j703w_1",
  "v-topbar-mobile__actions": "_v-topbar-mobile__actions_j703w_9",
  "v-topbar-mobile__icon": "_v-topbar-mobile__icon_j703w_16",
  "v-topbar-mobile__icon--close": "_v-topbar-mobile__icon--close_j703w_28"
}, M6 = {
  $style: $6
}, zx = /* @__PURE__ */ U(B6, [["__cssModules", M6]]), O6 = ["onClick"], L6 = /* @__PURE__ */ ue({
  __name: "VSidebarMobile",
  props: {
    routesGroups: { default: () => [] },
    profileSubtitle: { default: "" },
    profileFirstName: { default: "" },
    profileLastName: { default: "" },
    profileEmail: { default: "" },
    profileActions: {},
    isOpen: { type: Boolean, default: !1 },
    status: { default: null }
  },
  emits: ["update:status"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = Q(!1);
    return qe(() => e.isOpen, (a) => {
      a || (n.value = !1);
    }), (a, o) => (m(), x("div", {
      class: b([
        a.$style["v-sidebar-mobile"],
        {
          [a.$style["v-sidebar-mobile--open"]]: a.isOpen,
          [a.$style["v-sidebar-mobile--fullscreen"]]: n.value
        }
      ])
    }, [
      n.value ? (m(), x(pe, { key: 0 }, [
        C("div", {
          class: b([
            a.$style["v-sidebar-mobile__profile"],
            a.$style["v-sidebar-mobile__profile--open"]
          ])
        }, [
          j(p(Oo), {
            "first-name": a.profileFirstName,
            "last-name": a.profileLastName,
            subtitle: a.profileEmail,
            simple: ""
          }, {
            "trigger-icon": J(() => [
              C("div", {
                class: b(a.$style["v-sidebar-mobile__profile-trigger-icon"]),
                onClick: o[0] || (o[0] = (s) => n.value = !1)
              }, [
                j(Wt)
              ], 2)
            ]),
            _: 1
          }, 8, ["first-name", "last-name", "subtitle"]),
          j(p(pc), {
            status: a.status,
            "onUpdate:status": o[1] || (o[1] = (s) => u("update:status", s))
          }, null, 8, ["status"]),
          K(a.$slots, "outlook-integration-mobile")
        ], 2),
        C("div", {
          class: b(a.$style["v-sidebar-mobile__profile-actions"])
        }, [
          (m(!0), x(pe, null, ge(a.profileActions, (s, i) => (m(), x("div", {
            key: i,
            class: b([
              a.$style["v-sidebar-mobile__profile-action"],
              {
                [a.$style["v-sidebar-mobile__profile-action--active"]]: s.active,
                [a.$style["v-sidebar-mobile__profile-action--danger"]]: s.type === "danger"
              }
            ]),
            onClick: (l) => s.action()
          }, [
            ce(ne(s.title) + " ", 1),
            s.active ? (m(), H(Eu, { key: 0 })) : R("", !0)
          ], 10, O6))), 128))
        ], 2)
      ], 64)) : (m(), x("div", {
        key: 1,
        class: b(a.$style["v-sidebar-mobile__routes-wrapper"])
      }, [
        (m(!0), x(pe, null, ge(a.routesGroups, (s, i) => (m(), x("div", { key: i }, [
          C("nav", {
            class: b(a.$style["v-sidebar-mobile__routes-group"])
          }, [
            C("div", {
              class: b(a.$style["v-sidebar-mobile__routes-group-wrapper"])
            }, [
              (m(!0), x(pe, null, ge(s, (l, d) => (m(), H(p(Rs), {
                key: d,
                collapsed: !1,
                to: l.to,
                title: l.title,
                icon: l.icon,
                active: l.active,
                action: l.action,
                "sub-routes": l.subRoutes,
                "open-on-click": ""
              }, null, 8, ["to", "title", "icon", "active", "action", "sub-routes"]))), 128))
            ], 2)
          ], 2)
        ]))), 128)),
        C("div", {
          class: b(a.$style["v-sidebar-mobile__profile"])
        }, [
          j(p(Oo), {
            "first-name": a.profileFirstName,
            "last-name": a.profileLastName,
            subtitle: a.profileSubtitle,
            simple: "",
            onClick: o[2] || (o[2] = (s) => n.value = !0)
          }, null, 8, ["first-name", "last-name", "subtitle"])
        ], 2)
      ], 2))
    ], 2));
  }
}), F6 = {
  "v-sidebar-mobile": "_v-sidebar-mobile_mxwjf_1",
  "v-sidebar-mobile--open": "_v-sidebar-mobile--open_mxwjf_14",
  "v-sidebar-mobile--fullscreen": "_v-sidebar-mobile--fullscreen_mxwjf_18",
  "v-sidebar-mobile__routes-group": "_v-sidebar-mobile__routes-group_mxwjf_23",
  "v-sidebar-mobile__profile": "_v-sidebar-mobile__profile_mxwjf_31",
  "v-sidebar-mobile__profile--open": "_v-sidebar-mobile__profile--open_mxwjf_35",
  "v-sidebar-mobile__profile-trigger-icon": "_v-sidebar-mobile__profile-trigger-icon_mxwjf_41",
  "v-sidebar-mobile__profile-actions": "_v-sidebar-mobile__profile-actions_mxwjf_56",
  "v-sidebar-mobile__profile-action": "_v-sidebar-mobile__profile-action_mxwjf_56",
  "v-sidebar-mobile__profile-action--active": "_v-sidebar-mobile__profile-action--active_mxwjf_95",
  "v-sidebar-mobile__profile-action--danger": "_v-sidebar-mobile__profile-action--danger_mxwjf_99"
}, I6 = {
  $style: F6
}, Gx = /* @__PURE__ */ U(L6, [["__cssModules", I6]]), N6 = /* @__PURE__ */ ue({
  __name: "VChip",
  props: {
    content: { default: "" },
    maxLength: { default: 1 / 0 },
    type: { default: "default" }
  },
  setup(r) {
    const t = tt(), e = be();
    return (u, n) => (m(), H(p(yt), {
      content: u.content,
      "max-length": u.maxLength,
      class: b([
        p(e)["v-chip"],
        p(e)[`v-chip--${u.type}`]
      ])
    }, mt({ _: 2 }, [
      p(t).icon ? {
        name: "icon",
        fn: J(() => [
          K(u.$slots, "icon")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["content", "max-length", "class"]));
  }
}), q6 = {
  "v-chip": "_v-chip_ggez1_1",
  "v-chip--danger": "_v-chip--danger_ggez1_13"
}, P6 = {
  $style: q6
}, R6 = /* @__PURE__ */ U(N6, [["__cssModules", P6]]), V6 = ["onClick"], j6 = /* @__PURE__ */ ue({
  __name: "VRecordTypeSelect",
  props: {
    recordType: {},
    recordTypes: {},
    disabled: { type: Boolean, default: !1 },
    placement: { default: "bottom" }
  },
  emits: ["update:recordType"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G(
      () => e.recordTypes.find(({ slug: D }) => D === e.recordType) || null
    ), a = Q(!1), o = Q(null), s = Q(), i = Q(), l = () => {
      var D;
      o.value && ((D = o.value) == null || D.destroy(), o.value = null), i.value && document.body.removeChild(i.value);
    };
    qe(() => a.value, async (D) => {
      await Pe(), !(!s.value || !i.value) && (D && s.value && (o.value = Tt(s.value, i.value, {
        placement: e.placement,
        modifiers: [
          St,
          {
            name: "offset",
            options: {
              offset: [0, 4]
            }
          }
        ]
      }), document.body.appendChild(i.value)), !D && o.value && l());
    });
    const d = () => {
      e.disabled || (a.value = !1);
    }, h = () => {
      e.disabled || (a.value = !a.value);
    }, c = (D) => {
      D !== e.recordType && (u("update:recordType", D), d());
    }, f = Q(null);
    Zt(f, () => {
      d();
    }, {
      ignore: [i]
    }), Yt(() => {
      l();
    });
    const g = be();
    return (D, _) => {
      var O;
      return m(), x("div", {
        ref_key: "recordTypeSelect",
        ref: f,
        class: b([
          p(g)["v-record-type-select"],
          {
            [p(g)["v-record-type-select--disabled"]]: D.disabled
          }
        ])
      }, [
        C("div", {
          ref_key: "trigger",
          ref: s,
          class: b([
            p(g)["v-record-type-select__trigger"],
            {
              [p(g)["v-record-type-select__trigger--open"]]: a.value
            }
          ]),
          onClick: _[0] || (_[0] = (M) => h())
        }, [
          j(p(R6), {
            content: (O = n.value) == null ? void 0 : O.name,
            "max-length": 20
          }, mt({ _: 2 }, [
            D.disabled ? void 0 : {
              name: "icon",
              fn: J(() => [
                j(kt, {
                  class: b(p(g)["v-record-type-select__toggle"])
                }, null, 8, ["class"])
              ]),
              key: "0"
            }
          ]), 1032, ["content"])
        ], 2),
        a.value ? (m(), x("div", {
          key: 0,
          ref_key: "options",
          ref: i,
          class: b(p(g)["v-record-type-select__options"])
        }, [
          (m(!0), x(pe, null, ge(D.recordTypes, (M) => (m(), x("div", {
            key: M.slug,
            class: b([
              p(g)["v-record-type-select__option"],
              {
                [p(g)["v-record-type-select__option--active"]]: M.slug === D.recordType
              }
            ]),
            onClick: (L) => c(M.slug)
          }, ne(M.name), 11, V6))), 128))
        ], 2)) : R("", !0)
      ], 2);
    };
  }
}), H6 = {
  "v-record-type-select__trigger": "_v-record-type-select__trigger_a6fer_1",
  "v-record-type-select__toggle": "_v-record-type-select__toggle_a6fer_8",
  "v-record-type-select__trigger--open": "_v-record-type-select__trigger--open_a6fer_17",
  "v-record-type-select": "_v-record-type-select_a6fer_1",
  "v-record-type-select__options": "_v-record-type-select__options_a6fer_26",
  "v-record-type-select__option": "_v-record-type-select__option_a6fer_26",
  "v-record-type-select__option--active": "_v-record-type-select__option--active_a6fer_79",
  "v-record-type-select--disabled": "_v-record-type-select--disabled_a6fer_83"
}, U6 = {
  $style: H6
}, yc = /* @__PURE__ */ U(j6, [["__cssModules", U6]]), z6 = {}, G6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16.509 16.509"
};
function W6(r, t) {
  return m(), x("svg", G6, t[0] || (t[0] = [
    C("g", { transform: "translate(0.125 0.384)" }, [
      C("line", {
        x1: "8",
        y2: "8",
        transform: "translate(7.5 0.5)",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.75"
      }),
      C("path", {
        d: "M8.5.5h7v7",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.75"
      }),
      C("path", {
        d: "M4.5.5H2A1.5,1.5,0,0,0,.5,2V14A1.5,1.5,0,0,0,2,15.5H14A1.5,1.5,0,0,0,15.5,14V11.5",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.75"
      })
    ], -1)
  ]));
}
const Y6 = /* @__PURE__ */ U(z6, [["render", W6]]), Z6 = {}, K6 = {
  class: "b-icon bi bi-filter",
  viewBox: "0 0 16 16",
  width: "1em",
  height: "1em",
  focusable: "false",
  role: "img",
  "aria-label": "filter",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
};
function X6(r, t) {
  return m(), x("svg", K6, t[0] || (t[0] = [
    C("g", null, [
      C("path", { d: "M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" }),
      C("path", { d: "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" })
    ], -1)
  ]));
}
const J6 = /* @__PURE__ */ U(Z6, [["render", X6]]), Q6 = {}, em = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function tm(r, t) {
  return m(), x("svg", em, t[0] || (t[0] = [
    C("path", {
      d: "M3.33301 9.99967H2.66634C2.31272 9.99967 1.97358 9.8592 1.72353 9.60915C1.47348 9.3591 1.33301 9.01996 1.33301 8.66634V2.66634C1.33301 2.31272 1.47348 1.97358 1.72353 1.72353C1.97358 1.47348 2.31272 1.33301 2.66634 1.33301H8.66634C9.01996 1.33301 9.3591 1.47348 9.60915 1.72353C9.8592 1.97358 9.99967 2.31272 9.99967 2.66634V3.33301M7.33301 5.99967H13.333C14.0694 5.99967 14.6663 6.59663 14.6663 7.33301V13.333C14.6663 14.0694 14.0694 14.6663 13.333 14.6663H7.33301C6.59663 14.6663 5.99967 14.0694 5.99967 13.333V7.33301C5.99967 6.59663 6.59663 5.99967 7.33301 5.99967Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const rm = /* @__PURE__ */ U(Q6, [["render", tm]]), um = ["onClick"], nm = /* @__PURE__ */ ue({
  __name: "VActions",
  props: {
    options: {},
    minWidth: { default: "150px" },
    placement: { default: "bottom" },
    emitWholeOption: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    zIndex: { default: 110 }
  },
  emits: ["option:click", "actions:open"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G(() => e.options.map((g) => ({
      ...g,
      _id: Symbol()
    }))), a = Q(null), o = Q(), s = Q();
    Zt(o, () => {
      d.value = !1;
    }, {
      ignore: [s]
    });
    const { stop: i } = $0(o, ([{ isIntersecting: g }]) => {
      !g && d.value && (d.value = !1);
    }), l = () => {
      var g;
      a.value && ((g = a.value) == null || g.destroy(), a.value = null), s.value && document.body.removeChild(s.value);
    }, d = Q(!1);
    qe(() => d.value, async (g) => {
      var D;
      await Pe(), !(!o.value || !s.value) && (g && o.value && (s.value.style.width = `max(${(D = o.value) == null ? void 0 : D.clientWidth}px, ${e.minWidth})`, a.value = Tt(o.value, s.value, {
        placement: e.placement,
        modifiers: [
          St,
          {
            name: "offset",
            options: {
              offset: [0, 4]
            }
          }
        ]
      }), document.body.appendChild(s.value)), !g && a.value && l());
    });
    const h = (g) => {
      g.disabled || (e.emitWholeOption ? u("option:click", g) : u("option:click", g.value), d.value = !1);
    }, c = () => {
      e.disabled || (d.value || u("actions:open"), d.value = !d.value);
    }, f = be();
    return Yt(() => {
      l(), i == null || i();
    }), (g, D) => (m(), x("div", null, [
      C("div", {
        ref_key: "trigger",
        ref: o,
        class: b(p(f)["v-actions__trigger"]),
        onClick: D[0] || (D[0] = (_) => c())
      }, [
        K(g.$slots, "trigger")
      ], 2),
      d.value ? (m(), x("div", {
        key: 0,
        ref_key: "optionsList",
        ref: s,
        class: b(p(f)["v-actions__list"]),
        style: ht({
          zIndex: g.zIndex
        }),
        tabindex: "0"
      }, [
        (m(!0), x(pe, null, ge(n.value, (_) => (m(), H(p(Ve), {
          key: _._id,
          content: _ != null && _.disabled ? _ == null ? void 0 : _.disabledTooltip : "",
          disabled: !(_ != null && _.disabled),
          placement: "top"
        }, {
          default: J(() => [
            C("div", Te({ ref_for: !0 }, _.dataTest ? {
              "data-test": _.dataTest
            } : {}, {
              class: [
                p(f)["v-actions__option"],
                {
                  [p(f)[`v-actions__option--${_.modifier}`]]: _.modifier,
                  [p(f)["v-actions__option--with-icon"]]: _.icon,
                  [p(f)["v-actions__option--with-count"]]: "count" in _,
                  [p(f)["v-actions__option--disabled"]]: _.disabled
                }
              ],
              onClick: (O) => h(_)
            }), [
              _.icon ? (m(), H(He(_.icon), { key: 0 })) : R("", !0),
              ce(" " + ne(_.label) + " ", 1),
              _.count || _.isCountLoading ? (m(), H(p(or), { key: 1 }, {
                content: J(() => [
                  _.isCountLoading ? (m(), x(pe, { key: 0 }, [
                    _.isCountLoading ? (m(), H(p(Cu), {
                      key: 0,
                      size: p(Rt).SMALL
                    }, null, 8, ["size"])) : R("", !0)
                  ], 64)) : (m(), x(pe, { key: 1 }, [
                    ce(ne(_.count), 1)
                  ], 64))
                ]),
                _: 2
              }, 1024)) : R("", !0)
            ], 16, um)
          ]),
          _: 2
        }, 1032, ["content", "disabled"]))), 128))
      ], 6)) : R("", !0)
    ]));
  }
}), am = {
  "v-actions__trigger": "_v-actions__trigger_e2ynh_1",
  "v-actions__list": "_v-actions__list_e2ynh_6",
  "v-actions__option": "_v-actions__option_e2ynh_34",
  "v-actions__option--with-icon": "_v-actions__option--with-icon_e2ynh_71",
  "v-actions__option--with-count": "_v-actions__option--with-count_e2ynh_75",
  "v-actions__option--danger": "_v-actions__option--danger_e2ynh_79",
  "v-actions__option--disabled": "_v-actions__option--disabled_e2ynh_83"
}, im = {
  $style: am
}, Ma = /* @__PURE__ */ U(nm, [["__cssModules", im]]), om = {}, sm = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function lm(r, t) {
  return m(), x("svg", sm, t[0] || (t[0] = [
    C("path", {
      d: "M8.00033 8.66671C8.36851 8.66671 8.66699 8.36823 8.66699 8.00004C8.66699 7.63185 8.36851 7.33337 8.00033 7.33337C7.63214 7.33337 7.33366 7.63185 7.33366 8.00004C7.33366 8.36823 7.63214 8.66671 8.00033 8.66671Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      d: "M12.667 8.66671C13.0352 8.66671 13.3337 8.36823 13.3337 8.00004C13.3337 7.63185 13.0352 7.33337 12.667 7.33337C12.2988 7.33337 12.0003 7.63185 12.0003 8.00004C12.0003 8.36823 12.2988 8.66671 12.667 8.66671Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      d: "M3.33366 8.66671C3.70185 8.66671 4.00033 8.36823 4.00033 8.00004C4.00033 7.63185 3.70185 7.33337 3.33366 7.33337C2.96547 7.33337 2.66699 7.63185 2.66699 8.00004C2.66699 8.36823 2.96547 8.66671 3.33366 8.66671Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Oa = /* @__PURE__ */ U(om, [["render", lm]]), cm = /* @__PURE__ */ ue({
  __name: "VRecordKanbanCard",
  props: {
    isRecordTypesEnabled: { type: Boolean, default: !1 },
    recordType: { default: "Record Type" },
    createdDate: { default: "03/10/2022" },
    notificationCount: { default: 0 },
    inStage: { default: "" },
    title: {},
    to: {},
    statusColor: { default: "" },
    recordTypes: { default: () => [] },
    canEditRecordType: { type: Boolean, default: !1 }
  },
  emits: ["update:recordType", "actions:click"],
  setup(r, { emit: t }) {
    const e = t, u = G(() => [
      {
        label: "Preview",
        value: "preview",
        icon: J6
      },
      {
        label: "Open in New Tab",
        value: "openInNewTab",
        icon: Y6
      },
      {
        label: "Clone",
        value: "clone",
        icon: rm
      }
    ]);
    return (n, a) => {
      const o = Va("router-link");
      return m(), x("div", {
        class: b([
          n.$style["v-record-kanban-card"],
          {
            [n.$style["v-record-kanban-card--with-record-type"]]: n.isRecordTypesEnabled
          }
        ]),
        style: ht({
          color: n.statusColor
        })
      }, [
        n.notificationCount ? (m(), H(p(or), {
          key: 0,
          class: b(n.$style["v-record-kanban-card__notification"]),
          content: n.notificationCount
        }, null, 8, ["class", "content"])) : R("", !0),
        C("div", {
          class: b([
            n.$style["v-record-kanban-card__info"],
            {
              [n.$style["v-record-kanban-card__info--with-record-type"]]: n.isRecordTypesEnabled
            }
          ])
        }, [
          n.isRecordTypesEnabled ? (m(), x("div", {
            key: 0,
            class: b(n.$style["v-record-kanban-card__created-date"])
          }, ne(n.createdDate), 3)) : R("", !0),
          C("div", {
            class: b(n.$style["v-record-kanban-card__top-right"])
          }, [
            n.isRecordTypesEnabled ? (m(), H(p(yc), {
              key: 0,
              "record-type": n.recordType,
              "record-types": n.recordTypes,
              disabled: !n.canEditRecordType,
              placement: "bottom-end",
              "onUpdate:recordType": a[0] || (a[0] = (s) => e("update:recordType", s))
            }, null, 8, ["record-type", "record-types", "disabled"])) : R("", !0),
            n.isRecordTypesEnabled ? (m(), H(p(Ma), {
              key: 1,
              class: b(n.$style["v-record-kanban-card__actions"]),
              options: u.value,
              placement: "bottom-end",
              "min-width": "200px",
              "onOption:click": a[1] || (a[1] = (s) => e("actions:click", s))
            }, {
              trigger: J(() => [
                j(vt, {
                  variant: p(qt).GHOST,
                  "icon-only": "",
                  size: p(Pt).EXTRA_EXTRA_SMALL
                }, {
                  default: J(() => [
                    j(Oa)
                  ]),
                  _: 1
                }, 8, ["variant", "size"])
              ]),
              _: 1
            }, 8, ["class", "options"])) : R("", !0)
          ], 2)
        ], 2),
        C("div", {
          class: b([
            n.$style["v-record-kanban-card__title-wrapper"],
            {
              [n.$style["v-record-kanban-card__title-wrapper--without-record-type"]]: !n.isRecordTypesEnabled
            }
          ])
        }, [
          C("h3", null, [
            j(o, { to: n.to }, {
              default: J(() => [
                ce(ne(n.title), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ], 2),
        C("div", {
          class: b([
            n.$style["v-record-kanban-card__additional-info"],
            {
              [n.$style["v-record-kanban-card__additional-info--without-record-type"]]: !n.isRecordTypesEnabled
            }
          ])
        }, [
          ce(" in stage: " + ne(n.inStage) + " ", 1),
          n.isRecordTypesEnabled ? R("", !0) : (m(), x("div", {
            key: 0,
            class: b(n.$style["v-record-kanban-card__additional-info-date-actions-container"])
          }, [
            C("div", {
              class: b(n.$style["v-record-kanban-card__created-date"])
            }, ne(n.createdDate), 3),
            j(p(Ma), {
              class: b(n.$style["v-record-kanban-card__actions"]),
              options: u.value,
              placement: "bottom-end",
              "min-width": "200px",
              "onOption:click": a[2] || (a[2] = (s) => e("actions:click", s))
            }, {
              trigger: J(() => [
                j(vt, {
                  variant: p(qt).GHOST,
                  "icon-only": "",
                  size: p(Pt).EXTRA_EXTRA_SMALL
                }, {
                  default: J(() => [
                    j(Oa)
                  ]),
                  _: 1
                }, 8, ["variant", "size"])
              ]),
              _: 1
            }, 8, ["class", "options"])
          ], 2))
        ], 2)
      ], 6);
    };
  }
}), dm = {
  "v-record-kanban-card": "_v-record-kanban-card_lmoud_1",
  "v-record-kanban-card--with-record-type": "_v-record-kanban-card--with-record-type_lmoud_27",
  "v-record-kanban-card__info": "_v-record-kanban-card__info_lmoud_27",
  "v-record-kanban-card__title-wrapper": "_v-record-kanban-card__title-wrapper_lmoud_38",
  "v-record-kanban-card__title-wrapper--without-record-type": "_v-record-kanban-card__title-wrapper--without-record-type_lmoud_58",
  "v-record-kanban-card__top-right": "_v-record-kanban-card__top-right_lmoud_62",
  "v-record-kanban-card__additional-info": "_v-record-kanban-card__additional-info_lmoud_67",
  "v-record-kanban-card__created-date": "_v-record-kanban-card__created-date_lmoud_68",
  "v-record-kanban-card__notification": "_v-record-kanban-card__notification_lmoud_75",
  "v-record-kanban-card__additional-info--without-record-type": "_v-record-kanban-card__additional-info--without-record-type_lmoud_89",
  "v-record-kanban-card__additional-info-date-actions-container": "_v-record-kanban-card__additional-info-date-actions-container_lmoud_93",
  "v-record-kanban-card__actions": "_v-record-kanban-card__actions_lmoud_98"
}, fm = {
  $style: dm
}, Wx = /* @__PURE__ */ U(cm, [["__cssModules", fm]]), pm = /* @__PURE__ */ ue({
  __name: "VRecordKanbanColumn",
  props: {
    statusName: {},
    statusColor: {},
    statusDescription: {},
    total: {}
  },
  setup(r) {
    const t = r, e = G(
      () => yu(
        [String(t.total || ""), t.statusName]
      )
    );
    return (u, n) => (m(), x("div", {
      class: b(u.$style["v-record-kanban-card"])
    }, [
      C("div", {
        class: b([
          u.$style["v-record-kanban-card__status"],
          {
            [u.$style["v-record-kanban-card__status--with-tooltip"]]: u.statusDescription
          }
        ]),
        style: ht({
          color: u.statusColor,
          backgroundColor: `${u.statusColor}1F`
        })
      }, [
        j(p(yt), {
          content: e.value,
          "auto-shrink": ""
        }, null, 8, ["content"]),
        u.statusDescription ? (m(), H(p(Ve), {
          key: 0,
          content: u.statusDescription
        }, null, 8, ["content"])) : R("", !0)
      ], 6),
      K(u.$slots, "default")
    ], 2));
  }
}), hm = {
  "v-record-kanban-card": "_v-record-kanban-card_sr88i_1",
  "v-record-kanban-card__status": "_v-record-kanban-card__status_sr88i_9",
  "v-record-kanban-card__status--with-tooltip": "_v-record-kanban-card__status--with-tooltip_sr88i_24"
}, mm = {
  $style: hm
}, Yx = /* @__PURE__ */ U(pm, [["__cssModules", mm]]), vm = /* @__PURE__ */ ue({
  __name: "VFieldValue",
  props: {
    label: {},
    labelColor: { default: "black" },
    value: {},
    originalValue: {},
    loading: { type: Boolean, default: !1 }
  },
  setup(r) {
    const t = be(), e = tt();
    return (u, n) => (m(), x("div", {
      class: b(p(t)["v-field-value"])
    }, [
      j(p(zs), {
        size: "medium",
        color: u.labelColor,
        "with-space-bottom": !1
      }, {
        default: J(() => [
          ce(ne(u.label), 1)
        ]),
        _: 1
      }, 8, ["color"]),
      C("div", {
        class: b([
          p(t)["v-field-value__wrapper"],
          {
            [p(t)["v-field-value__wrapper--row"]]: p(e).icon && !u.loading,
            [p(t)["v-field-value__wrapper--with-loader"]]: !p(e).icon && u.loading,
            [p(t)["v-field-value__wrapper--row-with-loader"]]: p(e).icon && u.loading
          }
        ])
      }, [
        u.loading ? (m(), H(p(Cu), {
          key: 0,
          size: p(Rt).SMALL
        }, null, 8, ["size"])) : R("", !0),
        j(p(yt), {
          class: b(p(t)["v-field-value__value"]),
          content: u.value || "—",
          placement: "top-start",
          "hover-content": u.originalValue,
          "auto-shrink": ""
        }, null, 8, ["class", "content", "hover-content"]),
        K(u.$slots, "icon")
      ], 2)
    ], 2));
  }
}), gm = {
  "v-field-value": "_v-field-value_5rz75_1",
  "v-field-value__value": "_v-field-value__value_5rz75_12",
  "v-field-value__wrapper": "_v-field-value__wrapper_5rz75_28",
  "v-field-value__wrapper--row": "_v-field-value__wrapper--row_5rz75_50",
  "v-field-value__wrapper--with-loader": "_v-field-value__wrapper--with-loader_5rz75_54",
  "v-field-value__wrapper--row-with-loader": "_v-field-value__wrapper--row-with-loader_5rz75_58"
}, bm = {
  $style: gm
}, ym = /* @__PURE__ */ U(vm, [["__cssModules", bm]]), _m = (r) => {
  const t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(r ?? "#000000") || [], e = {
    r: parseInt(t[1], 16),
    g: parseInt(t[2], 16),
    b: parseInt(t[3], 16)
  };
  return 0.2126 * e.r + 0.7152 * e.g + 0.0722 * e.b < 170 ? "light" : "dark";
}, wm = ["onClick"], Cm = /* @__PURE__ */ ue({
  __name: "VStatusSelect",
  props: {
    activeStatus: {},
    statuses: {},
    disabled: { type: Boolean, default: !1 },
    size: { default: js.MEDIUM },
    align: { default: Vs.RIGHT },
    isColorfull: { type: Boolean, default: !1 },
    placement: { default: "bottom" }
  },
  emits: ["update:activeStatus"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G(
      () => e.statuses.find(({ slug: M }) => M === e.activeStatus) || null
    ), a = G(() => {
      var M;
      return ((M = n.value) == null ? void 0 : M.color) ?? "#000000";
    }), o = Q(!1), s = Q(null), i = Q(), l = Q(), d = () => {
      var M;
      s.value && ((M = s.value) == null || M.destroy(), s.value = null), l.value && document.body.removeChild(l.value);
    };
    qe(() => o.value, async (M) => {
      await Pe(), !(!i.value || !l.value) && (M && i.value && (s.value = Tt(i.value, l.value, {
        placement: e.placement,
        modifiers: [
          St,
          {
            name: "offset",
            options: {
              offset: [0, 4]
            }
          }
        ]
      }), document.body.appendChild(l.value)), !M && s.value && d());
    });
    const h = () => {
      e.disabled || (o.value = !1);
    }, c = G(() => e.statuses.some((M) => M.description)), f = () => {
      e.disabled || (o.value = !o.value);
    }, g = (M) => {
      M !== e.activeStatus && (u("update:activeStatus", M), h());
    }, D = Q(null);
    Zt(D, () => {
      h();
    }, {
      ignore: [l]
    });
    const _ = G(() => {
      var M;
      return _m((M = n.value) == null ? void 0 : M.color);
    }), O = G(() => e.isColorfull ? {
      backgroundColor: a.value
    } : {
      color: "#2B2B2B",
      backgroundColor: `${a.value}40`
    });
    return Yt(() => {
      d();
    }), (M, L) => {
      var q, z, X, ee;
      return m(), x("div", {
        ref_key: "statusSelect",
        ref: D,
        class: b([
          M.$style["v-status-select"],
          M.$style[`v-status-select--${M.size}`],
          {
            [M.$style[`v-status-select__trigger--${_.value}`]]: M.isColorfull,
            [M.$style["v-status-select--disabled"]]: M.disabled
          }
        ])
      }, [
        C("div", {
          ref_key: "trigger",
          ref: i,
          class: b([
            M.$style["v-status-select__trigger"],
            {
              [M.$style["v-status-select__trigger--open"]]: o.value,
              [M.$style["v-status-select__trigger--with-tooltip"]]: (q = n.value) == null ? void 0 : q.description
            }
          ]),
          style: ht(O.value),
          onClick: L[0] || (L[0] = (V) => f())
        }, [
          (z = n.value) != null && z.description ? (m(), H(p(Ve), {
            key: 0,
            content: (X = n.value) == null ? void 0 : X.description,
            placement: "top"
          }, null, 8, ["content"])) : R("", !0),
          ce(" " + ne((ee = n.value) == null ? void 0 : ee.name) + " ", 1),
          j(kt, {
            class: b(M.$style["v-status-select__toggle"])
          }, null, 8, ["class"])
        ], 6),
        o.value ? (m(), x("div", {
          key: 0,
          ref_key: "options",
          ref: l,
          class: b(M.$style["v-status-select__options"])
        }, [
          (m(!0), x(pe, null, ge(M.statuses, (V) => (m(), x("div", {
            key: V.slug,
            class: b([
              M.$style["v-status-select__option"],
              {
                [M.$style["v-status-select__option--without-tooltip"]]: !c.value,
                [M.$style["v-status-select__option--active"]]: V.slug === M.activeStatus
              }
            ]),
            onClick: (oe) => g(V.slug)
          }, [
            C("div", {
              class: b(M.$style["v-status-select__option-color"]),
              style: ht({
                backgroundColor: `${V == null ? void 0 : V.color}`
              })
            }, null, 6),
            ce(" " + ne(V.name) + " ", 1),
            V != null && V.description ? (m(), H(p(Ve), {
              key: 0,
              class: b(M.$style["v-status-select__option-tooltip"]),
              content: V == null ? void 0 : V.description
            }, null, 8, ["class", "content"])) : R("", !0),
            L[1] || (L[1] = C("div", null, null, -1))
          ], 10, wm))), 128))
        ], 2)) : R("", !0)
      ], 2);
    };
  }
}), Dm = {
  "v-status-select--large": "_v-status-select--large_1dhuf_1",
  "v-status-select__trigger": "_v-status-select__trigger_1dhuf_1",
  "v-status-select__trigger--with-tooltip": "_v-status-select__trigger--with-tooltip_1dhuf_5",
  "v-status-select__toggle": "_v-status-select__toggle_1dhuf_23",
  "v-status-select__trigger--open": "_v-status-select__trigger--open_1dhuf_37",
  "v-status-select": "_v-status-select_1dhuf_1",
  "v-status-select__options": "_v-status-select__options_1dhuf_46",
  "v-status-select__option": "_v-status-select__option_1dhuf_46",
  "v-status-select__option--active": "_v-status-select__option--active_1dhuf_99",
  "v-status-select__option--without-tooltip": "_v-status-select__option--without-tooltip_1dhuf_103",
  "v-status-select--disabled": "_v-status-select--disabled_1dhuf_107",
  "v-status-select__option-color": "_v-status-select__option-color_1dhuf_123",
  "v-status-select__trigger--dark": "_v-status-select__trigger--dark_1dhuf_130",
  "v-status-select__trigger--light": "_v-status-select__trigger--light_1dhuf_134"
}, Am = {
  $style: Dm
}, xm = /* @__PURE__ */ U(Cm, [["__cssModules", Am]]), Em = {};
function km(r, t) {
  return m(), x("svg", Te(r.$attrs, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }), t[0] || (t[0] = [
    C("path", {
      d: "M9.05116 2.89768H2.78915C2.31464 2.89768 1.85956 3.08618 1.52403 3.42171C1.1885 3.75724 1 4.21231 1 4.68682V17.2109C1 17.6854 1.1885 18.1404 1.52403 18.476C1.85956 18.8115 2.31464 19 2.78915 19H15.3132C15.7877 19 16.2428 18.8115 16.5783 18.476C16.9138 18.1404 17.1023 17.6854 17.1023 17.2109V10.9488M15.7605 1.55582C16.1163 1.19993 16.599 1 17.1023 1C17.6056 1 18.0883 1.19993 18.4442 1.55582C18.8001 1.9117 19 2.39438 19 2.89768C19 3.40097 18.8001 3.88365 18.4442 4.23954L9.94574 12.738L6.36744 13.6326L7.26201 10.0543L15.7605 1.55582Z",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]), 16);
}
const _c = /* @__PURE__ */ U(Em, [["render", km]]), Sm = /* @__PURE__ */ ue({
  __name: "VRecordCard",
  props: {
    activeStatus: {},
    statuses: {},
    recordTypes: { default: () => [] },
    notificationCount: { default: 0 },
    title: { default: "" },
    to: { default: "" },
    isRecordTypesEnabled: { type: Boolean },
    recordType: { default: "" },
    additionalInfo: { default: () => [] },
    inStage: { default: "" },
    countOfCols: { default: 5 },
    disabled: { type: Boolean, default: !1 },
    statusDisabled: { type: Boolean, default: !1 },
    recordTypeDisabled: { type: Boolean, default: !1 },
    simple: { type: Boolean, default: !1 },
    createdAt: { default: "" },
    modifiedAt: { default: "" },
    updatePendingSlug: { default: "" },
    actionsOptions: { default: () => [] }
  },
  emits: ["update:activeStatus", "update:recordType", "click:edit", "actions:click"],
  setup(r, { emit: t }) {
    ja((c) => ({
      "3f078de8": c.countOfCols
    }));
    const e = r, u = t, n = G(() => {
      const c = [];
      return e.createdAt && c.push(`Created: ${e.createdAt}`), e.modifiedAt && c.push(`Modified: ${e.modifiedAt}`), c.join(" — ");
    }), a = Q(!1), o = G(
      () => e.statuses.find(({ slug: c }) => c === e.activeStatus) || null
    ), s = G(() => e.additionalInfo.length), i = (c) => {
      const f = Array.from({ length: e.countOfCols }, () => []);
      for (const g in c)
        f[Number(g) % e.countOfCols].push(c[g]);
      return f.filter((g) => g.length);
    }, l = G(() => a.value ? i(e.additionalInfo) : i(e.additionalInfo.slice(0, e.countOfCols))), d = G(() => e.additionalInfo.length > e.countOfCols), h = be();
    return (c, f) => {
      var _;
      const g = Va("router-link"), D = Ds("tooltip");
      return m(), x("div", {
        class: b(p(h)["v-record-card"]),
        style: ht({
          color: ((_ = o.value) == null ? void 0 : _.color) || ""
        })
      }, [
        c.notificationCount ? (m(), H(p(or), {
          key: 0,
          class: b(p(h)["v-record-card__notifications"]),
          content: c.notificationCount,
          variant: p(lu).PRIMARY
        }, null, 8, ["class", "content", "variant"])) : R("", !0),
        C("div", {
          class: b(p(h)["v-record-card__wrapper"])
        }, [
          C("div", {
            class: b(p(h)["v-record-card__status-wrapper"])
          }, [
            c.simple ? R("", !0) : (m(), H(g, {
              key: 0,
              class: b(p(h)["v-record-card__link-area"]),
              to: c.to,
              "aria-label": c.title
            }, null, 8, ["class", "to", "aria-label"])),
            Xe(j(p(xm), {
              class: b(p(h)["v-record-card__status"]),
              statuses: c.statuses,
              "active-status": c.activeStatus,
              disabled: c.disabled || c.statusDisabled,
              placement: "bottom-start",
              "onUpdate:activeStatus": f[0] || (f[0] = (O) => u("update:activeStatus", O))
            }, null, 8, ["class", "statuses", "active-status", "disabled"]), [
              [
                D,
                c.statusDisabled ? "Status is disabled by validation" : "",
                void 0,
                { "right-start": !0 }
              ]
            ]),
            c.simple ? R("", !0) : (m(), x("div", {
              key: 1,
              class: b(p(h)["v-record-card__title-wrapper"])
            }, [
              C("h3", null, ne(c.title), 1)
            ], 2)),
            n.value ? (m(), x("div", {
              key: 2,
              class: b(p(h)["v-record-card__timestamps"])
            }, ne(n.value), 3)) : R("", !0)
          ], 2),
          C("div", {
            class: b(p(h)["v-record-card__actions-wrapper"])
          }, [
            j(g, {
              class: b(p(h)["v-record-card__link-area"]),
              to: c.to
            }, null, 8, ["class", "to"]),
            C("div", {
              class: b(p(h)["v-record-card__record-type-wrapper"])
            }, [
              c.isRecordTypesEnabled ? (m(), H(p(yc), {
                key: 0,
                "record-type": c.recordType,
                "record-types": c.recordTypes,
                disabled: c.recordTypeDisabled,
                placement: "bottom-end",
                "onUpdate:recordType": f[1] || (f[1] = (O) => u("update:recordType", O))
              }, null, 8, ["record-type", "record-types", "disabled"])) : R("", !0),
              c.actionsOptions.length ? (m(), H(p(Ma), {
                key: 1,
                class: b(p(h)["v-record-card__actions"]),
                options: c.actionsOptions,
                placement: "bottom-end",
                "min-width": "200px",
                "onOption:click": f[2] || (f[2] = (O) => u("actions:click", O))
              }, {
                trigger: J(() => [
                  j(vt, {
                    variant: p(qt).GHOST,
                    "icon-only": "",
                    size: p(Pt).EXTRA_EXTRA_SMALL
                  }, {
                    default: J(() => [
                      j(Oa)
                    ]),
                    _: 1
                  }, 8, ["variant", "size"])
                ]),
                _: 1
              }, 8, ["class", "options"])) : R("", !0)
            ], 2),
            C("p", {
              class: b(p(h)["v-record-card__days-in-stage"])
            }, " in stage: " + ne(c.inStage), 3)
          ], 2)
        ], 2),
        s.value ? (m(), x("div", {
          key: 1,
          class: b([
            p(h)["v-record-card__additional-info"]
          ])
        }, [
          (m(!0), x(pe, null, ge(l.value, (O, M) => (m(), x("div", {
            key: M,
            class: b(p(h)["v-record-card__field-value-col"])
          }, [
            (m(!0), x(pe, null, ge(O, (L, q) => (m(), x("div", { key: q }, [
              j(p(ym), {
                label: L.label,
                value: L.value,
                loading: L.slug === c.updatePendingSlug,
                "original-value": L.forceHoverValue
              }, mt({ _: 2 }, [
                !c.disabled && L.editOptions ? {
                  name: "icon",
                  fn: J(() => [
                    j(_c, {
                      class: b({
                        [p(h)["v-record-card__edit-value-icon--disabled"]]: !!c.updatePendingSlug
                      }),
                      height: "16",
                      width: "16",
                      onClick: (z) => u("click:edit", L.editOptions)
                    }, null, 8, ["class", "onClick"])
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["label", "value", "loading", "original-value"])
            ]))), 128))
          ], 2))), 128))
        ], 2)) : R("", !0),
        d.value ? (m(), x("div", {
          key: 2,
          class: b([
            p(h)["v-record-card__toggle"],
            {
              [p(h)["v-record-card__toggle--open"]]: a.value
            }
          ]),
          onClick: f[3] || (f[3] = (O) => a.value = !a.value)
        }, [
          j(kt)
        ], 2)) : R("", !0)
      ], 6);
    };
  }
}), Tm = {
  "v-record-card": "_v-record-card_isig0_1",
  "v-record-card__toggle": "_v-record-card__toggle_isig0_18",
  "v-record-card__additional-info": "_v-record-card__additional-info_isig0_33",
  "v-record-card__title-wrapper": "_v-record-card__title-wrapper_isig0_44",
  "v-record-card__wrapper": "_v-record-card__wrapper_isig0_64",
  "v-record-card__days-in-stage": "_v-record-card__days-in-stage_isig0_71",
  "v-record-card__actions-wrapper": "_v-record-card__actions-wrapper_isig0_81",
  "v-record-card__field-value-col": "_v-record-card__field-value-col_isig0_131",
  "v-record-card__toggle--open": "_v-record-card__toggle--open_isig0_149",
  "v-record-card__status-wrapper": "_v-record-card__status-wrapper_isig0_153",
  "v-record-card__notifications": "_v-record-card__notifications_isig0_160",
  "v-record-card__link-area": "_v-record-card__link-area_isig0_172",
  "v-record-card__status": "_v-record-card__status_isig0_153",
  "v-record-card__timestamps": "_v-record-card__timestamps_isig0_184",
  "v-record-card__edit-value-icon--disabled": "_v-record-card__edit-value-icon--disabled_isig0_192",
  "v-record-card__record-type-wrapper": "_v-record-card__record-type-wrapper_isig0_197",
  "v-record-card__actions": "_v-record-card__actions_isig0_81"
}, Bm = {
  $style: Tm
}, Zx = /* @__PURE__ */ U(Sm, [["__cssModules", Bm]]);
function _u(r) {
  return r.map((t) => ({
    ...t,
    _id: (t == null ? void 0 : t.id) || Symbol()
  }));
}
const $m = /* @__PURE__ */ ue({
  __name: "Circle",
  props: {
    height: { default: 100 },
    width: { default: 100 },
    color: { default: "rgba(0, 0, 0, 0.12)" },
    animation: { default: "wave" }
  },
  setup(r) {
    const t = r, e = G(() => `animation--${t.animation}`);
    return (u, n) => (m(), x("div", {
      class: b(["loader loader--circle", e.value]),
      style: ht({
        width: typeof u.width == "number" ? `${u.width}px` : u.width,
        height: typeof u.height == "number" ? `${u.height}px` : u.height,
        backgroundColor: u.color
      })
    }, null, 6));
  }
});
const Mm = /* @__PURE__ */ U($m, [["__scopeId", "data-v-0b9977e9"]]), Om = /* @__PURE__ */ ue({
  __name: "Straight",
  props: {
    height: { default: 100 },
    width: { default: 200 },
    color: { default: "rgba(0, 0, 0, 0.12)" },
    animation: { default: "wave" },
    type: { default: "rect" },
    rounded: { type: Boolean, default: !1 },
    radius: { default: 0 }
  },
  setup(r) {
    const t = r, e = G(() => `animation--${t.animation} shape--${t.type} shape--${t.rounded ? "round" : "flat"}`);
    return (u, n) => (m(), x("div", {
      class: b(["loader", e.value]),
      style: ht({
        width: typeof u.width == "number" ? `${u.width}px` : u.width,
        height: typeof u.height == "number" ? `${u.height}px` : u.height,
        backgroundColor: u.color,
        borderRadius: u.rounded ? `${u.radius}px` : 0
      })
    }, null, 6));
  }
});
const Lm = /* @__PURE__ */ U(Om, [["__scopeId", "data-v-3ea0ad73"]]), Dt = /* @__PURE__ */ ue({
  __name: "VSkeletonLoader",
  props: {
    type: { default: "rect" },
    size: {},
    animation: { default: "wave" },
    height: {},
    width: {},
    color: { default: "var(--v-text-secondary-light-color)" },
    waveColor: { default: "var(--v-skeleton-wave-color)" },
    rounded: { type: Boolean, default: !0 },
    radius: { default: 4 }
  },
  setup(r) {
    const t = r, e = G(() => t.size || t.width), u = G(() => t.size || t.height);
    return (n, a) => n.type === "circle" ? (m(), H(Mm, {
      key: 0,
      width: e.value,
      height: u.value,
      animation: n.animation,
      color: n.color
    }, null, 8, ["width", "height", "animation", "color"])) : (m(), H(Lm, {
      key: 1,
      width: e.value,
      height: u.value,
      animation: n.animation,
      type: n.type,
      color: n.color,
      rounded: n.rounded,
      radius: n.radius
    }, null, 8, ["width", "height", "animation", "type", "color", "rounded", "radius"]));
  }
});
const Fm = {}, Im = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function Nm(r, t) {
  return m(), x("svg", Im, t[0] || (t[0] = [
    C("g", { fill: "none" }, [
      C("path", {
        d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
        fill: "currentColor"
      })
    ], -1)
  ]));
}
const wc = /* @__PURE__ */ U(Fm, [["render", Nm]]), qm = {}, Pm = {
  width: "14",
  height: "16",
  viewBox: "0 0 14 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Rm(r, t) {
  return m(), x("svg", Pm, t[0] || (t[0] = [
    C("path", {
      d: "M13 11.98V13.98C13 14.2452 12.8946 14.4996 12.7071 14.6871C12.5196 14.8746 12.2652 14.98 12 14.98H1L7 7.97998L1 0.97998H12C12.2652 0.97998 12.5196 1.08534 12.7071 1.27287C12.8946 1.46041 13 1.71476 13 1.97998V3.97998",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Vm = /* @__PURE__ */ U(qm, [["render", Rm]]), jm = { key: 1 }, Hm = /* @__PURE__ */ ue({
  __name: "VCalculation",
  props: {
    modelValue: { default: () => [] },
    colKey: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G(() => {
      const c = (e.modelValue || []).filter((f) => f.field === e.colKey);
      return c.length ? {
        field: e.colKey,
        type: c.map(({ type: f }) => f)
      } : {
        field: e.colKey,
        type: []
      };
    }), a = G(() => [
      { label: "Sum", value: "sum" },
      { label: "Average", value: "avg" },
      { label: "Minimum", value: "min" },
      { label: "Maximum", value: "max" }
    ]), o = Q(!1), s = Q(null);
    Zt(s, () => o.value = !1);
    const i = G(() => {
      var c;
      return (c = n.value) == null ? void 0 : c.type.length;
    }), l = () => {
      o.value = !o.value;
    }, d = (c) => {
      const f = [...e.modelValue].map(({ field: D, type: _ }) => ({ field: D, type: _ })), g = f.findIndex(
        (D) => D.field === e.colKey && D.type === c
      );
      g > -1 ? f.splice(g, 1) : f.push({ field: e.colKey, type: c }), u("update:modelValue", f);
    }, h = be();
    return (c, f) => {
      var g, D, _, O;
      return m(), x("div", {
        ref_key: "trigger",
        ref: s
      }, [
        C("div", {
          class: b([
            p(h)["v-calculation"],
            {
              [p(h).active]: i.value
            }
          ]),
          onClick: ot(l, ["stop"])
        }, [
          ((D = (g = n.value) == null ? void 0 : g.type) == null ? void 0 : D.length) <= 1 ? (m(), H(Vm, {
            key: 0,
            class: b(p(h)["v-calculation__icon"])
          }, null, 8, ["class"])) : (m(), x("span", jm, ne((O = (_ = n.value) == null ? void 0 : _.type) == null ? void 0 : O.length), 1))
        ], 2),
        o.value ? (m(), x("div", {
          key: 0,
          class: b(p(h)["dropdown-menu"])
        }, [
          (m(!0), x(pe, null, ge(a.value, (M) => {
            var L, q;
            return m(), H(p(Hs), {
              key: M.value,
              label: M.label,
              value: (q = (L = n.value) == null ? void 0 : L.type) == null ? void 0 : q.includes(M.value),
              onClick: ot((z) => d(M.value), ["stop"])
            }, null, 8, ["label", "value", "onClick"]);
          }), 128))
        ], 2)) : R("", !0)
      ], 512);
    };
  }
}), Um = "_active_8k1b9_16", zm = {
  "v-calculation": "_v-calculation_8k1b9_1",
  active: Um,
  "dropdown-menu": "_dropdown-menu_8k1b9_23"
}, Gm = {
  $style: zm
}, Wm = /* @__PURE__ */ U(Hm, [["__cssModules", Gm]]), Ym = {}, Zm = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
};
function Km(r, t) {
  return m(), x("svg", Zm, t[0] || (t[0] = [
    C("path", {
      d: "M5.5 14.75L10 8L5.5 1.25",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Lo = /* @__PURE__ */ U(Ym, [["render", Km]]), Xm = {
  key: 0,
  span: "1"
}, Jm = ["onMousedown", "onTouchstart"], Qm = { key: 0 }, e5 = { key: 1 }, t5 = ["colspan"], r5 = { key: 1 }, u5 = { key: 1 }, n5 = ["colspan"], a5 = { key: 0 }, i5 = ["colspan"], o5 = /* @__PURE__ */ ue({
  __name: "TableComponent",
  props: {
    cols: {},
    rows: {},
    isSortEnabled: { type: Boolean },
    sortableKeys: { default: () => [] },
    calculatedKeys: { default: () => [] },
    sort: {},
    calculation: {},
    loading: { type: Boolean },
    rowTextMaxLength: {},
    isDraggable: { type: Boolean },
    emptyValue: { default: "Nothing to see here..." },
    fixedTopElement: { type: Boolean },
    isCalculationEnabled: { type: Boolean },
    resizable: { type: Boolean, default: !1 },
    ignoreLastColAlignment: { type: Boolean, default: !1 },
    compactHeader: { type: Boolean },
    withoutOutline: { type: Boolean, default: !1 },
    withoutTableHeader: { type: Boolean, default: !1 },
    isNestedExpanded: { type: Boolean }
  },
  emits: ["update:sort", "reorder", "update:calculation"],
  setup(r, { expose: t, emit: e }) {
    const u = tt(), n = r, a = e, o = G(() => _u(n.cols)), s = G(() => _u(n.rows)), i = Q([]);
    qe(() => s.value.length, () => {
      i.value = [];
    }), t({
      expandAllRows: () => {
        i.value = s.value.reduce((A, E, S) => {
          var $;
          return ($ = E == null ? void 0 : E.expandedData) != null && $.length && A.push(S), A;
        }, []);
      }
    });
    const d = (A) => {
      if (i.value.includes(A)) {
        i.value = i.value.filter((E) => E !== A);
        return;
      }
      i.value.push(A);
    }, h = (A) => {
      var E, S;
      if (X.value) {
        X.value = !1;
        return;
      }
      if (!(!n.isSortEnabled && !n.sortableKeys.length))
        return !n.sort || ((E = n.sort) == null ? void 0 : E.key) !== A ? a("update:sort", {
          key: A,
          type: "asc"
        }) : ((S = n.sort) == null ? void 0 : S.type) === "asc" ? a("update:sort", {
          key: A,
          type: "desc"
        }) : a("update:sort", null);
    }, c = (A) => {
      var E;
      return A !== ((E = n.sort) == null ? void 0 : E.key) ? "none" : n.sort.type === "asc" ? "ascending" : n.sort.type === "desc" ? "descending" : "none";
    }, f = (A) => n.calculation.filter((E) => E.field === A), g = G(() => s.value.length || 3), D = (A) => {
      a("reorder", A.map((E) => ks(E, ["_id"])));
    }, _ = Q(!1), O = Q(0), M = Q(0), L = Q(-1), q = Q(null), z = Q(null), X = Q(!1), ee = (A, E) => {
      const S = A.target, $ = S == null ? void 0 : S.closest("th");
      if (!$)
        return;
      A.preventDefault(), _.value = !0, X.value = !0;
      let w;
      "touches" in A ? w = (A.touches[0] || A.changedTouches[0]).pageX : w = A.pageX, O.value = w, L.value = n.isDraggable ? E + 1 : E, M.value = $.offsetWidth, document.addEventListener("touchmove", V), document.addEventListener("mousemove", V), document.addEventListener("touchend", oe), document.addEventListener("mouseup", oe);
    }, V = (A) => {
      var I, P;
      if (!_.value)
        return;
      let E;
      "touches" in A ? E = (A.touches[0] || ((I = A.changedTouches) == null ? void 0 : I[0])).pageX : E = A.pageX;
      const S = E - O.value, $ = (P = q.value) == null ? void 0 : P.querySelectorAll("th"), w = $ == null ? void 0 : $[L.value];
      if (!w || !z.value)
        return;
      const k = M.value + S, T = z.value.offsetWidth, F = k - w.offsetWidth;
      w.style.width = `${k}px`, z.value.style.width = `${T + F}px`;
    }, oe = () => {
      _.value = !1, document.removeEventListener("touchmove", V), document.removeEventListener("mousemove", V), document.removeEventListener("touchend", oe), document.removeEventListener("mouseup", oe);
    }, W = be();
    return (A, E) => (m(), x("table", {
      ref_key: "tableElement",
      ref: z,
      class: b([
        p(W)["v-table"],
        {
          [p(W)["v-table--ignore-last-col-align"]]: A.ignoreLastColAlignment,
          [p(W)["v-table--compact-header"]]: A.compactHeader,
          [p(W)["v-table--without-outline"]]: A.withoutOutline
        }
      ])
    }, [
      C("colgroup", null, [
        A.isDraggable ? (m(), x("col", Xm)) : R("", !0),
        (m(!0), x(pe, null, ge(o.value, (S) => (m(), x("col", Te({
          key: S._id,
          span: "1"
        }, { ref_for: !0 }, S.width ? {
          width: S.width
        } : {}), null, 16))), 128))
      ]),
      C("thead", {
        class: b({
          [p(W)["v-table__thead--hidden"]]: A.withoutTableHeader
        })
      }, [
        C("tr", {
          ref_key: "tableHeader",
          ref: q
        }, [
          A.isDraggable ? (m(), x("th", {
            key: 0,
            class: b(p(W)["v-table__drag"])
          }, null, 2)) : R("", !0),
          (m(!0), x(pe, null, ge(o.value, (S, $) => (m(), x("th", Te({
            key: S._id,
            ref_for: !0
          }, A.isSortEnabled || A.sortableKeys.includes(S.key) ? {
            "aria-sort": c(S.key)
          } : {}, {
            style: {
              ...S.maxWidth ? {
                maxWidth: S.maxWidth
              } : {},
              ...S.minWidth ? {
                minWidth: S.minWidth
              } : {}
            },
            class: {
              [p(W)["v-table__th--resizable"]]: A.resizable
            }
          }, As(A.isSortEnabled || A.sortableKeys.includes(S.key) ? {
            click: () => h(S.key)
          } : {}, !0)), [
            C("div", {
              class: b(p(W)["v-table__th-content"])
            }, [
              $ === 0 && !A.loading ? K(A.$slots, "select-all-checkbox", { key: 0 }) : R("", !0),
              C("div", {
                class: b(p(W)["v-table__title"])
              }, [
                K(A.$slots, "col-left", {}, () => [
                  S.helpText ? (m(), H(p(Ve), {
                    key: 0,
                    placement: "right",
                    content: S.helpText
                  }, null, 8, ["content"])) : R("", !0)
                ]),
                ce(" " + ne(S.title), 1)
              ], 2),
              S.title && (A.isSortEnabled || A.sortableKeys.includes(S.key)) ? (m(), H(kt, {
                key: 1,
                class: b(p(W)["v-table__sort-icon"])
              }, null, 8, ["class"])) : R("", !0),
              S.title && (A.isCalculationEnabled || A.calculatedKeys.includes(S.key)) ? (m(), H(Wm, {
                key: 2,
                class: b([
                  p(W)["v-table__calculation-icon"],
                  {
                    [p(W)["v-table__calculation-icon--hidden"]]: !f(S.key).length
                  }
                ]),
                "model-value": A.calculation,
                "col-key": S.key,
                "onUpdate:modelValue": E[0] || (E[0] = (w) => a("update:calculation", w))
              }, null, 8, ["class", "model-value", "col-key"])) : R("", !0),
              $ !== o.value.length - 1 && A.resizable ? (m(), x("div", {
                key: 3,
                class: b(p(W)["v-table__resizer"]),
                onMousedown: (w) => ee(w, $),
                onTouchstart: (w) => ee(w, $)
              }, null, 42, Jm)) : R("", !0)
            ], 2)
          ], 16))), 128))
        ], 512)
      ], 2),
      A.isDraggable ? (m(), H(p(Ts), {
        key: 0,
        tag: "tbody",
        "model-value": s.value,
        "item-key": "_id",
        handle: ".draggable-handle",
        "onUpdate:modelValue": E[1] || (E[1] = (S) => D(S))
      }, {
        item: J(({ element: S, index: $ }) => [
          A.loading ? R("", !0) : (m(), x("tr", Qm, [
            C("td", {
              class: b(p(W)["v-table__drag"])
            }, [
              !A.fixedTopElement || $ > 0 ? (m(), H(wc, {
                key: 0,
                class: "draggable-handle"
              })) : R("", !0)
            ], 2),
            (m(!0), x(pe, null, ge(o.value, (w, k) => {
              var T, F, I;
              return m(), x("td", {
                key: w._id,
                style: ht({
                  ...w.maxWidth ? {
                    maxWidth: w.maxWidth
                  } : {},
                  ...w.minWidth ? {
                    minWidth: w.minWidth
                  } : {}
                }),
                class: b({
                  [p(W)["v-table__td--with-expand"]]: ((T = S.expandedData) == null ? void 0 : T.length) && k === 0
                })
              }, [
                (F = S.expandedData) != null && F.length && k === 0 ? (m(), H(Lo, {
                  key: 0,
                  class: b([
                    p(W)["v-table__expand"],
                    {
                      [p(W)["v-table__expand--expanded"]]: i.value.includes($)
                    }
                  ]),
                  onClick: (P) => d($)
                }, null, 8, ["class", "onClick"])) : R("", !0),
                (I = p(u)) != null && I[w.key] ? K(A.$slots, w.key, Te({
                  key: 1,
                  ref_for: !0
                }, {
                  ...S,
                  colIndex: k,
                  rowIndex: $
                })) : K(A.$slots, "default", Te({
                  key: 2,
                  ref_for: !0
                }, {
                  row: S,
                  col: w
                }), () => [
                  j(p(yt), {
                    "max-length": A.rowTextMaxLength,
                    content: String((S == null ? void 0 : S[w.key]) || "—")
                  }, null, 8, ["max-length", "content"])
                ])
              ], 6);
            }), 128))
          ]))
        ]),
        footer: J(() => [
          A.loading ? (m(!0), x(pe, { key: 0 }, ge(g.value, (S) => (m(), x("tr", { key: S }, [
            C("td", null, [
              j(p(Dt), {
                width: "100%",
                height: "20px"
              })
            ]),
            (m(!0), x(pe, null, ge(o.value, ($) => (m(), x("td", {
              key: $._id
            }, [
              j(p(Dt), {
                width: "100%",
                height: "20px"
              })
            ]))), 128))
          ]))), 128)) : s.value.length ? R("", !0) : (m(), x("tr", e5, [
            C("td", {
              colspan: o.value.length + Number(A.isDraggable),
              class: b(p(W)["v-table__empty"])
            }, [
              K(A.$slots, "emptyValue", {}, () => [
                ce(ne(A.emptyValue), 1)
              ])
            ], 10, t5)
          ]))
        ]),
        _: 3
      }, 8, ["model-value"])) : (m(), x("tbody", r5, [
        A.loading ? (m(!0), x(pe, { key: 0 }, ge(g.value, (S) => (m(), x("tr", { key: S }, [
          (m(!0), x(pe, null, ge(o.value, ($) => (m(), x("td", {
            key: $._id
          }, [
            j(p(Dt), {
              width: "100%",
              height: "20px"
            })
          ]))), 128))
        ]))), 128)) : s.value.length ? (m(!0), x(pe, { key: 2 }, ge(s.value, (S, $) => {
          var w;
          return m(), x(pe, {
            key: S._id
          }, [
            C("tr", {
              class: b({
                [p(W)["v-table__tr--expanded"]]: i.value.includes($)
              })
            }, [
              (m(!0), x(pe, null, ge(o.value, (k, T) => {
                var F, I, P;
                return m(), x("td", {
                  key: k._id,
                  style: ht({
                    ...k.maxWidth ? {
                      maxWidth: k.maxWidth
                    } : {},
                    ...k.minWidth ? {
                      minWidth: k.minWidth
                    } : {}
                  }),
                  class: b({
                    [p(W)["v-table__td--with-expand"]]: ((F = S.expandedData) == null ? void 0 : F.length) && T === 0
                  })
                }, [
                  (I = S.expandedData) != null && I.length && T === 0 ? (m(), H(Lo, {
                    key: 0,
                    class: b([
                      p(W)["v-table__expand"],
                      {
                        [p(W)["v-table__expand--expanded"]]: i.value.includes($)
                      }
                    ]),
                    onClick: (Y) => d($)
                  }, null, 8, ["class", "onClick"])) : R("", !0),
                  (P = p(u)) != null && P[k.key] ? K(A.$slots, k.key, Te({
                    key: 1,
                    ref_for: !0
                  }, {
                    ...S,
                    colIndex: T,
                    rowIndex: $
                  })) : K(A.$slots, "default", Te({
                    key: 2,
                    ref_for: !0
                  }, {
                    row: S,
                    col: k
                  }), () => [
                    j(p(yt), {
                      "max-length": A.rowTextMaxLength,
                      content: String((S == null ? void 0 : S[k.key]) || "—")
                    }, null, 8, ["max-length", "content"])
                  ])
                ], 6);
              }), 128))
            ], 2),
            (w = S.expandedData) != null && w.length && i.value.includes($) ? (m(), x("tr", a5, [
              C("td", {
                colspan: o.value.length + Number(A.isDraggable),
                class: b(p(W)["v-table__expanded-row"])
              }, [
                K(A.$slots, "expandedData", Te({ ref_for: !0 }, {
                  expandedData: S.expandedData
                }))
              ], 10, i5)
            ])) : R("", !0)
          ], 64);
        }), 128)) : (m(), x("tr", u5, [
          C("td", {
            colspan: o.value.length + Number(A.isDraggable),
            class: b(p(W)["v-table__empty"])
          }, [
            K(A.$slots, "emptyValue", {}, () => [
              ce(ne(A.emptyValue), 1)
            ])
          ], 10, n5)
        ]))
      ]))
    ], 2));
  }
}), s5 = "_td_pee1s_9", l5 = {
  "v-table": "_v-table_pee1s_1",
  td: s5,
  "v-table--ignore-last-col-align": "_v-table--ignore-last-col-align_pee1s_12",
  "v-table__empty": "_v-table__empty_pee1s_16",
  "v-table__th-content": "_v-table__th-content_pee1s_19",
  "v-table__drag": "_v-table__drag_pee1s_39",
  "v-table__sort-icon": "_v-table__sort-icon_pee1s_69",
  "v-table__td--with-expand": "_v-table__td--with-expand_pee1s_79",
  "v-table__expanded-row": "_v-table__expanded-row_pee1s_83",
  "v-table--compact-header": "_v-table--compact-header_pee1s_88",
  "v-table--without-outline": "_v-table--without-outline_pee1s_92",
  "v-table__calculation-icon": "_v-table__calculation-icon_pee1s_107",
  "v-table__calculation-icon--hidden": "_v-table__calculation-icon--hidden_pee1s_111",
  "v-table__title": "_v-table__title_pee1s_130",
  "v-table__th--resizable": "_v-table__th--resizable_pee1s_142",
  "v-table__resizer": "_v-table__resizer_pee1s_145",
  "v-table__expand": "_v-table__expand_pee1s_83",
  "v-table__expand--expanded": "_v-table__expand--expanded_pee1s_174",
  "v-table__thead--hidden": "_v-table__thead--hidden_pee1s_193"
}, c5 = {
  $style: l5
}, d5 = /* @__PURE__ */ U(o5, [["__cssModules", c5]]), f5 = /* @__PURE__ */ ue({
  __name: "CardComponent",
  props: {
    cols: {},
    row: {},
    loading: { type: Boolean },
    rowIndex: {},
    rowTextMaxLength: {},
    isDraggable: { type: Boolean },
    cardTitle: {}
  },
  setup(r) {
    const t = r, e = G(() => t.cols.find((s) => s.key === "actions")), u = G(() => !!(e.value || t.isDraggable || t.cardTitle)), n = G(() => _u(
      t.cols.filter(
        (s) => !["actions"].includes(s.key)
      )
    )), a = tt(), o = be();
    return (s, i) => (m(), x("div", {
      class: b(p(o)["v-table-card"])
    }, [
      C("div", {
        class: b(p(o)["v-table-card__row"])
      }, [
        u.value ? (m(), x("div", {
          key: 0,
          class: b([p(o)["v-table-card__label"], p(o)["v-table-card__label--header"]])
        }, [
          s.isDraggable ? (m(), H(wc, {
            key: 0,
            class: "draggable-handle"
          })) : R("", !0),
          s.cardTitle ? (m(), x("h3", {
            key: 1,
            class: b(p(o)["v-table-card__title"])
          }, ne(s.cardTitle), 3)) : R("", !0)
        ], 2)) : R("", !0),
        C("div", {
          class: b(p(o)["v-table-card__value"])
        }, [
          e.value ? K(s.$slots, "actions", Le(Te({ key: 0 }, s.row))) : R("", !0)
        ], 2)
      ], 2),
      (m(!0), x(pe, null, ge(n.value, (l, d) => (m(), x("div", {
        key: l._id,
        class: b(p(o)["v-table-card__row"])
      }, [
        C("div", {
          class: b(p(o)["v-table-card__label"])
        }, [
          K(s.$slots, "col-left", {}, () => [
            l.helpText ? (m(), H(p(Ve), {
              key: 0,
              placement: "right",
              content: l.helpText
            }, null, 8, ["content"])) : R("", !0)
          ]),
          ce(" " + ne(l.title), 1)
        ], 2),
        C("div", {
          class: b(p(o)["v-table-card__value"])
        }, [
          p(a)[l.key] ? K(s.$slots, l.key, Te({
            key: 0,
            ref_for: !0
          }, {
            ...s.row,
            colIndex: d,
            rowIndex: s.rowIndex
          })) : K(s.$slots, "default", Te({
            key: 1,
            ref_for: !0
          }, {
            row: s.row,
            col: l
          }), () => [
            j(p(yt), {
              "max-length": s.rowTextMaxLength,
              content: String(s.row[l.key] || "—")
            }, null, 8, ["max-length", "content"])
          ])
        ], 2)
      ], 2))), 128))
    ], 2));
  }
}), p5 = {
  "v-table-card": "_v-table-card_1gl58_1",
  "v-table-card__row": "_v-table-card__row_1gl58_8",
  "v-table-card__label": "_v-table-card__label_1gl58_18",
  "v-table-card__label--header": "_v-table-card__label--header_1gl58_31",
  "v-table-card__value": "_v-table-card__value_1gl58_43",
  "v-table-card__title": "_v-table-card__title_1gl58_53"
}, h5 = {
  $style: p5
}, Fo = /* @__PURE__ */ U(f5, [["__cssModules", h5]]), m5 = /* @__PURE__ */ ue({
  __name: "CardsComponent",
  props: {
    cols: {},
    rows: {},
    loading: { type: Boolean },
    rowTextMaxLength: {},
    isDraggable: { type: Boolean },
    cardTitle: {},
    fixedTopElement: { type: Boolean }
  },
  emits: ["reorder"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = tt(), a = G(() => _u(e.rows)), o = (i) => {
      u("reorder", i.map((l) => ks(l, ["_id"])));
    }, s = be();
    return (i, l) => i.isDraggable ? (m(), H(p(Ts), {
      key: 0,
      tag: "div",
      class: b(p(s)["v-table-cards"]),
      "model-value": a.value,
      "item-key": "_id",
      handle: ".draggable-handle",
      "onUpdate:modelValue": l[0] || (l[0] = (d) => o(d))
    }, {
      item: J(({ element: d, index: h }) => [
        j(Fo, {
          row: d,
          cols: i.cols,
          "row-index": h,
          "card-title": i.cardTitle,
          "is-draggable": i.isDraggable && (!i.fixedTopElement || h > 0),
          loading: i.loading,
          "row-text-max-length": i.rowTextMaxLength
        }, mt({ _: 2 }, [
          ge(p(n), (c, f) => ({
            name: f,
            fn: J((g) => [
              K(i.$slots, f, Le(Ne(g)))
            ])
          }))
        ]), 1032, ["row", "cols", "row-index", "card-title", "is-draggable", "loading", "row-text-max-length"])
      ]),
      _: 3
    }, 8, ["class", "model-value"])) : (m(), x("div", {
      key: 1,
      class: b(p(s)["v-table-cards"])
    }, [
      (m(!0), x(pe, null, ge(a.value, (d, h) => (m(), H(Fo, {
        key: d._id,
        row: d,
        "row-index": h,
        "card-title": i.cardTitle,
        "is-draggable": i.isDraggable,
        loading: i.loading,
        "row-text-max-length": i.rowTextMaxLength,
        cols: i.cols
      }, mt({ _: 2 }, [
        ge(p(n), (c, f) => ({
          name: f,
          fn: J((g) => [
            K(i.$slots, f, Te({ ref_for: !0 }, g))
          ])
        }))
      ]), 1032, ["row", "row-index", "card-title", "is-draggable", "loading", "row-text-max-length", "cols"]))), 128))
    ], 2));
  }
}), v5 = {
  "v-table-cards": "_v-table-cards_jd9vj_1"
}, g5 = {
  $style: v5
}, b5 = /* @__PURE__ */ U(m5, [["__cssModules", g5]]), Kx = /* @__PURE__ */ ue({
  __name: "VTable",
  props: {
    cols: {},
    rows: {},
    isSortEnabled: { type: Boolean, default: !1 },
    isCalculationEnabled: { type: Boolean, default: !1 },
    sortableKeys: { default: () => [] },
    calculatedKeys: { default: () => [] },
    sort: { default: null },
    calculation: { default: () => [] },
    loading: { type: Boolean, default: !1 },
    rowTextMaxLength: { default: 15 },
    isDraggable: { type: Boolean, default: !1 },
    isMobile: { type: Boolean, default: !1 },
    cardTitle: { default: "" },
    fixedTopElement: { type: Boolean, default: !1 },
    resizable: { type: Boolean, default: !1 },
    compactHeader: { type: Boolean, default: !1 },
    withoutOutline: { type: Boolean, default: !1 },
    withoutTableHeader: { type: Boolean, default: !1 }
  },
  emits: ["update:sort", "reorder", "update:calculation"],
  setup(r, { expose: t, emit: e }) {
    const u = tt(), n = e, a = Cs("table");
    return t({
      expandAllRows: () => {
        var s, i;
        (i = (s = a.value) == null ? void 0 : s.expandAllRows) == null || i.call(s);
      }
    }), (s, i) => s.isMobile ? (m(), H(b5, {
      key: 0,
      cols: s.cols,
      rows: s.rows,
      "card-title": s.cardTitle,
      loading: s.loading,
      "row-text-max-length": s.rowTextMaxLength,
      "is-draggable": s.isDraggable,
      "fixed-top-element": s.fixedTopElement,
      onReorder: i[0] || (i[0] = (l) => n("reorder", l))
    }, mt({ _: 2 }, [
      ge(p(u), (l, d) => ({
        name: d,
        fn: J((h) => [
          K(s.$slots, d, Le(Ne(h)))
        ])
      }))
    ]), 1032, ["cols", "rows", "card-title", "loading", "row-text-max-length", "is-draggable", "fixed-top-element"])) : (m(), H(d5, {
      key: 1,
      ref: "table",
      cols: s.cols,
      rows: s.rows,
      sort: s.sort,
      "sortable-keys": s.sortableKeys,
      "is-sort-enabled": s.isSortEnabled,
      calculation: s.calculation,
      "without-table-header": s.withoutTableHeader,
      "calculated-keys": s.calculatedKeys,
      "is-calculation-enabled": s.isCalculationEnabled,
      loading: s.loading,
      "row-text-max-length": s.rowTextMaxLength,
      "is-draggable": s.isDraggable,
      "fixed-top-element": s.fixedTopElement,
      resizable: s.resizable,
      "compact-header": s.compactHeader,
      "without-outline": s.withoutOutline,
      "onUpdate:sort": i[1] || (i[1] = (l) => n("update:sort", l)),
      onReorder: i[2] || (i[2] = (l) => n("reorder", l)),
      "onUpdate:calculation": i[3] || (i[3] = (l) => n("update:calculation", l))
    }, mt({ _: 2 }, [
      ge(p(u), (l, d) => ({
        name: d,
        fn: J((h) => [
          K(s.$slots, d, Le(Ne(h)))
        ])
      }))
    ]), 1032, ["cols", "rows", "sort", "sortable-keys", "is-sort-enabled", "calculation", "without-table-header", "calculated-keys", "is-calculation-enabled", "loading", "row-text-max-length", "is-draggable", "fixed-top-element", "resizable", "compact-header", "without-outline"]));
  }
}), y5 = /* @__PURE__ */ ue({
  __name: "VSkeletonRecordsPage",
  props: {
    isRecordTypesEnabled: { type: Boolean, default: !1 },
    countOfCols: { default: 5 }
  },
  setup(r) {
    return (t, e) => (m(), x("div", {
      class: b(t.$style["v-skeleton-records-cards"])
    }, [
      (m(), x(pe, null, ge(6, (u) => C("div", {
        key: u,
        class: b(t.$style["v-skeleton-records-cards__card"])
      }, [
        C("div", {
          class: b(t.$style["v-skeleton-records-cards__header"])
        }, [
          C("div", {
            class: b(t.$style["v-skeleton-records-cards__status-wrapper"])
          }, [
            j(p(Dt), {
              height: "28px",
              width: "110px",
              radius: 20
            }),
            j(p(Dt), {
              class: b(t.$style["v-skeleton-records-cards__header-title"]),
              height: "24px",
              width: "max(60%, 150px)"
            }, null, 8, ["class"])
          ], 2),
          C("div", {
            class: b(t.$style["v-skeleton-records-cards__actions-wrapper"])
          }, [
            C("div", {
              class: b(t.$style["v-skeleton-records-cards__record-type-wrapper"])
            }, [
              t.isRecordTypesEnabled ? (m(), H(p(Dt), {
                key: 0,
                height: "24px",
                width: "95px",
                radius: 24
              })) : R("", !0),
              j(p(Dt), {
                class: b(t.$style["v-skeleton-records-cards__actions"]),
                height: "24px",
                width: "24px",
                radius: 4
              }, null, 8, ["class"])
            ], 2),
            j(p(Dt), {
              height: "18px",
              width: "90px"
            })
          ], 2)
        ], 2),
        C("div", {
          class: b(t.$style["v-skeleton-records-cards__body"])
        }, [
          (m(!0), x(pe, null, ge(t.countOfCols, (n) => (m(), x("div", {
            key: n,
            class: b(t.$style["v-skeleton-records-cards__field-value"])
          }, [
            j(p(Dt), {
              height: "15px",
              width: "100%"
            }),
            j(p(Dt), {
              height: "18px",
              width: "70%"
            })
          ], 2))), 128))
        ], 2)
      ], 2)), 64))
    ], 2));
  }
}), _5 = {
  "v-skeleton-records-cards": "_v-skeleton-records-cards_xiau6_1",
  "v-skeleton-records-cards__card": "_v-skeleton-records-cards__card_xiau6_13",
  "v-skeleton-records-cards__header-title-wrapper": "_v-skeleton-records-cards__header-title-wrapper_xiau6_35",
  "v-skeleton-records-cards__header": "_v-skeleton-records-cards__header_xiau6_35",
  "v-skeleton-records-cards__actions-wrapper": "_v-skeleton-records-cards__actions-wrapper_xiau6_47",
  "v-skeleton-records-cards__record-type-wrapper": "_v-skeleton-records-cards__record-type-wrapper_xiau6_55",
  "v-skeleton-records-cards__actions": "_v-skeleton-records-cards__actions_xiau6_47",
  "v-skeleton-records-cards__status-wrapper": "_v-skeleton-records-cards__status-wrapper_xiau6_64",
  "v-skeleton-records-cards__body": "_v-skeleton-records-cards__body_xiau6_70",
  "v-skeleton-records-cards__field-value": "_v-skeleton-records-cards__field-value_xiau6_82"
}, w5 = {
  $style: _5
}, Xx = /* @__PURE__ */ U(y5, [["__cssModules", w5]]);
var Cc = /* @__PURE__ */ ((r) => (r.PRIMARY = "primary", r.PRIMARY_OUTLINE = "primary-outline", r.SECONDARY_OUTLINE = "secondary-outline", r.ACTION = "action", r.BASIC = "basic", r.ICON = "icon", r))(Cc || {}), La = /* @__PURE__ */ ((r) => (r.EXTRA_SMALL = "xs", r.SMALL = "sm", r.MEDIUM = "md", r))(La || {});
const C5 = ["onClick"], D5 = /* @__PURE__ */ ue({
  __name: "VMultiSelect",
  props: {
    disabled: { type: Boolean, default: !1 },
    clearable: { type: Boolean },
    searchable: { type: Boolean },
    loading: { type: Boolean, default: !1 },
    prefixIcon: {},
    optionLabel: { type: [String, Function], default: "label" },
    options: {},
    selectable: {},
    reduce: { type: Function, default: (r) => typeof r == "string" ? r : (r == null ? void 0 : r.value) || r },
    emptyValue: { type: Boolean },
    placeholder: {},
    filterable: { type: Boolean },
    foreground: { type: Boolean },
    borderless: { type: Boolean, default: !0 },
    appendToBody: { type: Boolean },
    taggable: { type: Boolean, default: !1 },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    helpText: {},
    description: {},
    size: {},
    color: {},
    warning: {},
    infoText: {},
    inputMode: {},
    modelValue: { default: "[]" },
    isArray: { type: Boolean, default: !1 },
    optionMaxWidth: { default: 150 },
    linkField: { type: Boolean, default: !1 },
    fieldPlaceholder: { default: "" }
  },
  emits: ["update:modelValue", "search", "option:created", "option:deselecting", "option:selecting"],
  setup(r, { expose: t, emit: e }) {
    ja((E) => ({
      "796708ca": ee.value
    }));
    const u = r, n = e, a = E0(bc), o = Q("");
    qe(() => o.value, (E) => {
      n("search", E);
    });
    const s = Q(!1), i = Q(null), l = Q(null), d = Q(null), h = (E) => typeof E == "string" ? E : typeof u.optionLabel == "function" ? u.optionLabel(E) : typeof u.optionLabel == "string" && E[u.optionLabel] || "";
    qe(() => s.value, async (E) => {
      o.value = "", await Pe(), !(!i.value || !l.value) && (E && l.value && (i.value.style.width = `${l.value.clientWidth}px`, i.value.style.zIndex = "1100", d.value = Tt(l.value, i.value, {
        placement: "auto",
        modifiers: [
          St,
          {
            name: "offset",
            options: {
              offset: [0, -1]
            }
          },
          {
            name: "flip",
            options: {
              allowedAutoPlacements: ["top", "bottom"]
            }
          }
        ]
      }), document.body.appendChild(i.value)), !E && d.value && f());
    });
    const c = G(() => o.value ? u.options.filter(Boolean).filter((E) => typeof E == "string" ? E.toLowerCase().includes(o.value.toLowerCase()) : String(h(E) || "").toLowerCase().includes(o.value.toLowerCase())) : u.options.filter(Boolean)), f = () => {
      d.value && (d.value.destroy(), d.value = null), i.value && document.body.removeChild(i.value);
    };
    Zt(l, () => s.value = !1, {
      ignore: [i]
    }), Yt(() => {
      f();
    });
    const g = G({
      get() {
        if (u.isArray)
          return Array.isArray(u.modelValue) ? u.modelValue : [];
        try {
          return JSON.parse(u.modelValue || "[]") || [];
        } catch {
          return [];
        }
      },
      set(E) {
        return E || n("update:modelValue", E), u.isArray ? n("update:modelValue", E) : n("update:modelValue", JSON.stringify(E));
      }
    }), D = G(() => {
      var E;
      return (E = g.value || []) == null ? void 0 : E.map((S) => u.options.find(($) => typeof $ == "string" ? $ === S : u.reduce($) === S) || S).filter(Boolean);
    }), _ = (E) => {
      const S = typeof E == "string" ? E : u.reduce(E);
      if (g.value.includes(S)) {
        n("option:deselecting", E), g.value = g.value.filter(($) => $ !== S);
        return;
      }
      n("option:selecting", E), g.value = [
        ...g.value,
        S
      ];
    }, O = Q(1), M = G(() => D.value.slice(0, O.value)), L = G(() => {
      const E = D.value.slice(O.value);
      return {
        count: E.length,
        text: yu(E.map((S) => S ? h(S) : ""), ", ")
      };
    }), q = Q([]);
    k0(() => {
      q.value = [];
    });
    const z = Q(null);
    Ha(l, (E) => {
      window.requestAnimationFrame(() => {
        if (!Array.isArray(E) || !E.length)
          return;
        const S = E[0], { width: $ } = S.contentRect;
        z.value = $, i.value && (i.value.style.width = `${$}px`);
      });
    });
    const X = Q(null);
    qe(() => [z.value, q.value], Es(async () => {
      var k;
      await Pe();
      const E = (k = X.value) != null && k.trigger ? X.value.trigger.clientWidth + 8 : 0, S = (z.value || 0) - (30 + E), {
        leftTriggerWidth: $,
        count: w
      } = q.value.reduce((T, F) => {
        if (T.isEnded)
          return T;
        const { width: I } = F.getBoundingClientRect(), P = I + 4;
        return T.leftTriggerWidth >= P ? {
          leftTriggerWidth: T.leftTriggerWidth - P,
          count: T.count + 1,
          isEnded: !1
        } : (T.isEnded = !0, T);
      }, {
        leftTriggerWidth: S,
        count: 0,
        isEnded: !1
      });
      if ($ >= u.optionMaxWidth) {
        O.value = w + Math.floor($ / u.optionMaxWidth);
        return;
      }
      O.value = w || 1;
    }, 50));
    const ee = G(() => u.optionMaxWidth + "px"), V = be(), oe = G(() => u.loading ? () => Ze(Cu, {
      size: Rt.SMALL
    }) : u.taggable && !c.value.length ? () => Ze(vt, {
      size: La.EXTRA_SMALL,
      class: V["v-multi-select__add-tag"],
      onclick: () => {
        n("option:created", o.value), o.value = "";
      }
    }, () => "+ Add") : g.value.length ? () => Ze(vt, {
      size: La.EXTRA_SMALL,
      variant: Cc.PRIMARY_OUTLINE,
      class: V["v-multi-select__add-tag"],
      onClick: () => {
        D.value.forEach((E) => {
          _(E);
        }), g.value = [];
      }
    }, () => "Clear All") : null), W = () => {
      u.disabled || (s.value = !s.value);
    };
    return t({
      blur: () => {
        s.value = !1;
      }
    }), (E, S) => (m(), H(p(Lr), {
      class: b([
        p(V)["v-multi-select"]
      ]),
      error: E.error,
      label: E.label,
      "show-required-star": E.showRequiredStar,
      "with-error": E.withError,
      color: E.color,
      description: E.description,
      "help-text": E.helpText,
      warning: E.warning,
      "info-text": E.infoText
    }, {
      default: J(() => [
        C("div", {
          ref_key: "trigger",
          ref: l,
          class: b([
            p(V)["v-multi-select__trigger"],
            p(V)[`v-multi-select__trigger--${E.size}`],
            {
              [p(V)["v-multi-select__trigger--disabled"]]: E.disabled
            }
          ]),
          onClick: W
        }, [
          !M.value.length && !D.value.length ? (m(), x("div", {
            key: 0,
            class: b([p(V)["v-multi-select__field-placeholder"]])
          }, ne(E.fieldPlaceholder), 3)) : R("", !0),
          (m(!0), x(pe, null, ge(M.value, ($) => (m(), x("div", {
            key: String($ || E.reduce($)),
            class: b(p(V)["v-multi-select__selected"])
          }, [
            K(E.$slots, "option", Te({ ref_for: !0 }, {
              option: $,
              selected: !1
            }), () => [
              j(p(yt), {
                "auto-shrink": "",
                content: $ ? h($) : ""
              }, null, 8, ["content"])
            ]),
            K(E.$slots, "deselect", {}, () => [
              Xe(j(Wt, {
                class: b([p(V)["v-multi-select__deselect-icon"]]),
                height: "10",
                width: "10",
                onClick: ot((w) => _($), ["stop"])
              }, null, 8, ["class", "onClick"]), [
                [iu, !E.disabled]
              ])
            ])
          ], 2))), 128)),
          (m(!0), x(pe, null, ge(D.value, ($) => (m(), x("div", {
            key: String(typeof $ == "string" ? $ : E.reduce($)),
            ref_for: !0,
            ref: (w) => w ? q.value.push(w) : null,
            class: b([
              p(V)["v-multi-select__selected"],
              p(V)["v-multi-select__selected--invisible"]
            ])
          }, [
            K(E.$slots, "option", Te({ ref_for: !0 }, {
              option: $,
              selected: !1
            }), () => [
              j(p(yt), {
                "auto-shrink": "",
                content: $ ? h($) : ""
              }, null, 8, ["content"])
            ]),
            K(E.$slots, "deselect", {}, () => [
              j(Wt, {
                class: b([
                  p(V)["v-multi-select__deselect-icon"],
                  {
                    [p(V)["v-multi-select__deselect-icon--hide"]]: E.disabled
                  }
                ]),
                height: "10",
                width: "10",
                onClick: ot((w) => _($), ["stop"])
              }, null, 8, ["class", "onClick"])
            ])
          ], 2))), 128)),
          L.value.count > 0 ? (m(), H(p(Ve), {
            key: 1,
            ref_key: "countBubble",
            ref: X,
            content: L.value.text,
            placement: "top"
          }, {
            default: J(() => [
              j(p(or), {
                content: `+${L.value.count}`
              }, null, 8, ["content"])
            ]),
            _: 1
          }, 8, ["content"])) : R("", !0),
          j(kt, {
            class: b([
              p(V)["v-multi-select__toggle"],
              {
                [p(V)["v-multi-select__toggle--open"]]: s.value
              }
            ])
          }, null, 8, ["class"])
        ], 2),
        s.value ? (m(), x("div", {
          key: 0,
          ref_key: "optionsList",
          ref: i,
          class: b(p(V)["v-multi-select__options-list"])
        }, [
          j(p(Fr), {
            modelValue: o.value,
            "onUpdate:modelValue": S[0] || (S[0] = ($) => o.value = $),
            autofocus: "",
            class: b(p(V)["v-multi-select__options-search"]),
            borderless: !1,
            "suffix-icon": oe.value,
            "prefix-icon": a.value,
            placeholder: E.placeholder || "Search"
          }, null, 8, ["modelValue", "class", "suffix-icon", "prefix-icon", "placeholder"]),
          C("div", {
            class: b(p(V)["v-multi-select__options"])
          }, [
            c.value.length ? (m(), x(pe, { key: 0 }, [
              (m(!0), x(pe, null, ge(c.value, ($, w) => (m(), x("div", {
                key: w,
                class: b([
                  p(V)["v-multi-select__option"],
                  {
                    [p(V)["v-multi-select__option--checked"]]: g.value.includes(E.reduce($))
                  }
                ]),
                onClick: (k) => _($)
              }, [
                K(E.$slots, "option", Te({ ref_for: !0 }, {
                  option: $,
                  selected: !1
                }), () => [
                  ce(ne(h($)), 1)
                ]),
                K(E.$slots, "checked", {}, () => [
                  g.value.includes(E.reduce($)) ? (m(), H(Eu, {
                    key: 0,
                    width: "16px",
                    height: "16px"
                  })) : R("", !0)
                ])
              ], 10, C5))), 128)),
              K(E.$slots, "list-footer")
            ], 64)) : (m(), x("div", {
              key: 1,
              class: b(p(V)["v-multi-select__empty"])
            }, [
              K(E.$slots, "no-options", Le(Ne({
                search: o.value
              })), () => [
                S[1] || (S[1] = ce(" Sorry, no matching options. ", -1))
              ])
            ], 2))
          ], 2)
        ], 2)) : R("", !0)
      ]),
      _: 3
    }, 8, ["class", "error", "label", "show-required-star", "with-error", "color", "description", "help-text", "warning", "info-text"]));
  }
}), A5 = {
  "v-multi-select": "_v-multi-select_c8t07_1",
  "v-multi-select__trigger": "_v-multi-select__trigger_c8t07_10",
  "v-multi-select__field-placeholder": "_v-multi-select__field-placeholder_c8t07_25",
  "v-multi-select__trigger--disabled": "_v-multi-select__trigger--disabled_c8t07_30",
  "v-multi-select__selected": "_v-multi-select__selected_c8t07_35",
  "v-multi-select__trigger--large": "_v-multi-select__trigger--large_c8t07_51",
  "v-multi-select__options-list": "_v-multi-select__options-list_c8t07_58",
  "v-multi-select__options": "_v-multi-select__options_c8t07_58",
  "v-multi-select__options-search": "_v-multi-select__options-search_c8t07_89",
  "v-multi-select__option": "_v-multi-select__option_c8t07_58",
  "v-multi-select__empty": "_v-multi-select__empty_c8t07_115",
  "v-multi-select__option--checked": "_v-multi-select__option--checked_c8t07_134",
  "v-multi-select__toggle": "_v-multi-select__toggle_c8t07_138",
  "v-multi-select__toggle--open": "_v-multi-select__toggle--open_c8t07_148",
  "v-multi-select__deselect-icon": "_v-multi-select__deselect-icon_c8t07_152",
  "v-multi-select__selected--invisible": "_v-multi-select__selected--invisible_c8t07_158",
  "v-multi-select__add-tag": "_v-multi-select__add-tag_c8t07_165"
}, x5 = {
  $style: A5
}, Jx = /* @__PURE__ */ U(D5, [["__cssModules", x5]]), E5 = {}, k5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none"
};
function S5(r, t) {
  return m(), x("svg", k5, t[0] || (t[0] = [
    C("rect", {
      x: "2.7",
      y: "3.2",
      width: "18.6",
      height: "18.6",
      rx: "4.8",
      stroke: "currentColor",
      "stroke-width": "1.6"
    }, null, -1),
    C("path", {
      d: "M15.5355 9.03553L8.46447 16.1066M8.46447 9.03553L15.5355 16.1066",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const T5 = /* @__PURE__ */ U(E5, [["render", S5]]), B5 = /* @__PURE__ */ ue({
  __name: "VBaseModal",
  props: {
    title: { default: "" },
    cancelButtonText: { default: "Cancel" },
    cancelButtonDisabled: { type: Boolean, default: !1 },
    submitButtonDisabled: { type: Boolean, default: !1 },
    submitButtonText: { default: "Submit" },
    isModalShow: { type: Boolean },
    loading: { type: Boolean, default: !1 },
    closeOnOverlayClick: { type: Boolean, default: !0 },
    maxWidth: { default: "396px" },
    withCloseIcon: { type: Boolean, default: !0 },
    closeIconCustomEvent: { type: Boolean, default: !1 },
    hideFooter: { type: Boolean, default: !1 },
    hideSubmit: { type: Boolean, default: !1 },
    btnsAlignRight: { type: Boolean, default: !1 },
    escToClose: { type: Boolean, default: !0 },
    zIndexFn: { type: Function, default: ({ index: r }) => 1e3 + 2 * r },
    showRequiredStar: { type: Boolean, default: !1 }
  },
  emits: ["update:is-modal-show", "cancel", "click:closeIcon", "submit", "closed"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G({
      get() {
        return e.isModalShow;
      },
      set(i) {
        u("update:is-modal-show", i);
      }
    }), a = G(() => e.closeOnOverlayClick ? !e.loading : e.closeOnOverlayClick), o = tt(), s = () => {
      if (e.closeIconCustomEvent)
        return u("click:closeIcon");
      u("cancel");
    };
    return (i, l) => (m(), H(p(Ss), {
      modelValue: n.value,
      "onUpdate:modelValue": l[2] || (l[2] = (d) => n.value = d),
      class: b(i.$style["v-base-modal"]),
      "click-to-close": a.value,
      "esc-to-close": i.escToClose && !i.loading,
      "focus-trap": !1,
      "z-index-fn": i.zIndexFn,
      style: ht({
        "--modal-max-width": i.maxWidth
      }),
      onClosed: l[3] || (l[3] = (d) => u("closed"))
    }, {
      default: J(() => [
        C("div", {
          class: b(i.$style["v-base-modal__header"])
        }, [
          K(i.$slots, "modal-title", {}, () => [
            C("h3", {
              class: b([
                i.$style["v-base-modal__title"],
                {
                  [i.$style["v-base-modal__title--with-close"]]: i.withCloseIcon
                }
              ])
            }, [
              i.showRequiredStar ? (m(), x("span", {
                key: 0,
                class: b(i.$style["v-base-modal__title-required-star"])
              }, " * ", 2)) : R("", !0),
              ce(" " + ne(i.title), 1)
            ], 2)
          ]),
          K(i.$slots, "modal-extra-btn"),
          i.withCloseIcon ? (m(), x("div", {
            key: 0,
            class: b(i.$style["v-base-modal__close-icon"]),
            onClick: s
          }, [
            j(Wt)
          ], 2)) : R("", !0)
        ], 2),
        C("div", {
          class: b(i.$style["v-base-modal__body"])
        }, [
          K(i.$slots, "default")
        ], 2),
        i.hideFooter ? R("", !0) : (m(), x("div", {
          key: 0,
          class: b([
            i.$style["v-base-modal__buttons"],
            {
              [i.$style["v-base-modal__buttons--right"]]: i.btnsAlignRight,
              [i.$style["v-base-modal__buttons--single"]]: i.hideSubmit,
              [i.$style["v-base-modal__buttons--triple"]]: p(o)["footer-extra-btn"]
            }
          ])
        }, [
          K(i.$slots, "cancel-btn", {}, () => [
            j(p(vt), {
              variant: p(qt).PRIMARY_OUTLINE,
              fill: "",
              disabled: i.loading || i.cancelButtonDisabled,
              onClick: l[0] || (l[0] = (d) => u("cancel"))
            }, {
              icon: J(() => [
                j(T5)
              ]),
              default: J(() => [
                ce(" " + ne(i.cancelButtonText), 1)
              ]),
              _: 1
            }, 8, ["variant", "disabled"])
          ]),
          K(i.$slots, "footer-extra-btn"),
          i.hideSubmit ? R("", !0) : K(i.$slots, "submit-btn", { key: 0 }, () => [
            j(p(vt), {
              variant: p(qt).PRIMARY,
              loading: i.loading,
              disabled: i.submitButtonDisabled,
              fill: "",
              onClick: l[1] || (l[1] = (d) => u("submit"))
            }, {
              icon: J(() => [
                j(Eu)
              ]),
              default: J(() => [
                ce(" " + ne(i.submitButtonText), 1)
              ]),
              _: 1
            }, 8, ["variant", "loading", "disabled"])
          ])
        ], 2))
      ]),
      _: 3
    }, 8, ["modelValue", "class", "click-to-close", "esc-to-close", "z-index-fn", "style"]));
  }
}), $5 = {
  "v-base-modal": "_v-base-modal_1bnvg_1",
  "v-base-modal__header": "_v-base-modal__header_1bnvg_36",
  "v-base-modal__title": "_v-base-modal__title_1bnvg_48",
  "v-base-modal__title--with-close": "_v-base-modal__title--with-close_1bnvg_63",
  "v-base-modal__title-required-star": "_v-base-modal__title-required-star_1bnvg_67",
  "v-base-modal__body": "_v-base-modal__body_1bnvg_71",
  "v-base-modal__buttons": "_v-base-modal__buttons_1bnvg_77",
  "v-base-modal__buttons--single": "_v-base-modal__buttons--single_1bnvg_89",
  "v-base-modal__buttons--triple": "_v-base-modal__buttons--triple_1bnvg_98",
  "v-base-modal__buttons--right": "_v-base-modal__buttons--right_1bnvg_119",
  "v-base-modal__close-icon": "_v-base-modal__close-icon_1bnvg_153"
}, M5 = {
  $style: $5
}, vi = /* @__PURE__ */ U(B5, [["__cssModules", M5]]), O5 = /* @__PURE__ */ ue({
  __name: "VUpdateField",
  props: {
    isModalShow: { type: Boolean },
    fieldName: { default: "field" },
    loading: { type: Boolean, default: !1 },
    isEdit: { type: Boolean, default: !0 },
    cancelButtonDisabled: { type: Boolean, default: !1 },
    submitButtonDisabled: { type: Boolean, default: !1 },
    withSubmit: { type: Boolean, default: !0 },
    maxWidth: { default: "396px" },
    showRequiredStar: { type: Boolean, default: !1 },
    withCloseIcon: { type: Boolean, default: !0 }
  },
  emits: ["update:is-modal-show", "cancel", "submit"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G({
      get() {
        return e.isModalShow;
      },
      set(o) {
        u("update:is-modal-show", o);
      }
    }), a = G(() => e.fieldName ? e.fieldName.charAt(0).toUpperCase() + e.fieldName.slice(1) : "");
    return (o, s) => (m(), H(p(vi), {
      "is-modal-show": n.value,
      "onUpdate:isModalShow": s[0] || (s[0] = (i) => n.value = i),
      title: a.value,
      "cancel-button-text": o.isEdit ? "Cancel" : "Close",
      "submit-button-text": o.isEdit ? "Update" : "Edit",
      "cancel-button-disabled": o.cancelButtonDisabled,
      "submit-button-disabled": o.submitButtonDisabled,
      loading: o.loading,
      "hide-submit": !o.withSubmit,
      "max-width": o.maxWidth,
      "show-required-star": o.showRequiredStar,
      "with-close-icon": o.withCloseIcon,
      onCancel: s[1] || (s[1] = (i) => u("cancel")),
      onSubmit: s[2] || (s[2] = (i) => u("submit")),
      onClose: s[3] || (s[3] = (i) => u("cancel"))
    }, {
      default: J(() => [
        K(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["is-modal-show", "title", "cancel-button-text", "submit-button-text", "cancel-button-disabled", "submit-button-disabled", "loading", "hide-submit", "max-width", "show-required-star", "with-close-icon"]));
  }
}), L5 = /* @__PURE__ */ ue({
  __name: "VEditableTableItem",
  props: {
    content: { default: "—" },
    maxLength: { default: 50 },
    disabled: { type: Boolean, default: !1 },
    hoverContent: { default: "" },
    tooltipMaxWidth: { default: "200px" },
    autoShrink: { type: Boolean, default: !1 }
  },
  emits: ["edit"],
  setup(r, { emit: t }) {
    const e = t, u = be();
    return (n, a) => (m(), x("div", {
      class: b([
        p(u)["v-editable-table-item"],
        {
          [p(u)["v-editable-table-item--disabled"]]: n.disabled
        }
      ])
    }, [
      C("div", {
        class: b(p(u)["v-editable-table-item__content"])
      }, [
        K(n.$slots, "default", Le(Ne({
          content: n.content,
          hoverContent: n.hoverContent,
          maxLength: n.maxLength,
          autoShrink: n.autoShrink,
          tooltipMaxWidth: n.tooltipMaxWidth
        })), () => [
          j(p(yt), {
            content: n.content,
            "hover-content": n.hoverContent,
            "max-length": n.maxLength,
            "auto-shrink": n.autoShrink,
            "tooltip-max-width": n.tooltipMaxWidth,
            placement: "top"
          }, null, 8, ["content", "hover-content", "max-length", "auto-shrink", "tooltip-max-width"])
        ])
      ], 2),
      n.disabled ? R("", !0) : (m(), x("div", {
        key: 0,
        onClick: a[0] || (a[0] = (o) => e("edit"))
      }, [
        j(_c, {
          class: b(p(u)["v-editable-table-item__edit-icon"])
        }, null, 8, ["class"])
      ]))
    ], 2));
  }
}), F5 = {
  "v-editable-table-item": "_v-editable-table-item_1bg0k_1",
  "v-editable-table-item__edit-icon": "_v-editable-table-item__edit-icon_1bg0k_12",
  "v-editable-table-item--disabled": "_v-editable-table-item--disabled_1bg0k_16",
  "v-editable-table-item__content": "_v-editable-table-item__content_1bg0k_20"
}, I5 = {
  $style: F5
}, Qx = /* @__PURE__ */ U(L5, [["__cssModules", I5]]), N5 = /* @__PURE__ */ ue({
  __name: "VNewVersion",
  props: {
    isModalShow: { type: Boolean }
  },
  emits: ["update:is-modal-show", "cancel", "submit"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G({
      get() {
        return e.isModalShow;
      },
      set(o) {
        u("update:is-modal-show", o);
      }
    }), a = be();
    return (o, s) => (m(), H(p(vi), {
      "is-modal-show": n.value,
      "onUpdate:isModalShow": s[0] || (s[0] = (i) => n.value = i),
      title: "New version available",
      "submit-button-text": "Refresh",
      "close-on-overlay-click": !1,
      onCancel: s[1] || (s[1] = (i) => u("cancel")),
      onSubmit: s[2] || (s[2] = (i) => u("submit")),
      onClose: s[3] || (s[3] = (i) => u("cancel"))
    }, {
      default: J(() => [
        C("p", {
          class: b(p(a)["v-new-version__content"])
        }, ' Please click "Refresh" to use the latest version of Vsimple! If you need to save your work first, hit "Cancel" and refresh your browser at your convenience. ', 2)
      ]),
      _: 1
    }, 8, ["is-modal-show"]));
  }
}), q5 = {
  "v-new-version__content": "_v-new-version__content_1v7hk_1"
}, P5 = {
  $style: q5
}, eE = /* @__PURE__ */ U(N5, [["__cssModules", P5]]), R5 = /* @__PURE__ */ ue({
  __name: "VCreateViewModal",
  props: {
    isModalShow: { type: Boolean },
    title: {},
    loading: { type: Boolean, default: !1 }
  },
  emits: ["submit", "update:is-modal-show"],
  setup(r, { emit: t }) {
    const e = S0(), u = Q({
      title: ""
    }), n = {
      title: {
        required: sa.withMessage("Title is required field", la)
      }
    }, a = Bs(n, u), o = r, s = t, i = G({
      get() {
        return o.isModalShow;
      },
      set(h) {
        s("update:is-modal-show", h);
      }
    }), l = () => {
      a.value.$validate(), a.value.$error || s("submit", u.value);
    }, d = () => {
      a.value.$reset(), u.value = {
        title: ""
      };
    };
    return (h, c) => (m(), H(p(vi), Te({
      "is-modal-show": i.value,
      "onUpdate:isModalShow": c[1] || (c[1] = (f) => i.value = f),
      title: h.title,
      loading: h.loading,
      "max-width": "500px"
    }, p(e), {
      onSubmit: l,
      onClosed: d,
      onCancel: c[2] || (c[2] = (f) => i.value = !1)
    }), {
      default: J(() => {
        var f, g;
        return [
          C("div", {
            class: b(h.$style["v-create-view-modal-content"])
          }, [
            j(p(Fr), {
              modelValue: u.value.title,
              "onUpdate:modelValue": c[0] || (c[0] = (D) => u.value.title = D),
              label: "Title",
              error: String(((f = p(a).title.$errors[0]) == null ? void 0 : f.$message) || ""),
              "with-error": !!String(((g = p(a).title.$errors[0]) == null ? void 0 : g.$message) || ""),
              borderless: !1,
              "show-required-star": ""
            }, null, 8, ["modelValue", "error", "with-error"]),
            K(h.$slots, "default")
          ], 2)
        ];
      }),
      _: 3
    }, 16, ["is-modal-show", "title", "loading"]));
  }
}), V5 = {
  "v-create-view-modal-content": "_v-create-view-modal-content_1rfwn_1"
}, j5 = {
  $style: V5
}, tE = /* @__PURE__ */ U(R5, [["__cssModules", j5]]), H5 = ["onClick"], U5 = /* @__PURE__ */ ue({
  __name: "VTab",
  props: {
    title: {},
    count: { default: null },
    isCountLoading: { type: Boolean, default: !1 },
    actions: { default: () => [] },
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    description: { default: "" },
    tooltipClass: { default: "" }
  },
  emits: ["click:action", "click:tab"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G(() => {
      var f;
      return !!((f = e.actions) != null && f.length);
    }), a = G(() => _u(e.actions)), o = (f) => {
      u("click:action", f), l.value = !1;
    }, s = Q(null), i = Q(null), l = Q(!1), d = Q(null), h = () => {
      var f;
      d.value && ((f = d.value) == null || f.destroy(), d.value = null), i.value && document.body.removeChild(i.value);
    };
    qe(() => l.value, async (f) => {
      var g;
      await Pe(), !(!s.value || !i.value) && (f && s.value && (i.value.style.minWidth = `max(${(g = s.value) == null ? void 0 : g.clientWidth}px, 100px)`, d.value = Tt(s.value, i.value, {
        placement: "bottom",
        modifiers: [
          St,
          {
            name: "offset",
            options: {
              offset: [0, -20]
            }
          }
        ]
      }), document.body.appendChild(i.value)), !f && d.value && h());
    }), Yt(() => {
      h();
    }), Zt(s, () => {
      l.value = !1;
    }, {
      ignore: [i]
    });
    const c = be();
    return (f, g) => (m(), x("div", {
      ref_key: "tab",
      ref: s,
      class: b([
        p(c)["v-tab"],
        {
          [p(c)["v-tab--active"]]: f.active,
          [p(c)["v-tab--with-actions"]]: n.value
        }
      ]),
      onClick: g[1] || (g[1] = (D) => u("click:tab"))
    }, [
      f.description ? (m(), H(p(Ve), {
        key: 0,
        content: f.description,
        "tooltip-class": f.tooltipClass
      }, null, 8, ["content", "tooltip-class"])) : R("", !0),
      ce(" " + ne(f.title) + " ", 1),
      f.count || f.isCountLoading ? (m(), H(p(or), { key: 1 }, {
        content: J(() => [
          f.isCountLoading ? (m(), x(pe, { key: 0 }, [
            f.isCountLoading ? (m(), H(p(Cu), {
              key: 0,
              size: p(Rt).SMALL
            }, null, 8, ["size"])) : R("", !0)
          ], 64)) : (m(), x(pe, { key: 1 }, [
            ce(ne(f.count), 1)
          ], 64))
        ]),
        _: 1
      })) : R("", !0),
      n.value && !f.disabled ? (m(), x("div", {
        key: 2,
        class: b(p(c)["v-tab__toggle"]),
        onClick: g[0] || (g[0] = ot((D) => l.value = !l.value, ["stop"]))
      }, [
        j(kt)
      ], 2)) : R("", !0),
      l.value && n.value ? (m(), x("div", {
        key: 3,
        ref_key: "actions",
        ref: i,
        class: b(p(c)["v-tab__actions"])
      }, [
        (m(!0), x(pe, null, ge(a.value, (D) => (m(), x("div", {
          key: D._id,
          class: b([
            p(c)["v-tab__action"],
            {
              [p(c)[`v-tab__action--${D.modifier}`]]: D.modifier
            }
          ]),
          onClick: ot((_) => o(D.value), ["stop"])
        }, [
          D.icon ? (m(), H(He(D.icon), { key: 0 })) : R("", !0),
          ce(" " + ne(D.title), 1)
        ], 10, H5))), 128))
      ], 2)) : R("", !0)
    ], 2));
  }
}), z5 = {
  "v-tab": "_v-tab_1l396_1",
  "v-tab--active": "_v-tab--active_1l396_32",
  "v-tab--with-actions": "_v-tab--with-actions_1l396_39",
  "v-tab__toggle": "_v-tab__toggle_1l396_43",
  "v-tab__actions": "_v-tab__actions_1l396_58",
  "v-tab__action": "_v-tab__action_1l396_58",
  "v-tab__action--danger": "_v-tab__action--danger_1l396_97"
}, G5 = {
  $style: z5
}, rE = /* @__PURE__ */ U(U5, [["__cssModules", G5]]), W5 = /* @__PURE__ */ ue({
  __name: "VColorPicker",
  props: {
    simple: { type: Boolean, default: !1 },
    modelValue: { default: "" },
    placement: { default: "bottom" }
  },
  emits: ["update:modelValue"],
  setup(r, { emit: t }) {
    ja((d) => ({
      78424198: d.modelValue
    }));
    const e = r, u = t, n = Q(null), a = Q(), o = Q();
    Zt(a, (d) => {
      i.value = !1;
    }, {
      ignore: [
        o
      ]
    });
    const s = () => {
      var d;
      n.value && ((d = n.value) == null || d.destroy(), n.value = null), o.value && document.body.removeChild(o.value);
    }, i = Q(!1);
    qe(() => i.value, async (d) => {
      var h;
      await Pe(), !(!a.value || !o.value) && (d && a.value && (o.value.style.width = `max(${(h = a.value) == null ? void 0 : h.clientWidth}px, ${e.minWidth})`, n.value = Tt(a.value, o.value, {
        placement: e.placement,
        modifiers: [
          St,
          {
            name: "offset",
            options: {
              offset: [0, 4]
            }
          }
        ]
      }), document.body.appendChild(o.value)), !d && n.value && s());
    });
    const l = be();
    return Yt(() => {
      s();
    }), (d, h) => (m(), x("div", null, [
      C("div", {
        ref_key: "trigger",
        ref: a,
        class: b(d.$style["v-color-picker__trigger"]),
        onClick: h[0] || (h[0] = (c) => i.value = !i.value)
      }, [
        C("div", {
          class: b(p(l)["v-color-picker__circle"])
        }, null, 2),
        d.simple ? R("", !0) : (m(), x("span", {
          key: 0,
          class: b(p(l)["v-color-picker__text"])
        }, ne(d.modelValue), 3))
      ], 2),
      i.value ? (m(), x("div", {
        key: 0,
        ref_key: "popperWrapper",
        ref: o,
        class: b(p(l)["v-color-picker__wrapper"])
      }, [
        j(p(M0), {
          "model-value": {
            hex: d.modelValue
          },
          "onUpdate:modelValue": h[1] || (h[1] = (c) => u("update:modelValue", c.hex))
        }, null, 8, ["model-value"])
      ], 2)) : R("", !0)
    ]));
  }
}), Y5 = {
  "v-color-picker__trigger": "_v-color-picker__trigger_t6wdk_1",
  "v-color-picker__circle": "_v-color-picker__circle_t6wdk_10",
  "v-color-picker__text": "_v-color-picker__text_t6wdk_21",
  "v-color-picker__wrapper": "_v-color-picker__wrapper_t6wdk_26"
}, Z5 = {
  $style: Y5
}, uE = /* @__PURE__ */ U(W5, [["__cssModules", Z5]]), K5 = {}, X5 = {
  width: "48",
  height: "48",
  viewBox: "0 0 49 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function J5(r, t) {
  return m(), x("svg", X5, t[0] || (t[0] = [
    sr('<g clip-path="url(#clip0_26272_79717)"><path d="M39.264 14.3353C37.6428 6.20102 29.7344 0.921359 21.6002 2.54258C15.6507 3.72837 10.9987 8.37741 9.80928 14.3261C4.04182 14.9908 -0.0952621 20.2049 0.569045 25.9728C1.18062 31.281 5.67659 35.2859 11.02 35.2822H18.5288C19.3582 35.2822 20.0306 34.6098 20.0306 33.7804C20.0306 32.9509 19.3582 32.2785 18.5288 32.2785H11.02C6.87263 32.254 3.53096 28.8724 3.55513 24.7254C3.57966 20.5785 6.96126 17.2364 11.1086 17.2606C11.874 17.261 12.517 16.6849 12.6013 15.9243C13.3637 9.33286 19.3253 4.60764 25.9167 5.37009C31.4582 6.01133 35.8297 10.3824 36.4705 15.9243C36.5965 16.6985 37.2674 17.2657 38.0518 17.2606C42.1992 17.2606 45.561 20.6224 45.561 24.7697C45.561 28.9167 42.1992 32.2785 38.0518 32.2785H30.543C29.7136 32.2785 29.0412 32.9509 29.0412 33.7804C29.0412 34.6098 29.7136 35.2822 30.543 35.2822H38.0522C43.8577 35.2459 48.535 30.5105 48.4991 24.7046C48.4661 19.4176 44.5118 14.9776 39.264 14.3353Z" fill="currentColor"></path><path d="M29.8461 29.1996C30.4226 29.7966 31.3732 29.813 31.9698 29.2366C32.5664 28.6606 32.5828 27.7099 32.0068 27.1133C31.9947 27.1005 31.9823 27.0884 31.9698 27.0763L25.6007 20.7057C25.0151 20.1183 24.064 20.1172 23.4766 20.7028C23.4759 20.7039 23.4748 20.7046 23.4741 20.7057L17.1049 27.0763C16.5084 27.6524 16.4919 28.6031 17.0679 29.1996C17.6444 29.7962 18.595 29.8127 19.1916 29.2366C19.2041 29.2245 19.2165 29.2121 19.2286 29.1996L23.0357 25.391V44.2926C23.0357 45.1221 23.7081 45.7945 24.5376 45.7945C25.3667 45.7945 26.039 45.1221 26.039 44.2926V25.391L29.8461 29.1996Z" fill="currentColor"></path></g><defs><clipPath id="clip0_26272_79717"><rect width="48" height="48" fill="white" transform="translate(0.5)"></rect></clipPath></defs>', 2)
  ]));
}
const Q5 = /* @__PURE__ */ U(K5, [["render", J5]]);
function aa(r) {
  return uv(r) || rv(r) || tv(r) || ev();
}
function ev() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tv(r, t) {
  if (r) {
    if (typeof r == "string")
      return Fa(r, t);
    var e = Object.prototype.toString.call(r).slice(8, -1);
    if (e === "Object" && r.constructor && (e = r.constructor.name), e === "Map" || e === "Set")
      return Array.from(r);
    if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e))
      return Fa(r, t);
  }
}
function rv(r) {
  if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null)
    return Array.from(r);
}
function uv(r) {
  if (Array.isArray(r))
    return Fa(r);
}
function Fa(r, t) {
  (t == null || t > r.length) && (t = r.length);
  for (var e = 0, u = new Array(t); e < t; e++)
    u[e] = r[e];
  return u;
}
function Io(r, t) {
  var e = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(r);
    t && (u = u.filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    })), e.push.apply(e, u);
  }
  return e;
}
function Ut(r) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Io(Object(e), !0).forEach(function(u) {
      nv(r, u, e[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e)) : Io(Object(e)).forEach(function(u) {
      Object.defineProperty(r, u, Object.getOwnPropertyDescriptor(e, u));
    });
  }
  return r;
}
function nv(r, t, e) {
  return t in r ? Object.defineProperty(r, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[t] = e, r;
}
function au(r) {
  "@babel/helpers - typeof";
  return au = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, au(r);
}
function No(r, t) {
  var e = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(r);
    t && (u = u.filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    })), e.push.apply(e, u);
  }
  return e;
}
function Ju(r) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? No(Object(e), !0).forEach(function(u) {
      ov(r, u, e[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e)) : No(Object(e)).forEach(function(u) {
      Object.defineProperty(r, u, Object.getOwnPropertyDescriptor(e, u));
    });
  }
  return r;
}
function av(r, t) {
  if (!(r instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qo(r, t) {
  for (var e = 0; e < t.length; e++) {
    var u = t[e];
    u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(r, u.key, u);
  }
}
function iv(r, t, e) {
  return t && qo(r.prototype, t), e && qo(r, e), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function ov(r, t, e) {
  return t in r ? Object.defineProperty(r, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[t] = e, r;
}
var Dc = function(t) {
  var e = new XMLHttpRequest();
  return e.open(t.method || "GET", t.url), e.responseType = "json", t.headers && Object.keys(t.headers).forEach(function(u) {
    e.setRequestHeader(u, t.headers[u]);
  }), e;
}, sv = function(t, e) {
  return new Promise(function(u, n) {
    t.onload = function() {
      if (t.status >= 200 && t.status < 300) {
        var a;
        try {
          a = JSON.parse(t.response);
        } catch {
          a = t.response;
        }
        u(a);
      } else
        n(t.response);
    }, t.onerror = function() {
      return n(t.response);
    }, t.send(JSON.stringify(e));
  });
}, lv = function(t, e) {
  var u = new FormData();
  for (var n in e)
    u.append(n, e[n]);
  return new Promise(function(a, o) {
    t.onload = function() {
      if (t.status >= 200 && t.status < 300) {
        var s;
        try {
          s = JSON.parse(t.response);
        } catch {
          s = t.response;
        }
        a(s);
      } else
        o(t.response);
    }, t.onerror = function() {
      return o(t.response);
    }, t.send(u);
  });
};
function Po(r) {
  var t = Dc(r);
  return sv(t, r.body);
}
var cv = /* @__PURE__ */ function() {
  function r(t, e) {
    av(this, r), this.file = t, this.options = e, this.chunks = [], this.sessionId = null, this.chunkSize = null, this.speedInterval = null;
  }
  return iv(r, [{
    key: "maxRetries",
    get: function() {
      return parseInt(this.options.maxRetries, 10);
    }
    /**
     * Gets the max number of active chunks being uploaded at once from options
     */
  }, {
    key: "maxActiveChunks",
    get: function() {
      return parseInt(this.options.maxActive, 10);
    }
    /**
     * Gets the file type
     */
  }, {
    key: "fileType",
    get: function() {
      return this.file.type;
    }
    /**
     * Gets the file size
     */
  }, {
    key: "fileSize",
    get: function() {
      return this.file.size;
    }
    /**
     * Gets the file name
     */
  }, {
    key: "fileName",
    get: function() {
      return this.file.name;
    }
    /**
     * Gets action (url) to upload the file
     */
  }, {
    key: "action",
    get: function() {
      return this.options.action || null;
    }
    /**
     * Gets the body to be merged when sending the request in start phase
     */
  }, {
    key: "startBody",
    get: function() {
      return this.options.startBody || {};
    }
    /**
     * Gets the body to be merged when sending the request in upload phase
     */
  }, {
    key: "uploadBody",
    get: function() {
      return this.options.uploadBody || {};
    }
    /**
     * Gets the body to be merged when sending the request in finish phase
     */
  }, {
    key: "finishBody",
    get: function() {
      return this.options.finishBody || {};
    }
    /**
     * Gets the headers of the requests from options
     */
  }, {
    key: "headers",
    get: function() {
      return this.options.headers || {};
    }
    /**
     * Whether it's ready to upload files or not
     */
  }, {
    key: "readyToUpload",
    get: function() {
      return !!this.chunks;
    }
    /**
     * Gets the progress of the chunk upload
     * - Gets all the completed chunks
     * - Gets the progress of all the chunks that are being uploaded
     */
  }, {
    key: "progress",
    get: function() {
      var e = this, u = this.chunksUploaded.length / this.chunks.length * 100, n = this.chunksUploading.reduce(function(a, o) {
        return a + (o.progress | 0) / e.chunks.length;
      }, 0);
      return Math.min(u + n, 100);
    }
    /**
     * Gets all the chunks that are pending to be uploaded
     */
  }, {
    key: "chunksToUpload",
    get: function() {
      return this.chunks.filter(function(e) {
        return !e.active && !e.uploaded;
      });
    }
    /**
     * Whether there are chunks to upload or not
     */
  }, {
    key: "hasChunksToUpload",
    get: function() {
      return this.chunksToUpload.length > 0;
    }
    /**
     * Gets all the chunks that are uploading
     */
  }, {
    key: "chunksUploading",
    get: function() {
      return this.chunks.filter(function(e) {
        return !!e.xhr && !!e.active;
      });
    }
    /**
     * Gets all the chunks that have finished uploading
     */
  }, {
    key: "chunksUploaded",
    get: function() {
      return this.chunks.filter(function(e) {
        return !!e.uploaded;
      });
    }
    /**
     * Creates all the chunks in the initial state
     */
  }, {
    key: "createChunks",
    value: function() {
      this.chunks = [];
      for (var e = 0, u = this.chunkSize; e < this.fileSize; )
        this.chunks.push({
          blob: this.file.file.slice(e, u),
          startOffset: e,
          active: !1,
          retries: this.maxRetries
        }), e = u, u = e + this.chunkSize;
    }
    /**
     * Updates the progress of the file with the handler's progress
     */
  }, {
    key: "updateFileProgress",
    value: function() {
      this.file.progress = this.progress;
    }
    /**
     * Paues the upload process
     * - Stops all active requests
     * - Sets the file not active
     */
  }, {
    key: "pause",
    value: function() {
      this.file.active = !1, this.stopChunks();
    }
    /**
     * Stops all the current chunks
     */
  }, {
    key: "stopChunks",
    value: function() {
      this.chunksUploading.forEach(function(e) {
        e.xhr.abort(), e.active = !1;
      }), this.stopSpeedCalc();
    }
    /**
     * Resumes the file upload
     * - Sets the file active
     * - Starts the following chunks
     */
  }, {
    key: "resume",
    value: function() {
      this.file.active = !0, this.startChunking();
    }
    /**
     * Starts the file upload
     *
     * @returns Promise
     * - resolve  The file was uploaded
     * - reject   The file upload failed
     */
  }, {
    key: "upload",
    value: function() {
      var e = this;
      return this.promise = new Promise(function(u, n) {
        e.resolve = u, e.reject = n;
      }), this.start(), this.promise;
    }
    /**
     * Start phase
     * Sends a request to the backend to initialise the chunks
     */
  }, {
    key: "start",
    value: function() {
      var e = this;
      Po({
        method: "POST",
        headers: Ju(Ju({}, this.headers), {}, {
          "Content-Type": "application/json"
        }),
        url: this.action,
        body: Object.assign(this.startBody, {
          phase: "start",
          mime_type: this.fileType,
          size: this.fileSize,
          name: this.fileName
        })
      }).then(function(u) {
        if (u.status !== "success")
          return e.file.response = u, e.reject("server");
        e.sessionId = u.data.session_id, e.chunkSize = u.data.end_offset, e.createChunks(), e.startChunking();
      }).catch(function(u) {
        e.file.response = u, e.reject("server");
      });
    }
    /**
     * Starts to upload chunks
     */
  }, {
    key: "startChunking",
    value: function() {
      for (var e = 0; e < this.maxActiveChunks; e++)
        this.uploadNextChunk();
      this.startSpeedCalc();
    }
    /**
     * Uploads the next chunk
     * - Won't do anything if the process is paused
     * - Will start finish phase if there are no more chunks to upload
     */
  }, {
    key: "uploadNextChunk",
    value: function() {
      if (this.file.active) {
        if (this.hasChunksToUpload)
          return this.uploadChunk(this.chunksToUpload[0]);
        if (this.chunksUploading.length === 0)
          return this.finish();
      }
    }
    /**
     * Uploads a chunk
     * - Sends the chunk to the backend
     * - Sets the chunk as uploaded if everything went well
     * - Decreases the number of retries if anything went wrong
     * - Fails if there are no more retries
     *
     * @param {Object} chunk
     */
  }, {
    key: "uploadChunk",
    value: function(e) {
      var u = this;
      e.progress = 0, e.active = !0, this.updateFileProgress(), e.xhr = Dc({
        method: "POST",
        headers: this.headers,
        url: this.action
      }), e.xhr.upload.addEventListener("progress", function(n) {
        n.lengthComputable && (e.progress = Math.round(n.loaded / n.total * 100));
      }, !1), lv(e.xhr, Object.assign(this.uploadBody, {
        phase: "upload",
        session_id: this.sessionId,
        start_offset: e.startOffset,
        chunk: e.blob
      })).then(function(n) {
        if (e.active = !1, n.status === "success")
          e.uploaded = !0;
        else if (e.retries-- <= 0)
          return u.stopChunks(), u.reject("upload");
        u.uploadNextChunk();
      }).catch(function() {
        if (e.active = !1, e.retries-- <= 0)
          return u.stopChunks(), u.reject("upload");
        u.uploadNextChunk();
      });
    }
    /**
     * Finish phase
     * Sends a request to the backend to finish the process
     */
  }, {
    key: "finish",
    value: function() {
      var e = this;
      this.updateFileProgress(), this.stopSpeedCalc(), Po({
        method: "POST",
        headers: Ju(Ju({}, this.headers), {}, {
          "Content-Type": "application/json"
        }),
        url: this.action,
        body: Object.assign(this.finishBody, {
          phase: "finish",
          session_id: this.sessionId
        })
      }).then(function(u) {
        if (e.file.response = u, u.status !== "success")
          return e.reject("server");
        e.resolve(u);
      }).catch(function(u) {
        e.file.response = u, e.reject("server");
      });
    }
    /**
     * Sets an interval to calculate and
     * set upload speed every 3 seconds
     */
  }, {
    key: "startSpeedCalc",
    value: function() {
      var e = this;
      this.file.speed = 0;
      var u = 0;
      this.speedInterval || (this.speedInterval = window.setInterval(function() {
        var n = e.progress / 100 * e.fileSize;
        e.file.speed = n - u, u = n;
      }, 1e3));
    }
    /**
     * Removes the upload speed interval
     */
  }, {
    key: "stopSpeedCalc",
    value: function() {
      this.speedInterval && window.clearInterval(this.speedInterval), this.speedInterval = null, this.file.speed = 0;
    }
  }]), r;
}(), Ro = {
  headers: {},
  action: "",
  minSize: 1048576,
  maxActive: 3,
  maxRetries: 5,
  handler: cv
}, Ac = ue({
  props: {
    inputId: {
      type: String
    },
    name: {
      type: String,
      default: "file"
    },
    accept: {
      type: String
    },
    capture: {},
    disabled: {
      default: !1
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    maximum: {
      type: Number
    },
    addIndex: {
      type: [Boolean, Number]
    },
    directory: {
      type: Boolean
    },
    createDirectory: {
      type: Boolean,
      default: !1
    },
    postAction: {
      type: String
    },
    putAction: {
      type: String
    },
    customAction: {
      type: Function
    },
    headers: {
      type: Object,
      default: function() {
        return {};
      }
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    },
    timeout: {
      type: Number,
      default: 0
    },
    drop: {
      type: [Boolean, String, HTMLElement],
      default: function() {
        return !1;
      }
    },
    dropDirectory: {
      type: Boolean,
      default: !0
    },
    size: {
      type: Number,
      default: 0
    },
    extensions: {
      type: [RegExp, String, Array],
      default: function() {
        return [];
      }
    },
    modelValue: {
      type: Array,
      default: function() {
        return [];
      }
    },
    thread: {
      type: Number,
      default: 1
    },
    // Chunk upload enabled
    chunkEnabled: {
      type: Boolean,
      default: !1
    },
    // Chunk upload properties
    chunk: {
      type: Object,
      default: function() {
        return Ro;
      }
    }
  },
  emits: ["update:modelValue", "input-filter", "input-file"],
  data: function() {
    return {
      files: this.modelValue,
      features: {
        html5: !0,
        directory: !1,
        drop: !1
      },
      active: !1,
      dropActive: !1,
      uploading: 0,
      destroy: !1,
      maps: {},
      dropElement: null,
      dropTimeout: null,
      reload: !1
    };
  },
  /**
   * mounted
   * @return {[type]} [description]
   */
  mounted: function() {
    var t = this, e = document.createElement("input");
    if (e.type = "file", e.multiple = !0, window.FormData && e.files ? ((typeof e.webkitdirectory == "boolean" || typeof e.directory == "boolean") && (this.features.directory = !0), this.features.html5 && typeof e.ondrop < "u" && (this.features.drop = !0)) : this.features.html5 = !1, this.maps = {}, this.files)
      for (var u = 0; u < this.files.length; u++) {
        var n = this.files[u];
        this.maps[n.id] = n;
      }
    this.$nextTick(function() {
      t.$parent ? (t.$parent.$forceUpdate(), t.$parent.$nextTick(function() {
        t.watchDrop(t.drop);
      })) : t.watchDrop(t.drop);
    });
  },
  /**
   * beforeUnmount
   * @return {[type]} [description]
   */
  beforeUnmount: function() {
    this.destroy = !0, this.active = !1, this.watchDrop(!1), this.watchActive(!1);
  },
  computed: {
    /**
     * uploading 正在上传的线程
     * @return {[type]} [description]
     */
    /**
     * uploaded 文件列表是否全部已上传
     * @return {[type]} [description]
     */
    uploaded: function() {
      for (var t, e = 0; e < this.files.length; e++)
        if (t = this.files[e], t.fileObject && !t.error && !t.success)
          return !1;
      return !0;
    },
    chunkOptions: function() {
      return Object.assign(Ro, this.chunk);
    },
    className: function() {
      return ["file-uploads", this.features.html5 ? "file-uploads-html5" : "file-uploads-html4", this.features.directory && this.directory ? "file-uploads-directory" : void 0, this.features.drop && this.drop ? "file-uploads-drop" : void 0, this.disabled ? "file-uploads-disabled" : void 0];
    },
    forId: function() {
      return this.inputId || this.name;
    },
    iMaximum: function() {
      return this.maximum === void 0 ? this.multiple ? 0 : 1 : this.maximum;
    },
    iExtensions: function() {
      if (this.extensions) {
        if (this.extensions instanceof RegExp)
          return this.extensions;
        if (this.extensions.length) {
          var t = [];
          return typeof this.extensions == "string" ? t = this.extensions.split(",") : t = this.extensions, t = t.map(function(e) {
            return e.trim();
          }).filter(function(e) {
            return e;
          }), new RegExp("\\.(" + t.join("|").replace(/\./g, "\\.") + ")$", "i");
        }
      }
    },
    iDirectory: function() {
      if (this.directory && this.features.directory)
        return !0;
    }
  },
  watch: {
    active: function(t) {
      this.watchActive(t);
    },
    dropActive: function(t) {
      this.watchDropActive(t), this.$parent && this.$parent.$forceUpdate();
    },
    drop: function(t) {
      this.watchDrop(t);
    },
    modelValue: function(t) {
      if (this.files !== t) {
        this.files = t;
        var e = this.maps;
        this.maps = {};
        for (var u = 0; u < this.files.length; u++) {
          var n = this.files[u];
          this.maps[n.id] = n;
        }
        for (var a in this.maps) {
          var o = this.maps[a], s = e[a];
          o !== s && this.emitFile(o, s);
        }
        for (var i in e)
          this.maps[i] || this.emitFile(void 0, e[i]);
      }
    }
  },
  methods: {
    newId: function() {
      return Math.random().toString(36).substr(2);
    },
    // 清空
    clear: function() {
      if (this.files.length) {
        var t = this.files;
        this.files = [], this.maps = {}, this.emitInput();
        for (var e = 0; e < t.length; e++)
          this.emitFile(void 0, t[e]);
      }
      return !0;
    },
    // 选择
    get: function(t) {
      return t ? au(t) === "object" ? this.maps[t.id || ""] || !1 : this.maps[t] || !1 : !1;
    },
    // 添加
    add: function(t, e) {
      var u;
      t instanceof Array ? u = t : u = [t], e === void 0 && (e = this.addIndex);
      for (var n = [], a = 0; a < u.length; a++) {
        var o = u[a];
        this.features.html5 && o instanceof Blob && (o = {
          id: "",
          file: o,
          size: o.size,
          // @ts-ignore
          name: o.webkitRelativePath || o.relativePath || o.name || "unknown",
          type: o.type
        }), o = o;
        var s = !1;
        if (o.fileObject === !1 || (o.fileObject || typeof Element < "u" && o.el instanceof HTMLInputElement || typeof Blob < "u" && o.file instanceof Blob) && (s = !0), s && (o = Ut(Ut({
          fileObject: !0,
          size: -1,
          name: "Filename",
          type: "",
          active: !1,
          error: "",
          success: !1,
          putAction: this.putAction,
          postAction: this.postAction,
          timeout: this.timeout
        }, o), {}, {
          response: {},
          progress: "0.00",
          speed: 0
          // 只读
          // file: undefined,
          // xhr: undefined,
          // el: undefined,
          // iframe: undefined,
        }), o.data = Ut(Ut({}, this.data), o.data ? o.data : {}), o.headers = Ut(Ut({}, this.headers), o.headers ? o.headers : {})), o.id || (o.id = this.newId()), !this.emitFilter(o, void 0) && (this.iMaximum > 1 && n.length + this.files.length >= this.iMaximum || (n.push(o), this.iMaximum === 1)))
          break;
      }
      if (n.length) {
        this.iMaximum === 1 && this.clear();
        var i;
        if (e === !0 || e === 0)
          i = n.concat(this.files);
        else if (e) {
          var l;
          i = this.files.concat([]), (l = i).splice.apply(l, [e, 0].concat(aa(n)));
        } else
          i = this.files.concat(n);
        this.files = i;
        var d = 0;
        e === !0 || e === 0 ? d = 0 : e ? e >= 0 ? e + n.length > this.files.length ? d = this.files.length - n.length : d = e : (d = this.files.length - n.length + e, d < 0 && (d = 0)) : d = this.files.length - n.length, n = this.files.slice(d, d + n.length);
        for (var h = 0; h < n.length; h++) {
          var c = n[h];
          this.maps[c.id] = c;
        }
        this.emitInput();
        for (var f = 0; f < n.length; f++)
          this.emitFile(n[f], void 0);
        return t instanceof Array ? n : n[0];
      }
    },
    // 添加表单文件
    addInputFile: function(t) {
      var e = this, u = [];
      this.iMaximum;
      var n = t.webkitEntries || t.entries || void 0;
      if (n != null && n.length)
        return this.getFileSystemEntry(n).then(function(i) {
          return e.add(i);
        });
      if (t.files)
        for (var a = 0; a < t.files.length; a++) {
          var o = t.files[a];
          u.push({
            id: "",
            size: o.size,
            // @ts-ignore
            name: o.webkitRelativePath || o.relativePath || o.name,
            type: o.type,
            file: o
          });
        }
      else {
        var s = t.value.replace(/\\/g, "/").split("/");
        (!s || !s.length) && (s = [t.value]), delete t.__vuex__, u.push({
          id: "",
          name: s[s.length - 1],
          el: t
        });
      }
      return Promise.resolve(this.add(u));
    },
    // 添加 DataTransfer
    addDataTransfer: function(t) {
      var e, u = this;
      if (t != null && (e = t.items) !== null && e !== void 0 && e.length) {
        for (var n = [], a = 0; a < t.items.length; a++) {
          var o = t.items[a], s = void 0;
          o.getAsEntry ? s = o.getAsEntry() || o.getAsFile() : o.webkitGetAsEntry ? s = o.webkitGetAsEntry() || o.getAsFile() : s = o.getAsFile(), s && n.push(s);
        }
        return this.getFileSystemEntry(n).then(function(h) {
          return u.add(h);
        });
      }
      var i = this.iMaximum, l = [];
      if (t.files.length) {
        for (var d = 0; d < t.files.length && (l.push(t.files[d]), !(i > 0 && l.length >= i)); d++)
          ;
        return Promise.resolve(this.add(l));
      }
      return Promise.resolve([]);
    },
    // 获得 entrys    
    getFileSystemEntry: function(t) {
      var e = this, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      return new Promise(function(n) {
        var a = e.iMaximum;
        if (!t) {
          n([]);
          return;
        }
        if (t instanceof Array) {
          var o = [], s = function f(g) {
            var D = t[g];
            if (!D || a > 0 && o.length >= a)
              return n(o);
            e.getFileSystemEntry(D, u).then(function(_) {
              o.push.apply(o, aa(_)), f(g + 1);
            });
          };
          s(0);
          return;
        }
        if (t instanceof Blob) {
          n([{
            id: "",
            size: t.size,
            // @ts-ignore
            name: u + t.name,
            type: t.type,
            file: t
          }]);
          return;
        }
        if (t.isFile) {
          var i = t;
          i.file(function(f) {
            n([{
              id: "",
              size: f.size,
              name: u + f.name,
              type: f.type,
              file: f
            }]);
          });
          return;
        }
        if (t.isDirectory && e.dropDirectory) {
          var l = t, d = [];
          e.createDirectory && d.push({
            id: "",
            name: u + l.name,
            size: 0,
            type: "text/directory",
            file: new File([], u + l.name, {
              type: "text/directory"
            })
          });
          var h = l.createReader(), c = function f() {
            h.readEntries(function(g) {
              var D = function _(O) {
                if (!g[O] && O === 0 || a > 0 && d.length >= a)
                  return n(d);
                if (!g[O])
                  return f();
                e.getFileSystemEntry(g[O], u + l.name + "/").then(function(M) {
                  d.push.apply(d, aa(M)), _(O + 1);
                });
              };
              D(0);
            });
          };
          c();
          return;
        }
        n([]);
      });
    },
    // 替换
    replace: function(t, e) {
      var u = this.get(t), n = this.get(e);
      if (!u || !n || u === n)
        return !1;
      var a = this.files.concat([]), o = a.indexOf(u), s = a.indexOf(n);
      return o === -1 || s === -1 ? !1 : (a[o] = n, a[s] = u, this.files = a, this.emitInput(), !0);
    },
    // 移除
    remove: function(t) {
      var e = this.get(t);
      if (e) {
        if (this.emitFilter(void 0, e))
          return !1;
        var u = this.files.concat([]), n = u.indexOf(e);
        if (n === -1)
          return console.error("remove", e), !1;
        u.splice(n, 1), this.files = u, delete this.maps[e.id], this.emitInput(), this.emitFile(void 0, e);
      }
      return e;
    },
    // 更新
    update: function(t, e) {
      var u = this.get(t);
      if (u) {
        var n = Ut(Ut({}, u), e);
        if (u.fileObject && u.active && !n.active && !n.error && !n.success && (n.error = "abort"), this.emitFilter(n, u))
          return !1;
        var a = this.files.concat([]), o = a.indexOf(u);
        return o === -1 ? (console.error("update", u), !1) : (a.splice(o, 1, n), this.files = a, n = this.files[o], delete this.maps[u.id], this.maps[n.id] = n, this.emitInput(), this.emitFile(n, u), n);
      }
      return !1;
    },
    // 预处理 事件 过滤器
    emitFilter: function(t, e) {
      var u = !1;
      return this.$emit("input-filter", t, e, function() {
        var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
        return u = n, u;
      }), u;
    },
    // 处理后 事件 分发
    emitFile: function(t, e) {
      var u, n = this;
      this.$emit("input-file", t, e), (u = t) !== null && u !== void 0 && u.fileObject && t.active && (!e || !e.active) ? (this.uploading++, this.$nextTick(function() {
        setTimeout(function() {
          t && n.upload(t).then(function() {
            var a;
            t && (t = n.get(t) || void 0), (a = t) !== null && a !== void 0 && a.fileObject && n.update(t, {
              active: !1,
              success: !t.error
            });
          }).catch(function(a) {
            t && n.update(t, {
              active: !1,
              success: !1,
              error: a.code || a.error || a.message || a
            });
          });
        }, Math.ceil(Math.random() * 50 + 50));
      })) : (!t || !t.fileObject || !t.active) && e && e.fileObject && e.active && this.uploading--, this.active && (!!t != !!e || t.active !== e.active) && this.watchActive(!0);
    },
    emitInput: function() {
      this.$emit("update:modelValue", this.files);
    },
    // 上传
    upload: function(t) {
      var e = this.get(t);
      if (!e)
        return Promise.reject(new Error("not_exists"));
      if (!e.fileObject)
        return Promise.reject(new Error("file_object"));
      if (e.error)
        return e.error instanceof Error ? Promise.reject(e.error) : Promise.reject(new Error(e.error));
      if (e.success)
        return Promise.resolve(e);
      if (e.name && this.iExtensions && e.type !== "text/directory" && e.name.search(this.iExtensions) === -1)
        return Promise.reject(new Error("extension"));
      if (this.size > 0 && e.size !== void 0 && e.size >= 0 && e.size > this.size && e.type !== "text/directory")
        return Promise.reject(new Error("size"));
      if (this.customAction)
        return this.customAction(e, this);
      if (this.features.html5) {
        if (this.shouldUseChunkUpload(e))
          return this.uploadChunk(e);
        if (e.putAction)
          return this.uploadPut(e);
        if (e.postAction)
          return this.uploadHtml5(e);
      }
      return e.postAction ? this.uploadHtml4(e) : Promise.reject(new Error("No action configured"));
    },
    /**
     * Whether this file should be uploaded using chunk upload or not
     *
     * @param Object file
     */
    shouldUseChunkUpload: function(t) {
      return this.chunkEnabled && !!this.chunkOptions.handler && t.size && t.size > this.chunkOptions.minSize;
    },
    /**
     * Upload a file using Chunk method
     *
     * @param File file
     */
    uploadChunk: function(t) {
      var e = this.chunkOptions.handler;
      return t.chunk = new e(t, this.chunkOptions), t.chunk.upload().then(function(u) {
        return t;
      });
    },
    uploadPut: function(t) {
      var e = [], u;
      for (var n in t.data)
        u = t.data[n], u != null && e.push(encodeURIComponent(n) + "=" + encodeURIComponent(u));
      var a = t.putAction || "", o = e.length ? (a.indexOf("?") === -1 ? "?" : "&") + e.join("&") : "", s = new XMLHttpRequest();
      return s.open("PUT", a + o), this.uploadXhr(s, t, t.file);
    },
    uploadHtml5: function(t) {
      var e = new window.FormData(), u;
      for (var n in t.data)
        u = t.data[n], u && au(u) === "object" && typeof u.toString != "function" ? u instanceof File ? e.append(n, u, u.name) : e.append(n, JSON.stringify(u)) : u != null && e.append(n, u);
      e.append(this.name, t.file, t.name || t.file.name || t.file.filename);
      var a = new XMLHttpRequest();
      return a.open("POST", t.postAction || ""), this.uploadXhr(a, t, e);
    },
    uploadXhr: function(t, e, u) {
      var n = this, a = e, o = 0, s = 0;
      t.upload.onprogress = function(l) {
        if (a && (a = n.get(a), !(!l.lengthComputable || !a || !a.fileObject || !a.active))) {
          var d = Math.round(Date.now() / 1e3);
          d !== o && (o = d, a = n.update(a, {
            progress: (l.loaded / l.total * 100).toFixed(2),
            speed: l.loaded - s
          }), s = l.loaded);
        }
      };
      var i = window.setInterval(function() {
        if (a && (a = n.get(a))) {
          var l;
          if ((l = a) !== null && l !== void 0 && l.fileObject && !a.success && !a.error && a.active)
            return;
        }
        i && (clearInterval(i), i = void 0);
        try {
          t.abort(), t.timeout = 1;
        } catch {
        }
      }, 100);
      return new Promise(function(l, d) {
        if (!a) {
          d(new Error("not_exists"));
          return;
        }
        var h, c = function(D) {
          if (!h) {
            if (h = !0, i && (clearInterval(i), i = void 0), !a)
              return d(new Error("not_exists"));
            if (a = n.get(a), !a)
              return d(new Error("not_exists"));
            if (!a.fileObject)
              return d(new Error("file_object"));
            if (a.error)
              return a.error instanceof Error ? d(a.error) : d(new Error(a.error));
            if (!a.active)
              return d(new Error("abort"));
            if (a.success)
              return l(a);
            var _ = {};
            switch (D.type) {
              case "timeout":
              case "abort":
                _.error = D.type;
                break;
              case "error":
                t.status ? t.status >= 500 ? _.error = "server" : t.status >= 400 && (_.error = "denied") : _.error = "network";
                break;
              default:
                t.status >= 500 ? _.error = "server" : t.status >= 400 ? _.error = "denied" : _.progress = "100.00";
            }
            if (t.responseText) {
              var O = t.getResponseHeader("Content-Type");
              O && O.indexOf("/json") !== -1 ? _.response = JSON.parse(t.responseText) : _.response = t.responseText;
            }
            return a = n.update(a, _), a ? a.error ? a.error instanceof Error ? d(a.error) : d(new Error(a.error)) : l(a) : d(new Error("abort"));
          }
        };
        t.onload = c, t.onerror = c, t.onabort = c, t.ontimeout = c, a.timeout && (t.timeout = a.timeout);
        for (var f in a.headers)
          t.setRequestHeader(f, a.headers[f]);
        a = n.update(a, {
          xhr: t
        }), a && t.send(u);
      });
    },
    uploadHtml4: function(t) {
      var e = this, u = t;
      if (!u)
        return Promise.reject(new Error("not_exists"));
      var n = function(c) {
        c.keyCode === 27 && c.preventDefault();
      }, a = document.createElement("iframe");
      a.id = "upload-iframe-" + u.id, a.name = "upload-iframe-" + u.id, a.src = "about:blank", a.setAttribute("style", "width:1px;height:1px;top:-999em;position:absolute; margin-top:-999em;");
      var o = document.createElement("form");
      o.setAttribute("action", u.postAction || ""), o.name = "upload-form-" + u.id, o.setAttribute("method", "POST"), o.setAttribute("target", "upload-iframe-" + u.id), o.setAttribute("enctype", "multipart/form-data");
      for (var s in u.data) {
        var i = u.data[s];
        if (i && au(i) === "object" && typeof i.toString != "function" && (i = JSON.stringify(i)), i != null) {
          var l = document.createElement("input");
          l.type = "hidden", l.name = s, l.value = i, o.appendChild(l);
        }
      }
      o.appendChild(u.el), document.body.appendChild(a).appendChild(o);
      var d = function() {
        var c, f;
        try {
          a.contentWindow && (f = a.contentWindow.document);
        } catch {
        }
        if (!f)
          try {
            f = a.contentDocument ? a.contentDocument : a.document;
          } catch {
            f = a.document;
          }
        return (c = f) !== null && c !== void 0 && c.body ? f.body.innerHTML : null;
      };
      return new Promise(function(h, c) {
        setTimeout(function() {
          if (!u) {
            c(new Error("not_exists"));
            return;
          }
          if (u = e.update(u, {
            iframe: a
          }), !u)
            return c(new Error("not_exists"));
          var f = window.setInterval(function() {
            u && (u = e.get(u)) && u.fileObject && !u.success && !u.error && u.active || (f && (clearInterval(f), f = void 0), a.onabort({
              type: u ? "abort" : "not_exists"
            }));
          }, 100), g, D = function(O) {
            var M;
            if (!g) {
              if (g = !0, f && (clearInterval(f), f = void 0), document.body.removeEventListener("keydown", n), !u)
                return c(new Error("not_exists"));
              if (u = e.get(u), !u)
                return c(new Error("not_exists"));
              if (!u.fileObject)
                return c(new Error("file_object"));
              if (u.error)
                return u.error instanceof Error ? c(u.error) : c(new Error(u.error));
              if (!u.active)
                return c(new Error("abort"));
              if (u.success)
                return h(u);
              var L = d(), q = {};
              if (typeof O == "string")
                return c(new Error(O));
              switch (O.type) {
                case "abort":
                  q.error = "abort";
                  break;
                case "error":
                  u.error ? q.error = u.error : L === null ? q.error = "network" : q.error = "denied";
                  break;
                default:
                  u.error ? q.error = u.error : L === null ? q.error = "network" : q.progress = "100.00";
              }
              if (L !== null) {
                if (L && L.substr(0, 1) === "{" && L.substr(L.length - 1, 1) === "}")
                  try {
                    L = JSON.parse(L);
                  } catch {
                  }
                q.response = L;
              }
              return u = e.update(u, q), u ? (M = u) !== null && M !== void 0 && M.error ? u.error instanceof Error ? c(u.error) : c(new Error(u.error)) : h(u) : c(new Error("not_exists"));
            }
          };
          a.onload = D, a.onerror = D, a.onabort = D, document.body.addEventListener("keydown", n), o.submit();
        }, 50);
      }).then(function(h) {
        var c;
        return a == null || (c = a.parentNode) === null || c === void 0 || c.removeChild(a), h;
      }).catch(function(h) {
        var c;
        return a == null || (c = a.parentNode) === null || c === void 0 || c.removeChild(a), h;
      });
    },
    watchActive: function(t) {
      for (var e, u = 0; e = this.files[u]; )
        if (u++, e.fileObject)
          if (t && !this.destroy) {
            if (this.uploading >= this.thread || this.uploading && !this.features.html5)
              break;
            !e.active && !e.error && !e.success && this.update(e, {
              active: !0
            });
          } else
            e.active && this.update(e, {
              active: !1
            });
      this.uploading === 0 && (this.active = !1);
    },
    watchDrop: function(t) {
      var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
      if (this.features.drop && t !== e) {
        if (this.dropElement)
          try {
            document.removeEventListener("dragenter", this.onDocumentDragenter, !1), document.removeEventListener("dragleave", this.onDocumentDragleave, !1), document.removeEventListener("dragover", this.onDocumentDragover, !1), document.removeEventListener("drop", this.onDocumentDrop, !1), this.dropElement.removeEventListener("dragover", this.onDragover, !1), this.dropElement.removeEventListener("drop", this.onDrop, !1);
          } catch {
          }
        var u = null;
        if (t)
          if (typeof t == "string")
            u = document.querySelector(t) || this.$root.$el.querySelector(t);
          else if (t === !0) {
            var n;
            if (u = this.$parent.$el, !u || ((n = u) === null || n === void 0 ? void 0 : n.nodeType) === 8) {
              var a;
              u = this.$root.$el, (!u || ((a = u) === null || a === void 0 ? void 0 : a.nodeType) === 8) && (u = document.body);
            }
          } else
            u = t;
        this.dropElement = u, this.dropElement && (document.addEventListener("dragenter", this.onDocumentDragenter, !1), document.addEventListener("dragleave", this.onDocumentDragleave, !1), document.addEventListener("dragover", this.onDocumentDragover, !1), document.addEventListener("drop", this.onDocumentDrop, !1), this.dropElement.addEventListener("dragover", this.onDragover, !1), this.dropElement.addEventListener("drop", this.onDrop, !1));
      }
    },
    watchDropActive: function(t, e) {
      t !== e && (this.dropTimeout && (clearTimeout(this.dropTimeout), this.dropTimeout = null), t && (this.dropTimeout = setTimeout(this.onDocumentDrop, 1e3)));
    },
    onDocumentDragenter: function(t) {
      var e, u;
      if (!this.dropActive && t.dataTransfer) {
        var n = t.dataTransfer;
        n != null && (e = n.files) !== null && e !== void 0 && e.length ? this.dropActive = !0 : n.types ? n.types.indexOf && n.types.indexOf("Files") !== -1 ? this.dropActive = !0 : (u = n.types) !== null && u !== void 0 && u.contains && n.types.contains("Files") && (this.dropActive = !0) : this.dropActive = !0, this.dropActive && this.watchDropActive(!0);
      }
    },
    onDocumentDragleave: function(t) {
      this.dropActive && (t.target === t.explicitOriginalTarget || !t.fromElement && (t.clientX <= 0 || t.clientY <= 0 || t.clientX >= window.innerWidth || t.clientY >= window.innerHeight)) && (this.dropActive = !1, this.watchDropActive(!1));
    },
    onDocumentDragover: function() {
      this.watchDropActive(!0);
    },
    onDocumentDrop: function() {
      this.dropActive = !1, this.watchDropActive(!1);
    },
    onDragover: function(t) {
      t.preventDefault();
    },
    onDrop: function(t) {
      t.preventDefault(), t.dataTransfer && this.addDataTransfer(t.dataTransfer);
    },
    inputOnChange: async function(t) {
      var e = this;
      if (!(t.target instanceof HTMLInputElement))
        return Promise.reject(new Error("not HTMLInputElement"));
      t.target;
      var u = function(a) {
        return e.reload = !0, e.$nextTick(function() {
          e.reload = !1;
        }), a;
      };
      return this.addInputFile(t.target).then(u).catch(u);
    }
  }
}), dv = ["for"], fv = ["name", "id", "accept", "capture", "disabled", "webkitdirectory", "allowdirs", "directory", "multiple"];
function pv(r, t, e, u, n, a) {
  return m(), x("span", {
    class: b(r.className)
  }, [K(r.$slots, "default"), C("label", {
    for: r.forId
  }, null, 8, dv), r.reload ? R("", !0) : (m(), x("input", {
    key: 0,
    ref: "input",
    type: "file",
    name: r.name,
    id: r.forId,
    accept: r.accept,
    capture: r.capture,
    disabled: r.disabled,
    webkitdirectory: r.iDirectory,
    allowdirs: r.iDirectory,
    directory: r.iDirectory,
    multiple: r.multiple && r.features.html5,
    onChange: t[0] || (t[0] = function() {
      return r.inputOnChange && r.inputOnChange.apply(r, arguments);
    })
  }, null, 40, fv))], 2);
}
function hv(r, t) {
  t === void 0 && (t = {});
  var e = t.insertAt;
  if (!(!r || typeof document > "u")) {
    var u = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
    n.type = "text/css", e === "top" && u.firstChild ? u.insertBefore(n, u.firstChild) : u.appendChild(n), n.styleSheet ? n.styleSheet.cssText = r : n.appendChild(document.createTextNode(r));
  }
}
var mv = `
.file-uploads {
  overflow: hidden;
  position: relative;
  text-align: center;
  display: inline-block;
}
.file-uploads.file-uploads-html4 input,
.file-uploads.file-uploads-html5 label {
  /* background fix ie  click */
  background: #fff;
  opacity: 0;
  font-size: 20em;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  width: 100%;
  height: 100%;
}
.file-uploads.file-uploads-html5 input,
.file-uploads.file-uploads-html4 label {
  /* background fix ie  click */
  position: absolute;
  background: rgba(255, 255, 255, 0);
  overflow: hidden;
  position: fixed;
  width: 1px;
  height: 1px;
  z-index: -1;
  opacity: 0;
}
`;
hv(mv);
Ac.render = pv;
const vv = /* @__PURE__ */ ue({
  __name: "VFileUploader",
  props: /* @__PURE__ */ T0({
    accept: {},
    error: {},
    multiple: { type: Boolean, default: !0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(r) {
    const t = B0(r, "modelValue"), e = Q(null), u = async (s) => {
      const i = s.file, l = await i.arrayBuffer(), d = new File([l], i.name, {
        type: i.type,
        lastModified: i.lastModified
      });
      return {
        ...s,
        file: d
      };
    }, n = () => {
      var i, l;
      const s = (l = (i = e.value) == null ? void 0 : i.$el) == null ? void 0 : l.querySelector('input[type="file"]');
      s && s.click();
    }, a = async (s) => {
      Promise.all(s.map(u)).then((i) => {
        t.value = i;
      });
    }, o = be();
    return (s, i) => {
      var l;
      return m(), x("div", {
        class: b(p(o)["v-file-uploader"])
      }, [
        C("div", {
          class: b([
            p(o)["v-file-uploader__body"],
            {
              [p(o)["v-file-uploader__body--error"]]: !!s.error
            }
          ]),
          onClick: n
        }, [
          C("div", {
            class: b(p(o)["v-file-uploader__wrapper"])
          }, [
            j(Q5, {
              class: b(p(o)["v-file-uploader__upload-icon"])
            }, null, 8, ["class"]),
            C("div", {
              class: b(p(o)["v-file-uploader__content"])
            }, i[0] || (i[0] = [
              C("p", null, [
                C("b", null, "Drag and drop"),
                ce(" or "),
                C("span", null, "browse"),
                ce(" to upload file(s) ")
              ], -1),
              C("p", null, "Maximum upload size per post: 100MB", -1)
            ]), 2)
          ], 2),
          Xe(C("div", {
            class: b(p(o)["v-file-uploader_overlay"])
          }, " Drop files to upload ", 2), [
            [iu, (l = e.value) == null ? void 0 : l.dropActive]
          ]),
          Xe(j(p(Ac), {
            ref_key: "upload",
            ref: e,
            "model-value": t.value,
            accept: s.accept,
            multiple: s.multiple,
            drop: "",
            "drop-directory": "",
            "onUpdate:modelValue": a
          }, {
            default: J(() => i[1] || (i[1] = [
              ce(" Select files ", -1)
            ])),
            _: 1,
            __: [1]
          }, 8, ["model-value", "accept", "multiple"]), [
            [iu, !1]
          ])
        ], 2),
        s.error ? (m(), H(p(ac), {
          key: 0,
          error: s.error
        }, null, 8, ["error"])) : R("", !0)
      ], 2);
    };
  }
}), gv = {
  "v-file-uploader__body": "_v-file-uploader__body_zbdnd_1",
  "v-file-uploader__body--error": "_v-file-uploader__body--error_zbdnd_13",
  "v-file-uploader__upload-icon": "_v-file-uploader__upload-icon_zbdnd_16",
  "v-file-uploader__wrapper": "_v-file-uploader__wrapper_zbdnd_24",
  "v-file-uploader__content": "_v-file-uploader__content_zbdnd_36",
  "v-file-uploader_overlay": "_v-file-uploader_overlay_zbdnd_57"
}, bv = {
  $style: gv
}, nE = /* @__PURE__ */ U(vv, [["__cssModules", bv]]), yv = {}, _v = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "16",
  width: "16",
  viewBox: "0 0 16 16"
};
function wv(r, t) {
  return m(), x("svg", _v, t[0] || (t[0] = [
    sr('<g fill="currentColor"><line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" x1="4.5" y1="11.5" x2="11.5" y2="11.5" data-color="color-2"></line> <line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" x1="4.5" y1="8.5" x2="11.5" y2="8.5" data-color="color-2"></line> <line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" x1="4.5" y1="5.5" x2="6.5" y2="5.5" data-color="color-2"></line> <polygon fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" points="9.5,0.5 1.5,0.5 1.5,15.5 14.5,15.5 14.5,5.5 "></polygon> <polyline fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" points="9.5,0.5 9.5,5.5 14.5,5.5 "></polyline></g>', 1)
  ]));
}
const Cv = /* @__PURE__ */ U(yv, [["render", wv]]), Dv = {}, Av = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
};
function xv(r, t) {
  return m(), x("svg", Av, t[0] || (t[0] = [
    C("path", {
      d: "M13.1 3H6.8C6.32261 3 5.86477 3.18964 5.52721 3.52721C5.18964 3.86477 5 4.32261 5 4.8V19.2C5 19.6774 5.18964 20.1352 5.52721 20.4728C5.86477 20.8104 6.32261 21 6.8 21H17.6C18.0774 21 18.5352 20.8104 18.8728 20.4728C19.2104 20.1352 19.4 19.6774 19.4 19.2V9.3M13.1 3L19.4 9.3M13.1 3V9.3H19.4",
      stroke: "#28936B",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("rect", {
      y: "11",
      width: "14",
      height: "7",
      rx: "1",
      fill: "#28936B"
    }, null, -1),
    C("path", {
      d: "M5.18071 14.0906H4.51665C4.49771 13.9817 4.46279 13.8852 4.41189 13.8011C4.36099 13.7159 4.29766 13.6437 4.2219 13.5845C4.14614 13.5253 4.05973 13.4809 3.96267 13.4513C3.86679 13.4206 3.76321 13.4052 3.65194 13.4052C3.45426 13.4052 3.27907 13.4549 3.12638 13.5543C2.97368 13.6526 2.85412 13.797 2.76771 13.9876C2.6813 14.177 2.63809 14.4084 2.63809 14.6818C2.63809 14.96 2.6813 15.1944 2.76771 15.3849C2.85531 15.5743 2.97486 15.7176 3.12638 15.8146C3.27907 15.9105 3.45367 15.9585 3.65017 15.9585C3.75907 15.9585 3.86087 15.9442 3.95557 15.9158C4.05145 15.8862 4.13727 15.843 4.21302 15.7862C4.28997 15.7294 4.35448 15.6596 4.40656 15.5767C4.45983 15.4938 4.49652 15.3991 4.51665 15.2926L5.18071 15.2962C5.15585 15.469 5.10199 15.6312 5.01913 15.7827C4.93746 15.9342 4.83033 16.0679 4.69775 16.1839C4.56518 16.2988 4.41011 16.3887 4.23256 16.4538C4.055 16.5178 3.85791 16.5497 3.64129 16.5497C3.32169 16.5497 3.03641 16.4757 2.78547 16.3278C2.53452 16.1798 2.33684 15.9661 2.19243 15.6868C2.04801 15.4074 1.97581 15.0724 1.97581 14.6818C1.97581 14.29 2.04861 13.955 2.1942 13.6768C2.3398 13.3975 2.53807 13.1838 2.78902 13.0359C3.03997 12.8879 3.32406 12.8139 3.64129 12.8139C3.84371 12.8139 4.03192 12.8423 4.20592 12.8991C4.37993 12.956 4.53499 13.0394 4.67112 13.1495C4.80725 13.2584 4.91911 13.3922 5.0067 13.5508C5.09548 13.7082 5.15348 13.8881 5.18071 14.0906ZM7.76017 13.8633C7.74359 13.7082 7.67375 13.5875 7.55065 13.5011C7.42873 13.4147 7.27011 13.3714 7.0748 13.3714C6.93749 13.3714 6.81971 13.3922 6.72146 13.4336C6.62321 13.475 6.54804 13.5312 6.49596 13.6023C6.44388 13.6733 6.41724 13.7544 6.41606 13.8455C6.41606 13.9213 6.43322 13.987 6.46755 14.0426C6.50306 14.0982 6.551 14.1456 6.61137 14.1847C6.67174 14.2225 6.73862 14.2545 6.81201 14.2805C6.8854 14.3066 6.95938 14.3285 7.03396 14.3462L7.37487 14.4315C7.51218 14.4634 7.64416 14.5066 7.77082 14.5611C7.89866 14.6155 8.01289 14.6842 8.1135 14.767C8.2153 14.8499 8.29579 14.9499 8.35498 15.0671C8.41417 15.1843 8.44376 15.3216 8.44376 15.479C8.44376 15.6921 8.38931 15.8797 8.28041 16.0419C8.17151 16.2029 8.01407 16.329 7.80811 16.4201C7.60332 16.5101 7.35534 16.555 7.06414 16.555C6.78124 16.555 6.53561 16.5112 6.32728 16.4237C6.12013 16.3361 5.95796 16.2082 5.84078 16.0401C5.72477 15.872 5.66204 15.6673 5.65257 15.4258H6.30065C6.31012 15.5524 6.34918 15.6578 6.41784 15.7418C6.48649 15.8259 6.57586 15.8886 6.68595 15.93C6.79722 15.9715 6.92151 15.9922 7.05882 15.9922C7.20204 15.9922 7.32752 15.9709 7.43524 15.9283C7.54414 15.8845 7.62936 15.8241 7.69092 15.7472C7.75247 15.669 7.78384 15.5779 7.78502 15.4737C7.78384 15.379 7.75602 15.3009 7.70157 15.2393C7.64712 15.1766 7.57077 15.1245 7.47252 15.0831C7.37546 15.0405 7.26182 15.0026 7.13161 14.9695L6.71791 14.8629C6.41843 14.786 6.18169 14.6694 6.00768 14.5131C5.83486 14.3557 5.74845 14.1468 5.74845 13.8864C5.74845 13.6721 5.80645 13.4845 5.92245 13.3235C6.03964 13.1625 6.19885 13.0376 6.40008 12.9489C6.60131 12.8589 6.82918 12.8139 7.08367 12.8139C7.34172 12.8139 7.56781 12.8589 7.76194 12.9489C7.95725 13.0376 8.11054 13.1613 8.22181 13.32C8.33308 13.4774 8.39049 13.6585 8.39404 13.8633H7.76017ZM9.51753 12.8636L10.4639 15.7259H10.5012L11.4458 12.8636H12.1702L10.8883 16.5H10.0751L8.79488 12.8636H9.51753Z",
      fill: "white"
    }, null, -1)
  ]));
}
const Ev = /* @__PURE__ */ U(Dv, [["render", xv]]), kv = {}, Sv = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
};
function Tv(r, t) {
  return m(), x("svg", Sv, t[0] || (t[0] = [
    C("path", {
      d: "M13.1 3H6.8C6.32261 3 5.86477 3.18964 5.52721 3.52721C5.18964 3.86477 5 4.32261 5 4.8V19.2C5 19.6774 5.18964 20.1352 5.52721 20.4728C5.86477 20.8104 6.32261 21 6.8 21H17.6C18.0774 21 18.5352 20.8104 18.8728 20.4728C19.2104 20.1352 19.4 19.6774 19.4 19.2V9.3M13.1 3L19.4 9.3M13.1 3V9.3H19.4",
      stroke: "#0c74f4",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("rect", {
      y: "11",
      width: "14",
      height: "7",
      rx: "1",
      fill: "#0c74f4"
    }, null, -1),
    C("path", {
      d: "M2.98544 16.5H1.7532V12.8636H3.0103C3.37133 12.8636 3.68146 12.9364 3.9407 13.082C4.20111 13.2264 4.40116 13.4342 4.54084 13.7053C4.68052 13.9763 4.75036 14.3007 4.75036 14.6783C4.75036 15.0571 4.67992 15.3826 4.53906 15.6548C4.39938 15.9271 4.19756 16.136 3.93359 16.2816C3.67081 16.4272 3.35476 16.5 2.98544 16.5ZM2.41193 15.93H2.95348C3.20679 15.93 3.41809 15.8839 3.58736 15.7915C3.75663 15.698 3.88388 15.5589 3.96911 15.3743C4.05433 15.1884 4.09695 14.9564 4.09695 14.6783C4.09695 14.4001 4.05433 14.1693 3.96911 13.9858C3.88388 13.8011 3.75781 13.6632 3.59091 13.5721C3.42519 13.4798 3.21922 13.4336 2.97301 13.4336H2.41193V15.93ZM8.62553 14.6818C8.62553 15.0736 8.55214 15.4092 8.40536 15.6886C8.25977 15.9667 8.0609 16.1798 7.80877 16.3278C7.55782 16.4757 7.27314 16.5497 6.95472 16.5497C6.6363 16.5497 6.35103 16.4757 6.0989 16.3278C5.84795 16.1786 5.64909 15.965 5.50231 15.6868C5.35671 15.4074 5.28391 15.0724 5.28391 14.6818C5.28391 14.29 5.35671 13.955 5.50231 13.6768C5.64909 13.3975 5.84795 13.1838 6.0989 13.0359C6.35103 12.8879 6.6363 12.8139 6.95472 12.8139C7.27314 12.8139 7.55782 12.8879 7.80877 13.0359C8.0609 13.1838 8.25977 13.3975 8.40536 13.6768C8.55214 13.955 8.62553 14.29 8.62553 14.6818ZM7.96325 14.6818C7.96325 14.406 7.92004 14.1734 7.83363 13.984C7.7484 13.7934 7.63003 13.6496 7.47852 13.5526C7.327 13.4543 7.1524 13.4052 6.95472 13.4052C6.75704 13.4052 6.58245 13.4543 6.43093 13.5526C6.27942 13.6496 6.16045 13.7934 6.07404 13.984C5.98881 14.1734 5.9462 14.406 5.9462 14.6818C5.9462 14.9576 5.98881 15.1908 6.07404 15.3814C6.16045 15.5708 6.27942 15.7146 6.43093 15.8129C6.58245 15.9099 6.75704 15.9585 6.95472 15.9585C7.1524 15.9585 7.327 15.9099 7.47852 15.8129C7.63003 15.7146 7.7484 15.5708 7.83363 15.3814C7.92004 15.1908 7.96325 14.9576 7.96325 14.6818ZM12.3609 14.0906H11.6968C11.6779 13.9817 11.643 13.8852 11.5921 13.8011C11.5412 13.7159 11.4778 13.6437 11.4021 13.5845C11.3263 13.5253 11.2399 13.4809 11.1428 13.4513C11.047 13.4206 10.9434 13.4052 10.8321 13.4052C10.6344 13.4052 10.4593 13.4549 10.3066 13.5543C10.1539 13.6526 10.0343 13.797 9.94789 13.9876C9.86148 14.177 9.81827 14.4084 9.81827 14.6818C9.81827 14.96 9.86148 15.1944 9.94789 15.3849C10.0355 15.5743 10.155 15.7176 10.3066 15.8146C10.4593 15.9105 10.6338 15.9585 10.8303 15.9585C10.9392 15.9585 11.041 15.9442 11.1357 15.9158C11.2316 15.8862 11.3174 15.843 11.3932 15.7862C11.4701 15.7294 11.5347 15.6596 11.5867 15.5767C11.64 15.4938 11.6767 15.3991 11.6968 15.2926L12.3609 15.2962C12.336 15.469 12.2822 15.6312 12.1993 15.7827C12.1176 15.9342 12.0105 16.0679 11.8779 16.1839C11.7454 16.2988 11.5903 16.3887 11.4127 16.4538C11.2352 16.5178 11.0381 16.5497 10.8215 16.5497C10.5019 16.5497 10.2166 16.4757 9.96564 16.3278C9.7147 16.1798 9.51702 15.9661 9.3726 15.6868C9.22819 15.4074 9.15598 15.0724 9.15598 14.6818C9.15598 14.29 9.22878 13.955 9.37438 13.6768C9.51998 13.3975 9.71825 13.1838 9.96919 13.0359C10.2201 12.8879 10.5042 12.8139 10.8215 12.8139C11.0239 12.8139 11.2121 12.8423 11.3861 12.8991C11.5601 12.956 11.7152 13.0394 11.8513 13.1495C11.9874 13.2584 12.0993 13.3922 12.1869 13.5508C12.2757 13.7082 12.3337 13.8881 12.3609 14.0906Z",
      fill: "white"
    }, null, -1)
  ]));
}
const ia = /* @__PURE__ */ U(kv, [["render", Tv]]), Bv = {}, $v = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
};
function Mv(r, t) {
  return m(), x("svg", $v, t[0] || (t[0] = [
    C("path", {
      d: "M13.1 3H6.8C6.32261 3 5.86477 3.18964 5.52721 3.52721C5.18964 3.86477 5 4.32261 5 4.8V19.2C5 19.6774 5.18964 20.1352 5.52721 20.4728C5.86477 20.8104 6.32261 21 6.8 21H17.6C18.0774 21 18.5352 20.8104 18.8728 20.4728C19.2104 20.1352 19.4 19.6774 19.4 19.2V9.3M13.1 3L19.4 9.3M13.1 3V9.3H19.4",
      stroke: "#ff6010",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("rect", {
      y: "11",
      width: "14",
      height: "7",
      rx: "1",
      fill: "#ff6010"
    }, null, -1),
    C("path", {
      d: "M2.47341 16.5V12.8636H3.83705C4.1164 12.8636 4.35078 12.9157 4.54017 13.0199C4.73075 13.1241 4.87457 13.2673 4.97164 13.4496C5.06988 13.6307 5.11901 13.8366 5.11901 14.0675C5.11901 14.3007 5.06988 14.5078 4.97164 14.6889C4.87339 14.87 4.72838 15.0127 4.53662 15.1168C4.34486 15.2198 4.10871 15.2713 3.82817 15.2713H2.92441V14.7298H3.73939C3.90274 14.7298 4.0365 14.7013 4.14067 14.6445C4.24484 14.5877 4.32178 14.5096 4.37149 14.4102C4.42239 14.3107 4.44784 14.1965 4.44784 14.0675C4.44784 13.9384 4.42239 13.8248 4.37149 13.7266C4.32178 13.6283 4.24424 13.552 4.13889 13.4975C4.03473 13.4419 3.90038 13.4141 3.73584 13.4141H3.13215V16.5H2.47341ZM6.92343 16.5H5.69118V12.8636H6.94829C7.30932 12.8636 7.61945 12.9364 7.87868 13.082C8.1391 13.2264 8.33915 13.4342 8.47883 13.7053C8.6185 13.9763 8.68834 14.3007 8.68834 14.6783C8.68834 15.0571 8.61791 15.3826 8.47705 15.6548C8.33737 15.9271 8.13555 16.136 7.87158 16.2816C7.6088 16.4272 7.29275 16.5 6.92343 16.5ZM6.34992 15.93H6.89147C7.14478 15.93 7.35608 15.8839 7.52535 15.7915C7.69462 15.698 7.82187 15.5589 7.90709 15.3743C7.99232 15.1884 8.03493 14.9564 8.03493 14.6783C8.03493 14.4001 7.99232 14.1693 7.90709 13.9858C7.82187 13.8011 7.6958 13.6632 7.5289 13.5721C7.36318 13.4798 7.15721 13.4336 6.911 13.4336H6.34992V15.93ZM9.31423 16.5V12.8636H11.6438V13.4158H9.97297V14.4031H11.484V14.9553H9.97297V16.5H9.31423Z",
      fill: "white"
    }, null, -1)
  ]));
}
const Ov = /* @__PURE__ */ U(Bv, [["render", Mv]]), Lv = {}, Fv = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
};
function Iv(r, t) {
  return m(), x("svg", Fv, t[0] || (t[0] = [
    C("path", {
      d: "M13.1 3H6.8C6.32261 3 5.86477 3.18964 5.52721 3.52721C5.18964 3.86477 5 4.32261 5 4.8V19.2C5 19.6774 5.18964 20.1352 5.52721 20.4728C5.86477 20.8104 6.32261 21 6.8 21H17.6C18.0774 21 18.5352 20.8104 18.8728 20.4728C19.2104 20.1352 19.4 19.6774 19.4 19.2V9.3M13.1 3L19.4 9.3M13.1 3V9.3H19.4",
      stroke: "#ff6010",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("rect", {
      y: "11",
      width: "14",
      height: "7",
      rx: "1",
      fill: "#ff6010"
    }, null, -1),
    C("path", {
      d: "M2.4905 16.5V12.8636H3.85414C4.13349 12.8636 4.36787 12.9157 4.55726 13.0199C4.74784 13.1241 4.89166 13.2673 4.98873 13.4496C5.08697 13.6307 5.1361 13.8366 5.1361 14.0675C5.1361 14.3007 5.08697 14.5078 4.98873 14.6889C4.89048 14.87 4.74547 15.0127 4.55371 15.1168C4.36195 15.2198 4.1258 15.2713 3.84526 15.2713H2.9415V14.7298H3.75648C3.91983 14.7298 4.05359 14.7013 4.15776 14.6445C4.26193 14.5877 4.33887 14.5096 4.38858 14.4102C4.43948 14.3107 4.46493 14.1965 4.46493 14.0675C4.46493 13.9384 4.43948 13.8248 4.38858 13.7266C4.33887 13.6283 4.26133 13.552 4.15598 13.4975C4.05182 13.4419 3.91747 13.4141 3.75293 13.4141H3.14924V16.5H2.4905ZM5.70827 16.5V12.8636H7.07191C7.35127 12.8636 7.58564 12.9157 7.77504 13.0199C7.96561 13.1241 8.10943 13.2673 8.2065 13.4496C8.30475 13.6307 8.35387 13.8366 8.35387 14.0675C8.35387 14.3007 8.30475 14.5078 8.2065 14.6889C8.10825 14.87 7.96325 15.0127 7.77148 15.1168C7.57972 15.2198 7.34357 15.2713 7.06303 15.2713H6.15927V14.7298H6.97425C7.13761 14.7298 7.27137 14.7013 7.37553 14.6445C7.4797 14.5877 7.55664 14.5096 7.60636 14.4102C7.65726 14.3107 7.68271 14.1965 7.68271 14.0675C7.68271 13.9384 7.65726 13.8248 7.60636 13.7266C7.55664 13.6283 7.47911 13.552 7.37376 13.4975C7.26959 13.4419 7.13524 13.4141 6.9707 13.4141H6.36701V16.5H5.70827ZM8.76625 13.4158V12.8636H11.6675V13.4158H10.5436V16.5H9.89018V13.4158H8.76625Z",
      fill: "white"
    }, null, -1)
  ]));
}
const Vo = /* @__PURE__ */ U(Lv, [["render", Iv]]), Nv = {}, qv = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
};
function Pv(r, t) {
  return m(), x("svg", qv, t[0] || (t[0] = [
    C("path", {
      d: "M13.1 3H6.8C6.32261 3 5.86477 3.18964 5.52721 3.52721C5.18964 3.86477 5 4.32261 5 4.8V19.2C5 19.6774 5.18964 20.1352 5.52721 20.4728C5.86477 20.8104 6.32261 21 6.8 21H17.6C18.0774 21 18.5352 20.8104 18.8728 20.4728C19.2104 20.1352 19.4 19.6774 19.4 19.2V9.3M13.1 3L19.4 9.3M13.1 3V9.3H19.4",
      stroke: "#28936B",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("rect", {
      y: "11",
      width: "14",
      height: "7",
      rx: "1",
      fill: "#28936B"
    }, null, -1),
    C("path", {
      d: "M2.90909 12.8636L3.70987 14.1953H3.73828L4.54261 12.8636H5.29368L4.1733 14.6818L5.31143 16.5H4.54794L3.73828 15.1772H3.70987L2.90021 16.5H2.14027L3.28906 14.6818L2.15447 12.8636H2.90909ZM5.81081 16.5V12.8636H6.46955V15.9478H8.07111V16.5H5.81081ZM10.6191 13.8633C10.6025 13.7082 10.5326 13.5875 10.4095 13.5011C10.2876 13.4147 10.129 13.3714 9.93368 13.3714C9.79637 13.3714 9.67859 13.3922 9.58034 13.4336C9.4821 13.475 9.40693 13.5312 9.35485 13.6023C9.30276 13.6733 9.27613 13.7544 9.27495 13.8455C9.27495 13.9213 9.29211 13.987 9.32644 14.0426C9.36195 14.0982 9.40989 14.1456 9.47026 14.1847C9.53063 14.2225 9.59751 14.2545 9.6709 14.2805C9.74429 14.3066 9.81827 14.3285 9.89284 14.3462L10.2338 14.4315C10.3711 14.4634 10.503 14.5066 10.6297 14.5611C10.7575 14.6155 10.8718 14.6842 10.9724 14.767C11.0742 14.8499 11.1547 14.9499 11.2139 15.0671C11.2731 15.1843 11.3026 15.3216 11.3026 15.479C11.3026 15.6921 11.2482 15.8797 11.1393 16.0419C11.0304 16.2029 10.873 16.329 10.667 16.4201C10.4622 16.5101 10.2142 16.555 9.92303 16.555C9.64012 16.555 9.3945 16.5112 9.18617 16.4237C8.97902 16.3361 8.81685 16.2082 8.69966 16.0401C8.58366 15.872 8.52092 15.6673 8.51145 15.4258H9.15953C9.169 15.5524 9.20807 15.6578 9.27672 15.7418C9.34538 15.8259 9.43475 15.8886 9.54483 15.93C9.6561 15.9715 9.78039 15.9922 9.9177 15.9922C10.0609 15.9922 10.1864 15.9709 10.2941 15.9283C10.403 15.8845 10.4883 15.8241 10.5498 15.7472C10.6114 15.669 10.6427 15.5779 10.6439 15.4737C10.6427 15.379 10.6149 15.3009 10.5605 15.2393C10.506 15.1766 10.4297 15.1245 10.3314 15.0831C10.2343 15.0405 10.1207 15.0026 9.9905 14.9695L9.57679 14.8629C9.27731 14.786 9.04057 14.6694 8.86657 14.5131C8.69374 14.3557 8.60733 14.1468 8.60733 13.8864C8.60733 13.6721 8.66534 13.4845 8.78134 13.3235C8.89853 13.1625 9.05774 13.0376 9.25897 12.9489C9.4602 12.8589 9.68806 12.8139 9.94256 12.8139C10.2006 12.8139 10.4267 12.8589 10.6208 12.9489C10.8161 13.0376 10.9694 13.1613 11.0807 13.32C11.192 13.4774 11.2494 13.6585 11.2529 13.8633H10.6191Z",
      fill: "white"
    }, null, -1)
  ]));
}
const jo = /* @__PURE__ */ U(Nv, [["render", Pv]]), Rv = {}, Vv = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
};
function jv(r, t) {
  return m(), x("svg", Vv, t[0] || (t[0] = [
    C("path", {
      d: "M5.06107 20.0451L5.50191 19.4383L5.06107 20.0451ZM3.95491 18.9389L3.34815 19.3798L3.95491 18.9389ZM20.0451 18.9389L19.4383 18.4981L20.0451 18.9389ZM18.9389 20.0451L18.4981 19.4383L18.9389 20.0451ZM18.9389 3.95491L18.4981 4.56168L18.9389 3.95491ZM20.0451 5.06107L19.4383 5.50191L20.0451 5.06107ZM5.06107 3.95491L5.50191 4.56168L5.06107 3.95491ZM3.95491 5.06107L4.56168 5.50191L3.95491 5.06107ZM4.21965 18.5607L3.54883 18.2253H3.54883L4.21965 18.5607ZM11.5 15L11.724 14.2842L11.6861 14.2724L11.6471 14.2646L11.5 15ZM9.15808 14.653L9.17401 15.4028L9.15808 14.653ZM5.38354 16.4991L4.80143 16.0261L5.38354 16.4991ZM11.6727 15.7714L11.0198 15.4023L11.6727 15.7714ZM8.34708 20.131C8.14326 20.4916 8.27036 20.9491 8.63096 21.1529C8.99156 21.3567 9.44911 21.2296 9.65292 20.869L8.34708 20.131ZM19.5106 13.1101L19.9448 12.4986L19.5106 13.1101ZM12.7358 14.0336L12.1537 13.5606H12.1537L12.7358 14.0336ZM4.10982 18.7804L4.75526 19.1623L4.76878 19.1395L4.78065 19.1158L4.10982 18.7804ZM8.25 9C8.25 10.5188 9.48122 11.75 11 11.75V10.25C10.3096 10.25 9.75 9.69036 9.75 9H8.25ZM11 11.75C12.5188 11.75 13.75 10.5188 13.75 9H12.25C12.25 9.69036 11.6904 10.25 11 10.25V11.75ZM13.75 9C13.75 7.48122 12.5188 6.25 11 6.25V7.75C11.6904 7.75 12.25 8.30964 12.25 9H13.75ZM11 6.25C9.48122 6.25 8.25 7.48122 8.25 9H9.75C9.75 8.30964 10.3096 7.75 11 7.75V6.25ZM12 20.25C10.1084 20.25 8.74999 20.249 7.69804 20.135C6.66013 20.0225 6.00992 19.8074 5.50191 19.4383L4.62023 20.6518C5.42656 21.2377 6.37094 21.5 7.53648 21.6263C8.68798 21.751 10.1418 21.75 12 21.75V20.25ZM2.25 12C2.25 13.8582 2.24897 15.312 2.37373 16.4635C2.50001 17.6291 2.76232 18.5734 3.34815 19.3798L4.56168 18.4981C4.19259 17.9901 3.97745 17.3399 3.865 16.302C3.75103 15.25 3.75 13.8916 3.75 12H2.25ZM12 21.75C13.8582 21.75 15.312 21.751 16.4635 21.6263C17.6291 21.5 18.5734 21.2377 19.3798 20.6518L18.4981 19.4383C17.9901 19.8074 17.3399 20.0225 16.302 20.135C15.25 20.249 13.8916 20.25 12 20.25V21.75ZM19.4383 18.4981C19.1762 18.8589 18.8589 19.1762 18.4981 19.4383L19.3798 20.6518C19.8679 20.2972 20.2972 19.8679 20.6518 19.3798L19.4383 18.4981ZM12 3.75C13.8916 3.75 15.25 3.75103 16.302 3.865C17.3399 3.97745 17.9901 4.19259 18.4981 4.56168L19.3798 3.34815C18.5734 2.76232 17.6291 2.50001 16.4635 2.37373C15.312 2.24897 13.8582 2.25 12 2.25V3.75ZM21.75 12C21.75 10.1418 21.751 8.68798 21.6263 7.53648C21.5 6.37094 21.2377 5.42656 20.6518 4.62023L19.4383 5.50191C19.8074 6.00992 20.0225 6.66013 20.135 7.69804C20.249 8.74999 20.25 10.1084 20.25 12H21.75ZM18.4981 4.56168C18.8589 4.82382 19.1762 5.14111 19.4383 5.50191L20.6518 4.62023C20.2972 4.13209 19.8679 3.70281 19.3798 3.34815L18.4981 4.56168ZM12 2.25C10.1418 2.25 8.68798 2.24897 7.53648 2.37373C6.37094 2.50001 5.42656 2.76232 4.62023 3.34815L5.50191 4.56168C6.00992 4.19259 6.66013 3.97745 7.69804 3.865C8.74999 3.75103 10.1084 3.75 12 3.75V2.25ZM3.75 12C3.75 10.1084 3.75103 8.74999 3.865 7.69804C3.97745 6.66013 4.19259 6.00992 4.56168 5.50191L3.34815 4.62023C2.76232 5.42656 2.50001 6.37094 2.37373 7.53648C2.24897 8.68798 2.25 10.1418 2.25 12H3.75ZM4.62023 3.34815C4.13209 3.70281 3.70281 4.13209 3.34815 4.62023L4.56168 5.50191C4.82382 5.14111 5.14111 4.82382 5.50191 4.56168L4.62023 3.34815ZM11.6471 14.2646C10.4878 14.0327 9.79315 13.8893 9.14216 13.9032L9.17401 15.4028C9.62029 15.3933 10.1211 15.4891 11.3529 15.7354L11.6471 14.2646ZM4.89047 18.8961C5.45225 17.7726 5.68417 17.3184 5.96564 16.972L4.80143 16.0261C4.39085 16.5315 4.07753 17.1679 3.54883 18.2253L4.89047 18.8961ZM9.14216 13.9032C7.45369 13.939 5.86635 14.7154 4.80143 16.0261L5.96564 16.972C6.75276 16.0031 7.92601 15.4293 9.17401 15.4028L9.14216 13.9032ZM11.0198 15.4023L8.34708 20.131L9.65292 20.869L12.3256 16.1404L11.0198 15.4023ZM19.9448 12.4986C17.4737 10.7441 14.0651 11.2087 12.1537 13.5606L13.3178 14.5066C14.7305 12.7683 17.25 12.4249 19.0764 13.7217L19.9448 12.4986ZM12.3256 16.1404C12.4556 15.9105 12.5685 15.7108 12.6693 15.5345L11.3671 14.7899C11.2641 14.9701 11.1492 15.1733 11.0198 15.4023L12.3256 16.1404ZM12.6693 15.5345C12.9887 14.9758 13.1615 14.699 13.3178 14.5066L12.1537 13.5606C11.9086 13.8622 11.6794 14.2437 11.3671 14.7899L12.6693 15.5345ZM11.276 15.7158L11.7942 15.8779L12.2422 14.4464L11.724 14.2842L11.276 15.7158ZM21.5153 13.9547C20.7847 13.224 20.3507 12.7868 19.9448 12.4986L19.0764 13.7217C19.3525 13.9177 19.6771 14.2377 20.4547 15.0153L21.5153 13.9547ZM20.25 12C20.25 12.9413 20.25 13.7543 20.2352 14.4695L21.7348 14.5005C21.75 13.7667 21.75 12.9368 21.75 12H20.25ZM20.2352 14.4695C20.19 16.6526 20 17.725 19.4383 18.4981L20.6518 19.3798C21.5217 18.1825 21.6903 16.6546 21.7348 14.5005L20.2352 14.4695ZM3.54883 18.2253L3.439 18.4449L4.78065 19.1158L4.89047 18.8961L3.54883 18.2253ZM5.50191 19.4383C5.1542 19.1857 4.8469 18.8818 4.59044 18.5372L3.38706 19.4327C3.73405 19.899 4.1498 20.3101 4.62023 20.6518L5.50191 19.4383ZM4.59044 18.5372C4.58078 18.5242 4.57119 18.5112 4.56168 18.4981L3.34815 19.3798C3.36102 19.3975 3.37399 19.4151 3.38706 19.4327L4.59044 18.5372ZM3.46439 18.3984L3.34331 18.603L4.63418 19.3669L4.75526 19.1623L3.46439 18.3984Z",
      fill: "#696969"
    }, null, -1)
  ]));
}
const Qu = /* @__PURE__ */ U(Rv, [["render", jv]]), Hv = {}, Uv = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
};
function zv(r, t) {
  return m(), x("svg", Uv, t[0] || (t[0] = [
    C("path", {
      d: "M20.186 19.8605H3.81395C3.06848 19.8578 2.3543 19.5604 1.82717 19.0333C1.30003 18.5062 1.0027 17.792 1 17.0465V6.81395C1.0027 6.06848 1.30003 5.3543 1.82717 4.82717C2.3543 4.30003 3.06848 4.0027 3.81395 4H20.186C20.9315 4.0027 21.6457 4.30003 22.1728 4.82717C22.7 5.3543 22.9973 6.06848 23 6.81395V17.0465C22.9973 17.792 22.7 18.5062 22.1728 19.0333C21.6457 19.5604 20.9315 19.8578 20.186 19.8605ZM3.81395 5.53488C3.47472 5.53488 3.14939 5.66964 2.90951 5.90951C2.66964 6.14939 2.53488 6.47472 2.53488 6.81395V17.0465C2.53488 17.3857 2.66964 17.7111 2.90951 17.951C3.14939 18.1908 3.47472 18.3256 3.81395 18.3256H20.186C20.5253 18.3256 20.8506 18.1908 21.0905 17.951C21.3304 17.7111 21.4651 17.3857 21.4651 17.0465V6.81395C21.4651 6.47472 21.3304 6.14939 21.0905 5.90951C20.8506 5.66964 20.5253 5.53488 20.186 5.53488H3.81395Z",
      fill: "#696969",
      stroke: "#696969",
      "stroke-width": "0.2"
    }, null, -1),
    C("path", {
      d: "M12 13.1C11.4197 13.1 10.85 12.9446 10.35 12.65L1.62001 7.45999C1.4569 7.35834 1.33837 7.19866 1.28827 7.01311C1.23817 6.82756 1.26023 6.62993 1.35001 6.45999C1.44985 6.29479 1.6103 6.17514 1.79712 6.12657C1.98394 6.07799 2.18234 6.10434 2.35001 6.19999L11.09 11.38C11.3551 11.5417 11.6595 11.6272 11.97 11.6272C12.2805 11.6272 12.585 11.5417 12.85 11.38L21.59 6.19999C21.7577 6.10434 21.9561 6.07799 22.1429 6.12657C22.3297 6.17514 22.4902 6.29479 22.59 6.45999C22.6798 6.62993 22.7018 6.82756 22.6518 7.01311C22.6017 7.19866 22.4831 7.35834 22.32 7.45999L13.65 12.65C13.15 12.9446 12.5803 13.1 12 13.1Z",
      fill: "#696969",
      stroke: "#696969",
      "stroke-width": "0.2"
    }, null, -1)
  ]));
}
const Ho = /* @__PURE__ */ U(Hv, [["render", zv]]), Gv = Object.freeze([
  { extension: "csv", icon: Ev },
  { extension: "msword", icon: ia },
  { extension: "docx", icon: ia },
  { extension: "doc", icon: ia },
  { extension: "pdf", icon: Ov },
  { extension: "ppt", icon: Vo },
  { extension: "pptx", icon: Vo },
  { extension: "xls", icon: jo },
  { extension: "xlsx", icon: jo },
  { extension: "msg", icon: Ho },
  { extension: "eml", icon: Ho },
  { extension: "jpeg", icon: Qu },
  { extension: "jpg", icon: Qu },
  { extension: "png", icon: Qu },
  { extension: "gif", icon: Qu }
]), Wv = /* @__PURE__ */ ue({
  __name: "VFileAttachmentField",
  props: {
    fileName: {},
    fileType: {},
    fileExtension: {},
    fileTypeOptions: {},
    foreground: { type: Boolean, default: !1 },
    borderless: { type: Boolean, default: !1 },
    showLabels: { type: Boolean, default: !0 },
    appendToBody: { type: Boolean, default: !0 }
  },
  emits: ["update:fileName", "update:fileType"],
  setup(r, { emit: t }) {
    const e = r, u = t, n = G(() => {
      var i;
      return ((i = Gv.find((l) => e.fileExtension === l.extension)) == null ? void 0 : i.icon) || Cv;
    }), a = G(() => ({
      fileName: {
        required: sa.withMessage("File Name is not valid.", la)
      },
      fileType: {
        required: sa.withMessage("File Type is not valid.", la)
      }
    })), o = Bs(a, e), s = be();
    return (i, l) => {
      var d, h, c, f;
      return m(), x("div", {
        class: b(p(s)["v-file-attachment"])
      }, [
        j(p(Fr), {
          class: b(p(s)["v-file-attachment__input"]),
          "model-value": i.fileName,
          "prefix-icon": n.value,
          label: i.showLabels ? "File Name" : "",
          "show-required-star": i.showLabels,
          foreground: i.foreground,
          borderless: i.borderless,
          "with-error": !!((d = p(o).fileName.$errors[0]) != null && d.$message),
          error: String((h = p(o).fileName.$errors[0]) == null ? void 0 : h.$message),
          "onUpdate:modelValue": l[0] || (l[0] = (g) => u("update:fileName", g))
        }, null, 8, ["class", "model-value", "prefix-icon", "label", "show-required-star", "foreground", "borderless", "with-error", "error"]),
        j(p(fc), {
          class: b(p(s)["v-file-attachment__select"]),
          "model-value": i.fileType,
          foreground: i.foreground,
          "show-required-star": i.showLabels,
          label: i.showLabels ? "File Type" : "",
          borderless: i.borderless,
          "append-to-body": i.appendToBody,
          filterable: "",
          searchable: "",
          options: i.fileTypeOptions,
          "with-error": !!((c = p(o).fileType.$errors[0]) != null && c.$message),
          error: String((f = p(o).fileType.$errors[0]) == null ? void 0 : f.$message),
          "onUpdate:modelValue": l[1] || (l[1] = (g) => u("update:fileType", g))
        }, null, 8, ["class", "model-value", "foreground", "show-required-star", "label", "borderless", "append-to-body", "options", "with-error", "error"])
      ], 2);
    };
  }
}), Yv = {
  "v-file-attachment": "_v-file-attachment_vmerj_1",
  "v-file-attachment__select": "_v-file-attachment__select_vmerj_13",
  "v-file-attachment__input": "_v-file-attachment__input_vmerj_16"
}, Zv = {
  $style: Yv
}, aE = /* @__PURE__ */ U(Wv, [["__cssModules", Zv]]), Kv = /* @__PURE__ */ ue({
  __name: "VMultipleButtons",
  props: {
    buttons: {}
  },
  emits: ["click"],
  setup(r, { emit: t }) {
    const e = t, u = be();
    return (n, a) => (m(), x("div", {
      class: b(p(u)["v-multiple-buttons"])
    }, [
      (m(!0), x(pe, null, ge(n.buttons, (o, s) => (m(), H(vt, Te({ key: s }, { ref_for: !0 }, o, {
        onClick: (i) => e("click", s)
      }), mt({
        default: J(() => [
          o.text ? (m(), x(pe, { key: 0 }, [
            ce(ne(o.text), 1)
          ], 64)) : R("", !0)
        ]),
        _: 2
      }, [
        o.icon ? {
          name: "icon",
          fn: J(() => [
            (m(), H(He(o.icon)))
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["onClick"]))), 128))
    ], 2));
  }
}), Xv = {
  "v-multiple-buttons": "_v-multiple-buttons_11zv6_1"
}, Jv = {
  $style: Xv
}, iE = /* @__PURE__ */ U(Kv, [["__cssModules", Jv]]), Qv = {}, eg = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function tg(r, t) {
  return m(), x("svg", eg, t[0] || (t[0] = [
    C("path", {
      d: "M15.25 11.8C15.7396 11.5018 16.1528 11.0934 16.4567 10.6073C16.7605 10.1212 16.9465 9.57077 17 9C17.0093 8.48388 16.9168 7.971 16.7278 7.49063C16.5388 7.01027 16.2571 6.57184 15.8986 6.20039C15.5402 5.82894 15.112 5.53174 14.6387 5.32578C14.1654 5.11981 13.6561 5.00911 13.14 5H6.64999V19H13.65C14.1411 18.9948 14.6265 18.8929 15.0782 18.7001C15.53 18.5073 15.9393 18.2274 16.2829 17.8764C16.6265 17.5253 16.8976 17.1101 17.0807 16.6543C17.2638 16.1985 17.3553 15.7112 17.35 15.22V15.1C17.3503 14.4071 17.1529 13.7285 16.7809 13.144C16.4089 12.5594 15.8778 12.0931 15.25 11.8ZM8.64999 7H12.85C13.2762 6.98681 13.6962 7.10428 14.0537 7.33665C14.4112 7.56902 14.689 7.90517 14.85 8.3C15.0129 8.82779 14.9602 9.39859 14.7035 9.88765C14.4468 10.3767 14.0069 10.7443 13.48 10.91C13.2754 10.97 13.0632 11.0003 12.85 11H8.64999V7ZM13.25 17H8.64999V13H13.25C13.6762 12.9868 14.0962 13.1043 14.4537 13.3367C14.8112 13.569 15.089 13.9052 15.25 14.3C15.4129 14.8278 15.3602 15.3986 15.1035 15.8877C14.8468 16.3767 14.4069 16.7443 13.88 16.91C13.6754 16.97 13.4632 17.0003 13.25 17Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const rg = /* @__PURE__ */ U(Qv, [["render", tg]]), ug = {}, ng = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ag(r, t) {
  return m(), x("svg", ng, t[0] || (t[0] = [
    C("path", {
      d: "M11.76 9H13.76L11.56 19H9.56L11.76 9ZM13.44 5C13.2422 5 13.0489 5.05865 12.8844 5.16853C12.72 5.27841 12.5918 5.43459 12.5161 5.61732C12.4404 5.80004 12.4206 6.00111 12.4592 6.19509C12.4978 6.38907 12.593 6.56725 12.7329 6.70711C12.8727 6.84696 13.0509 6.9422 13.2449 6.98079C13.4389 7.01937 13.64 6.99957 13.8227 6.92388C14.0054 6.84819 14.1616 6.72002 14.2715 6.55557C14.3813 6.39112 14.44 6.19778 14.44 6C14.44 5.73478 14.3346 5.48043 14.1471 5.29289C13.9596 5.10536 13.7052 5 13.44 5Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const ig = /* @__PURE__ */ U(ug, [["render", ag]]), og = {}, sg = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  color: "currentColor"
};
function lg(r, t) {
  return m(), x("svg", sg, t[0] || (t[0] = [
    C("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" }, null, -1),
    C("path", { d: "M6 20L8 13H16L18 20" }, null, -1),
    C("path", { d: "M9.5 13L11.0299 6.88057C11.2823 5.87062 12.7177 5.87062 12.9701 6.88057L14.5 13" }, null, -1)
  ]));
}
const cg = /* @__PURE__ */ U(og, [["render", lg]]), dg = { key: 0 }, fg = /* @__PURE__ */ ue({
  __name: "VLongTextField",
  props: /* @__PURE__ */ lt({
    modelValue: {},
    foreground: { type: Boolean },
    placeholder: {},
    autofocus: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    helpText: {},
    description: {},
    borderless: { type: Boolean },
    disabled: { type: Boolean },
    size: {},
    color: {},
    warning: {},
    infoText: {},
    inputMode: {}
  }, {
    foreground: !1,
    autofocus: !1,
    ...ct
  }),
  emits: ["update:model-value"],
  setup(r, { expose: t, emit: e }) {
    const u = r, n = e, a = {
      name: "mark",
      level: "inline",
      start(l) {
        var d;
        return (d = l.match(/==(.*?)==/)) == null ? void 0 : d.index;
      },
      tokenizer(l) {
        const h = /^==(.*)==/.exec(l);
        if (h)
          return {
            type: "mark",
            raw: h[0],
            text: h[1].trim()
          };
      },
      renderer(l) {
        return `<mark>${l.text}</mark>`;
      }
    };
    Oi.use({
      extensions: [a],
      breaks: !0
    });
    const o = new F0({
      blankReplacement: () => `
`,
      emDelimiter: "*"
    });
    o.addRule("mark", {
      filter: ["mark"],
      replacement: (l) => `==${l}==`
    }), o.addRule("newLine", {
      filter: ["p"],
      replacement: (l) => `${l}
`
    });
    const s = O0({
      content: Oi.marked(u.modelValue || ""),
      editable: !0,
      extensions: [
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        I0,
        N0
      ],
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onCreate: ({ editor: l }) => {
        u.autofocus && Pe(() => {
          l.commands.focus("end");
        });
      },
      onUpdate: ({ editor: l }) => {
        const h = o.turndown(l.getHTML()).replace(/\$\{([^}]*)\}/g, (c, f) => `\${${f.replace(/\\_/g, "_")}}`);
        n("update:model-value", h);
      }
    });
    qe(() => u.disabled, (l) => {
      Pe(() => {
        s.value && s.value.setEditable(!l);
      });
    }, {
      immediate: !0
    });
    const i = be();
    return t({
      editor: s
    }), (l, d) => (m(), H(p(Lr), {
      class: b(p(i)["v-long-text"]),
      error: l.error,
      label: l.label,
      "show-required-star": l.showRequiredStar,
      "with-error": l.withError,
      "aria-label": l.label,
      color: l.color,
      description: l.description,
      "help-text": l.helpText,
      warning: l.warning,
      "info-text": l.infoText
    }, {
      "label-right": J(() => [
        K(l.$slots, "label-right")
      ]),
      default: J(() => [
        C("div", null, [
          C("div", {
            class: b(p(i)["v-long-text__editor-header"])
          }, [
            j(p(Ve), {
              content: "Add bold text",
              placement: "top"
            }, {
              default: J(() => [
                C("div", {
                  class: b([
                    p(i)["v-long-text__editor-icon"],
                    {
                      [p(i)["v-long-text__editor-icon--active"]]: p(s) && p(s).isActive("bold")
                    }
                  ]),
                  onClick: d[0] || (d[0] = (h) => {
                    var c, f;
                    return (f = (c = p(s)) == null ? void 0 : c.commands) == null ? void 0 : f.toggleBold();
                  })
                }, [
                  j(rg)
                ], 2)
              ]),
              _: 1
            }),
            j(p(Ve), {
              content: "Add italic text",
              placement: "top"
            }, {
              default: J(() => [
                C("div", {
                  class: b([
                    p(i)["v-long-text__editor-icon"],
                    {
                      [p(i)["v-long-text__editor-icon--active"]]: p(s) && p(s).isActive("italic")
                    }
                  ]),
                  onClick: d[1] || (d[1] = (h) => {
                    var c, f;
                    return (f = (c = p(s)) == null ? void 0 : c.commands) == null ? void 0 : f.toggleItalic();
                  })
                }, [
                  j(ig)
                ], 2)
              ]),
              _: 1
            }),
            j(p(Ve), {
              content: "Add highlight text",
              placement: "top"
            }, {
              default: J(() => [
                C("div", {
                  class: b([
                    p(i)["v-long-text__editor-icon"],
                    {
                      [p(i)["v-long-text__editor-icon--active"]]: p(s) && p(s).isActive("highlight")
                    }
                  ]),
                  onClick: d[2] || (d[2] = (h) => {
                    var c, f;
                    return (f = (c = p(s)) == null ? void 0 : c.commands) == null ? void 0 : f.toggleHighlight();
                  })
                }, [
                  j(cg)
                ], 2)
              ]),
              _: 1
            })
          ], 2),
          p(s) ? (m(), x("div", dg, [
            j(p(L0), {
              class: b(p(i)["v-long-text__editor"]),
              editor: p(s)
            }, null, 8, ["class", "editor"])
          ])) : R("", !0)
        ])
      ]),
      _: 3
    }, 8, ["class", "error", "label", "show-required-star", "with-error", "aria-label", "color", "description", "help-text", "warning", "info-text"]));
  }
}), pg = {
  "v-long-text": "_v-long-text_12gkz_1",
  "v-long-text__editor-header": "_v-long-text__editor-header_12gkz_5",
  "v-long-text__editor-icon": "_v-long-text__editor-icon_12gkz_16",
  "v-long-text__editor-icon--active": "_v-long-text__editor-icon--active_12gkz_27",
  "v-long-text__editor": "_v-long-text__editor_12gkz_5"
}, hg = {
  $style: pg
}, mg = /* @__PURE__ */ U(fg, [["__cssModules", hg]]), vg = {}, gg = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function bg(r, t) {
  return m(), x("svg", gg, t[0] || (t[0] = [
    sr('<path d="M19.1667 8H12.5C12.04 8 11.6667 8.3725 11.6667 8.83333C11.6667 9.29417 12.04 9.66667 12.5 9.66667H19.1667C19.6267 9.66667 20 9.29417 20 8.83333C20 8.3725 19.6267 8 19.1667 8Z" fill="currentColor"></path><path d="M12.5 5.49967H19.1667C19.6267 5.49967 20 5.12717 20 4.66634C20 4.20551 19.6267 3.83301 19.1667 3.83301H12.5C12.04 3.83301 11.6667 4.20551 11.6667 4.66634C11.6667 5.12717 12.04 5.49967 12.5 5.49967Z" fill="currentColor"></path><path d="M19.1667 12.167H12.5C12.04 12.167 11.6667 12.5395 11.6667 13.0003C11.6667 13.4612 12.04 13.8337 12.5 13.8337H19.1667C19.6267 13.8337 20 13.4612 20 13.0003C20 12.5395 19.6267 12.167 19.1667 12.167Z" fill="currentColor"></path><path d="M19.1667 16.333H0.833333C0.373333 16.333 0 16.7055 0 17.1663C0 17.6272 0.373333 17.9997 0.833333 17.9997H19.1667C19.6267 17.9997 20 17.6272 20 17.1663C20 16.7055 19.6267 16.333 19.1667 16.333Z" fill="currentColor"></path><path d="M1.38168 13.7825C1.81501 13.9392 2.29251 13.7175 2.45001 13.2842L3.16001 11.3325H7.67418L8.38418 13.2842C8.50751 13.6225 8.82668 13.8325 9.16751 13.8325C9.26251 13.8325 9.35835 13.8158 9.45251 13.7817C9.88501 13.625 10.1083 13.1467 9.95085 12.7142L6.61668 3.54833C6.49668 3.21833 6.18335 3 5.83335 3H5.00001C4.65001 3 4.33668 3.21917 4.21668 3.54833L0.883346 12.715C0.726679 13.1483 0.949179 13.6258 1.38168 13.7825ZM5.41668 5.12583L7.06751 9.66667H3.76501L5.41668 5.12583Z" fill="currentColor"></path>', 5)
  ]));
}
const yg = /* @__PURE__ */ U(vg, [["render", bg]]);
function _g(r, t) {
  for (var e = -1, u = r == null ? 0 : r.length, n = Array(u); ++e < u; )
    n[e] = t(r[e], e, r);
  return n;
}
var xc = _g;
function wg() {
  this.__data__ = [], this.size = 0;
}
var Cg = wg;
function Dg(r, t) {
  return r === t || r !== r && t !== t;
}
var Ec = Dg, Ag = Ec;
function xg(r, t) {
  for (var e = r.length; e--; )
    if (Ag(r[e][0], t))
      return e;
  return -1;
}
var qn = xg, Eg = qn, kg = Array.prototype, Sg = kg.splice;
function Tg(r) {
  var t = this.__data__, e = Eg(t, r);
  if (e < 0)
    return !1;
  var u = t.length - 1;
  return e == u ? t.pop() : Sg.call(t, e, 1), --this.size, !0;
}
var Bg = Tg, $g = qn;
function Mg(r) {
  var t = this.__data__, e = $g(t, r);
  return e < 0 ? void 0 : t[e][1];
}
var Og = Mg, Lg = qn;
function Fg(r) {
  return Lg(this.__data__, r) > -1;
}
var Ig = Fg, Ng = qn;
function qg(r, t) {
  var e = this.__data__, u = Ng(e, r);
  return u < 0 ? (++this.size, e.push([r, t])) : e[u][1] = t, this;
}
var Pg = qg, Rg = Cg, Vg = Bg, jg = Og, Hg = Ig, Ug = Pg;
function Ir(r) {
  var t = -1, e = r == null ? 0 : r.length;
  for (this.clear(); ++t < e; ) {
    var u = r[t];
    this.set(u[0], u[1]);
  }
}
Ir.prototype.clear = Rg;
Ir.prototype.delete = Vg;
Ir.prototype.get = jg;
Ir.prototype.has = Hg;
Ir.prototype.set = Ug;
var Pn = Ir, zg = Pn;
function Gg() {
  this.__data__ = new zg(), this.size = 0;
}
var Wg = Gg;
function Yg(r) {
  var t = this.__data__, e = t.delete(r);
  return this.size = t.size, e;
}
var Zg = Yg;
function Kg(r) {
  return this.__data__.get(r);
}
var Xg = Kg;
function Jg(r) {
  return this.__data__.has(r);
}
var Qg = Jg, e8 = typeof de == "object" && de && de.Object === Object && de, kc = e8, t8 = kc, r8 = typeof self == "object" && self && self.Object === Object && self, u8 = t8 || r8 || Function("return this")(), Bt = u8, n8 = Bt, a8 = n8.Symbol, Mu = a8, Uo = Mu, Sc = Object.prototype, i8 = Sc.hasOwnProperty, o8 = Sc.toString, Kr = Uo ? Uo.toStringTag : void 0;
function s8(r) {
  var t = i8.call(r, Kr), e = r[Kr];
  try {
    r[Kr] = void 0;
    var u = !0;
  } catch {
  }
  var n = o8.call(r);
  return u && (t ? r[Kr] = e : delete r[Kr]), n;
}
var l8 = s8, c8 = Object.prototype, d8 = c8.toString;
function f8(r) {
  return d8.call(r);
}
var p8 = f8, zo = Mu, h8 = l8, m8 = p8, v8 = "[object Null]", g8 = "[object Undefined]", Go = zo ? zo.toStringTag : void 0;
function b8(r) {
  return r == null ? r === void 0 ? g8 : v8 : Go && Go in Object(r) ? h8(r) : m8(r);
}
var Nr = b8;
function y8(r) {
  var t = typeof r;
  return r != null && (t == "object" || t == "function");
}
var Ou = y8, _8 = Nr, w8 = Ou, C8 = "[object AsyncFunction]", D8 = "[object Function]", A8 = "[object GeneratorFunction]", x8 = "[object Proxy]";
function E8(r) {
  if (!w8(r))
    return !1;
  var t = _8(r);
  return t == D8 || t == A8 || t == C8 || t == x8;
}
var Tc = E8, k8 = Bt, S8 = k8["__core-js_shared__"], T8 = S8, oa = T8, Wo = function() {
  var r = /[^.]+$/.exec(oa && oa.keys && oa.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function B8(r) {
  return !!Wo && Wo in r;
}
var $8 = B8, M8 = Function.prototype, O8 = M8.toString;
function L8(r) {
  if (r != null) {
    try {
      return O8.call(r);
    } catch {
    }
    try {
      return r + "";
    } catch {
    }
  }
  return "";
}
var Bc = L8, F8 = Tc, I8 = $8, N8 = Ou, q8 = Bc, P8 = /[\\^$.*+?()[\]{}|]/g, R8 = /^\[object .+?Constructor\]$/, V8 = Function.prototype, j8 = Object.prototype, H8 = V8.toString, U8 = j8.hasOwnProperty, z8 = RegExp(
  "^" + H8.call(U8).replace(P8, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function G8(r) {
  if (!N8(r) || I8(r))
    return !1;
  var t = F8(r) ? z8 : R8;
  return t.test(q8(r));
}
var W8 = G8;
function Y8(r, t) {
  return r == null ? void 0 : r[t];
}
var Z8 = Y8, K8 = W8, X8 = Z8;
function J8(r, t) {
  var e = X8(r, t);
  return K8(e) ? e : void 0;
}
var cr = J8, Q8 = cr, eb = Bt, tb = Q8(eb, "Map"), gi = tb, rb = cr, ub = rb(Object, "create"), Rn = ub, Yo = Rn;
function nb() {
  this.__data__ = Yo ? Yo(null) : {}, this.size = 0;
}
var ab = nb;
function ib(r) {
  var t = this.has(r) && delete this.__data__[r];
  return this.size -= t ? 1 : 0, t;
}
var ob = ib, sb = Rn, lb = "__lodash_hash_undefined__", cb = Object.prototype, db = cb.hasOwnProperty;
function fb(r) {
  var t = this.__data__;
  if (sb) {
    var e = t[r];
    return e === lb ? void 0 : e;
  }
  return db.call(t, r) ? t[r] : void 0;
}
var pb = fb, hb = Rn, mb = Object.prototype, vb = mb.hasOwnProperty;
function gb(r) {
  var t = this.__data__;
  return hb ? t[r] !== void 0 : vb.call(t, r);
}
var bb = gb, yb = Rn, _b = "__lodash_hash_undefined__";
function wb(r, t) {
  var e = this.__data__;
  return this.size += this.has(r) ? 0 : 1, e[r] = yb && t === void 0 ? _b : t, this;
}
var Cb = wb, Db = ab, Ab = ob, xb = pb, Eb = bb, kb = Cb;
function qr(r) {
  var t = -1, e = r == null ? 0 : r.length;
  for (this.clear(); ++t < e; ) {
    var u = r[t];
    this.set(u[0], u[1]);
  }
}
qr.prototype.clear = Db;
qr.prototype.delete = Ab;
qr.prototype.get = xb;
qr.prototype.has = Eb;
qr.prototype.set = kb;
var Sb = qr, Zo = Sb, Tb = Pn, Bb = gi;
function $b() {
  this.size = 0, this.__data__ = {
    hash: new Zo(),
    map: new (Bb || Tb)(),
    string: new Zo()
  };
}
var Mb = $b;
function Ob(r) {
  var t = typeof r;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? r !== "__proto__" : r === null;
}
var Lb = Ob, Fb = Lb;
function Ib(r, t) {
  var e = r.__data__;
  return Fb(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
}
var Vn = Ib, Nb = Vn;
function qb(r) {
  var t = Nb(this, r).delete(r);
  return this.size -= t ? 1 : 0, t;
}
var Pb = qb, Rb = Vn;
function Vb(r) {
  return Rb(this, r).get(r);
}
var jb = Vb, Hb = Vn;
function Ub(r) {
  return Hb(this, r).has(r);
}
var zb = Ub, Gb = Vn;
function Wb(r, t) {
  var e = Gb(this, r), u = e.size;
  return e.set(r, t), this.size += e.size == u ? 0 : 1, this;
}
var Yb = Wb, Zb = Mb, Kb = Pb, Xb = jb, Jb = zb, Qb = Yb;
function Pr(r) {
  var t = -1, e = r == null ? 0 : r.length;
  for (this.clear(); ++t < e; ) {
    var u = r[t];
    this.set(u[0], u[1]);
  }
}
Pr.prototype.clear = Zb;
Pr.prototype.delete = Kb;
Pr.prototype.get = Xb;
Pr.prototype.has = Jb;
Pr.prototype.set = Qb;
var $c = Pr, e9 = Pn, t9 = gi, r9 = $c, u9 = 200;
function n9(r, t) {
  var e = this.__data__;
  if (e instanceof e9) {
    var u = e.__data__;
    if (!t9 || u.length < u9 - 1)
      return u.push([r, t]), this.size = ++e.size, this;
    e = this.__data__ = new r9(u);
  }
  return e.set(r, t), this.size = e.size, this;
}
var a9 = n9, i9 = Pn, o9 = Wg, s9 = Zg, l9 = Xg, c9 = Qg, d9 = a9;
function Rr(r) {
  var t = this.__data__ = new i9(r);
  this.size = t.size;
}
Rr.prototype.clear = o9;
Rr.prototype.delete = s9;
Rr.prototype.get = l9;
Rr.prototype.has = c9;
Rr.prototype.set = d9;
var f9 = Rr;
function p9(r, t) {
  for (var e = -1, u = r == null ? 0 : r.length; ++e < u && t(r[e], e, r) !== !1; )
    ;
  return r;
}
var h9 = p9, m9 = cr, v9 = function() {
  try {
    var r = m9(Object, "defineProperty");
    return r({}, "", {}), r;
  } catch {
  }
}(), Mc = v9, Ko = Mc;
function g9(r, t, e) {
  t == "__proto__" && Ko ? Ko(r, t, {
    configurable: !0,
    enumerable: !0,
    value: e,
    writable: !0
  }) : r[t] = e;
}
var Oc = g9, b9 = Oc, y9 = Ec, _9 = Object.prototype, w9 = _9.hasOwnProperty;
function C9(r, t, e) {
  var u = r[t];
  (!(w9.call(r, t) && y9(u, e)) || e === void 0 && !(t in r)) && b9(r, t, e);
}
var Lc = C9, D9 = Lc, A9 = Oc;
function x9(r, t, e, u) {
  var n = !e;
  e || (e = {});
  for (var a = -1, o = t.length; ++a < o; ) {
    var s = t[a], i = u ? u(e[s], r[s], s, e, r) : void 0;
    i === void 0 && (i = r[s]), n ? A9(e, s, i) : D9(e, s, i);
  }
  return e;
}
var Lu = x9;
function E9(r, t) {
  for (var e = -1, u = Array(r); ++e < r; )
    u[e] = t(e);
  return u;
}
var k9 = E9;
function S9(r) {
  return r != null && typeof r == "object";
}
var dr = S9, T9 = Nr, B9 = dr, $9 = "[object Arguments]";
function M9(r) {
  return B9(r) && T9(r) == $9;
}
var O9 = M9, Xo = O9, L9 = dr, Fc = Object.prototype, F9 = Fc.hasOwnProperty, I9 = Fc.propertyIsEnumerable, N9 = Xo(function() {
  return arguments;
}()) ? Xo : function(r) {
  return L9(r) && F9.call(r, "callee") && !I9.call(r, "callee");
}, Ic = N9, q9 = Array.isArray, fr = q9, wn = { exports: {} };
function P9() {
  return !1;
}
var R9 = P9;
wn.exports;
(function(r, t) {
  var e = Bt, u = R9, n = t && !t.nodeType && t, a = n && !0 && r && !r.nodeType && r, o = a && a.exports === n, s = o ? e.Buffer : void 0, i = s ? s.isBuffer : void 0, l = i || u;
  r.exports = l;
})(wn, wn.exports);
var Nc = wn.exports, V9 = 9007199254740991, j9 = /^(?:0|[1-9]\d*)$/;
function H9(r, t) {
  var e = typeof r;
  return t = t ?? V9, !!t && (e == "number" || e != "symbol" && j9.test(r)) && r > -1 && r % 1 == 0 && r < t;
}
var U9 = H9, z9 = 9007199254740991;
function G9(r) {
  return typeof r == "number" && r > -1 && r % 1 == 0 && r <= z9;
}
var qc = G9, W9 = Nr, Y9 = qc, Z9 = dr, K9 = "[object Arguments]", X9 = "[object Array]", J9 = "[object Boolean]", Q9 = "[object Date]", e7 = "[object Error]", t7 = "[object Function]", r7 = "[object Map]", u7 = "[object Number]", n7 = "[object Object]", a7 = "[object RegExp]", i7 = "[object Set]", o7 = "[object String]", s7 = "[object WeakMap]", l7 = "[object ArrayBuffer]", c7 = "[object DataView]", d7 = "[object Float32Array]", f7 = "[object Float64Array]", p7 = "[object Int8Array]", h7 = "[object Int16Array]", m7 = "[object Int32Array]", v7 = "[object Uint8Array]", g7 = "[object Uint8ClampedArray]", b7 = "[object Uint16Array]", y7 = "[object Uint32Array]", Be = {};
Be[d7] = Be[f7] = Be[p7] = Be[h7] = Be[m7] = Be[v7] = Be[g7] = Be[b7] = Be[y7] = !0;
Be[K9] = Be[X9] = Be[l7] = Be[J9] = Be[c7] = Be[Q9] = Be[e7] = Be[t7] = Be[r7] = Be[u7] = Be[n7] = Be[a7] = Be[i7] = Be[o7] = Be[s7] = !1;
function _7(r) {
  return Z9(r) && Y9(r.length) && !!Be[W9(r)];
}
var w7 = _7;
function C7(r) {
  return function(t) {
    return r(t);
  };
}
var bi = C7, Cn = { exports: {} };
Cn.exports;
(function(r, t) {
  var e = kc, u = t && !t.nodeType && t, n = u && !0 && r && !r.nodeType && r, a = n && n.exports === u, o = a && e.process, s = function() {
    try {
      var i = n && n.require && n.require("util").types;
      return i || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  r.exports = s;
})(Cn, Cn.exports);
var yi = Cn.exports, D7 = w7, A7 = bi, Jo = yi, Qo = Jo && Jo.isTypedArray, x7 = Qo ? A7(Qo) : D7, E7 = x7, k7 = k9, S7 = Ic, T7 = fr, B7 = Nc, $7 = U9, M7 = E7, O7 = Object.prototype, L7 = O7.hasOwnProperty;
function F7(r, t) {
  var e = T7(r), u = !e && S7(r), n = !e && !u && B7(r), a = !e && !u && !n && M7(r), o = e || u || n || a, s = o ? k7(r.length, String) : [], i = s.length;
  for (var l in r)
    (t || L7.call(r, l)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    n && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    $7(l, i))) && s.push(l);
  return s;
}
var Pc = F7, I7 = Object.prototype;
function N7(r) {
  var t = r && r.constructor, e = typeof t == "function" && t.prototype || I7;
  return r === e;
}
var _i = N7;
function q7(r, t) {
  return function(e) {
    return r(t(e));
  };
}
var Rc = q7, P7 = Rc, R7 = P7(Object.keys, Object), V7 = R7, j7 = _i, H7 = V7, U7 = Object.prototype, z7 = U7.hasOwnProperty;
function G7(r) {
  if (!j7(r))
    return H7(r);
  var t = [];
  for (var e in Object(r))
    z7.call(r, e) && e != "constructor" && t.push(e);
  return t;
}
var W7 = G7, Y7 = Tc, Z7 = qc;
function K7(r) {
  return r != null && Z7(r.length) && !Y7(r);
}
var Vc = K7, X7 = Pc, J7 = W7, Q7 = Vc;
function ey(r) {
  return Q7(r) ? X7(r) : J7(r);
}
var wi = ey, ty = Lu, ry = wi;
function uy(r, t) {
  return r && ty(t, ry(t), r);
}
var ny = uy;
function ay(r) {
  var t = [];
  if (r != null)
    for (var e in Object(r))
      t.push(e);
  return t;
}
var iy = ay, oy = Ou, sy = _i, ly = iy, cy = Object.prototype, dy = cy.hasOwnProperty;
function fy(r) {
  if (!oy(r))
    return ly(r);
  var t = sy(r), e = [];
  for (var u in r)
    u == "constructor" && (t || !dy.call(r, u)) || e.push(u);
  return e;
}
var py = fy, hy = Pc, my = py, vy = Vc;
function gy(r) {
  return vy(r) ? hy(r, !0) : my(r);
}
var Ci = gy, by = Lu, yy = Ci;
function _y(r, t) {
  return r && by(t, yy(t), r);
}
var wy = _y, Dn = { exports: {} };
Dn.exports;
(function(r, t) {
  var e = Bt, u = t && !t.nodeType && t, n = u && !0 && r && !r.nodeType && r, a = n && n.exports === u, o = a ? e.Buffer : void 0, s = o ? o.allocUnsafe : void 0;
  function i(l, d) {
    if (d)
      return l.slice();
    var h = l.length, c = s ? s(h) : new l.constructor(h);
    return l.copy(c), c;
  }
  r.exports = i;
})(Dn, Dn.exports);
var Cy = Dn.exports;
function Dy(r, t) {
  var e = -1, u = r.length;
  for (t || (t = Array(u)); ++e < u; )
    t[e] = r[e];
  return t;
}
var Ay = Dy;
function xy(r, t) {
  for (var e = -1, u = r == null ? 0 : r.length, n = 0, a = []; ++e < u; ) {
    var o = r[e];
    t(o, e, r) && (a[n++] = o);
  }
  return a;
}
var Ey = xy;
function ky() {
  return [];
}
var jc = ky, Sy = Ey, Ty = jc, By = Object.prototype, $y = By.propertyIsEnumerable, es = Object.getOwnPropertySymbols, My = es ? function(r) {
  return r == null ? [] : (r = Object(r), Sy(es(r), function(t) {
    return $y.call(r, t);
  }));
} : Ty, Di = My, Oy = Lu, Ly = Di;
function Fy(r, t) {
  return Oy(r, Ly(r), t);
}
var Iy = Fy;
function Ny(r, t) {
  for (var e = -1, u = t.length, n = r.length; ++e < u; )
    r[n + e] = t[e];
  return r;
}
var Ai = Ny, qy = Rc, Py = qy(Object.getPrototypeOf, Object), xi = Py, Ry = Ai, Vy = xi, jy = Di, Hy = jc, Uy = Object.getOwnPropertySymbols, zy = Uy ? function(r) {
  for (var t = []; r; )
    Ry(t, jy(r)), r = Vy(r);
  return t;
} : Hy, Hc = zy, Gy = Lu, Wy = Hc;
function Yy(r, t) {
  return Gy(r, Wy(r), t);
}
var Zy = Yy, Ky = Ai, Xy = fr;
function Jy(r, t, e) {
  var u = t(r);
  return Xy(r) ? u : Ky(u, e(r));
}
var Uc = Jy, Qy = Uc, e_ = Di, t_ = wi;
function r_(r) {
  return Qy(r, t_, e_);
}
var u_ = r_, n_ = Uc, a_ = Hc, i_ = Ci;
function o_(r) {
  return n_(r, i_, a_);
}
var zc = o_, s_ = cr, l_ = Bt, c_ = s_(l_, "DataView"), d_ = c_, f_ = cr, p_ = Bt, h_ = f_(p_, "Promise"), m_ = h_, v_ = cr, g_ = Bt, b_ = v_(g_, "Set"), y_ = b_, __ = cr, w_ = Bt, C_ = __(w_, "WeakMap"), D_ = C_, Ia = d_, Na = gi, qa = m_, Pa = y_, Ra = D_, Gc = Nr, Vr = Bc, ts = "[object Map]", A_ = "[object Object]", rs = "[object Promise]", us = "[object Set]", ns = "[object WeakMap]", as = "[object DataView]", x_ = Vr(Ia), E_ = Vr(Na), k_ = Vr(qa), S_ = Vr(Pa), T_ = Vr(Ra), Qt = Gc;
(Ia && Qt(new Ia(new ArrayBuffer(1))) != as || Na && Qt(new Na()) != ts || qa && Qt(qa.resolve()) != rs || Pa && Qt(new Pa()) != us || Ra && Qt(new Ra()) != ns) && (Qt = function(r) {
  var t = Gc(r), e = t == A_ ? r.constructor : void 0, u = e ? Vr(e) : "";
  if (u)
    switch (u) {
      case x_:
        return as;
      case E_:
        return ts;
      case k_:
        return rs;
      case S_:
        return us;
      case T_:
        return ns;
    }
  return t;
});
var Ei = Qt, B_ = Object.prototype, $_ = B_.hasOwnProperty;
function M_(r) {
  var t = r.length, e = new r.constructor(t);
  return t && typeof r[0] == "string" && $_.call(r, "index") && (e.index = r.index, e.input = r.input), e;
}
var O_ = M_, L_ = Bt, F_ = L_.Uint8Array, I_ = F_, is = I_;
function N_(r) {
  var t = new r.constructor(r.byteLength);
  return new is(t).set(new is(r)), t;
}
var ki = N_, q_ = ki;
function P_(r, t) {
  var e = t ? q_(r.buffer) : r.buffer;
  return new r.constructor(e, r.byteOffset, r.byteLength);
}
var R_ = P_, V_ = /\w*$/;
function j_(r) {
  var t = new r.constructor(r.source, V_.exec(r));
  return t.lastIndex = r.lastIndex, t;
}
var H_ = j_, os = Mu, ss = os ? os.prototype : void 0, ls = ss ? ss.valueOf : void 0;
function U_(r) {
  return ls ? Object(ls.call(r)) : {};
}
var z_ = U_, G_ = ki;
function W_(r, t) {
  var e = t ? G_(r.buffer) : r.buffer;
  return new r.constructor(e, r.byteOffset, r.length);
}
var Y_ = W_, Z_ = ki, K_ = R_, X_ = H_, J_ = z_, Q_ = Y_, ew = "[object Boolean]", tw = "[object Date]", rw = "[object Map]", uw = "[object Number]", nw = "[object RegExp]", aw = "[object Set]", iw = "[object String]", ow = "[object Symbol]", sw = "[object ArrayBuffer]", lw = "[object DataView]", cw = "[object Float32Array]", dw = "[object Float64Array]", fw = "[object Int8Array]", pw = "[object Int16Array]", hw = "[object Int32Array]", mw = "[object Uint8Array]", vw = "[object Uint8ClampedArray]", gw = "[object Uint16Array]", bw = "[object Uint32Array]";
function yw(r, t, e) {
  var u = r.constructor;
  switch (t) {
    case sw:
      return Z_(r);
    case ew:
    case tw:
      return new u(+r);
    case lw:
      return K_(r, e);
    case cw:
    case dw:
    case fw:
    case pw:
    case hw:
    case mw:
    case vw:
    case gw:
    case bw:
      return Q_(r, e);
    case rw:
      return new u();
    case uw:
    case iw:
      return new u(r);
    case nw:
      return X_(r);
    case aw:
      return new u();
    case ow:
      return J_(r);
  }
}
var _w = yw, ww = Ou, cs = Object.create, Cw = function() {
  function r() {
  }
  return function(t) {
    if (!ww(t))
      return {};
    if (cs)
      return cs(t);
    r.prototype = t;
    var e = new r();
    return r.prototype = void 0, e;
  };
}(), Dw = Cw, Aw = Dw, xw = xi, Ew = _i;
function kw(r) {
  return typeof r.constructor == "function" && !Ew(r) ? Aw(xw(r)) : {};
}
var Sw = kw, Tw = Ei, Bw = dr, $w = "[object Map]";
function Mw(r) {
  return Bw(r) && Tw(r) == $w;
}
var Ow = Mw, Lw = Ow, Fw = bi, ds = yi, fs = ds && ds.isMap, Iw = fs ? Fw(fs) : Lw, Nw = Iw, qw = Ei, Pw = dr, Rw = "[object Set]";
function Vw(r) {
  return Pw(r) && qw(r) == Rw;
}
var jw = Vw, Hw = jw, Uw = bi, ps = yi, hs = ps && ps.isSet, zw = hs ? Uw(hs) : Hw, Gw = zw, Ww = f9, Yw = h9, Zw = Lc, Kw = ny, Xw = wy, Jw = Cy, Qw = Ay, eC = Iy, tC = Zy, rC = u_, uC = zc, nC = Ei, aC = O_, iC = _w, oC = Sw, sC = fr, lC = Nc, cC = Nw, dC = Ou, fC = Gw, pC = wi, hC = Ci, mC = 1, vC = 2, gC = 4, Wc = "[object Arguments]", bC = "[object Array]", yC = "[object Boolean]", _C = "[object Date]", wC = "[object Error]", Yc = "[object Function]", CC = "[object GeneratorFunction]", DC = "[object Map]", AC = "[object Number]", Zc = "[object Object]", xC = "[object RegExp]", EC = "[object Set]", kC = "[object String]", SC = "[object Symbol]", TC = "[object WeakMap]", BC = "[object ArrayBuffer]", $C = "[object DataView]", MC = "[object Float32Array]", OC = "[object Float64Array]", LC = "[object Int8Array]", FC = "[object Int16Array]", IC = "[object Int32Array]", NC = "[object Uint8Array]", qC = "[object Uint8ClampedArray]", PC = "[object Uint16Array]", RC = "[object Uint32Array]", Se = {};
Se[Wc] = Se[bC] = Se[BC] = Se[$C] = Se[yC] = Se[_C] = Se[MC] = Se[OC] = Se[LC] = Se[FC] = Se[IC] = Se[DC] = Se[AC] = Se[Zc] = Se[xC] = Se[EC] = Se[kC] = Se[SC] = Se[NC] = Se[qC] = Se[PC] = Se[RC] = !0;
Se[wC] = Se[Yc] = Se[TC] = !1;
function on(r, t, e, u, n, a) {
  var o, s = t & mC, i = t & vC, l = t & gC;
  if (e && (o = n ? e(r, u, n, a) : e(r)), o !== void 0)
    return o;
  if (!dC(r))
    return r;
  var d = sC(r);
  if (d) {
    if (o = aC(r), !s)
      return Qw(r, o);
  } else {
    var h = nC(r), c = h == Yc || h == CC;
    if (lC(r))
      return Jw(r, s);
    if (h == Zc || h == Wc || c && !n) {
      if (o = i || c ? {} : oC(r), !s)
        return i ? tC(r, Xw(o, r)) : eC(r, Kw(o, r));
    } else {
      if (!Se[h])
        return n ? r : {};
      o = iC(r, h, s);
    }
  }
  a || (a = new Ww());
  var f = a.get(r);
  if (f)
    return f;
  a.set(r, o), fC(r) ? r.forEach(function(_) {
    o.add(on(_, t, e, _, r, a));
  }) : cC(r) && r.forEach(function(_, O) {
    o.set(O, on(_, t, e, O, r, a));
  });
  var g = l ? i ? uC : rC : i ? hC : pC, D = d ? void 0 : g(r);
  return Yw(D || r, function(_, O) {
    D && (O = _, _ = r[O]), Zw(o, O, on(_, t, e, O, r, a));
  }), o;
}
var VC = on, jC = Nr, HC = dr, UC = "[object Symbol]";
function zC(r) {
  return typeof r == "symbol" || HC(r) && jC(r) == UC;
}
var Si = zC, GC = fr, WC = Si, YC = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ZC = /^\w*$/;
function KC(r, t) {
  if (GC(r))
    return !1;
  var e = typeof r;
  return e == "number" || e == "symbol" || e == "boolean" || r == null || WC(r) ? !0 : ZC.test(r) || !YC.test(r) || t != null && r in Object(t);
}
var XC = KC, Kc = $c, JC = "Expected a function";
function Ti(r, t) {
  if (typeof r != "function" || t != null && typeof t != "function")
    throw new TypeError(JC);
  var e = function() {
    var u = arguments, n = t ? t.apply(this, u) : u[0], a = e.cache;
    if (a.has(n))
      return a.get(n);
    var o = r.apply(this, u);
    return e.cache = a.set(n, o) || a, o;
  };
  return e.cache = new (Ti.Cache || Kc)(), e;
}
Ti.Cache = Kc;
var QC = Ti, eD = QC, tD = 500;
function rD(r) {
  var t = eD(r, function(u) {
    return e.size === tD && e.clear(), u;
  }), e = t.cache;
  return t;
}
var uD = rD, nD = uD, aD = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, iD = /\\(\\)?/g, oD = nD(function(r) {
  var t = [];
  return r.charCodeAt(0) === 46 && t.push(""), r.replace(aD, function(e, u, n, a) {
    t.push(n ? a.replace(iD, "$1") : u || e);
  }), t;
}), sD = oD, ms = Mu, lD = xc, cD = fr, dD = Si, fD = 1 / 0, vs = ms ? ms.prototype : void 0, gs = vs ? vs.toString : void 0;
function Xc(r) {
  if (typeof r == "string")
    return r;
  if (cD(r))
    return lD(r, Xc) + "";
  if (dD(r))
    return gs ? gs.call(r) : "";
  var t = r + "";
  return t == "0" && 1 / r == -fD ? "-0" : t;
}
var pD = Xc, hD = pD;
function mD(r) {
  return r == null ? "" : hD(r);
}
var vD = mD, gD = fr, bD = XC, yD = sD, _D = vD;
function wD(r, t) {
  return gD(r) ? r : bD(r, t) ? [r] : yD(_D(r));
}
var Bi = wD;
function CD(r) {
  var t = r == null ? 0 : r.length;
  return t ? r[t - 1] : void 0;
}
var DD = CD, AD = Si, xD = 1 / 0;
function ED(r) {
  if (typeof r == "string" || AD(r))
    return r;
  var t = r + "";
  return t == "0" && 1 / r == -xD ? "-0" : t;
}
var Jc = ED, kD = Bi, SD = Jc;
function TD(r, t) {
  t = kD(t, r);
  for (var e = 0, u = t.length; r != null && e < u; )
    r = r[SD(t[e++])];
  return e && e == u ? r : void 0;
}
var BD = TD;
function $D(r, t, e) {
  var u = -1, n = r.length;
  t < 0 && (t = -t > n ? 0 : n + t), e = e > n ? n : e, e < 0 && (e += n), n = t > e ? 0 : e - t >>> 0, t >>>= 0;
  for (var a = Array(n); ++u < n; )
    a[u] = r[u + t];
  return a;
}
var MD = $D, OD = BD, LD = MD;
function FD(r, t) {
  return t.length < 2 ? r : OD(r, LD(t, 0, -1));
}
var ID = FD, ND = Bi, qD = DD, PD = ID, RD = Jc;
function VD(r, t) {
  return t = ND(t, r), r = PD(r, t), r == null || delete r[RD(qD(t))];
}
var jD = VD, HD = Nr, UD = xi, zD = dr, GD = "[object Object]", WD = Function.prototype, YD = Object.prototype, Qc = WD.toString, ZD = YD.hasOwnProperty, KD = Qc.call(Object);
function XD(r) {
  if (!zD(r) || HD(r) != GD)
    return !1;
  var t = UD(r);
  if (t === null)
    return !0;
  var e = ZD.call(t, "constructor") && t.constructor;
  return typeof e == "function" && e instanceof e && Qc.call(e) == KD;
}
var JD = XD, QD = JD;
function eA(r) {
  return QD(r) ? void 0 : r;
}
var tA = eA, bs = Mu, rA = Ic, uA = fr, ys = bs ? bs.isConcatSpreadable : void 0;
function nA(r) {
  return uA(r) || rA(r) || !!(ys && r && r[ys]);
}
var aA = nA, iA = Ai, oA = aA;
function e0(r, t, e, u, n) {
  var a = -1, o = r.length;
  for (e || (e = oA), n || (n = []); ++a < o; ) {
    var s = r[a];
    t > 0 && e(s) ? t > 1 ? e0(s, t - 1, e, u, n) : iA(n, s) : u || (n[n.length] = s);
  }
  return n;
}
var sA = e0, lA = sA;
function cA(r) {
  var t = r == null ? 0 : r.length;
  return t ? lA(r, 1) : [];
}
var dA = cA;
function fA(r, t, e) {
  switch (e.length) {
    case 0:
      return r.call(t);
    case 1:
      return r.call(t, e[0]);
    case 2:
      return r.call(t, e[0], e[1]);
    case 3:
      return r.call(t, e[0], e[1], e[2]);
  }
  return r.apply(t, e);
}
var pA = fA, hA = pA, _s = Math.max;
function mA(r, t, e) {
  return t = _s(t === void 0 ? r.length - 1 : t, 0), function() {
    for (var u = arguments, n = -1, a = _s(u.length - t, 0), o = Array(a); ++n < a; )
      o[n] = u[t + n];
    n = -1;
    for (var s = Array(t + 1); ++n < t; )
      s[n] = u[n];
    return s[t] = e(o), hA(r, this, s);
  };
}
var vA = mA;
function gA(r) {
  return function() {
    return r;
  };
}
var bA = gA;
function yA(r) {
  return r;
}
var _A = yA, wA = bA, ws = Mc, CA = _A, DA = ws ? function(r, t) {
  return ws(r, "toString", {
    configurable: !0,
    enumerable: !1,
    value: wA(t),
    writable: !0
  });
} : CA, AA = DA, xA = 800, EA = 16, kA = Date.now;
function SA(r) {
  var t = 0, e = 0;
  return function() {
    var u = kA(), n = EA - (u - e);
    if (e = u, n > 0) {
      if (++t >= xA)
        return arguments[0];
    } else
      t = 0;
    return r.apply(void 0, arguments);
  };
}
var TA = SA, BA = AA, $A = TA, MA = $A(BA), OA = MA, LA = dA, FA = vA, IA = OA;
function NA(r) {
  return IA(FA(r, void 0, LA), r + "");
}
var qA = NA, PA = xc, RA = VC, VA = jD, jA = Bi, HA = Lu, UA = tA, zA = qA, GA = zc, WA = 1, YA = 2, ZA = 4, KA = zA(function(r, t) {
  var e = {};
  if (r == null)
    return e;
  var u = !1;
  t = PA(t, function(a) {
    return a = jA(a, r), u || (u = a.length > 1), a;
  }), HA(r, GA(r), e), u && (e = RA(e, WA | YA | ZA, UA));
  for (var n = t.length; n--; )
    VA(e, t[n]);
  return e;
}), XA = KA;
const JA = /* @__PURE__ */ xn(XA), oE = /* @__PURE__ */ ue({
  __name: "VLongTextShortField",
  props: /* @__PURE__ */ lt({
    modelValue: {},
    placeholder: {},
    prefixIcon: {},
    suffixIcon: {},
    foreground: { type: Boolean },
    type: {},
    min: {},
    disabled: { type: Boolean },
    isNumber: { type: Boolean },
    borderless: { type: Boolean },
    readonly: { type: Boolean },
    autofocus: { type: Boolean },
    resizable: { type: Boolean },
    inputMode: {},
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    helpText: {},
    description: {},
    size: {},
    color: {},
    warning: {},
    infoText: {},
    modalLabel: {}
  }, {
    foreground: !1,
    autofocus: !1,
    modalLabel: "",
    ...ct,
    borderless: !1,
    showRequiredStar: !1
  }),
  emits: ["update:modelValue"],
  setup(r, { emit: t }) {
    const e = r, u = G(() => JA(e, ["modalLabel"])), n = Q(e.modelValue);
    qe(() => e.modelValue, (l) => {
      n.value = l;
    });
    const a = Q(!1), o = () => {
      a.value = !1, n.value = e.modelValue;
    }, s = t, i = () => {
      s("update:modelValue", n.value), a.value = !1;
    };
    return (l, d) => (m(), x("div", null, [
      j(p(Fr), Te(u.value, {
        readonly: "",
        "prefix-icon": yg,
        disabled: l.disabled,
        onClick: d[0] || (d[0] = (h) => a.value = !0)
      }), null, 16, ["disabled"]),
      j(p(O5), {
        "is-modal-show": a.value,
        "onUpdate:isModalShow": d[2] || (d[2] = (h) => a.value = h),
        "field-name": l.modalLabel || e.label,
        "show-required-star": l.showRequiredStar,
        "max-width": "600px",
        onCancel: d[3] || (d[3] = (h) => o()),
        onSubmit: d[4] || (d[4] = (h) => i())
      }, {
        default: J(() => [
          j(p(mg), {
            modelValue: n.value,
            "onUpdate:modelValue": d[1] || (d[1] = (h) => n.value = h),
            autofocus: l.autofocus
          }, null, 8, ["modelValue", "autofocus"])
        ]),
        _: 1
      }, 8, ["is-modal-show", "field-name", "show-required-star"])
    ]));
  }
}), QA = {}, ex = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "32",
  width: "32",
  viewBox: "0 0 32 32"
};
function tx(r, t) {
  return m(), x("svg", ex, t[0] || (t[0] = [
    sr('<g stroke-linecap="round" fill="currentColor" stroke-linejoin="round" class="nc-icon-wrapper"><path d="M18 29.8582C17.3468 29.9517 16.679 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16C30 16.679 29.9517 17.3468 29.8582 18" stroke="currentColor" stroke-width="2.4" fill="none"></path><path d="M16 24C12.829 24 10.1504 21.8915 9.28988 19" stroke="currentColor" stroke-width="2.4" fill="none"></path><path d="M25 30V20" stroke="currentColor" stroke-width="2.4" data-color="color-2" fill="none"></path><path d="M20 25L30 25" stroke="currentColor" stroke-width="2.4" data-color="color-2" fill="none"></path><path d="M22 13C22 13.5523 21.5523 14 21 14C20.4477 14 20 13.5523 20 13C20 12.4477 20.4477 12 21 12C21.5523 12 22 12.4477 22 13Z" fill="currentColor" stroke="currentColor" stroke-width="2.4" data-cap="butt"></path><path d="M12 13C12 13.5523 11.5523 14 11 14C10.4477 14 10 13.5523 10 13C10 12.4477 10.4477 12 11 12C11.5523 12 12 12.4477 12 13Z" fill="currentColor" stroke="currentColor" stroke-width="2.4" data-cap="butt"></path></g>', 1)
  ]));
}
const rx = /* @__PURE__ */ U(QA, [["render", tx]]), ux = /* @__PURE__ */ ue({
  __name: "VEmojiPicker",
  emits: ["pick"],
  setup(r, { emit: t }) {
    const e = t, u = Q(null), n = Q(), a = Q(), o = Q({
      additionalGroups: {
        quickPicks: [
          { n: ["thumbs up sign", "+1", "thumbsup"], u: "1f44d" },
          { n: ["thumbs down sign", "-1", "thumbdown"], u: "1f44e" },
          { n: ["eyes"], u: "1f440" },
          { n: ["white heavy check mark", "white_check_mark"], u: "2705" },
          { n: ["heavy plus sign", "heavy_plus_sign"], u: "2795" },
          { n: ["heavy black heart", "heart"], u: "2764-fe0f" }
        ]
      },
      groupNames: {
        quickPicks: "Quick Picks"
      }
    });
    Zt(n, (d) => {
      i.value = !1;
    }, {
      ignore: [
        a
      ]
    });
    const s = () => {
      var d;
      u.value && ((d = u.value) == null || d.destroy(), u.value = null), a.value && document.body.removeChild(a.value);
    }, i = Q(!1);
    qe(() => i.value, async (d) => {
      await Pe(), !(!n.value || !a.value) && (d && n.value && (a.value.style.width = "300px", a.value.style.zIndex = "1100", u.value = Tt(n.value, a.value, {
        placement: "top",
        modifiers: [
          St,
          {
            name: "offset",
            options: {
              offset: [0, 4]
            }
          },
          {
            name: "flip",
            options: {
              allowedAutoPlacements: ["top", "bottom"]
            }
          }
        ]
      }), document.body.appendChild(a.value)), !d && u.value && s());
    });
    const l = (d) => {
      e("pick", d), i.value = !1;
    };
    return (d, h) => (m(), x("div", null, [
      C("div", {
        ref_key: "trigger",
        ref: n,
        class: b(d.$style["v-emoji-picker__trigger"]),
        onClick: h[0] || (h[0] = (c) => i.value = !i.value)
      }, [
        j(rx)
      ], 2),
      i.value ? (m(), x("div", {
        key: 0,
        ref_key: "popperWrapper",
        ref: a
      }, [
        i.value ? (m(), H(p(q0), {
          key: 0,
          "additional-groups": o.value.additionalGroups,
          "group-names": o.value.groupNames,
          "display-recent": !0,
          "disable-skin-tones": !0,
          onSelect: h[1] || (h[1] = (c) => l(c))
        }, null, 8, ["additional-groups", "group-names"])) : R("", !0)
      ], 512)) : R("", !0)
    ]));
  }
}), nx = {
  "v-emoji-picker__trigger": "_v-emoji-picker__trigger_r0o11_1"
}, ax = {
  $style: nx
}, sE = /* @__PURE__ */ U(ux, [["__cssModules", ax]]);
export {
  Oa as DotsHorizontalIcon,
  yg as LongTextIcon,
  Ma as VActions,
  nr as VAvatar,
  jx as VAvatarGroup,
  Gt as VAvatarSizes,
  Lr as VBaseField,
  gd as VBaseFieldSize,
  vi as VBaseModal,
  vt as VButton,
  Pt as VButtonSizes,
  sn as VButtonTags,
  P0 as VButtonTypes,
  qt as VButtonVariants,
  Wm as VCalculation,
  Hs as VCheckbox,
  xu as VCheckboxSizes,
  R6 as VChip,
  uE as VColorPicker,
  tE as VCreateViewModal,
  Px as VCurrencyField,
  oh as VDateField,
  Nx as VDatetimeField,
  Qx as VEditableTableItem,
  Vx as VEmailField,
  sE as VEmojiPicker,
  ac as VError,
  O3 as VFieldDescription,
  ym as VFieldValue,
  aE as VFileAttachmentField,
  nE as VFileUploader,
  Fr as VInput,
  zs as VLabel,
  mg as VLongTextField,
  oE as VLongTextShortField,
  or as VMarkedText,
  lu as VMarkedTextVariants,
  Jx as VMultiSelect,
  iE as VMultipleButtons,
  Rs as VNavItem,
  eE as VNewVersion,
  dc as VNumberField,
  qx as VPercentField,
  Oo as VProfile,
  pc as VProfileStatus,
  Zx as VRecordCard,
  Wx as VRecordKanbanCard,
  Yx as VRecordKanbanColumn,
  yc as VRecordTypeSelect,
  fc as VSelect,
  yt as VShrinkText,
  bx as VSidebar,
  Gx as VSidebarMobile,
  Dt as VSkeletonLoader,
  Xx as VSkeletonRecordsPage,
  Cu as VSpinner,
  Rt as VSpinnerSizes,
  ln as VSpinnerVariants,
  xm as VStatusSelect,
  Vs as VStatusSelectAlign,
  js as VStatusSelectSize,
  Ux as VSupportCenter,
  rE as VTab,
  Kx as VTable,
  Ix as VTextarea,
  yx as VToast,
  Ve as VTooltip,
  Hx as VTopbar,
  zx as VTopbarMobile,
  O5 as VUpdateField,
  Rx as VUserField,
  A3 as VWarning,
  ct as V_BASE_FIELD_DEFAULT_PROPS,
  nc as getSanitizedText,
  yu as getUnifiedString
};
